(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.drawing.cmn.chunk.js'), require('kendo.common.cmn.chunk.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.drawing.cmn.chunk', 'kendo.common.cmn.chunk'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.DiagramCommonCmnChunk = {}), global.kendo._globals.DrawingCmnChunk, global.kendo._globals.CommonCmnChunk));
})(this, (function (exports, kendo_drawing_cmn_chunk_js, kendo_common_cmn_chunk_js) {
    const __meta__ = {
        id: "diagram-common.cmn.chunk",
        name: "DiagramCommonCmnChunk",
        category: "web",
        description: "A reusable outputed chunk of code",
        depends: ['drawing.cmn.chunk', 'common.cmn.chunk'],
        hidden: true,
        chunk: true,
        
    };

    const WIDTH = 'width';
    const HEIGHT = 'height';
    const X = 'x';
    const Y = 'y';
    const FULL_CIRCLE_ANGLE = 360;
    const TRANSPARENT = 'transparent';
    const START$1 = 'start';
    const END$1 = 'end';
    const Markers = {
        none: 'none',
        arrowStart: 'ArrowStart',
        filledCircle: 'FilledCircle',
        arrowEnd: 'ArrowEnd'
    };
    const DEG_TO_RAD = Math.PI / 180;
    const EPSILON = 1e-06;
    const CHANGE$1 = 'change';
    const Cursors = {
        arrow: 'default',
        grip: 'pointer',
        cross: 'pointer',
        add: 'pointer',
        move: 'move',
        select: 'pointer',
        south: 's-resize',
        east: 'e-resize',
        west: 'w-resize',
        north: 'n-resize',
        rowresize: 'row-resize',
        colresize: 'col-resize'
    };
    const HIT_TEST_DISTANCE = 10, AUTO = 'Auto', TOP = 'Top', RIGHT = 'Right', LEFT = 'Left', BOTTOM = 'Bottom', DEFAULT_SNAP_SIZE = 10, DEFAULT_SNAP_ANGLE = 10, DRAG_START = 'dragStart', DRAG = 'drag', DRAG_END = 'dragEnd', ITEMROTATE = 'itemRotate', ITEMBOUNDSCHANGE = 'itemBoundsChange', MIN_SNAP_SIZE = 5, MIN_SNAP_ANGLE = 5, MOUSE_ENTER = 'mouseEnter', MOUSE_LEAVE = 'mouseLeave', ZOOM_START = 'zoomStart', ZOOM_END = 'zoomEnd', SCROLL_MIN = -20000, SCROLL_MAX = 20000, FRICTION$1 = 0.90, FRICTION_MOBILE = 0.93, VELOCITY_MULTIPLIER$1 = 5, PAN = 'pan', ROTATED = 'rotated', SOURCE = 'source', TARGET = 'target', HANDLE_NAMES = {
        '-1': SOURCE,
        '1': TARGET
    };
    const ConnectionEditing = 'Connection Editing';
    const NS = '.kendoDiagram', CASCADING = 'cascading', CLICK = 'click', ERROR = 'error', MAXINT = 9007199254740992, SELECT$1 = 'select', NONE = 'none', DEFAULT_CANVAS_WIDTH = 600, DEFAULT_CANVAS_HEIGHT = 600, DEFAULT_SHAPE_TYPE = 'rectangle', DEFAULT_SHAPE_WIDTH = 100, DEFAULT_SHAPE_HEIGHT = 100, DEFAULT_SHAPE_MINWIDTH = 20, DEFAULT_SHAPE_MINHEIGHT = 20, DEFAULT_SHAPE_POSITION = 0, DEFAULT_CONNECTION_BACKGROUND = 'Yellow', MAX_VALUE = Number.MAX_VALUE, MIN_VALUE = -Number.MAX_VALUE, ABSOLUTE = 'absolute', TRANSFORMED = 'transformed', MOUSEWHEEL_NS = 'DOMMouseScroll' + NS + ' mousewheel' + NS, MOBILE_ZOOM_RATE = 0.05, MOBILE_PAN_DISTANCE = 5, CONNECTION_CONTENT_OFFSET = 5;

    const isNearZero = (value) => Math.abs(value) < EPSILON;
    const isDefined = (obj) => typeof obj !== 'undefined';
    const defined = isDefined;
    const isFunction$1 = (obj) => typeof obj === 'function';
    const isUndefined = (obj) => typeof obj === 'undefined' || obj === null;
    /**
     * Returns whether the given object is an object or a value.
     */
    const isObject = (obj) => obj === Object(obj);
    /**
     * Returns whether the object has a property with the given name.
     */
    const has = (obj, key) => Object.hasOwnProperty.call(obj, key);
    /**
     * Returns whether the given object is a string.
     */
    const isString$1 = (obj) => {
        return Object.prototype.toString.call(obj) === '[object String]';
    };
    const isBoolean = (obj) => {
        return Object.prototype.toString.call(obj) === '[object Boolean]';
    };
    const isType = (obj, type) => {
        return Object.prototype.toString.call(obj) === '[object ' + type + ']';
    };
    /**
     * Returns whether the given object is a number.
     */
    const isNumber = (obj) => !isNaN(parseFloat(obj)) && isFinite(obj);
    /**
     * Return whether the given object (array or dictionary).
     */
    const isEmpty = (obj) => {
        if (obj === null) {
            return true;
        }
        if (Array.isArray(obj) || isString$1(obj)) {
            return obj.length === 0;
        }
        for (const key in obj) {
            if (has(obj, key)) {
                return false;
            }
        }
        return true;
    };
    const simpleExtend = (destination, source) => {
        if (!isObject(source)) {
            return;
        }
        for (const name in source) {
            if (name) {
                destination[name] = source[name];
            }
        }
    };
    /**
     * Returns an array of the specified size and with each entry set to the given value.
     *
     * @param size
     * @param value
     * @returns {Array}
     */
    const initArray = (size, value) => {
        const array = [];
        for (let i = 0; i < size; ++i) {
            array[i] = value;
        }
        return array;
    };
    const serializePoints = (points) => {
        const res = [];
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            res.push(p.x + ';' + p.y);
        }
        return res.join(';');
    };
    const deserializePoints = (s) => {
        const v = s.split(';');
        const points = [];
        if (v.length % 2 !== 0) {
            throw new Error('Not an array of points.');
        }
        for (let i = 0; i < v.length; i += 2) {
            points.push({
                x: parseInt(v[i], 10),
                y: parseInt(v[i + 1], 10)
            });
        }
        return points;
    };
    /**
     * Returns an integer within the given bounds.
     *
     * @param lower The inclusive lower bound.
     * @param upper The exclusive upper bound.
     * @returns {number}
     */
    const randomInteger = (lower, upper) => {
        const random = Math.floor(Math.random() * upper) + lower;
        return parseInt(random.toString(), 10);
    };
    /*
     Depth-first traversal of the given node.
     */
    const DFT = (el, func) => {
        func(el);
        if (el.childNodes) {
            for (let i = 0; i < el.childNodes.length; i++) {
                const item = el.childNodes[i];
                DFT(item, func);
            }
        }
    };
    /*
     Returns the angle in degrees for the given matrix
     */
    const getMatrixAngle = (m) => {
        if (m === null || m.d === 0) {
            return 0;
        }
        return Math.atan2(m.b, m.d) * 180 / Math.PI;
    };
    /*
     Returns the scaling factors for the given matrix.
     */
    const getMatrixScaling = (m) => {
        const sX = Math.sqrt(m.a * m.a + m.c * m.c);
        const sY = Math.sqrt(m.b * m.b + m.d * m.d);
        return [sX, sY];
    };
    const findRadian = (start, end) => {
        if (start === end) {
            return 0;
        }
        const sngXComp = end.x - start.x;
        const sngYComp = start.y - end.y;
        const atan = Math.atan(sngXComp / sngYComp);
        if (sngYComp >= 0) {
            return sngXComp < 0 ? atan + (2 * Math.PI) : atan;
        }
        return atan + Math.PI;
    };
    const sign = (num) => {
        return num ? num < 0 ? -1 : 1 : 0;
    };
    const findAngle = (center, end) => {
        return findRadian(center, end) * 180 / Math.PI;
    };
    const forEach = (arr, iterator, thisRef) => {
        for (let i = 0; i < arr.length; i++) {
            iterator.call(thisRef, arr[i], i, arr);
        }
    };
    const getAny = (arr, predicate) => {
        for (let i = 0; i < arr.length; ++i) {
            if (predicate(arr[i])) {
                return arr[i];
            }
        }
        return null;
    };
    const remove = (arr, what) => {
        let ax = arr.indexOf(what);
        while (ax !== -1) {
            arr.splice(ax, 1);
            ax = arr.indexOf(what);
        }
        return arr;
    };
    const contains = (arr, obj) => {
        return (arr || []).includes(obj);
    };
    const indexOf = (arr, what) => {
        return arr.indexOf(what);
    };
    const inArray = (what, arr) => {
        return arr.indexOf(what);
    };
    const grep$1 = (arr, predicate) => arr.filter(predicate);
    const fold = (list, iterator, acc, context) => {
        let initial = acc !== undefined;
        for (let i = 0; i < list.length; i++) {
            const value = list[i];
            if (!initial) {
                acc = value;
                initial = true;
            }
            else {
                acc = iterator.call(context, acc, value, i, list);
            }
        }
        if (!initial) {
            throw new Error('Reduce of empty array with no initial value');
        }
        return acc;
    };
    const find = (arr, iterator, context) => {
        return arr.find(iterator.bind(context)) || undefined;
    };
    const first = (arr, constraint, context) => {
        if (arr.length === 0) {
            return null;
        }
        if (isUndefined(constraint)) {
            return arr[0];
        }
        return find(arr, constraint, context);
    };
    /**
     * Inserts the given element at the specified position and returns the result.
     */
    const insert = (arr, element, position) => {
        arr.splice(position, 0, element);
        return arr;
    };
    const all = (arr, iterator, context) => {
        let result = true;
        let value;
        for (let i = 0; i < arr.length; i++) {
            value = arr[i];
            result = result && iterator.call(context, value, i, arr);
            if (!result) {
                break;
            }
        }
        return result;
    };
    const clear = (arr) => {
        arr.splice(0, arr.length);
    };
    const bisort = (a, b, sortfunc) => {
        if (isUndefined(a)) {
            throw new Error('First array is not specified.');
        }
        if (isUndefined(b)) {
            throw new Error('Second array is not specified.');
        }
        if (a.length !== b.length) {
            throw new Error('The two arrays should have equal length');
        }
        const points = [];
        for (let i = 0; i < a.length; i++) {
            points.push({ x: a[i], y: b[i] });
        }
        if (isUndefined(sortfunc)) {
            points.sort((m, n) => m.x - n.x);
        }
        else {
            points.sort((m, n) => sortfunc(m.x, n.x));
        }
        clear(a);
        clear(b);
        for (let i = 0; i < points.length; i++) {
            a.push(points[i].x);
            b.push(points[i].y);
        }
    };
    const addRange = (arr, range) => {
        arr.push(...range);
    };
    const noop$1 = () => { };

    const STRING = 'string';
    const FUNCTION = 'function';
    const preventDefault$2 = function () {
        this._defaultPrevented = true;
    };
    const isDefaultPrevented = function () {
        return this._defaultPrevented === true;
    };
    class Observable {
        constructor() {
            this.options = {};
            this.events = [];
            this._events = {};
        }
        destroy() {
            this.unbind();
        }
        bind(event, handlers, one) {
            if (!handlers && isObject(event) && !Array.isArray(event)) {
                for (const name in event) {
                    if (event[name]) {
                        this.bind(name, event[name]);
                    }
                }
                return this;
            }
            const eventNames = typeof event === STRING ? [event] : event, handlersIsFunction = typeof handlers === FUNCTION;
            let original, handler;
            for (let idx = 0, length = eventNames.length; idx < length; idx++) {
                const eventName = eventNames[idx];
                handler = handlersIsFunction ? handlers : handlers[eventName];
                if (handler) {
                    if (one) {
                        original = handler;
                        handler = (...args) => {
                            this.unbind(eventName, handler);
                            original.apply(this, args);
                        };
                        handler.original = original;
                    }
                    this._events[eventName] = this._events[eventName] || [];
                    this._events[eventName].push(handler);
                }
            }
            return this;
        }
        one(eventNames, handlers) {
            return this.bind(eventNames, handlers, true);
        }
        first(eventName, handlers) {
            const eventNames = typeof eventName === STRING ? [String(eventName)] : Array.from(eventName), handlersIsFunction = typeof handlers === FUNCTION;
            let handler;
            for (let idx = 0, length = eventNames.length; idx < length; idx++) {
                const curName = eventNames[idx];
                handler = handlersIsFunction ? handlers : handlers[curName];
                if (handler) {
                    this._events[curName] = this._events[curName] || [];
                    this._events[curName].unshift(handler);
                }
            }
            return this;
        }
        trigger(eventName, eventArgs) {
            let events = this._events[eventName];
            if (events) {
                const e = eventArgs || {};
                e.sender = this;
                e._defaultPrevented = false;
                e.preventDefault = preventDefault$2;
                e.isDefaultPrevented = isDefaultPrevented;
                events = events.slice();
                for (let idx = 0, length = events.length; idx < length; idx++) {
                    events[idx].call(this, e);
                }
                return e._defaultPrevented === true;
            }
            return false;
        }
        unbind(eventName, handler) {
            const events = this._events[eventName];
            if (eventName === undefined) {
                this._events = {};
            }
            else if (events) {
                if (handler) {
                    for (let idx = events.length - 1; idx >= 0; idx--) {
                        if (events[idx] === handler || events[idx].original === handler) {
                            events.splice(idx, 1);
                        }
                    }
                }
                else {
                    this._events[eventName] = [];
                }
            }
            return this;
        }
        _setEvents(options) {
            const length = (this.events || []).length;
            for (let idx = 0; idx < length; idx++) {
                const name = this.events[idx];
                if (this.options[name] && options[name]) {
                    this.unbind(name, this.options[name]);
                    if (this._events && this._events[name]) {
                        delete this._events[name];
                    }
                }
            }
            this.bind(this.events, options);
        }
    }

    var Utils$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        DFT: DFT,
        Observable: Observable,
        addRange: addRange,
        all: all,
        bisort: bisort,
        clear: clear,
        contains: contains,
        defined: defined,
        deserializePoints: deserializePoints,
        find: find,
        findAngle: findAngle,
        findRadian: findRadian,
        first: first,
        fold: fold,
        forEach: forEach,
        getAny: getAny,
        getMatrixAngle: getMatrixAngle,
        getMatrixScaling: getMatrixScaling,
        grep: grep$1,
        has: has,
        inArray: inArray,
        indexOf: indexOf,
        initArray: initArray,
        insert: insert,
        isBoolean: isBoolean,
        isDefined: isDefined,
        isEmpty: isEmpty,
        isFunction: isFunction$1,
        isNearZero: isNearZero,
        isNumber: isNumber,
        isObject: isObject,
        isString: isString$1,
        isType: isType,
        isUndefined: isUndefined,
        noop: noop$1,
        randomInteger: randomInteger,
        remove: remove,
        serializePoints: serializePoints,
        sign: sign,
        simpleExtend: simpleExtend
    });

    /**
     * The Range defines an array of equally separated numbers.
     *
     * @param start The start-value of the Range.
     * @param stop The end-value of the Range.
     * @param step The separation between the values (default:1).
     * @returns {Array}
     */
    function Range(start, stop, step) {
        if (typeof start == 'undefined' || typeof stop == 'undefined') {
            return [];
        }
        if (step && sign(stop - start) !== sign(step)) {
            throw new Error('The sign of the increment should allow to reach the stop-value.');
        }
        step = step || 1;
        start = start || 0;
        stop = stop || start;
        if ((stop - start) / step === Infinity) {
            throw new Error('Infinite range defined.');
        }
        const range = [];
        let i = -1, j;
        function rangeIntegerScale(x) {
            let curK = 1;
            while (x * curK % 1) {
                curK *= 10;
            }
            return curK;
        }
        const k = rangeIntegerScale(Math.abs(step));
        start *= k;
        stop *= k;
        step *= k;
        if (start > stop && step > 0) {
            step = -step;
        }
        if (step < 0) {
            while ((j = start + step * ++i) >= stop) {
                range.push(j / k);
            }
        }
        else {
            while ((j = start + step * ++i) <= stop) {
                range.push(j / k);
            }
        }
        return range;
    }
    ;

    const Easing = {
        easeInOut(pos) {
            return ((-Math.cos(pos * Math.PI) / 2) + 0.5);
        }
    };
    /**
     * An animation ticker driving an adapter which sets a particular
     * property in function of the tick.
     *
     * @type {*}
     */
    class Ticker {
        constructor() {
            this.adapters = [];
            this.target = 0;
            this.tick = 0;
            this.interval = 20;
            this.duration = 800;
            this.lastTime = null;
            this.handlers = [];
            this.timerDelegate = () => { };
            this.intervalId = null;
            this.caller = null;
            this.timerDelegate = () => {
                this.onTimerEvent();
            };
        }
        ;
        addAdapter(a) {
            this.adapters.push(a);
        }
        ;
        onComplete(handler) {
            this.handlers.push(handler);
        }
        ;
        removeHandler(handler) {
            this.handlers = this.handlers.filter((h) => {
                return h !== handler;
            });
        }
        ;
        trigger() {
            if (this.handlers) {
                forEach(this.handlers, (h) => {
                    return h.call(this.caller !== null ? this.caller : this);
                });
            }
        }
        ;
        onStep() {
        }
        ;
        seekTo(to) {
            this.seekFromTo(this.tick, to);
        }
        ;
        seekFromTo(from, to) {
            this.target = Math.max(0, Math.min(1, to));
            this.tick = Math.max(0, Math.min(1, from));
            this.lastTime = new Date().getTime();
            if (!this.intervalId) {
                this.intervalId = window.setInterval(this.timerDelegate, this.interval);
            }
        }
        ;
        stop() {
            if (this.intervalId) {
                window.clearInterval(this.intervalId);
                this.intervalId = null;
                // this.trigger.call(this);
                this.trigger();
                // this.next();
            }
        }
        ;
        play(origin) {
            if (this.adapters.length === 0) {
                return;
            }
            if (origin !== null) {
                this.caller = origin;
            }
            this.initState();
            this.seekFromTo(0, 1);
        }
        ;
        reverse() {
            this.seekFromTo(1, 0);
        }
        ;
        initState() {
            if (this.adapters.length === 0) {
                return;
            }
            for (let i = 0; i < this.adapters.length; i++) {
                this.adapters[i].initState();
            }
        }
        ;
        propagate() {
            const value = Easing.easeInOut(this.tick);
            for (let i = 0; i < this.adapters.length; i++) {
                this.adapters[i].update(value);
            }
        }
        ;
        onTimerEvent() {
            const now = new Date().getTime();
            const timePassed = now - this.lastTime;
            this.lastTime = now;
            const movement = (timePassed / this.duration) * (this.tick < this.target ? 1 : -1);
            if (Math.abs(movement) >= Math.abs(this.tick - this.target)) {
                this.tick = this.target;
            }
            else {
                this.tick += movement;
            }
            try {
                this.propagate();
            }
            finally {
                this.onStep.call(this);
                if (this.target === this.tick) {
                    this.stop();
                }
            }
        }
    }

    /**
     * Returns a random identifier which can be used as an ID of objects, eventually augmented with a prefix.
     *
     * @returns {string}
     */
    function randomId(length) {
        if (isUndefined(length)) {
            length = 10;
        }
        // old version return Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1);
        let result = '';
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = length; i > 0; --i) {
            result += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
        }
        return result;
    }

    /**
     * Represents a collection of key-value pairs that are organized based on the hash code of the key.
     * _buckets[hashId] = {key: key, value:...}
     * Important: do not use the standard Array access method, use the get/set methods instead.
     * See http://en.wikipedia.org/wiki/Hash_table
     */
    class HashTable {
        constructor() {
            this._buckets = {};
            this.length = 0;
        }
        /**
         * Adds the literal object with the given key (of the form {key: key,....}).
         */
        add(key, value) {
            const obj = this._createGetBucket(key);
            if (isDefined(value)) {
                obj.value = value;
            }
            return obj;
        }
        /**
         * Gets the literal object with the given key.
         */
        get(key) {
            if (this._bucketExists(key)) {
                return this._createGetBucket(key);
            }
            return null;
        }
        /**
         * Set the key-value pair.
         *
         * @param key The key of the entry.
         * @param value The value to set. If the key already exists the value will be overwritten.
         */
        set(key, value) {
            this.add(key, value);
        }
        /**
         * Determines whether the HashTable contains a specific key.
         */
        containsKey(key) {
            return this._bucketExists(key);
        }
        /**
         * Removes the element with the specified key from the hashtable.
         * Returns the removed bucket.
         */
        remove(key) {
            if (this._bucketExists(key)) {
                const hashId = this._hash(key);
                delete this._buckets[hashId];
                this.length--;
                return key;
            }
        }
        /**
         * Foreach with an iterator working on the key-value pairs.
         *
         * @param func
         */
        forEach(func) {
            const hashes = this._hashes();
            for (let i = 0, len = hashes.length; i < len; i++) {
                const hash = hashes[i];
                const bucket = this._buckets[hash];
                if (isUndefined(bucket)) {
                    continue;
                }
                func(bucket);
            }
        }
        /**
         * Returns a (shallow) clone of the current HashTable.
         *
         * @returns {HashTable}
         */
        clone() {
            const ht = new HashTable();
            const hashes = this._hashes();
            for (let i = 0, len = hashes.length; i < len; i++) {
                const hash = hashes[i];
                const bucket = this._buckets[hash];
                if (isUndefined(bucket)) {
                    continue;
                }
                ht.add(bucket.key, bucket.value);
            }
            return ht;
        }
        /**
         * Returns the hashes of the buckets.
         *
         * @returns {Array}
         * @private
         */
        _hashes() {
            const hashes = [];
            for (const hash in this._buckets) {
                if (Object.prototype.hasOwnProperty.call(this._buckets, hash)) {
                    hashes.push(hash);
                }
            }
            return hashes;
        }
        _bucketExists(key) {
            const hashId = this._hash(key);
            return isDefined(this._buckets[hashId]);
        }
        /**
         * Returns-adds the createGetBucket with the given key. If not present it will
         * be created and returned.
         * A createGetBucket is a literal object of the form {key: key, ...}.
         */
        _createGetBucket(key) {
            const hashId = this._hash(key);
            let bucket = this._buckets[hashId];
            if (isUndefined(bucket)) {
                bucket = { key: key };
                this._buckets[hashId] = bucket;
                this.length++;
            }
            return bucket;
        }
        /**
         * Hashing of the given key.
         */
        _hash(key) {
            if (isNumber(key)) {
                return key;
            }
            if (isString$1(key)) {
                return this._hashString(key);
            }
            if (isObject(key)) {
                return this._objectHashId(key);
            }
            console.log(key);
            throw new Error('Unsupported key type.');
        }
        /**
         * Hashing of a string.
         */
        _hashString(s) {
            // see for example http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
            let result = 0;
            if (s.length === 0) {
                return result;
            }
            for (let i = 0; i < s.length; i++) {
                const ch = s.charCodeAt(i);
                result = ((result * 32) - result) + ch;
            }
            return result;
        }
        /**
         * Returns the unique identifier for an object. This is automatically assigned and add on the object.
         */
        _objectHashId(key) {
            let id = key._hashId;
            if (isUndefined(id)) {
                id = randomId();
                key._hashId = id;
            }
            return id;
        }
    }

    /**
     * Represents a collection of key-value pairs.
     * Important: do not use the standard Array access method, use the get/Set methods instead.
     */
    class Dictionary extends Observable {
        /**
         * Initializes a new instance of the Dictionary class.
         *
         * @param dictionary Loads the content of the given dictionary into this new one.
         */
        constructor(dictionary) {
            super();
            this._hashTable = new HashTable();
            this.length = 0;
            if (isDefined(dictionary)) {
                if (Array.isArray(dictionary)) {
                    for (let i = 0; i < dictionary.length; i++) {
                        this.add(dictionary[i]);
                    }
                }
                else {
                    dictionary.forEach(function (k, v) {
                        this.add(k, v);
                    }, this);
                }
            }
        }
        /**
         * Adds a key-value to the dictionary.
         * If the key already exists this will assign the given value to the existing entry.
         */
        add(key, value) {
            let entry = this._hashTable.get(key);
            if (!entry) {
                entry = this._hashTable.add(key);
                this.length++;
                this.trigger('changed');
            }
            entry.value = value;
        }
        /**
         * Set the key-value pair.
         *
         * @param key The key of the entry.
         * @param value The value to set. If the key already exists the value will be overwritten.
         */
        set(key, value) {
            this.add(key, value);
        }
        /**
         * Gets the value associated with the given key in the dictionary.
         */
        get(key) {
            const entry = this._hashTable.get(key);
            if (entry) {
                return entry.value;
            }
            throw new Error('Cannot find key ' + key);
        }
        /**
         * Returns whether the dictionary contains the given key.
         */
        containsKey(key) {
            return this._hashTable.containsKey(key);
        }
        /**
         * Removes the element with the specified key from the dictionary.
         */
        remove(key) {
            if (this.containsKey(key)) {
                this.trigger('changed');
                this.length--;
                return this._hashTable.remove(key);
            }
        }
        /**
         * The functional gets the key and value as parameters.
         */
        forEach(func, thisRef) {
            this._hashTable.forEach(function (entry) {
                func.call(thisRef, entry.key, entry.value);
            });
        }
        /**
         * Same as forEach except that only the value is passed to the functional.
         */
        forEachValue(func, thisRef) {
            this._hashTable.forEach(function (entry) {
                func.call(thisRef, entry.value);
            });
        }
        /**
         * Calls a defined callback function for each key in the dictionary.
         */
        forEachKey(func, thisRef) {
            this._hashTable.forEach(function (entry) {
                func.call(thisRef, entry.key);
            });
        }
        /**
         * Gets an array with all keys in the dictionary.
         */
        keys() {
            const keys = [];
            this.forEachKey(function (key) {
                keys.push(key);
            });
            return keys;
        }
    }

    const Geometry = {
        /**
         * Returns the squared distance to the line defined by the two given Points.
         *
         * @param p An arbitrary Point.
         * @param a An endpoint of the line or segment.
         * @param b The complementary endpoint of the line or segment.
         */
        _distanceToLineSquared: function (p, a, b) {
            function d2(pt1, pt2) {
                return (pt1.x - pt2.x) * (pt1.x - pt2.x) + (pt1.y - pt2.y) * (pt1.y - pt2.y);
            }
            if (a === b) { // returns the distance of p to a
                return d2(p, a);
            }
            const vx = b.x - a.x, vy = b.y - a.y;
            let dot = (p.x - a.x) * vx + (p.y - a.y) * vy;
            if (dot < 0) {
                return d2(a, p); // sits on side of a
            }
            dot = (b.x - p.x) * vx + (b.y - p.y) * vy;
            if (dot < 0) {
                return d2(b, p); // sits on side of b
            }
            // regular case, use crossproduct to get the sine out
            dot = (b.x - p.x) * vy - (b.y - p.y) * vx;
            return dot * dot / (vx * vx + vy * vy);
        },
        /**
         * Returns the distance to the line defined by the two given Points.
         *
         * @param p An arbitrary Point.
         * @param a An endpoint of the line or segment.
         * @param b The complementary endpoint of the line or segment.
         */
        distanceToLine: function (p, a, b) {
            return Math.sqrt(this._distanceToLineSquared(p, a, b));
        },
        /**
         * Returns the distance of the given points to the polyline defined by the points.
         *
         * @param p An arbitrary point.
         * @param points The points defining the polyline.
         * @returns {Number}
         */
        distanceToPolyline: function (p, points) {
            let minimum = Number.MAX_VALUE;
            if (isUndefined(points) || points.length === 0) {
                return Number.MAX_VALUE;
            }
            for (let s = 0; s < points.length - 1; s++) {
                const p1 = points[s];
                const p2 = points[s + 1];
                const d = this._distanceToLineSquared(p, p1, p2);
                if (d < minimum) {
                    minimum = d;
                }
            }
            return Math.sqrt(minimum);
        }
    };

    class Polar {
        constructor(r, a) {
            this.r = r;
            this.angle = a;
        }
    }

    const HITTESTAREA = 3;
    class Point extends kendo_drawing_cmn_chunk_js.P {
        constructor(x, y) {
            super(x, y);
        }
        clone() {
            return new Point(this.x, this.y);
        }
        plus(p) {
            return new Point(this.x + p.x, this.y + p.y);
        }
        minus(p) {
            return new Point(this.x - p.x, this.y - p.y);
        }
        offset(value) {
            return new Point(this.x - value, this.y - value);
        }
        times(s) {
            return new Point(this.x * s, this.y * s);
        }
        normalize() {
            if (this.length() === 0) {
                return new Point();
            }
            return this.times(1 / this.length());
        }
        length() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        }
        toString() {
            return '(' + this.x + ',' + this.y + ')';
        }
        lengthSquared() {
            return (this.x * this.x + this.y * this.y);
        }
        middleOf(p, q) {
            return new Point(q.x - p.x, q.y - p.y).times(0.5).plus(p);
        }
        toPolar(useDegrees) {
            let factor = 1;
            if (useDegrees) {
                factor = 180 / Math.PI;
            }
            const a = Math.atan2(Math.abs(this.y), Math.abs(this.x));
            const halfpi = Math.PI / 2;
            const len = this.length();
            if (this.x === 0) {
                // note that the angle goes down and not the usual mathematical convention
                if (this.y === 0) {
                    return new Polar(0, 0);
                }
                if (this.y > 0) {
                    return new Polar(len, factor * halfpi);
                }
                if (this.y < 0) {
                    return new Polar(len, factor * 3 * halfpi);
                }
            }
            else if (this.x > 0) {
                if (this.y === 0) {
                    return new Polar(len, 0);
                }
                if (this.y > 0) {
                    return new Polar(len, factor * a);
                }
                if (this.y < 0) {
                    return new Polar(len, factor * (4 * halfpi - a));
                }
            }
            else {
                if (this.y === 0) {
                    return new Polar(len, 2 * halfpi);
                }
                if (this.y > 0) {
                    return new Polar(len, factor * (2 * halfpi - a));
                }
                if (this.y < 0) {
                    return new Polar(len, factor * (2 * halfpi + a));
                }
            }
        }
        isOnLine(from, to) {
            if (from.x > to.x) { // from must be the leftmost point
                const temp = to;
                to = from;
                from = temp;
            }
            const r1 = new Rect(from.x, from.y).inflate(HITTESTAREA, HITTESTAREA), r2 = new Rect(to.x, to.y).inflate(HITTESTAREA, HITTESTAREA);
            let o1, u1;
            if (r1.union(r2).contains(this)) {
                if (from.x === to.x || from.y === to.y) {
                    return true;
                }
                else if (from.y < to.y) {
                    o1 = r1.x + (((r2.x - r1.x) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - r1.y)) / (r2.y - r1.y));
                }
                else {
                    o1 = r1.x + (((r2.x - r1.x) * (this.y - r1.y)) / (r2.y - r1.y));
                    u1 = (r1.x + r1.width) + ((((r2.x + r2.width) - (r1.x + r1.width)) * (this.y - (r1.y + r1.height))) / ((r2.y + r2.height) - (r1.y + r1.height)));
                }
                return (this.x > o1 && this.x < u1);
            }
            return false;
        }
        parse(str) {
            const tempStr = str.slice(1, str.length - 1), xy = tempStr.split(','), x = parseInt(xy[0], 10), y = parseInt(xy[1], 10);
            if (!isNaN(x) && !isNaN(y)) {
                return new Point(x, y);
            }
        }
    }
    class Rect {
        constructor(x, y, width, height) {
            this.x = x || 0;
            this.y = y || 0;
            this.width = width || 0;
            this.height = height || 0;
        }
        contains(point) {
            return ((point.x >= this.x) && (point.x <= (this.x + this.width)) && (point.y >= this.y) && (point.y <= (this.y + this.height)));
        }
        inflate(dx, dy) {
            if (dy === undefined) {
                dy = dx;
            }
            this.x -= dx;
            this.y -= dy;
            this.width += 2 * dx + 1;
            this.height += 2 * dy + 1;
            return this;
        }
        offset(dx, dy) {
            let x = dx, y = dy;
            if (dx instanceof Point) {
                x = dx.x;
                y = dx.y;
            }
            this.x += x;
            this.y += y;
            return this;
        }
        union(r) {
            const x1 = Math.min(this.x, r.x);
            const y1 = Math.min(this.y, r.y);
            const x2 = Math.max((this.x + this.width), (r.x + r.width));
            const y2 = Math.max((this.y + this.height), (r.y + r.height));
            return new Rect(x1, y1, x2 - x1, y2 - y1);
        }
        center() {
            return new Point(this.x + this.width / 2, this.y + this.height / 2);
        }
        top() {
            return new Point(this.x + this.width / 2, this.y);
        }
        right() {
            return new Point(this.x + this.width, this.y + this.height / 2);
        }
        bottom() {
            return new Point(this.x + this.width / 2, this.y + this.height);
        }
        left() {
            return new Point(this.x, this.y + this.height / 2);
        }
        topLeft() {
            return new Point(this.x, this.y);
        }
        topRight() {
            return new Point(this.x + this.width, this.y);
        }
        bottomLeft() {
            return new Point(this.x, this.y + this.height);
        }
        bottomRight() {
            return new Point(this.x + this.width, this.y + this.height);
        }
        clone() {
            return new Rect(this.x, this.y, this.width, this.height);
        }
        isEmpty() {
            return !this.width && !this.height;
        }
        equals(rect) {
            return this.x === rect.x && this.y === rect.y && this.width === rect.width && this.height === rect.height;
        }
        rotatedBounds(angle) {
            const rect = this.clone(), points = this.rotatedPoints(angle), tl = points[0], tr = points[1], br = points[2], bl = points[3];
            rect.x = Math.min(br.x, tl.x, tr.x, bl.x);
            rect.y = Math.min(br.y, tl.y, tr.y, bl.y);
            rect.width = Math.max(br.x, tl.x, tr.x, bl.x) - rect.x;
            rect.height = Math.max(br.y, tl.y, tr.y, bl.y) - rect.y;
            return rect;
        }
        rotatedPoints(angle) {
            const c = this.center(), br = this.bottomRight().rotate(angle, c), tl = this.topLeft().rotate(angle, c), tr = this.topRight().rotate(angle, c), bl = this.bottomLeft().rotate(angle, c);
            return [tl, tr, br, bl];
        }
        toString(delimiter) {
            delimiter = delimiter || ' ';
            return this.x + delimiter + this.y + delimiter + this.width + delimiter + this.height;
        }
        scale(scaleX, scaleY, staicPoint, adornerCenter, angle) {
            let tl = this.topLeft();
            const thisCenter = this.center();
            tl.rotate(angle, thisCenter).rotate(angle, adornerCenter);
            const delta = staicPoint.minus(tl);
            const scaled = new Point(delta.x * scaleX, delta.y * scaleY);
            const position = delta.minus(scaled);
            tl = tl.plus(position);
            tl.rotate(angle, adornerCenter).rotate(angle, thisCenter);
            this.x = tl.x;
            this.y = tl.y;
            this.width *= scaleX;
            this.height *= scaleY;
        }
        zoom(zoom) {
            this.x *= zoom;
            this.y *= zoom;
            this.width *= zoom;
            this.height *= zoom;
            return this;
        }
        overlaps(rect) {
            const bottomRight = this.bottomRight();
            const rectBottomRight = rect.bottomRight();
            const overlaps = !(bottomRight.x < rect.x || bottomRight.y < rect.y ||
                rectBottomRight.x < this.x || rectBottomRight.y < this.y);
            return overlaps;
        }
        static toRect(rect) {
            if (!(rect instanceof Rect)) {
                rect = new Rect(rect.x, rect.y, rect.width, rect.height);
            }
            return rect;
        }
        static empty() {
            return new Rect(0, 0, 0, 0);
        }
        static fromPoints(p, q) {
            if (isNaN(p.x) || isNaN(p.y) || isNaN(q.x) || isNaN(q.y)) {
                throw new Error('Some values are NaN.');
            }
            return new Rect(Math.min(p.x, q.x), Math.min(p.y, q.y), Math.abs(p.x - q.x), Math.abs(p.y - q.y));
        }
    }
    /**
     * Aligns two rectangles, where one is the container and the other is content.
     */
    class RectAlign {
        constructor(container) {
            this.container = Rect.toRect(container);
        }
        align(content, alignment) {
            const alignValues = alignment.toLowerCase().split(' ');
            for (let i = 0; i < alignValues.length; i++) {
                content = this._singleAlign(content, alignValues[i]);
            }
            return content;
        }
        _singleAlign(content, alignment) {
            if (isFunction$1(this[alignment])) {
                return this[alignment](content);
            }
            else {
                return content;
            }
        }
        left(content) {
            return this._align(content, this._left);
        }
        center(content) {
            return this._align(content, this._center);
        }
        right(content) {
            return this._align(content, this._right);
        }
        stretch(content) {
            return this._align(content, this._stretch);
        }
        top(content) {
            return this._align(content, this._top);
        }
        middle(content) {
            return this._align(content, this._middle);
        }
        bottom(content) {
            return this._align(content, this._bottom);
        }
        _left(container, content) {
            content.x = container.x;
        }
        _center(container, content) {
            content.x = ((container.width - content.width) / 2) || 0;
        }
        _right(container, content) {
            content.x = container.width - content.width;
        }
        _top(container, content) {
            content.y = container.y;
        }
        _middle(container, content) {
            content.y = ((container.height - content.height) / 2) || 0;
        }
        _bottom(container, content) {
            content.y = container.height - content.height;
        }
        _stretch(container, content) {
            content.x = 0;
            content.y = 0;
            content.height = container.height;
            content.width = container.width;
        }
        _align(content, alignCalc) {
            content = Rect.toRect(content);
            alignCalc(this.container, content);
            return content;
        }
    }

    class Queue {
        constructor() {
            this._tail = null;
            this._head = null;
            this.length = 0;
        }
        /**
         * Enqueues an object to the end of the queue.
         */
        enqueue(value) {
            const entry = { value: value, next: null };
            if (!this._head) {
                this._head = entry;
                this._tail = this._head;
            }
            else {
                this._tail.next = entry;
                this._tail = this._tail.next;
            }
            this.length++;
        }
        /**
         * Removes and returns the object at top of the queue.
         */
        dequeue() {
            if (this.length < 1) {
                throw new Error('The queue is empty.');
            }
            const value = this._head.value;
            this._head = this._head.next;
            this.length--;
            return value;
        }
        contains(item) {
            let current = this._head;
            while (current) {
                if (current.value === item) {
                    return true;
                }
                current = current.next;
            }
            return false;
        }
    }

    const OBJECT = 'object';
    const UNDEFINED = 'undefined';
    const isFunction = (obj) => typeof obj === 'function';
    function deepExtendOne(destination, source) {
        for (const property in source) {
            if (property === '__proto__' || property === 'constructor') {
                continue;
            }
            const propValue = source[property];
            const propType = typeof propValue;
            let propInit;
            if (propType === OBJECT && propValue !== null) {
                propInit = propValue.constructor;
            }
            else {
                propInit = null;
            }
            if (propInit && propInit !== Array) {
                if (propValue instanceof Date) {
                    destination[property] = new Date(propValue.getTime());
                }
                else if (isFunction(propValue.clone)) {
                    destination[property] = propValue.clone();
                }
                else {
                    const destProp = destination[property];
                    if (typeof (destProp) === OBJECT) {
                        destination[property] = destProp || {};
                    }
                    else {
                        destination[property] = {};
                    }
                    deepExtendOne(destination[property], propValue);
                }
            }
            else if (propType !== UNDEFINED) {
                destination[property] = propValue;
            }
        }
        return destination;
    }
    function deepExtend(destination, ...sources) {
        const length = sources.length;
        for (let i = 0; i < length; i++) {
            deepExtendOne(destination, sources[i]);
        }
        return destination;
    }

    const LayoutDefaultOptions = {
        type: 'Tree',
        subtype: 'Down',
        roots: null,
        animate: false,
        // -------------------------------------------------------------------
        /**
         * Force-directed option: whether the motion of the nodes should be limited by the boundaries of the diagram surface.
         */
        limitToView: false,
        /**
         * Force-directed option: the amount of friction applied to the motion of the nodes.
         */
        friction: 0.9,
        /**
         * Force-directed option: the optimal distance between nodes (minimum energy).
         */
        nodeDistance: 50,
        /**
         * Force-directed option: the number of time things are being calculated.
         */
        iterations: 300,
        // -------------------------------------------------------------------
        /**
         * Tree option: the separation in one direction (depends on the subtype what direction this is).
         */
        horizontalSeparation: 90,
        /**
         * Tree option: the separation in the complementary direction (depends on the subtype what direction this is).
         */
        verticalSeparation: 50,
        // -------------------------------------------------------------------
        /**
         * Tip-over tree option: children-to-parent vertical distance.
         */
        underneathVerticalTopOffset: 15,
        /**
         * Tip-over tree option: children-to-parent horizontal distance.
         */
        underneathHorizontalOffset: 15,
        /**
         * Tip-over tree option: leaf-to-next-branch vertical distance.
         */
        underneathVerticalSeparation: 15,
        // -------------------------------------------------------------------
        /**
         * Settings object to organize the different components of the diagram in a grid layout structure
         */
        grid: {
            /**
             * The width of the grid in which components are arranged. Beyond this width a component will be on the next row.
             */
            width: 1500,
            /**
             * The left offset of the grid.
             */
            offsetX: 50,
            /**
             * The top offset of the grid.
             */
            offsetY: 50,
            /**
             * The horizontal padding within a cell of the grid where a single component resides.
             */
            componentSpacingX: 20,
            /**
             * The vertical padding within a cell of the grid where a single component resides.
             */
            componentSpacingY: 20
        },
        // -------------------------------------------------------------------
        /**
         * Layered option: the separation height/width between the layers.
         */
        layerSeparation: 50,
        /**
         * Layered option: how many rounds of shifting and fine-tuning.
         */
        layeredIterations: 2,
        /**
         * Tree-radial option: the angle at which the layout starts.
         */
        startRadialAngle: 0,
        /**
         * Tree-radial option: the angle at which the layout starts.
         */
        endRadialAngle: 360,
        /**
         * Tree-radial option: the separation between levels.
         */
        radialSeparation: 150,
        /**
         * Tree-radial option: the separation between the root and the first level.
         */
        radialFirstLevelSeparation: 200,
        /**
         * Tree-radial option: whether a virtual roots bing the components in one radial layout.
         */
        keepComponentsInOneRadialLayout: false,
        // -------------------------------------------------------------------
        // TODO: ensure to change this to false when containers are around
        ignoreContainers: true,
        layoutContainerChildren: false,
        ignoreInvisible: true,
        animateTransitions: false
    };
    /**
     * Base class for layout algorithms.
     *
     * @type {*}
     */
    class LayoutBase {
        constructor() {
            this.defaultOptions = { ...LayoutDefaultOptions, grid: { ...LayoutDefaultOptions.grid } };
        }
        /**
         * Organizes the components in a grid.
         * Returns the final set of nodes (not the Graph).
         *
         * @param components
         */
        gridLayoutComponents(components) {
            if (!components) {
                throw new Error('No components supplied.');
            }
            // calculate and cache the bounds of the components
            forEach(components, function (c) {
                c.calcBounds();
            });
            // order by decreasing width
            components.sort(function (a, b) {
                return b.bounds.width - a.bounds.width;
            });
            const maxWidth = this.options.grid.width, offsetX = this.options.grid.componentSpacingX, offsetY = this.options.grid.componentSpacingY, startX = this.options.grid.offsetX, startY = this.options.grid.offsetY, resultLinkSet = [], resultNodeSet = [];
            let height = 0, x = startX, y = startY;
            while (components.length > 0) {
                if (x >= maxWidth) {
                    // start a new row
                    x = startX;
                    y += height + offsetY;
                    // reset the row height
                    height = 0;
                }
                const component = components.pop();
                this.moveToOffset(component, new Point(x, y));
                for (let i = 0; i < component.nodes.length; i++) {
                    resultNodeSet.push(component.nodes[i]); // to be returned in the end
                }
                for (let i = 0; i < component.links.length; i++) {
                    resultLinkSet.push(component.links[i]);
                }
                const boundingRect = component.bounds;
                let currentHeight = boundingRect.height;
                if (currentHeight <= 0 || isNaN(currentHeight)) {
                    currentHeight = 0;
                }
                let currentWidth = boundingRect.width;
                if (currentWidth <= 0 || isNaN(currentWidth)) {
                    currentWidth = 0;
                }
                if (currentHeight >= height) {
                    height = currentHeight;
                }
                x += currentWidth + offsetX;
            }
            return {
                nodes: resultNodeSet,
                links: resultLinkSet
            };
        }
        moveToOffset(component, p) {
            let i, j;
            const bounds = component.bounds, deltaX = p.x - bounds.x, deltaY = p.y - bounds.y;
            for (i = 0; i < component.nodes.length; i++) {
                const node = component.nodes[i];
                let nodeBounds = node.bounds();
                if (nodeBounds.width === 0 && nodeBounds.height === 0 && nodeBounds.x === 0 && nodeBounds.y === 0) {
                    nodeBounds = new Rect(0, 0, 0, 0);
                }
                nodeBounds.x += deltaX;
                nodeBounds.y += deltaY;
                node.bounds(nodeBounds);
            }
            for (i = 0; i < component.links.length; i++) {
                const link = component.links[i];
                if (link.points) {
                    const newPoints = [];
                    const points = link.points;
                    for (j = 0; j < points.length; j++) {
                        const pt = points[j];
                        pt.x += deltaX;
                        pt.y += deltaY;
                        newPoints.push(pt);
                    }
                    link.points = newPoints;
                }
            }
            this.currentHorizontalOffset += bounds.width + this.options.grid.offsetX;
            return new Point(deltaX, deltaY);
        }
        transferOptions(options) {
            // Size options lead to stackoverflow and need special handling
            this.options = deepExtend({}, this.defaultOptions);
            if (isUndefined(options)) {
                return;
            }
            this.options = deepExtend(this.options, options || {});
        }
    }

    /**
     * Captures the state of a diagram; node positions, link points and so on.
     *
     * @type {*}
     */
    class LayoutState {
        constructor(diagram, graphOrNodes) {
            if (isUndefined(diagram)) {
                throw new Error('No diagram given');
            }
            this.diagram = diagram;
            this.nodeMap = new Dictionary();
            this.linkMap = new Dictionary();
            this.capture(graphOrNodes ? graphOrNodes : diagram);
        }
        /**
         * Will capture either
         * - the state of the shapes and the intermediate points of the connections in the diagram
         * - the bounds of the nodes contained in the Graph together with the intermediate points of the links in the Graph
         * - the bounds of the nodes in the Array<Node>
         * - the links points and node bounds in the literal object
         *
         * @param diagramOrGraphOrNodes
         */
        capture(diagramOrGraphOrNodes) {
            let node, nodes, shape, i, conn, link, links;
            if (diagramOrGraphOrNodes && diagramOrGraphOrNodes.type === 'Graph') {
                for (i = 0; i < diagramOrGraphOrNodes.nodes.length; i++) {
                    node = diagramOrGraphOrNodes.nodes[i];
                    shape = node.associatedShape;
                    // shape.bounds(new Rect(node.x, node.y, node.width, node.height));
                    this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
                }
                for (i = 0; i < diagramOrGraphOrNodes.links.length; i++) {
                    link = diagramOrGraphOrNodes.links[i];
                    conn = link.associatedConnection;
                    this.linkMap.set(conn.visual.id, link.points());
                }
            }
            else if (diagramOrGraphOrNodes instanceof Array) {
                nodes = diagramOrGraphOrNodes;
                for (i = 0; i < nodes.length; i++) {
                    node = nodes[i];
                    shape = node.associatedShape;
                    if (shape) {
                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
                    }
                }
            }
            else if (Object.prototype.hasOwnProperty.call(diagramOrGraphOrNodes, 'links') && Object.prototype.hasOwnProperty.call(diagramOrGraphOrNodes, 'nodes')) {
                nodes = diagramOrGraphOrNodes.nodes;
                links = diagramOrGraphOrNodes.links;
                for (i = 0; i < nodes.length; i++) {
                    node = nodes[i];
                    shape = node.associatedShape;
                    if (shape) {
                        this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
                    }
                }
                for (i = 0; i < links.length; i++) {
                    link = links[i];
                    conn = link.associatedConnection;
                    if (conn) {
                        this.linkMap.set(conn.visual.id, link.points);
                    }
                }
            }
            else { // capture the diagram
                const shapes = this.diagram.shapes;
                const connections = this.diagram.connections;
                for (i = 0; i < shapes.length; i++) {
                    shape = shapes[i];
                    this.nodeMap.set(shape.visual.id, shape.bounds());
                }
                for (i = 0; i < connections.length; i++) {
                    conn = connections[i];
                    this.linkMap.set(conn.visual.id, conn.points());
                }
            }
        }
    }

    /**
     * Defines the node (vertex) of a Graph.
     */
    let Node$1 = class Node {
        constructor(id, shape) {
            /**
             * Holds all the links incident with the current node.
             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
             */
            this.links = [];
            /**
             * Holds the links from the current one to another Node .
             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
             */
            this.outgoing = [];
            /**
             * Holds the links from another Node to the current one.
             * Do not use this property to manage the incoming links, use the appropriate add/remove methods instead.
             */
            this.incoming = [];
            /**
             * Holds the weight of this Node.
             */
            this.weight = 1;
            /**
             * The payload of the node.
             *
             * @type {null}
             */
            this.data = null;
            this.type = 'Node';
            /**
             * Whether this is an injected node during the analysis or layout process.
             *
             * @type {boolean}
             */
            this.isVirtual = false;
            if (isDefined(id)) {
                this.id = id;
            }
            else {
                this.id = randomId();
            }
            if (isDefined(shape)) {
                this.associatedShape = shape;
                // transfer the shape's bounds to the runtime props
                const b = shape.bounds();
                this.width = b.width;
                this.height = b.height;
                this.x = b.x;
                this.y = b.y;
            }
            else {
                this.associatedShape = null;
            }
            this.shortForm = 'Node \'' + this.id + '\'';
        }
        /**
         * Returns whether this node has no links attached.
         */
        isIsolated() {
            return isEmpty(this.links);
        }
        /**
         * Gets or sets the bounding rectangle of this node.
         * This should be considered as runtime data, the property is not hotlinked to a SVG item.
         */
        bounds(r) {
            if (!isDefined(r)) {
                return new Rect(this.x, this.y, this.width, this.height);
            }
            this.x = r.x;
            this.y = r.y;
            this.width = r.width;
            this.height = r.height;
        }
        /**
         * Returns whether there is at least one link with the given (complementary) node. This can be either an
         * incoming or outgoing link.
         */
        isLinkedTo(node) {
            return getAny(this.links, (link) => {
                return link.getComplement(this) === node;
            });
        }
        /**
         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
         *
         * @returns {Array}
         */
        getChildren() {
            if (this.outgoing.length === 0) {
                return [];
            }
            const children = [];
            for (let i = 0, len = this.outgoing.length; i < len; i++) {
                const link = this.outgoing[i];
                children.push(link.getComplement(this));
            }
            return children;
        }
        /**
         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
         *
         * @returns {Array}
         */
        getParents() {
            if (this.incoming.length === 0) {
                return [];
            }
            const parents = [];
            for (let i = 0, len = this.incoming.length; i < len; i++) {
                const link = this.incoming[i];
                parents.push(link.getComplement(this));
            }
            return parents;
        }
        /**
         * Returns a clone of the Node. Note that the identifier is not cloned since it's a different Node instance.
         *
         * @returns {Node}
         */
        clone() {
            const copy = new Node();
            if (isDefined(this.weight)) {
                copy.weight = this.weight;
            }
            if (isDefined(this.balance)) {
                copy.balance = this.balance;
            }
            if (isDefined(this.owner)) {
                copy.owner = this.owner;
            }
            copy.associatedShape = this.associatedShape;
            copy.x = this.x;
            copy.y = this.y;
            copy.width = this.width;
            copy.height = this.height;
            return copy;
        }
        /**
         * Returns whether there is a link from the current node to the given node.
         */
        adjacentTo(node) {
            return this.isLinkedTo(node) !== null;
        }
        /**
         * Removes the given link from the link collection this node owns.
         *
         * @param link
         */
        removeLink(link) {
            if (link.source === this) {
                remove(this.links, link);
                remove(this.outgoing, link);
                link.source = null;
            }
            if (link.target === this) {
                remove(this.links, link);
                remove(this.incoming, link);
                link.target = null;
            }
        }
        /**
         * Returns whether there is a (outgoing) link from the current node to the given one.
         */
        hasLinkTo(node) {
            return getAny(this.outgoing, function (link) {
                return link.target === node;
            });
        }
        /**
         * Returns the degree of this node, i.e. the sum of incoming and outgoing links.
         */
        degree() {
            return this.links.length;
        }
        /**
         * Returns whether this node is either the source or the target of the given link.
         */
        incidentWith(link) {
            return contains(this.links, link);
        }
        /**
         * Returns the links between this node and the given one.
         */
        getLinksWith(node) {
            return all(this.links, function (link) {
                return link.getComplement(this) === node;
            }, this);
        }
        /**
         * Returns the nodes (either parent or child) which are linked to the current one.
         */
        getNeighbors() {
            const neighbors = [];
            forEach(this.incoming, function (e) {
                neighbors.push(e.getComplement(this));
            }, this);
            forEach(this.outgoing, function (e) {
                neighbors.push(e.getComplement(this));
            }, this);
            return neighbors;
        }
    };
    /**
     * Defines a directed link (edge, connection) of a Graph.
     */
    class Link {
        constructor(source, target, id, connection) {
            if (isUndefined(source)) {
                throw new Error('The source of the new link is not set.');
            }
            if (isUndefined(target)) {
                throw new Error('The target of the new link is not set.');
            }
            let sourceFound, targetFound;
            if (isString$1(source)) {
                sourceFound = new Node$1(source);
            }
            else {
                sourceFound = source;
            }
            if (isString$1(target)) {
                targetFound = new Node$1(target);
            }
            else {
                targetFound = target;
            }
            this.source = sourceFound;
            this.target = targetFound;
            this.source.links.push(this);
            this.target.links.push(this);
            this.source.outgoing.push(this);
            this.target.incoming.push(this);
            if (isDefined(id)) {
                this.id = id;
            }
            else {
                this.id = randomId();
            }
            if (isDefined(connection)) {
                this.associatedConnection = connection;
            }
            else {
                this.associatedConnection = null;
            }
            this.type = 'Link';
            this.shortForm = 'Link \'' + this.source.id + '->' + this.target.id + '\'';
        }
        /**
         * Returns the complementary node of the given one, if any.
         */
        getComplement(node) {
            if (this.source !== node && this.target !== node) {
                throw new Error('The given node is not incident with this link.');
            }
            return this.source === node ? this.target : this.source;
        }
        /**
         * Returns the overlap of the current link with the given one, if any.
         */
        getCommonNode(link) {
            if (this.source === link.source || this.source === link.target) {
                return this.source;
            }
            if (this.target === link.source || this.target === link.target) {
                return this.target;
            }
            return null;
        }
        /**
         * Returns whether the current link is bridging the given nodes.
         */
        isBridging(v1, v2) {
            return this.source === v1 && this.target === v2 || this.source === v2 && this.target === v1;
        }
        /**
         * Returns the source and target of this link as a tuple.
         */
        getNodes() {
            return [this.source, this.target];
        }
        /**
         * Returns whether the given node is either the source or the target of the current link.
         */
        incidentWith(node) {
            return this.source === node || this.target === node;
        }
        /**
         * Returns whether the given link is a continuation of the current one. This can be both
         * via an incoming or outgoing link.
         */
        adjacentTo(link) {
            return contains(this.source.links, link) || contains(this.target.links, link);
        }
        /**
         * Changes the source-node of this link.
         */
        changeSource(node) {
            remove(this.source.links, this);
            remove(this.source.outgoing, this);
            node.links.push(this);
            node.outgoing.push(this);
            this.source = node;
        }
        /**
         * Changes the target-node of this link.
         *
         * @param node
         */
        changeTarget(node) {
            remove(this.target.links, this);
            remove(this.target.incoming, this);
            node.links.push(this);
            node.incoming.push(this);
            this.target = node;
        }
        /**
         * Changes both the source and the target nodes of this link.
         */
        changesNodes(v, w) {
            if (this.source === v) {
                this.changeSource(w);
            }
            else if (this.target === v) {
                this.changeTarget(w);
            }
        }
        /**
         * Reverses the direction of this link.
         */
        reverse() {
            const oldSource = this.source;
            const oldTarget = this.target;
            this.source = oldTarget;
            remove(oldSource.outgoing, this);
            this.source.outgoing.push(this);
            this.target = oldSource;
            remove(oldTarget.incoming, this);
            this.target.incoming.push(this);
            return this;
        }
        /**
         * Ensures that the given target defines the endpoint of this link.
         */
        directTo(target) {
            if (this.source !== target && this.target !== target) {
                throw new Error('The given node is not incident with this link.');
            }
            if (this.target !== target) {
                this.reverse();
            }
        }
        /**
         * Returns a reversed clone of this link.
         */
        createReverseEdge() {
            const r = this.clone();
            r.reverse();
            r.reversed = true;
            return r;
        }
        /**
         * Returns a clone of this link.
         */
        clone() {
            const clone = new Link(this.source, this.target);
            return clone;
        }
    }
    /* --------------Graph structure---------------------------------*/
    /**
     * Defines a directed graph structure.
     * Note that the incidence structure resides in the nodes through the incoming and outgoing links collection, rahter than
     * inside the Graph.
     */
    class Graph {
        constructor(idOrDiagram) {
            /**
             * The links or edge collection of this Graph.
             *
             * @type {Array}
             */
            this.links = [];
            /**
             * The node or vertex collection of this Graph.
             *
             * @type {Array}
             */
            this.nodes = [];
            this._nodeMap = new Dictionary();
            /**
             * The optional reference to the Diagram on which this Graph is based.
             *
             * @type {null}
             */
            this.diagram = null;
            /**
             * The root of this Graph. If not set explicitly the first Node with zero incoming links will be taken.
             *
             * @type {null}
             * @private
             */
            this._root = null;
            /**
             * The bounds of this graph if the nodes have spatial extension defined.
             *
             * @type {Rect}
             */
            this.bounds = new Rect();
            // keeps track whether the children & parents have been created
            this._hasCachedRelationships = false;
            this.type = 'Graph';
            this.componentIndex = 0;
            if (isDefined(idOrDiagram)) {
                if (isString$1(idOrDiagram)) {
                    this.id = idOrDiagram;
                }
                else {
                    this.diagram = idOrDiagram;
                    this.id = idOrDiagram.id;
                }
            }
            else {
                this.id = randomId();
            }
        }
        /**
         * Caches the relational information of parents and children in the 'parents' and 'children'
         * properties.
         *
         * @param forceRebuild If set to true the relational info will be rebuild even if already present.
         */
        cacheRelationships(forceRebuild) {
            if (isUndefined(forceRebuild)) {
                forceRebuild = false;
            }
            if (this._hasCachedRelationships && !forceRebuild) {
                return;
            }
            for (let i = 0, len = this.nodes.length; i < len; i++) {
                const node = this.nodes[i];
                node.children = this.getChildren(node);
                node.parents = this.getParents(node);
            }
            this._hasCachedRelationships = true;
        }
        /**
         * Assigns tree-levels to the nodes assuming this is a tree graph.
         * If not connected or not a tree the process will succeed but
         * will have little meaning.
         *
         * @param startNode The node from where the level numbering starts, usually the root of the tree.
         * @param visited The collection of visited nodes.
         * @param offset The offset or starting counter of the level info.
         */
        assignLevels(startNode, offset, visited) {
            if (!startNode) {
                throw new Error('Start node not specified.');
            }
            if (isUndefined(offset)) {
                offset = 0;
            }
            // if not done before, cache the parents and children
            this.cacheRelationships();
            if (isUndefined(visited)) {
                visited = new Dictionary();
                forEach(this.nodes, function (n) {
                    visited.add(n, false);
                });
            }
            visited.set(startNode, true);
            startNode.level = offset;
            const children = startNode.children;
            for (let i = 0, len = children.length; i < len; i++) {
                const child = children[i];
                if (!child || visited.get(child)) {
                    continue;
                }
                this.assignLevels(child, offset + 1, visited);
            }
        }
        /**
         * Gets or set the root of this graph.
         * If not set explicitly the first Node with zero incoming links will be taken.
         *
         * @param value
         * @returns {*}
         */
        root(value) {
            if (isUndefined(value)) {
                if (!this._root) {
                    // TODO: better to use the longest path for the most probable root?
                    const found = first(this.nodes, function (n) {
                        return n.incoming.length === 0;
                    });
                    if (found) {
                        return found;
                    }
                    return first(this.nodes);
                }
                else {
                    return this._root;
                }
            }
            else {
                this._root = value;
            }
        }
        /**
         * Returns the connected components of this graph.
         * Note that the returned graphs are made up of the nodes and links of this graph, i.e. a pointer to the items of this graph.
         * If you alter the items of the components you'll alter the original graph and vice versa.
         *
         * @returns {Array}
         */
        getConnectedComponents() {
            this.componentIndex = 0;
            this.setItemIndices();
            const componentId = initArray(this.nodes.length, -1);
            for (let v = 0; v < this.nodes.length; v++) {
                if (componentId[v] === -1) {
                    this._collectConnectedNodes(componentId, v);
                    this.componentIndex++;
                }
            }
            const components = [];
            let i;
            for (i = 0; i < this.componentIndex; ++i) {
                components[i] = new Graph();
            }
            for (i = 0; i < componentId.length; ++i) {
                const graph = components[componentId[i]];
                graph.addNodeAndOutgoings(this.nodes[i]);
            }
            // sorting the components in decreasing order of node count
            components.sort(function (a, b) {
                return b.nodes.length - a.nodes.length;
            });
            return components;
        }
        _collectConnectedNodes(setIds, nodeIndex) {
            setIds[nodeIndex] = this.componentIndex; // part of the current component
            const node = this.nodes[nodeIndex];
            forEach(node.links, function (link) {
                const next = link.getComplement(node);
                const nextId = next.index;
                if (setIds[nextId] === -1) {
                    this._collectConnectedNodes(setIds, nextId);
                }
            }, this);
        }
        /**
         * Calculates the bounds of this Graph if the Nodes have spatial dimensions defined.
         *
         * @returns {Rect}
         */
        calcBounds() {
            if (this.isEmpty()) {
                this.bounds = new Rect();
                return this.bounds;
            }
            let b = null;
            for (let i = 0, len = this.nodes.length; i < len; i++) {
                const node = this.nodes[i];
                if (!b) {
                    b = node.bounds();
                }
                else {
                    b = b.union(node.bounds());
                }
            }
            this.bounds = b;
            return this.bounds;
        }
        /**
         * Creates a spanning tree for the current graph.
         * Important: this will not return a spanning forest if the graph is disconnected.
         * Prim's algorithm  finds a minimum-cost spanning tree of an edge-weighted, connected, undirected graph;
         * see http://en.wikipedia.org/wiki/Prim%27s_algorithm .
         *
         * @param root The root of the spanning tree.
         * @returns {Graph}
         */
        getSpanningTree(root) {
            const tree = new Graph();
            const map = new Dictionary();
            let source, target;
            const rootClone = root.clone();
            tree.root(rootClone);
            rootClone.level = 0;
            rootClone.id = root.id;
            map.add(root, tree.root());
            root.level = 0;
            const visited = [];
            const remaining = [];
            tree._addNode(tree.root());
            visited.push(root);
            remaining.push(root);
            let levelCount = 1;
            while (remaining.length > 0) {
                const next = remaining.pop();
                for (let ni = 0; ni < next.links.length; ni++) {
                    const link = next.links[ni];
                    const cn = link.getComplement(next);
                    if (contains(visited, cn)) {
                        continue;
                    }
                    cn.level = next.level + 1;
                    if (levelCount < cn.level + 1) {
                        levelCount = cn.level + 1;
                    }
                    if (!contains(remaining, cn)) {
                        remaining.push(cn);
                    }
                    if (!contains(visited, cn)) {
                        visited.push(cn);
                    }
                    if (map.containsKey(next)) {
                        source = map.get(next);
                    }
                    else {
                        source = next.clone();
                        source.level = next.level;
                        source.id = next.id;
                        map.add(next, source);
                    }
                    if (map.containsKey(cn)) {
                        target = map.get(cn);
                    }
                    else {
                        target = cn.clone();
                        target.level = cn.level;
                        target.id = cn.id;
                        map.add(cn, target);
                    }
                    const newLink = new Link(source, target);
                    tree.addLink(newLink);
                }
            }
            const treeLevels = [];
            for (let i = 0; i < levelCount; i++) {
                treeLevels.push([]);
            }
            forEach(tree.nodes, function (node) {
                treeLevels[node.level].push(node);
            });
            tree.treeLevels = treeLevels;
            tree.cacheRelationships();
            return tree;
        }
        /**
         * Returns a random node in this graph.
         *
         * @param excludedNodes The collection of nodes which should not be considered.
         * @param incidenceLessThan The maximum degree or incidence the random node should have.
         * @returns {*}
         */
        takeRandomNode(excludedNodes, incidenceLessThan) {
            if (isUndefined(excludedNodes)) {
                excludedNodes = [];
            }
            if (isUndefined(incidenceLessThan)) {
                incidenceLessThan = 4;
            }
            if (this.nodes.length === 0) {
                return null;
            }
            if (this.nodes.length === 1) {
                return contains(excludedNodes, this.nodes[0]) ? null : this.nodes[0];
            }
            const pool = this.nodes.filter(function (node) {
                return !contains(excludedNodes, node) && node.degree() <= incidenceLessThan;
            });
            if (isEmpty(pool)) {
                return null;
            }
            return pool[randomInteger(0, pool.length)];
        }
        /**
         * Returns whether this is an empty graph.
         */
        isEmpty() {
            return isEmpty(this.nodes);
        }
        /**
         * Checks whether the endpoints of the links are all in the nodes collection.
         */
        isHealthy() {
            return all(this.links, function (link) {
                return contains(this.nodes, link.source) && contains(this.nodes, link.target);
            }, this);
        }
        /**
         * Gets the parents of this node, defined as the adjacent nodes with a link from the adjacent node to this one.
         *
         * @returns {Array}
         */
        getParents(n) {
            if (!this.hasNode(n)) {
                throw new Error('The given node is not part of this graph.');
            }
            return n.getParents();
        }
        /**
         * Gets the children of this node, defined as the adjacent nodes with a link from this node to the adjacent one.
         *
         * @returns {Array}
         */
        getChildren(n) {
            if (!this.hasNode(n)) {
                throw new Error('The given node is not part of this graph.');
            }
            return n.getChildren();
        }
        /**
         * Adds a new link to the graph between the given nodes.
         */
        addLink(sourceOrLink, target, owner) {
            if (isUndefined(sourceOrLink)) {
                throw new Error('The source of the link is not defined.');
            }
            if (isUndefined(target)) {
                // can only be undefined if the first one is a Link
                if (isDefined(sourceOrLink.type) && sourceOrLink.type === 'Link') {
                    this.addExistingLink(sourceOrLink);
                    return;
                }
                else {
                    throw new Error('The target of the link is not defined.');
                }
            }
            let foundSource = this.getNode(sourceOrLink);
            if (isUndefined(foundSource)) {
                foundSource = this.addNode(sourceOrLink);
            }
            let foundTarget = this.getNode(target);
            if (isUndefined(foundTarget)) {
                foundTarget = this.addNode(target);
            }
            const newLink = new Link(foundSource, foundTarget);
            if (isDefined(owner)) {
                newLink.owner = owner;
            }
            /* newLink.source.outgoing.push(newLink);
                newLink.source.links.push(newLink);
                newLink.target.incoming.push(newLink);
                newLink.target.links.push(newLink);*/
            this.links.push(newLink);
            return newLink;
        }
        /**
         * Removes all the links in this graph.
         */
        removeAllLinks() {
            while (this.links.length > 0) {
                const link = this.links[0];
                this.removeLink(link);
            }
        }
        /**
         * Adds the given link to the current graph.
         */
        addExistingLink(link) {
            if (this.hasLink(link)) {
                return;
            }
            this.links.push(link);
            if (this.hasNode(link.source.id)) {
                // priority to the existing node with the id even if other props are different
                const s = this.getNode(link.source.id);
                link.changeSource(s);
            }
            else {
                this.addNode(link.source);
            }
            if (this.hasNode(link.target.id)) {
                const t = this.getNode(link.target.id);
                link.changeTarget(t);
            }
            else {
                this.addNode(link.target);
            }
            /*  if (!link.source.outgoing.contains(link)) {
                link.source.outgoing.push(link);
                }
                if (!link.source.links.contains(link)) {
                link.source.links.push(link);
                }
                if (!link.target.incoming.contains(link)) {
                link.target.incoming.push(link);
                }
                if (!link.target.links.contains(link)) {
                link.target.links.push(link);
                }*/
        }
        /**
         * Returns whether the given identifier or Link is part of this graph.
         *
         * @param linkOrId An identifier or a Link object.
         * @returns {*}
         */
        hasLink(linkOrId) {
            if (isString$1(linkOrId)) {
                return getAny(this.links, function (link) {
                    return link.id === linkOrId;
                });
            }
            if (linkOrId.type === 'Link') {
                return contains(this.links, linkOrId);
            }
            throw new Error('The given object is neither an identifier nor a Link.');
        }
        /**
         * Gets the node with the specified Id or null if not part of this graph.
         */
        getNode(nodeOrId) {
            const id = nodeOrId.id || nodeOrId;
            if (this._nodeMap.containsKey(id)) {
                return this._nodeMap.get(id);
            }
        }
        /**
         * Returns whether the given node or node Id is part of this graph.
         */
        hasNode(nodeOrId) {
            const id = nodeOrId.id || nodeOrId;
            return this._nodeMap.containsKey(id);
        }
        _addNode(node) {
            this.nodes.push(node);
            this._nodeMap.add(node.id, node);
        }
        _removeNode(node) {
            remove(this.nodes, node);
            this._nodeMap.remove(node.id);
        }
        /**
         * Removes the given node from this graph.
         * The node can be specified as an object or as an identifier (string).
         */
        removeNode(nodeOrId) {
            let n = nodeOrId;
            if (isString$1(nodeOrId)) {
                n = this.getNode(nodeOrId);
            }
            if (isDefined(n)) {
                const links = n.links;
                n.links = [];
                for (let i = 0, len = links.length; i < len; i++) {
                    const link = links[i];
                    this.removeLink(link);
                }
                this._removeNode(n);
            }
            else {
                throw new Error('The identifier should be a Node or the Id (string) of a node.');
            }
        }
        /**
         * Returns whether the given nodes are connected with a least one link independently of the direction.
         */
        areConnected(n1, n2) {
            return getAny(this.links, function (link) {
                return link.source === n1 && link.target === n2 || link.source === n2 && link.target === n1;
            });
        }
        /**
         * Removes the given link from this graph.
         */
        removeLink(link) {
            /*    if (!this.links.contains(link)) {
                throw "The given link is not part of the Graph.";
                }
                */
            remove(this.links, link);
            remove(link.source.outgoing, link);
            remove(link.source.links, link);
            remove(link.target.incoming, link);
            remove(link.target.links, link);
        }
        /**
         * Adds a new node to this graph, if not already present.
         * The node can be an existing Node or the identifier of a new node.
         * No error is thrown if the node is already there and the existing one is returned.
         */
        addNode(nodeOrId, layoutRect, owner) {
            let newNode = null;
            if (!isDefined(nodeOrId)) {
                throw new Error('No Node or identifier for a new Node is given.');
            }
            if (isString$1(nodeOrId)) {
                if (this.hasNode(nodeOrId)) {
                    return this.getNode(nodeOrId);
                }
                newNode = new Node$1(nodeOrId);
            }
            else {
                if (this.hasNode(nodeOrId)) {
                    return this.getNode(nodeOrId);
                }
                // todo: ensure that the param is a Node?
                newNode = nodeOrId;
            }
            if (isDefined(layoutRect)) {
                newNode.bounds(layoutRect);
            }
            if (isDefined(owner)) {
                newNode.owner = owner;
            }
            this._addNode(newNode);
            return newNode;
        }
        /**
         * Adds the given Node and its outgoing links.
         */
        addNodeAndOutgoings(node) {
            if (!this.hasNode(node)) {
                this._addNode(node);
            }
            const newLinks = node.outgoing;
            node.outgoing = [];
            forEach(newLinks, function (link) {
                this.addExistingLink(link);
            }, this);
        }
        /**
         * Sets the 'index' property on the links and nodes of this graph.
         */
        setItemIndices() {
            let i;
            for (i = 0; i < this.nodes.length; ++i) {
                this.nodes[i].index = i;
            }
            for (i = 0; i < this.links.length; ++i) {
                this.links[i].index = i;
            }
        }
        /**
         * Returns a clone of this graph.
         */
        clone(saveMapping) {
            const copy = new Graph();
            const save = isDefined(saveMapping) && saveMapping === true;
            if (save) {
                copy.nodeMap = new Dictionary();
                copy.linkMap = new Dictionary();
            }
            // we need a map even if the saveMapping is not set
            const map = new Dictionary();
            forEach(this.nodes, function (nOriginal) {
                const nCopy = nOriginal.clone();
                map.set(nOriginal, nCopy);
                copy._addNode(nCopy);
                if (save) {
                    copy.nodeMap.set(nCopy, nOriginal);
                }
            });
            forEach(this.links, function (linkOriginal) {
                if (map.containsKey(linkOriginal.source) && map.containsKey(linkOriginal.target)) {
                    const linkCopy = copy.addLink(map.get(linkOriginal.source), map.get(linkOriginal.target));
                    if (save) {
                        copy.linkMap.set(linkCopy, linkOriginal);
                    }
                }
            });
            return copy;
        }
        /**
         * The parsing allows a quick way to create graphs.
         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
         *  - ["n1->n2", {id: "QSDF"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
         */
        linearize(addIds) {
            return Graph.Utils.linearize(this, addIds);
        }
        /**
         * Performs a depth-first traversal starting at the given node.
         *
         * @param startNode a node or id of a node in this graph
         * @param action
         */
        depthFirstTraversal(startNode, action) {
            if (isUndefined(startNode)) {
                throw new Error('You need to supply a starting node.');
            }
            if (isUndefined(action)) {
                throw new Error('You need to supply an action.');
            }
            if (!this.hasNode(startNode)) {
                throw new Error('The given start-node is not part of this graph');
            }
            const foundNode = this.getNode(startNode); // case the given one is an Id
            const visited = [];
            this._dftIterator(foundNode, action, visited);
        }
        _dftIterator(node, action, visited) {
            action(node);
            visited.push(node);
            const children = node.getChildren();
            for (let i = 0, len = children.length; i < len; i++) {
                const child = children[i];
                if (contains(visited, child)) {
                    continue;
                }
                this._dftIterator(child, action, visited);
            }
        }
        /**
         * Performs a breadth-first traversal starting at the given node.
         *
         * @param startNode a node or id of a node in this graph
         * @param action
         */
        breadthFirstTraversal(startNode, action) {
            if (isUndefined(startNode)) {
                throw new Error('You need to supply a starting node.');
            }
            if (isUndefined(action)) {
                throw new Error('You need to supply an action.');
            }
            if (!this.hasNode(startNode)) {
                throw new Error('The given start-node is not part of this graph');
            }
            const foundNode = this.getNode(startNode); // case the given one is an Id
            const queue = new Queue();
            const visited = [];
            queue.enqueue(foundNode);
            while (queue.length > 0) {
                const node = queue.dequeue();
                action(node);
                visited.push(node);
                const children = node.getChildren();
                for (let i = 0, len = children.length; i < len; i++) {
                    const child = children[i];
                    if (contains(visited, child) || queue.contains(child)) {
                        continue;
                    }
                    queue.enqueue(child);
                }
            }
        }
        /**
         * This is the classic Tarjan algorithm for strongly connected components.
         * See e.g. http://en.wikipedia.org/wiki/Tarjan's_strongly_connected_components_algorithm
         *
         * @param excludeSingleItems Whether isolated nodes should be excluded from the analysis.
         * @param node The start node from which the analysis starts.
         * @param indices  Numbers the nodes consecutively in the order in which they are discovered.
         * @param lowLinks The smallest index of any node known to be reachable from the node, including the node itself
         * @param connected The current component.
         * @param stack The bookkeeping stack of things to visit.
         * @param index The counter of visited nodes used to assign the indices.
         * @private
         */
        _stronglyConnectedComponents(excludeSingleItems, node, indices, lowLinks, connected, stack, index) {
            indices.add(node, index);
            lowLinks.add(node, index);
            index++;
            stack.push(node);
            const children = node.getChildren();
            let next;
            for (let i = 0, len = children.length; i < len; i++) {
                next = children[i];
                if (!indices.containsKey(next)) {
                    this._stronglyConnectedComponents(excludeSingleItems, next, indices, lowLinks, connected, stack, index);
                    lowLinks.add(node, Math.min(lowLinks.get(node), lowLinks.get(next)));
                }
                else if (contains(stack, next)) {
                    lowLinks.add(node, Math.min(lowLinks.get(node), indices.get(next)));
                }
            }
            // If v is a root node, pop the stack and generate a strong component
            if (lowLinks.get(node) === indices.get(node)) {
                const component = [];
                do {
                    next = stack.pop();
                    component.push(next);
                } while (next !== node);
                if (!excludeSingleItems || (component.length > 1)) {
                    connected.push(component);
                }
            }
        }
        /**
         * Returns the cycles found in this graph.
         * The returned arrays consist of the nodes which are strongly coupled.
         *
         * @param excludeSingleItems Whether isolated nodes should be excluded.
         * @returns {Array} The array of cycles found.
         */
        findCycles(excludeSingleItems) {
            if (isUndefined(excludeSingleItems)) {
                excludeSingleItems = true;
            }
            const indices = new Dictionary();
            const lowLinks = new Dictionary();
            const connected = [];
            const stack = [];
            for (let i = 0, len = this.nodes.length; i < len; i++) {
                const node = this.nodes[i];
                if (indices.containsKey(node)) {
                    continue;
                }
                this._stronglyConnectedComponents(excludeSingleItems, node, indices, lowLinks, connected, stack, 0);
            }
            return connected;
        }
        /**
         * Returns whether this graph is acyclic.
         *
         * @returns {*}
         */
        isAcyclic() {
            return isEmpty(this.findCycles());
        }
        /**
         * Returns whether the given graph is a subgraph of this one.
         *
         * @param other Another graph instance.
         */
        isSubGraph(other) {
            const otherArray = other.linearize();
            const thisArray = this.linearize();
            return all(otherArray, function (s) {
                return contains(thisArray, s);
            });
        }
        /**
         *  Makes an acyclic graph from the current (connected) one.
         * * @returns {Array} The reversed links.
         */
        makeAcyclic() {
            // if empty or almost empty
            if (this.isEmpty() || this.nodes.length <= 1 || this.links.length <= 1) {
                return [];
            }
            // singular case of just two nodes
            if (this.nodes.length === 2) {
                const result = [];
                if (this.links.length > 1) {
                    const oneLink = this.links[0];
                    const oneNode = oneLink.source;
                    for (let i = 0, len = this.links.length; i < len; i++) {
                        const link = this.links[i];
                        if (link.source === oneNode) {
                            continue;
                        }
                        const rev = link.reverse();
                        result.push(rev);
                    }
                }
                return result;
            }
            const copy = this.clone(true); // copy.nodeMap tells you the mapping
            const N = this.nodes.length;
            const intensityCatalog = new Dictionary();
            /**
             * If there are both incoming and outgoing links this will return the flow intensity (out-in).
             * Otherwise the node acts as a flow source with N specifying the (equal) intensity.
             *
             * @param node
             * @returns {number}
             */
            const flowIntensity = function (node) {
                if (node.outgoing.length === 0) {
                    return (2 - N);
                }
                else if (node.incoming.length === 0) {
                    return (N - 2);
                }
                else {
                    return node.outgoing.length - node.incoming.length;
                }
            };
            /**
             * Collects the nodes with the same intensity.
             *
             * @param node
             * @param intensityCatalog
             */
            const catalogEqualIntensity = function (node) {
                const intensity = flowIntensity(node);
                if (!intensityCatalog.containsKey(intensity)) {
                    intensityCatalog.set(intensity, []);
                }
                intensityCatalog.get(intensity).push(node);
            };
            forEach(copy.nodes, function (v) {
                catalogEqualIntensity(v);
            });
            let sourceStack = [];
            const targetStack = [];
            while (copy.nodes.length > 0) {
                let source, target, intensity;
                if (intensityCatalog.containsKey(2 - N)) {
                    const targets = intensityCatalog.get(2 - N); // nodes without outgoings
                    while (targets.length > 0) {
                        target = targets.pop();
                        for (let li = 0; li < target.links.length; li++) {
                            const targetLink = target.links[li];
                            source = targetLink.getComplement(target);
                            intensity = flowIntensity(source);
                            remove(intensityCatalog.get(intensity), source);
                            source.removeLink(targetLink);
                            catalogEqualIntensity(source);
                        }
                        copy._removeNode(target);
                        targetStack.unshift(target);
                    }
                }
                // move sources to sourceStack
                if (intensityCatalog.containsKey(N - 2)) {
                    const sources = intensityCatalog.get(N - 2); // nodes without incomings
                    while (sources.length > 0) {
                        source = sources.pop();
                        for (let si = 0; si < source.links.length; si++) {
                            const sourceLink = source.links[si];
                            target = sourceLink.getComplement(source);
                            intensity = flowIntensity(target);
                            remove(intensityCatalog.get(intensity), target);
                            target.removeLink(sourceLink);
                            catalogEqualIntensity(target);
                        }
                        sourceStack.push(source);
                        copy._removeNode(source);
                    }
                }
                if (copy.nodes.length > 0) {
                    for (let k = N - 3; k > 2 - N; k--) {
                        if (intensityCatalog.containsKey(k) &&
                            intensityCatalog.get(k).length > 0) {
                            const maxdiff = intensityCatalog.get(k);
                            const v = maxdiff.pop();
                            for (let ri = 0; ri < v.links.length; ri++) {
                                const ril = v.links[ri];
                                const u = ril.getComplement(v);
                                intensity = flowIntensity(u);
                                remove(intensityCatalog.get(intensity), u);
                                u.removeLink(ril);
                                catalogEqualIntensity(u);
                            }
                            sourceStack.push(v);
                            copy._removeNode(v);
                            break;
                        }
                    }
                }
            }
            sourceStack = sourceStack.concat(targetStack);
            const vertexOrder = new Dictionary();
            for (let kk = 0; kk < this.nodes.length; kk++) {
                vertexOrder.set(copy.nodeMap.get(sourceStack[kk]), kk);
            }
            const reversedEdges = [];
            forEach(this.links, function (link) {
                if (vertexOrder.get(link.source) > vertexOrder.get(link.target)) {
                    link.reverse();
                    reversedEdges.push(link);
                }
            });
            return reversedEdges;
        }
    }
    /**
     * A collection of predefined graphs for demo and testing purposes.
     */
    Graph.Predefined = {
        /**
         * Eight-shapes graph all connected in a cycle.
         *
         * @returns {*}
         * @constructor
         */
        EightGraph() {
            return Graph.Utils.parse(['1->2', '2->3', '3->4', '4->1', '3->5', '5->6', '6->7', '7->3']);
        },
        /**
         * Creates a typical mindmap diagram.
         *
         * @returns {*}
         * @constructor
         */
        Mindmap() {
            return Graph.Utils.parse(['0->1', '0->2', '0->3', '0->4', '0->5', '1->6', '1->7', '7->8', '2->9', '9->10', '9->11', '3->12',
                '12->13', '13->14', '4->15', '4->16', '15->17', '15->18', '18->19', '18->20', '14->21', '14->22', '5->23', '23->24', '23->25', '6->26']);
        },
        /**
         * Three nodes connected in a cycle.
         *
         * @returns {*}
         * @constructor
         */
        ThreeGraph() {
            return Graph.Utils.parse(['1->2', '2->3', '3->1']);
        },
        /**
         * A tree with each node having two children.
         *
         * @param levels How many levels the binary tree should have.
         * @returns {diagram.Graph}
         * @constructor
         */
        BinaryTree(levels) {
            if (isUndefined(levels)) {
                levels = 5;
            }
            return Graph.Utils.createBalancedTree(levels, 2);
        },
        /**
         * A linear graph (discrete line segment).
         *
         * @param length How many segments (the node count is hence (length+1)).
         * @returns {diagram.Graph}
         * @constructor
         */
        Linear(length) {
            if (isUndefined(length)) {
                length = 10;
            }
            return Graph.Utils.createBalancedTree(length, 1);
        },
        /**
         * A standard tree-graph with the specified levels and children (siblings) count.
         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
         * - NodeCount = (1-s^(N+1))/(1-s)]
         * - LinkCount = s.(1-s^N)/(1-s)
         *
         * @param levels How many levels the tree should have.
         * @param siblingsCount How many siblings each level should have.
         * @returns {diagram.Graph}
         * @constructor
         */
        Tree(levels, siblingsCount) {
            return Graph.Utils.createBalancedTree(levels, siblingsCount);
        },
        /**
         * Creates a forest.
         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
         * - NodeCount = t.(1-s^(N+1))/(1-s)]
         * - LinkCount = t.s.(1-s^N)/(1-s)
         *
         * @param levels How many levels the tree should have.
         * @param siblingsCount How many siblings each level should have.
         * @param trees The amount of trees the forest should have.
         * @returns {diagram.Graph}
         * @constructor
         */
        Forest(levels, siblingsCount, trees) {
            return Graph.Utils.createBalancedForest(levels, siblingsCount, trees);
        },
        /**
         * A workflow-like graph with cycles.
         *
         * @returns {*}
         * @constructor
         */
        Workflow() {
            return Graph.Utils.parse(['0->1', '1->2', '2->3', '1->4', '4->3', '3->5', '5->6', '6->3', '6->7', '5->4']);
        },
        /**
         * A grid graph with the direction of the links avoiding cycles.
         * Node count: (n+1).(m+1)
         * Link count: n.(m+1) + m.(n+1)
         *
         * @param n Horizontal count of grid cells. If zero this will result in a linear graph.
         * @param m Vertical count of grid cells. If zero this will result in a linear graph.
         * @constructor
         */
        Grid(n, m) {
            const g = new Graph();
            if (n <= 0 && m <= 0) {
                return g;
            }
            for (let i = 0; i < n + 1; i++) {
                let previous = null;
                for (let j = 0; j < m + 1; j++) {
                    // using x-y coordinates to name the nodes
                    const node = new Node$1(i.toString() + '.' + j.toString());
                    g.addNode(node);
                    if (previous) {
                        g.addLink(previous, node);
                    }
                    if (i > 0) {
                        const left = g.getNode((i - 1).toString() + '.' + j.toString());
                        g.addLink(left, node);
                    }
                    previous = node;
                }
            }
            return g;
        }
    };
    /**
     * Graph generation and other utilities.
     */
    Graph.Utils = {
        /**
         * The parsing allows a quick way to create graphs.
         *  - ["n1->n2", "n2->n3"]: creates the three nodes and adds the links
         *  - ["n1->n2", {id: "id177"}, "n2->n3"]: same as previous but also performs a deep extend of the link between n1 and n2 with the given object.
         */
        parse(graphString) {
            let previousLink;
            const graph = new Graph(), parts = graphString.slice();
            for (let i = 0, len = parts.length; i < len; i++) {
                const part = parts[i];
                if (isString$1(part)) { // link spec
                    if (part.indexOf('->') < 0) {
                        throw new Error('The link should be specified as \'a->b\'.');
                    }
                    const p = part.split('->');
                    if (p.length !== 2) {
                        throw new Error('The link should be specified as \'a->b\'.');
                    }
                    previousLink = new Link(p[0], p[1]);
                    graph.addLink(previousLink);
                }
                if (isObject(part)) {
                    if (!previousLink) {
                        throw new Error('Specification found before Link definition.');
                    }
                    deepExtend(previousLink, part);
                }
            }
            return graph;
        },
        /**
         * Returns a linearized representation of the given Graph.
         * See also the Graph.Utils.parse method for the inverse operation.
         */
        linearize(graph, addIds) {
            if (isUndefined(graph)) {
                throw new Error('Expected an instance of a Graph object in slot one.');
            }
            if (isUndefined(addIds)) {
                addIds = false;
            }
            const lin = [];
            for (let i = 0, len = graph.links.length; i < len; i++) {
                const link = graph.links[i];
                lin.push(link.source.id + '->' + link.target.id);
                if (addIds) {
                    lin.push({ id: link.id });
                }
            }
            return lin;
        },
        /**
         * The method used by the diagram creation to instantiate a shape.
         *
         * @param kendoDiagram The Kendo diagram where the diagram will be created.
         * @param p The position at which to place the shape.
         * @param shapeDefaults Optional Shape options.
         * @param id Optional identifier of the shape.
         * @returns {*}
         * @private
         */
        _addShape(kendoDiagram, p, id, shapeDefaults) {
            if (isUndefined(p)) {
                p = new Point(0, 0);
            }
            if (isUndefined(id)) {
                id = randomId();
            }
            shapeDefaults = deepExtend({
                width: 20,
                height: 20,
                id: id,
                radius: 10,
                fill: '#778899',
                data: 'circle',
                undoable: false,
                x: p.x,
                y: p.y
            }, shapeDefaults);
            return kendoDiagram.addShape(shapeDefaults);
        },
        /**
         * The method used by the diagram creation to instantiate a connection.
         *
         * @param diagram he Kendo diagram where the diagram will be created.
         * @param from The source shape.
         * @param to The target shape.
         * @param options Optional Connection options.
         * @returns {*}
         * @private
         */
        _addConnection(diagram, from, to, options) {
            return diagram.connect(from, to, options);
        },
        /**
         * Creates a diagram from the given Graph.
         *
         * @param diagram The Kendo diagram where the diagram will be created.
         * @param graph The graph structure defining the diagram.
         */
        createDiagramFromGraph(diagram, graph, doLayout, randomSize) {
            if (isUndefined(diagram)) {
                throw new Error('The diagram surface is undefined.');
            }
            if (isUndefined(graph)) {
                throw new Error('No graph specification defined.');
            }
            if (isUndefined(doLayout)) {
                doLayout = true;
            }
            if (isUndefined(randomSize)) {
                randomSize = false;
            }
            const width = diagram.element.clientWidth || 200;
            const height = diagram.element.clientHeight || 200;
            const map = [];
            let node, shape;
            for (let i = 0, len = graph.nodes.length; i < len; i++) {
                node = graph.nodes[i];
                let p = node.position;
                if (isUndefined(p)) {
                    if (isDefined(node.x) && isDefined(node.y)) {
                        p = new Point(node.x, node.y);
                    }
                    else {
                        p = new Point(randomInteger(10, width - 20), randomInteger(10, height - 20));
                    }
                }
                const opt = {};
                if (node.id === '0') {
                    /* deepExtend(opt,
                       {
                       fill: "Orange",
                       data: 'circle',
                       width: 100,
                       height: 100,
                       center: new Point(50, 50)
                       });*/
                }
                else if (randomSize) {
                    deepExtend(opt, {
                        width: Math.random() * 150 + 20,
                        height: Math.random() * 80 + 50,
                        data: 'rectangle',
                        fill: {
                            color: '#778899'
                        }
                    });
                }
                shape = this._addShape(diagram, p, node.id, opt);
                // shape.content(node.id);
                const bounds = shape.bounds();
                if (isDefined(bounds)) {
                    node.x = bounds.x;
                    node.y = bounds.y;
                    node.width = bounds.width;
                    node.height = bounds.height;
                }
                map[node.id] = shape;
            }
            for (let gli = 0; gli < graph.links.length; gli++) {
                const link = graph.links[gli];
                const sourceShape = map[link.source.id];
                if (isUndefined(sourceShape)) {
                    continue;
                }
                const targetShape = map[link.target.id];
                if (isUndefined(targetShape)) {
                    continue;
                }
                this._addConnection(diagram, sourceShape, targetShape, { id: link.id });
            }
            if (doLayout) {
                const l = new SpringLayout(diagram);
                l.layoutGraph(graph, { limitToView: false });
                for (let shi = 0; shi < graph.nodes.length; shi++) {
                    node = graph.nodes[shi];
                    shape = map[node.id];
                    shape.bounds(new Rect(node.x, node.y, node.width, node.height));
                }
            }
        },
        /**
         * Creates a balanced tree with the specified number of levels and siblings count.
         * Note that for a balanced tree of level N and sibling count s, counting the root as level zero:
         * - NodeCount = (1-s^(N+1))/(1-s)]
         * - LinkCount = s.(1-s^N)/(1-s)
         *
         * @param levels How many levels the tree should have.
         * @param siblingsCount How many siblings each level should have.
         * @returns {diagram.Graph}
         */
        createBalancedTree(levels, siblingsCount) {
            if (isUndefined(levels)) {
                levels = 3;
            }
            if (isUndefined(siblingsCount)) {
                siblingsCount = 3;
            }
            const g = new Graph();
            let news, counter = -1, lastAdded = [];
            if (levels <= 0 || siblingsCount <= 0) {
                return g;
            }
            const root = new Node$1((++counter).toString());
            g.addNode(root);
            g.root(root);
            lastAdded.push(root);
            for (let i = 0; i < levels; i++) {
                news = [];
                for (let j = 0; j < lastAdded.length; j++) {
                    const parent = lastAdded[j];
                    for (let k = 0; k < siblingsCount; k++) {
                        const item = new Node$1((++counter).toString());
                        g.addLink(parent, item);
                        news.push(item);
                    }
                }
                lastAdded = news;
            }
            return g;
        },
        /**
         * Creates a balanced tree with the specified number of levels and siblings count.
         * Note that for a balanced forest of level N, sibling count s and tree count t, counting the root as level zero:
         * - NodeCount = t.(1-s^(N+1))/(1-s)]
         * - LinkCount = t.s.(1-s^N)/(1-s)
         *
         * @param levels How many levels the tree should have.
         * @param siblingsCount How many siblings each level should have.
         * @returns {diagram.Graph}
         * @param treeCount The number of trees the forest should have.
         */
        createBalancedForest(levels, siblingsCount, treeCount) {
            if (isUndefined(levels)) {
                levels = 3;
            }
            if (isUndefined(siblingsCount)) {
                siblingsCount = 3;
            }
            if (isUndefined(treeCount)) {
                treeCount = 5;
            }
            const g = new Graph();
            let counter = -1, lastAdded = [], news;
            if (levels <= 0 || siblingsCount <= 0 || treeCount <= 0) {
                return g;
            }
            for (let t = 0; t < treeCount; t++) {
                const root = new Node$1((++counter).toString());
                g.addNode(root);
                lastAdded = [root];
                for (let i = 0; i < levels; i++) {
                    news = [];
                    for (let j = 0; j < lastAdded.length; j++) {
                        const parent = lastAdded[j];
                        for (let k = 0; k < siblingsCount; k++) {
                            const item = new Node$1((++counter).toString());
                            g.addLink(parent, item);
                            news.push(item);
                        }
                    }
                    lastAdded = news;
                }
            }
            return g;
        },
        /**
         * Creates a random graph (uniform distribution) with the specified amount of nodes.
         *
         * @param nodeCount The amount of nodes the random graph should have.
         * @param maxIncidence The maximum allowed degree of the nodes.
         * @param isTree Whether the return graph should be a tree (default: false).
         * @returns {diagram.Graph}
         */
        createRandomConnectedGraph(nodeCount, maxIncidence, isTree) {
            /* Swa's Mathematica export of random Bernoulli graphs
               gr[n_,p_]:=Module[{g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]},
               While[Not[ConnectedGraphQ[g]],g=RandomGraph[BernoulliGraphDistribution[n,p],VertexLabels->"Name",DirectedEdges->True]];g];
               project[a_]:=("\""<>ToString[Part[#,1]]<>"->"<>ToString[Part[#,2]]<>"\"")&     @ a;
               export[g_]:=project/@ EdgeList[g]
               g = gr[12,.1]
               export [g]
               */
            if (isUndefined(nodeCount)) {
                nodeCount = 40;
            }
            if (isUndefined(maxIncidence)) {
                maxIncidence = 4;
            }
            if (isUndefined(isTree)) {
                isTree = false;
            }
            const g = new Graph();
            let counter = -1;
            if (nodeCount <= 0) {
                return g;
            }
            const root = new Node$1((++counter).toString());
            g.addNode(root);
            if (nodeCount === 1) {
                return g;
            }
            if (nodeCount > 1) {
                // random tree
                for (let i = 1; i < nodeCount; i++) {
                    const poolNode = g.takeRandomNode([], maxIncidence);
                    if (!poolNode) {
                        // failed to find one so the graph will have less nodes than specified
                        break;
                    }
                    const newNode = g.addNode(i.toString());
                    g.addLink(poolNode, newNode);
                }
                if (!isTree && nodeCount > 1) {
                    const randomAdditions = randomInteger(1, nodeCount);
                    for (let ri = 0; ri < randomAdditions; ri++) {
                        const n1 = g.takeRandomNode([], maxIncidence);
                        const n2 = g.takeRandomNode([], maxIncidence);
                        if (n1 && n2 && !g.areConnected(n1, n2)) {
                            g.addLink(n1, n2);
                        }
                    }
                }
                return g;
            }
        },
        /**
         * Generates a random diagram.
         *
         * @param diagram The host diagram.
         * @param shapeCount The number of shapes the random diagram should contain.
         * @param maxIncidence The maximum degree the shapes can have.
         * @param isTree Whether the generated diagram should be a tree
         * @param layoutType The optional layout type to apply after the diagram is generated.
         */
        randomDiagram(diagram, shapeCount, maxIncidence, isTree, randomSize) {
            const g = Graph.Utils.createRandomConnectedGraph(shapeCount, maxIncidence, isTree);
            Graph.Utils.createDiagramFromGraph(diagram, g, false, randomSize);
        }
    };
    /**
     * The classic spring-embedder (aka force-directed, Fruchterman-Rheingold, barycentric) algorithm.
     * http://en.wikipedia.org/wiki/Force-directed_graph_drawing
     * - Chapter 12 of Tamassia et al. "Handbook of graph drawing and visualization".
     * - Kobourov on preprint arXiv; http://arxiv.org/pdf/1201.3011.pdf
     * - Fruchterman and Rheingold in SOFTWARE-PRACTICE AND EXPERIENCE, VOL. 21(1 1), 1129-1164 (NOVEMBER 1991)
     *
     * @type {*}
     */
    class SpringLayout extends LayoutBase {
        constructor(diagram) {
            super();
            if (isUndefined(diagram)) {
                throw new Error('Diagram is not specified.');
            }
            this.diagram = diagram;
        }
        layout(options) {
            this.transferOptions(options);
            const adapter = new DiagramToHyperTreeAdapter(this.diagram);
            const graph = adapter.convert(options);
            if (graph.isEmpty()) {
                return;
            }
            // split into connected components
            const components = graph.getConnectedComponents();
            if (isEmpty(components)) {
                return;
            }
            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                this.layoutGraph(component, options);
            }
            const finalNodeSet = this.gridLayoutComponents(components);
            return new LayoutState(this.diagram, finalNodeSet);
        }
        layoutGraph(graph, options) {
            if (isDefined(options)) {
                this.transferOptions(options);
            }
            this.graph = graph;
            const initialTemperature = this.options.nodeDistance * 9;
            this.temperature = initialTemperature;
            const guessBounds = this._expectedBounds();
            this.width = guessBounds.width;
            this.height = guessBounds.height;
            for (let step = 0; step < this.options.iterations; step++) {
                this.refineStage = step >= this.options.iterations * 5 / 6;
                this.tick();
                // exponential cooldown
                this.temperature = this.refineStage ?
                    initialTemperature / 30 :
                    initialTemperature * (1 - step / (2 * this.options.iterations));
            }
        }
        /**
         * Single iteration of the simulation.
         */
        tick() {
            let i;
            // collect the repulsive forces on each node
            for (i = 0; i < this.graph.nodes.length; i++) {
                this._repulsion(this.graph.nodes[i]);
            }
            // collect the attractive forces on each node
            for (i = 0; i < this.graph.links.length; i++) {
                this._attraction(this.graph.links[i]);
            }
            // update the positions
            for (i = 0; i < this.graph.nodes.length; i++) {
                const node = this.graph.nodes[i];
                const offset = Math.sqrt(node.dx * node.dx + node.dy * node.dy);
                if (offset === 0) {
                    return;
                }
                node.x += Math.min(offset, this.temperature) * node.dx / offset;
                node.y += Math.min(offset, this.temperature) * node.dy / offset;
                if (this.options.limitToView) {
                    node.x = Math.min(this.width, Math.max(node.width / 2, node.x));
                    node.y = Math.min(this.height, Math.max(node.height / 2, node.y));
                }
            }
        }
        /**
         * Shakes the node away from its current position to escape the deadlock.
         *
         * @param node A Node.
         * @private
         */
        _shake(node) {
            // just a simple polar neighborhood
            const rho = Math.random() * this.options.nodeDistance / 4;
            const alpha = Math.random() * 2 * Math.PI;
            node.x += rho * Math.cos(alpha);
            node.y -= rho * Math.sin(alpha);
        }
        /**
         * The typical Coulomb-Newton force law F=k/r^2
         *
         * @remark This only works in dimensions less than three.
         * @param d
         * @param n A Node.
         * @param m Another Node.
         * @returns {number}
         * @private
         */
        _InverseSquareForce(d, n, m) {
            let force;
            if (!this.refineStage) {
                force = Math.pow(d, 2) / Math.pow(this.options.nodeDistance, 2);
            }
            else {
                const deltax = n.x - m.x;
                const deltay = n.y - m.y;
                const wn = n.width / 2;
                const hn = n.height / 2;
                const wm = m.width / 2;
                const hm = m.height / 2;
                force = (Math.pow(deltax, 2) / Math.pow(wn + wm + this.options.nodeDistance, 2)) + (Math.pow(deltay, 2) / Math.pow(hn + hm + this.options.nodeDistance, 2));
            }
            return force * 4 / 3;
        }
        /**
         * The typical Hooke force law F=kr^2
         *
         * @param d
         * @param n
         * @param m
         * @returns {number}
         * @private
         */
        _SquareForce(d, n, m) {
            return 1 / this._InverseSquareForce(d, n, m);
        }
        _repulsion(n) {
            n.dx = 0;
            n.dy = 0;
            forEach(this.graph.nodes, function (m) {
                if (m === n) {
                    return;
                }
                while (n.x === m.x && n.y === m.y) {
                    this._shake(m);
                }
                const vx = n.x - m.x;
                const vy = n.y - m.y;
                const distance = Math.sqrt(vx * vx + vy * vy);
                const r = this._SquareForce(distance, n, m) * 2;
                n.dx += (vx / distance) * r;
                n.dy += (vy / distance) * r;
            }, this);
        }
        _attraction(link) {
            const t = link.target;
            const s = link.source;
            if (s === t) {
                // loops induce endless shakes
                return;
            }
            while (s.x === t.x && s.y === t.y) {
                this._shake(t);
            }
            const vx = s.x - t.x;
            const vy = s.y - t.y;
            const distance = Math.sqrt(vx * vx + vy * vy);
            const a = this._InverseSquareForce(distance, s, t) * 5;
            const dx = (vx / distance) * a;
            const dy = (vy / distance) * a;
            t.dx += dx;
            t.dy += dy;
            s.dx -= dx;
            s.dy -= dy;
        }
        /**
         * Calculates the expected bounds after layout.
         *
         * @returns {*}
         * @private
         */
        _expectedBounds() {
            const N = this.graph.nodes.length, /* golden ration optimal?*/ ratio = 1.5, multiplier = 4;
            if (N === 0) {
                return;
            }
            const size = fold(this.graph.nodes, function (s, node) {
                const area = node.width * node.height;
                if (area > 0) {
                    s += Math.sqrt(area);
                    return s;
                }
                return 0;
            }, 0, this);
            const av = size / N;
            const squareSize = av * Math.ceil(Math.sqrt(N));
            const width = squareSize * Math.sqrt(ratio);
            const height = squareSize / Math.sqrt(ratio);
            return { width: width * multiplier, height: height * multiplier };
        }
    }
    /**
     * Adapter between the diagram control and the graph representation. It converts shape and connections to nodes and edges taking into the containers and their collapsef state,
     * the visibility of items and more. If the layoutContainerChildren is true a hypertree is constructed which holds the hierarchy of containers and many conditions are analyzed
     * to investigate how the effective graph structure looks like and how the layout has to be performed.
     *
     * @type {*}
     */
    class DiagramToHyperTreeAdapter {
        constructor(diagram) {
            /**
             * The mapping to/from the original nodes.
             *
             * @type {Dictionary}
             */
            this.nodeMap = new Dictionary();
            /**
             * Gets the mapping of a shape to a container in case the shape sits in a collapsed container.
             *
             * @type {Dictionary}
             */
            this.shapeMap = new Dictionary();
            /**
             * The nodes being mapped.
             *
             * @type {Dictionary}
             */
            this.nodes = [];
            /**
             * The connections being mapped.
             *
             * @type {Dictionary}
             */
            this.edges = [];
            // the mapping from an edge to all the connections it represents, this can be both because of multiple connections between
            // two shapes or because a container holds multiple connections to another shape or container.
            this.edgeMap = new Dictionary();
            /**
             * The resulting set of Nodes when the analysis has finished.
             *
             * @type {Array}
             */
            this.finalNodes = [];
            /**
             * The resulting set of Links when the analysis has finished.
             *
             * @type {Array}
             */
            this.finalLinks = [];
            /**
             * The items being omitted because of multigraph edges.
             *
             * @type {Array}
             */
            this.ignoredConnections = [];
            /**
             * The items being omitted because of containers, visibility and other factors.
             *
             * @type {Array}
             */
            this.ignoredShapes = [];
            /**
             * The map from a node to the partition/hypernode in which it sits. This hyperMap is null if 'options.layoutContainerChildren' is false.
             *
             * @type {Dictionary}
             */
            this.hyperMap = new Dictionary();
            /**
             * The hypertree contains the hierarchy defined by the containers.
             * It's in essence a Graph of Graphs with a tree structure defined by the hierarchy of containers.
             *
             * @type {HyperTree}
             */
            this.hyperTree = new Graph();
            /**
             * The resulting graph after conversion. Note that this does not supply the information contained in the
             * ignored connection and shape collections.
             *
             * @type {null}
             */
            this.finalGraph = null;
            this.diagram = diagram;
        }
        /**
         * The hyperTree is used when the 'options.layoutContainerChildren' is true. It contains the hierarchy of containers whereby each node is a ContainerGraph.
         * This type of node has a Container reference to the container which holds the Graph items. There are three possible situations during the conversion process:
         * - Ignore the containers: the container are non-existent and only normal shapes are mapped. If a shape has a connection to a container it will be ignored as well
         * since there is no node mapped for the container.
         * - Do not ignore the containers and leave the content of the containers untouched: the top-level elements are being mapped and the children within a container are not altered.
         * - Do not ignore the containers and organize the content of the containers as well: the hypertree is constructed and there is a partitioning of all nodes and connections into the hypertree.
         * The only reason a connection or node is not being mapped might be due to the visibility, which includes the visibility change through a collapsed parent container.
         *
         * @param options
         */
        convert(options) {
            if (isUndefined(this.diagram)) {
                throw new Error('No diagram to convert.');
            }
            this.options = deepExtend({
                ignoreInvisible: true,
                ignoreContainers: true,
                layoutContainerChildren: false
            }, options || {});
            this.clear();
            // create the nodes which participate effectively in the graph analysis
            this._renormalizeShapes();
            // recreate the incoming and outgoing collections of each and every node
            this._renormalizeConnections();
            // export the resulting graph
            this.finalNodes = new Dictionary(this.nodes);
            this.finalLinks = new Dictionary(this.edges);
            this.finalGraph = new Graph();
            this.finalNodes.forEach(function (n) {
                this.finalGraph.addNode(n);
            }, this);
            this.finalLinks.forEach(function (l) {
                this.finalGraph.addExistingLink(l);
            }, this);
            return this.finalGraph;
        }
        /**
         * Maps the specified connection to an edge of the graph deduced from the given diagram.
         *
         * @param connection
         * @returns {*}
         */
        mapConnection(connection) {
            return this.edgeMap.get(connection.id);
        }
        /**
         * Maps the specified shape to a node of the graph deduced from the given diagram.
         *
         * @param shape
         * @returns {*}
         */
        mapShape(shape) {
            return this.nodeMap.get(shape.id);
        }
        /**
         * Gets the edge, if any, between the given nodes.
         *
         * @param a
         * @param b
         */
        getEdge(a, b) {
            return first(a.links, function (link) {
                return link.getComplement(a) === b;
            });
        }
        /**
         * Clears all the collections used by the conversion process.
         */
        clear() {
            this.finalGraph = null;
            this.hyperTree = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new Graph() : null;
            this.hyperMap = (!this.options.ignoreContainers && this.options.layoutContainerChildren) ? new Dictionary() : null;
            this.nodeMap = new Dictionary();
            this.shapeMap = new Dictionary();
            this.nodes = [];
            this.edges = [];
            this.edgeMap = new Dictionary();
            this.ignoredConnections = [];
            this.ignoredShapes = [];
            this.finalNodes = [];
            this.finalLinks = [];
        }
        /**
         * The path from a given ContainerGraph to the root (container).
         *
         * @param containerGraph
         * @returns {Array}
         */
        listToRoot(containerGraph) {
            const list = [];
            let s = containerGraph.container;
            if (!s) {
                return list;
            }
            list.push(s);
            while (s.parentContainer) {
                s = s.parentContainer;
                list.push(s);
            }
            list.reverse();
            return list;
        }
        firstNonIgnorableContainer(shape) {
            if (shape.isContainer && !this.isIgnorableItem(shape)) {
                return shape;
            }
            return !shape.parentContainer ? null : this.firstNonIgnorableContainer(shape.parentContainer);
        }
        isContainerConnection(a, b) {
            if (a.isContainer && this.isDescendantOf(a, b)) {
                return true;
            }
            return b.isContainer && this.isDescendantOf(b, a);
        }
        /**
         * Returns true if the given shape is a direct child or a nested container child of the given container.
         * If the given container and shape are the same this will return false since a shape cannot be its own child.
         *
         * @param scope
         * @param a
         * @returns {boolean}
         */
        isDescendantOf(scope, a) {
            if (!scope.isContainer) {
                throw new Error('Expecting a container.');
            }
            if (scope === a) {
                return false;
            }
            if (contains(scope.children, a)) {
                return true;
            }
            const containers = [];
            for (let i = 0, len = scope.children.length; i < len; i++) {
                const c = scope.children[i];
                if (c.isContainer && this.isDescendantOf(c, a)) {
                    containers.push(c);
                }
            }
            return containers.length > 0;
        }
        isIgnorableItem(shape) {
            if (this.options.ignoreInvisible) {
                if (shape.isCollapsed && this._isVisible(shape)) {
                    return false;
                }
                if (!shape.isCollapsed && this._isVisible(shape)) {
                    return false;
                }
                return true;
            }
            else {
                return shape.isCollapsed && !this._isTop(shape);
            }
        }
        /**
         *  Determines whether the shape is or needs to be mapped to another shape. This occurs essentially when the shape sits in
         *  a collapsed container hierarchy and an external connection needs a node endpoint. This node then corresponds to the mapped shape and is
         *  necessarily a container in the parent hierarchy of the shape.
         *
         * @param shape
         */
        isShapeMapped(shape) {
            return shape.isCollapsed && !this._isVisible(shape) && !this._isTop(shape);
        }
        leastCommonAncestor(a, b) {
            if (!a) {
                throw new Error('Parameter should not be null.');
            }
            if (!b) {
                throw new Error('Parameter should not be null.');
            }
            if (!this.hyperTree) {
                throw new Error('No hypertree available.');
            }
            const al = this.listToRoot(a);
            const bl = this.listToRoot(b);
            let found = null;
            if (isEmpty(al) || isEmpty(bl)) {
                return this.hyperTree.root().data;
            }
            let xa = al[0];
            let xb = bl[0];
            let i = 0;
            while (xa === xb) {
                found = al[i];
                i++;
                if (i >= al.length || i >= bl.length) {
                    break;
                }
                xa = al[i];
                xb = bl[i];
            }
            if (!found) {
                return this.hyperTree.root().data;
            }
            else {
                return this.hyperTree.nodes.filter(function (n) {
                    return n.data.container === found;
                });
            }
        }
        /**
         * Determines whether the specified item is a top-level shape or container.
         *
         * @param item
         * @returns {boolean}
         * @private
         */
        _isTop(item) {
            return !item.parentContainer;
        }
        /**
         * Determines iteratively (by walking up the container stack) whether the specified shape is visible.
         * This does NOT tell whether the item is not visible due to an explicit Visibility change or due to a collapse state.
         *
         * @param shape
         * @returns {*}
         * @private
         */
        _isVisible(shape) {
            if (!shape.visible()) {
                return false;
            }
            return !shape.parentContainer ? shape.visible() : this._isVisible(shape.parentContainer);
        }
        _isCollapsed(shape) {
            if (shape.isContainer && shape.isCollapsed) {
                return true;
            }
            return shape.parentContainer && this._isCollapsed(shape.parentContainer);
        }
        /**
         * First part of the graph creation; analyzing the shapes and containers and deciding whether they should be mapped to a Node.
         *
         * @private
         */
        _renormalizeShapes() {
            // add the nodes, the adjacency structure will be reconstructed later on
            if (this.options.ignoreContainers) {
                for (let i = 0, len = this.diagram.shapes.length; i < len; i++) {
                    const shape = this.diagram.shapes[i];
                    // if not visible (and ignoring the invisible ones) or a container we skip
                    if ((this.options.ignoreInvisible && !this._isVisible(shape)) || shape.isContainer) {
                        this.ignoredShapes.push(shape);
                        continue;
                    }
                    const node = new Node$1(shape.id, shape);
                    node.isVirtual = false;
                    // the mapping will always contain singletons and the hyperTree will be null
                    this.nodeMap.add(shape.id, node);
                    this.nodes.push(node);
                }
            }
            else {
                throw new Error('Containers are not supported yet, but stay tuned.');
            }
        }
        /**
         * Second part of the graph creation; analyzing the connections and deciding whether they should be mapped to an edge.
         *
         * @private
         */
        _renormalizeConnections() {
            if (this.diagram.connections.length === 0) {
                return;
            }
            for (let i = 0, len = this.diagram.connections.length; i < len; i++) {
                const conn = this.diagram.connections[i];
                if (this.isIgnorableItem(conn)) {
                    this.ignoredConnections.push(conn);
                    continue;
                }
                let source = !conn.sourceConnector ? null : conn.sourceConnector.shape;
                let sink = !conn.targetConnector ? null : conn.targetConnector.shape;
                // no layout for floating connections
                if (!source || !sink) {
                    this.ignoredConnections.push(conn);
                    continue;
                }
                if (contains(this.ignoredShapes, source) && !this.shapeMap.containsKey(source)) {
                    this.ignoredConnections.push(conn);
                    continue;
                }
                if (contains(this.ignoredShapes, sink) && !this.shapeMap.containsKey(sink)) {
                    this.ignoredConnections.push(conn);
                    continue;
                }
                // if the endpoint sits in a collapsed container we need the container rather than the shape itself
                if (this.shapeMap.containsKey(source)) {
                    source = this.shapeMap[source];
                }
                if (this.shapeMap.containsKey(sink)) {
                    sink = this.shapeMap[sink];
                }
                const sourceNode = this.mapShape(source);
                const sinkNode = this.mapShape(sink);
                if ((sourceNode === sinkNode) || this.areConnectedAlready(sourceNode, sinkNode)) {
                    this.ignoredConnections.push(conn);
                    continue;
                }
                if (sourceNode === null || sinkNode === null) {
                    throw new Error('A shape was not mapped to a node.');
                }
                if (this.options.ignoreContainers) {
                    // much like a floating connection here since at least one end is attached to a container
                    if (sourceNode.isVirtual || sinkNode.isVirtual) {
                        this.ignoredConnections.push(conn);
                        continue;
                    }
                    const newEdge = new Link(sourceNode, sinkNode, conn.id, conn);
                    this.edgeMap.add(conn.id, newEdge);
                    this.edges.push(newEdge);
                }
                else {
                    throw new Error('Containers are not supported yet, but stay tuned.');
                }
            }
        }
        areConnectedAlready(n, m) {
            return getAny(this.edges, function (l) {
                return l.source === n && l.target === m || l.source === m && l.target === n;
            });
        }
    }

    function intersectLine(start1, end1, start2, end2, isSegment) {
        const tangensdiff = ((end1.x - start1.x) * (end2.y - start2.y)) - ((end1.y - start1.y) * (end2.x - start2.x));
        if (isNearZero(tangensdiff)) {
            // parallel lines
            return;
        }
        const num1 = ((start1.y - start2.y) * (end2.x - start2.x)) - ((start1.x - start2.x) * (end2.y - start2.y));
        const num2 = ((start1.y - start2.y) * (end1.x - start1.x)) - ((start1.x - start2.x) * (end1.y - start1.y));
        const r = num1 / tangensdiff;
        const s = num2 / tangensdiff;
        if (isSegment && (r < 0 || r > 1 || s < 0 || s > 1)) {
            // r < 0 => line 1 is below line 2
            // r > 1 => line 1 is above line 2
            // s < 0 => line 2 is below line 1
            // s > 1 => line 2 is above line 1
            return;
        }
        return new Point(start1.x + (r * (end1.x - start1.x)), start1.y + (r * (end1.y - start1.y)));
    }
    const Intersect = {
        lines(start1, end1, start2, end2) {
            return intersectLine(start1, end1, start2, end2);
        },
        segments(start1, end1, start2, end2) {
            return intersectLine(start1, end1, start2, end2, true);
        },
        rectWithLine(rect, start, end) {
            return Intersect.segments(start, end, rect.topLeft(), rect.topRight()) ||
                Intersect.segments(start, end, rect.topRight(), rect.bottomRight()) ||
                Intersect.segments(start, end, rect.bottomLeft(), rect.bottomRight()) ||
                Intersect.segments(start, end, rect.topLeft(), rect.bottomLeft());
        },
        rects(rect1, rect2, angle) {
            let tl = rect2.topLeft(), tr = rect2.topRight(), bl = rect2.bottomLeft(), br = rect2.bottomRight();
            const center = rect2.center();
            if (angle) {
                tl = tl.rotate(angle, center);
                tr = tr.rotate(angle, center);
                bl = bl.rotate(angle, center);
                br = br.rotate(angle, center);
            }
            let intersect = rect1.contains(tl) ||
                rect1.contains(tr) ||
                rect1.contains(bl) ||
                rect1.contains(br) ||
                Intersect.rectWithLine(rect1, tl, tr) ||
                Intersect.rectWithLine(rect1, tl, bl) ||
                Intersect.rectWithLine(rect1, tr, br) ||
                Intersect.rectWithLine(rect1, bl, br);
            if (!intersect) { // last possible case is rect1 to be completely within rect2
                tl = rect1.topLeft();
                tr = rect1.topRight();
                bl = rect1.bottomLeft();
                br = rect1.bottomRight();
                if (angle) {
                    const reverseAngle = 360 - angle;
                    tl = tl.rotate(reverseAngle, center);
                    tr = tr.rotate(reverseAngle, center);
                    bl = bl.rotate(reverseAngle, center);
                    br = br.rotate(reverseAngle, center);
                }
                intersect = rect2.contains(tl) ||
                    rect2.contains(tr) ||
                    rect2.contains(bl) ||
                    rect2.contains(br);
            }
            return intersect;
        }
    };

    const map = (arr, func) => arr.map(func);
    /**
     * SVG transformation represented as a vector.
     */
    class MatrixVector {
        constructor(a, b, c, d, e, f) {
            this.a = a || 0;
            this.b = b || 0;
            this.c = c || 0;
            this.d = d || 0;
            this.e = e || 0;
            this.f = f || 0;
        }
        fromMatrix(m) {
            const v = new MatrixVector();
            v.a = m.a;
            v.b = m.b;
            v.c = m.c;
            v.d = m.d;
            v.e = m.e;
            v.f = m.f;
            return v;
        }
    }
    /**
     * SVG transformation matrix.
     */
    class Matrix {
        constructor(a, b, c, d, e, f) {
            this.a = a || 0;
            this.b = b || 0;
            this.c = c || 0;
            this.d = d || 0;
            this.e = e || 0;
            this.f = f || 0;
        }
        plus(m) {
            this.a += m.a;
            this.b += m.b;
            this.c += m.c;
            this.d += m.d;
            this.e += m.e;
            this.f += m.f;
        }
        minus(m) {
            this.a -= m.a;
            this.b -= m.b;
            this.c -= m.c;
            this.d -= m.d;
            this.e -= m.e;
            this.f -= m.f;
        }
        times(m) {
            return new Matrix(this.a * m.a + this.c * m.b, this.b * m.a + this.d * m.b, this.a * m.c + this.c * m.d, this.b * m.c + this.d * m.d, this.a * m.e + this.c * m.f + this.e, this.b * m.e + this.d * m.f + this.f);
        }
        apply(p) {
            return new Point(this.a * p.x + this.c * p.y + this.e, this.b * p.x + this.d * p.y + this.f);
        }
        applyRect(r) {
            return Rect.fromPoints(this.apply(r.topLeft()), this.apply(r.bottomRight()));
        }
        toString() {
            return 'matrix(' + this.a + ' ' + this.b + ' ' + this.c + ' ' + this.d + ' ' + this.e + ' ' + this.f + ')';
        }
        static fromSVGMatrix(vm) {
            const m = new Matrix();
            m.a = vm.a;
            m.b = vm.b;
            m.c = vm.c;
            m.d = vm.d;
            m.e = vm.e;
            m.f = vm.f;
            return m;
        }
        static fromMatrixVector(v) {
            const m = new Matrix();
            m.a = v.a;
            m.b = v.b;
            m.c = v.c;
            m.d = v.d;
            m.e = v.e;
            m.f = v.f;
            return m;
        }
        static fromList(v) {
            if (v.length !== 6) {
                throw new Error('The given list should consist of six elements.');
            }
            const m = new Matrix();
            m.a = v[0];
            m.b = v[1];
            m.c = v[2];
            m.d = v[3];
            m.e = v[4];
            m.f = v[5];
            return m;
        }
        static translation(x, y) {
            const m = new Matrix();
            m.a = 1;
            m.b = 0;
            m.c = 0;
            m.d = 1;
            m.e = x;
            m.f = y;
            return m;
        }
        static unit() {
            return new Matrix(1, 0, 0, 1, 0, 0);
        }
        static rotation(angle, x, y) {
            const m = new Matrix();
            m.a = Math.cos(angle * Math.PI / 180);
            m.b = Math.sin(angle * Math.PI / 180);
            m.c = -m.b;
            m.d = m.a;
            m.e = (x - x * m.a + y * m.b) || 0;
            m.f = (y - y * m.a - x * m.b) || 0;
            return m;
        }
        static scaling(scaleX, scaleY) {
            const m = new Matrix();
            m.a = scaleX;
            m.b = 0;
            m.c = 0;
            m.d = scaleY;
            m.e = 0;
            m.f = 0;
            return m;
        }
        static parse(v) {
            let parts, nums;
            if (v) {
                v = v.trim();
                // of the form "matrix(...)"
                if (v.slice(0, 6).toLowerCase() === 'matrix') {
                    nums = v.slice(7, v.length - 1).trim();
                    parts = nums.split(',');
                    if (parts.length === 6) {
                        return Matrix.fromList(map(parts, function (p) {
                            return parseFloat(p);
                        }));
                    }
                    parts = nums.split(' ');
                    if (parts.length === 6) {
                        return Matrix.fromList(map(parts, function (p) {
                            return parseFloat(p);
                        }));
                    }
                }
                // of the form "(...)"
                if (v.slice(0, 1) === '(' && v.slice(v.length - 1) === ')') {
                    v = v.substr(1, v.length - 1);
                }
                if (v.indexOf(',') > 0) {
                    parts = v.split(',');
                    if (parts.length === 6) {
                        return Matrix.fromList(map(parts, function (p) {
                            return parseFloat(p);
                        }));
                    }
                }
                if (v.indexOf(' ') > 0) {
                    parts = v.split(' ');
                    if (parts.length === 6) {
                        return Matrix.fromList(map(parts, function (p) {
                            return parseFloat(p);
                        }));
                    }
                }
            }
            return parts;
        }
    }

    /**
     * Returns a value with Gaussian (normal) distribution.
     *
     * @param mean The mean value of the distribution.
     * @param deviation The deviation (spreading at half-height) of the distribution.
     * @returns {number}
     */
    function normalVariable(mean, deviation) {
        let x, y, r;
        do {
            x = Math.random() * 2 - 1;
            y = Math.random() * 2 - 1;
            r = x * x + y * y;
        } while (!r || r > 1);
        return mean + deviation * x * Math.sqrt(-2 * Math.log(r) / r);
    }

    /**
     * Structure combining a Point with two additional points representing the handles or tangents attached to the first point.
     * If the additional points are null or equal to the first point the path will be sharp.
     * Left and right correspond to the direction of the underlying path.
     */
    class PathDefiner {
        constructor(p, left, right) {
            this.point = p;
            this.left = left;
            this.right = right;
        }
    }

    /**
     * While other data structures can have multiple times the same item a Set owns only
     * once a particular item.
     *
     * @type {*}
     */
    let Set$1 = class Set extends Observable {
        constructor(resource) {
            super();
            this._hashTable = new HashTable();
            this.length = 0;
            if (isDefined(resource)) {
                if (resource instanceof HashTable) {
                    resource.forEach(function (d) {
                        this.add(d);
                    });
                }
                else if (resource instanceof Dictionary) {
                    resource.forEach(function (k, v) {
                        this.add({ key: k, value: v });
                    }, this);
                }
            }
        }
        contains(item) {
            return this._hashTable.containsKey(item);
        }
        add(item) {
            const entry = this._hashTable.get(item);
            if (!entry) {
                this._hashTable.add(item, item);
                this.length++;
                this.trigger('changed');
            }
        }
        get(item) {
            if (this.contains(item)) {
                return this._hashTable.get(item).value;
            }
            else {
                return null;
            }
        }
        /**
         * Returns the hash of the item.
         *
         * @param item
         * @returns {*}
         */
        hash(item) {
            return this._hashTable._hash(item);
        }
        /**
         * Removes the given item from the set. No exception is thrown if the item is not in the Set.
         *
         * @param item
         */
        remove(item) {
            if (this.contains(item)) {
                this._hashTable.remove(item);
                this.length--;
                this.trigger('changed');
            }
        }
        /**
         * Foreach with an iterator working on the key-value pairs.
         *
         * @param func
         */
        forEach(func, context) {
            const call = context ? func.bind(context) : func;
            this._hashTable.forEach(function (kv) {
                call(kv.value);
            });
        }
        toArray() {
            const r = [];
            this.forEach(function (d) {
                r.push(d);
            });
            return r;
        }
    };

    class Size {
        constructor(width, height) {
            this.width = width;
            this.height = height;
        }
        static Empty() {
            return new Size(0, 0);
        }
    }

    class Rotation {
        constructor(angle, x, y) {
            this.x = x || 0;
            this.y = y || 0;
            this.angle = angle;
        }
        toString() {
            if (this.x && this.y) {
                return `rotate(${this.angle},${this.x},${this.y})`;
            }
            else {
                return `rotate(${this.angle})`;
            }
        }
        toMatrix() {
            return Matrix.rotation(this.angle, this.x, this.y); // T*R*T^-1
        }
        center() {
            return new Point(this.x, this.y);
        }
        invert() {
            return new Rotation(FULL_CIRCLE_ANGLE - this.angle, this.x, this.y);
        }
        static create(rotation) {
            return new Rotation(rotation.angle, rotation.x, rotation.y);
        }
        static parse(str) {
            const values = str.slice(1, str.length - 1).split(',');
            const angle = parseFloat(values[0]);
            const x = parseFloat(values[1]);
            const y = parseFloat(values[2]);
            return new Rotation(angle, x, y);
        }
    }
    Rotation.ZERO = new Rotation(0);

    class Scale {
        constructor(x, y) {
            this.x = x;
            this.y = y;
        }
        toMatrix() {
            return Matrix.scaling(this.x, this.y);
        }
        toString() {
            return `scale(${this.x},${this.y})`;
        }
        invert() {
            return new Scale(1 / this.x, 1 / this.y);
        }
    }
    ;

    class Translation {
        constructor(x, y) {
            this.x = x;
            this.y = y;
        }
        toMatrixVector() {
            return new MatrixVector(0, 0, 0, 0, this.x, this.y);
        }
        toMatrix() {
            return Matrix.translation(this.x, this.y);
        }
        toString() {
            return `translate(${this.x},${this.y})`;
        }
        plus(delta) {
            this.x += delta.x;
            this.y += delta.y;
        }
        times(factor) {
            this.x *= factor;
            this.y *= factor;
        }
        length() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        }
        normalize() {
            if (this.Length === 0) {
                return;
            }
            this.times(1 / this.length());
        }
        invert() {
            return new Translation(-this.x, -this.y);
        }
    }

    class CompositeTransform {
        constructor(x, y, scaleX, scaleY, angle, center) {
            this.translate = new Translation(x, y);
            if (scaleX !== undefined && scaleY !== undefined) {
                this.scale = new Scale(scaleX, scaleY);
            }
            if (angle !== undefined) {
                this.rotate = center ? new Rotation(angle, center.x, center.y) : new Rotation(angle);
            }
        }
        toString() {
            const toString = function (transform) {
                return transform ? transform.toString() : '';
            };
            return toString(this.translate) +
                toString(this.rotate) +
                toString(this.scale);
        }
        render(visual) {
            visual._transform = this;
            visual._renderTransform();
        }
        toMatrix() {
            let m = Matrix.unit();
            if (this.translate) {
                m = m.times(this.translate.toMatrix());
            }
            if (this.rotate) {
                m = m.times(this.rotate.toMatrix());
            }
            if (this.scale) {
                m = m.times(this.scale.toMatrix());
            }
            return m;
        }
        invert() {
            const rotate = this.rotate ? this.rotate.invert() : undefined, rotateMatrix = rotate ? rotate.toMatrix() : Matrix.unit(), scale = this.scale ? this.scale.invert() : undefined, scaleMatrix = scale ? scale.toMatrix() : Matrix.unit();
            let translatePoint = new Point(-this.translate.x, -this.translate.y);
            translatePoint = rotateMatrix.times(scaleMatrix).apply(translatePoint);
            const translate = new Translation(translatePoint.x, translatePoint.y);
            const transform = new CompositeTransform();
            transform.translate = translate;
            transform.rotate = rotate;
            transform.scale = scale;
            return transform;
        }
    }

    function diffNumericOptions(options, fields) {
        const elementOptions = this.options;
        let hasChanges = false;
        let value, field;
        for (let i = 0; i < fields.length; i++) {
            field = fields[i];
            value = options[field];
            if (isNumber(value) && elementOptions[field] !== value) {
                elementOptions[field] = value;
                hasChanges = true;
            }
        }
        return hasChanges;
    }

    class Element {
        constructor(options) {
            this.options = deepExtend({}, this.options, options);
            this.id = this.options.id;
            this._originSize = Rect.empty();
            this._transform = new CompositeTransform();
        }
        visible(value) {
            return this.drawingContainer().visible(value);
        }
        redraw(options) {
            if (options && options.id) {
                this.id = options.id;
            }
        }
        position(x, y) {
            const options = this.options;
            if (!defined(x)) {
                return new Point(options.x, options.y);
            }
            if (defined(y)) {
                options.x = x;
                options.y = y;
            }
            else if (x instanceof Point) {
                options.x = x.x;
                options.y = x.y;
            }
            this._transform.translate = new Translation(options.x, options.y);
            this._renderTransform();
        }
        rotate(angle, center) {
            if (defined(angle)) {
                this._transform.rotate = new Rotation(angle, center.x, center.y);
                this._renderTransform();
            }
            return this._transform.rotate || Rotation.ZERO;
        }
        drawingContainer() {
            return this.drawingElement;
        }
        _renderTransform() {
            const matrix = this._transform.toMatrix();
            this.drawingContainer().transform(new kendo_drawing_cmn_chunk_js.M(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f));
        }
        _hover() { }
        _diffNumericOptions(options, fields) {
            return diffNumericOptions.call(this, options, fields);
        }
        _measure(force) {
            let rect;
            if (!this._measured || force) {
                const box = this._boundingBox() || new kendo_drawing_cmn_chunk_js.R([0, 0], [0, 0]);
                const startPoint = box.topLeft();
                rect = new Rect(startPoint.x, startPoint.y, box.width(), box.height());
                this._originSize = rect;
                this._originWidth = rect.width;
                this._originHeight = rect.height;
                this._measured = true;
            }
            else {
                rect = this._originSize;
            }
            return rect;
        }
        _boundingBox() {
            return this.drawingElement.rawBBox();
        }
    }

    function sizeOptionsOrDefault(options) {
        return {
            x: options.x || 0,
            y: options.y || 0,
            width: options.width || 0,
            height: options.height || 0
        };
    }
    function normalizeDrawingOptions(options) {
        if (options) {
            let drawingOptions = options;
            if (isString$1(drawingOptions)) {
                drawingOptions = {
                    color: drawingOptions
                };
            }
            if (drawingOptions.color) {
                drawingOptions.color = getColor(drawingOptions.color);
            }
            return drawingOptions;
        }
    }
    function getColor(value) {
        let color;
        if (value !== TRANSPARENT) {
            color = new kendo_drawing_cmn_chunk_js.C(value).toHex();
        }
        else {
            color = value;
        }
        return color;
    }
    function lineAngle(p1, p2) {
        const xDiff = p2.x - p1.x;
        const yDiff = p2.y - p1.y;
        const angle = kendo_drawing_cmn_chunk_js.v(Math.atan2(yDiff, xDiff));
        return angle;
    }
    function createSegment(x, y) {
        return new kendo_drawing_cmn_chunk_js.S(new kendo_drawing_cmn_chunk_js.P(x, y));
    }
    function toDrawingRect(rect) {
        if (rect) {
            return new kendo_drawing_cmn_chunk_js.R([rect.x, rect.y], [rect.width, rect.height]);
        }
    }
    function removeChildren$1(element) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }

    const defaultOptions$a = {
        stroke: {
            color: 'gray',
            width: 1
        },
        fill: {
            color: TRANSPARENT
        }
    };
    class VisualBase extends Element {
        constructor(options) {
            options = deepExtend({}, defaultOptions$a, options);
            super(options);
            options = this.options;
            options.fill = normalizeDrawingOptions(options.fill);
            options.stroke = normalizeDrawingOptions(options.stroke);
        }
        fill(color, opacity) {
            this._fill({
                color: getColor(color),
                opacity: opacity
            });
        }
        stroke(color, width, opacity) {
            this._stroke({
                color: getColor(color),
                width: width,
                opacity: opacity
            });
        }
        redraw(options) {
            if (options) {
                const stroke = options.stroke;
                const fill = options.fill;
                if (stroke) {
                    this._stroke(normalizeDrawingOptions(stroke));
                }
                if (fill) {
                    this._fill(normalizeDrawingOptions(fill));
                }
                super.redraw(options);
            }
        }
        _hover(show) {
            const drawingElement = this.drawingElement;
            const options = this.options;
            const hover = options.hover;
            if (hover && hover.fill) {
                const fill = show ? normalizeDrawingOptions(hover.fill) : options.fill;
                drawingElement.fill(fill.color, fill.opacity);
            }
        }
        _stroke(strokeOptions) {
            const options = this.options;
            deepExtend(options, {
                stroke: strokeOptions
            });
            strokeOptions = options.stroke;
            let stroke = null;
            if (strokeOptions.width > 0) {
                stroke = {
                    color: strokeOptions.color,
                    width: strokeOptions.width,
                    opacity: strokeOptions.opacity,
                    dashType: strokeOptions.dashType
                };
            }
            this.drawingElement.options.set('stroke', stroke);
        }
        _fill(fillOptions) {
            const options = this.options;
            deepExtend(options, {
                fill: fillOptions || {}
            });
            const fill = options.fill;
            if (fill.gradient) {
                const gradient = fill.gradient;
                const GradientClass = (gradient.type === 'radial' ? kendo_drawing_cmn_chunk_js.i : kendo_drawing_cmn_chunk_js.L);
                this.drawingElement.fill(new GradientClass(gradient));
            }
            else {
                this.drawingElement.fill(fill.color, fill.opacity);
            }
        }
    }

    const defaultOptions$9 = {
        stroke: {
            color: TRANSPARENT,
            width: 0
        },
        fill: {
            color: 'black'
        }
    };
    class MarkerBase extends VisualBase {
        constructor(options) {
            options = deepExtend({}, defaultOptions$9, options);
            super(options);
            const anchor = this.options.anchor || {};
            this.anchor = new kendo_drawing_cmn_chunk_js.P(anchor.x, anchor.y);
            this.createElement();
        }
        createElement() { }
        _transformToPath(point, path) {
            const transform = path.transform();
            if (point && transform) {
                point = point.transformCopy(transform);
            }
            return point;
        }
        redraw(options) {
            if (options) {
                if (options.position) {
                    this.options.position = options.position;
                }
                super.redraw(options);
            }
        }
    }

    const defaultOptions$8 = {
        path: 'M 0 0 L 10 5 L 0 10 L 3 5 z',
        anchor: {
            x: 10,
            y: 5
        }
    };
    class ArrowMarker extends MarkerBase {
        constructor(options) {
            options = deepExtend({}, defaultOptions$8, options);
            super(options);
        }
        createElement() {
            const options = this.options;
            this.drawingElement = kendo_drawing_cmn_chunk_js.b.parse(options.path, {
                fill: options.fill,
                stroke: options.stroke
            });
        }
        positionMarker(path) {
            const points = this._linePoints(path);
            const start = points.start;
            const end = points.end;
            const transform$1 = kendo_drawing_cmn_chunk_js.t();
            if (start) {
                transform$1.rotate(lineAngle(start, end), end);
            }
            if (end) {
                const anchor = this.anchor;
                const translate = end.clone().translate(-anchor.x, -anchor.y);
                transform$1.translate(translate.x, translate.y);
            }
            this.drawingElement.transform(transform$1);
        }
        _linePoints(path) {
            const options = this.options;
            const segments = path.segments;
            let startPoint, endPoint, targetSegment;
            if (options.position === START$1) {
                targetSegment = segments[0];
                if (targetSegment) {
                    endPoint = targetSegment.anchor();
                    startPoint = targetSegment.controlOut();
                    const nextSegment = segments[1];
                    if (!startPoint && nextSegment) {
                        startPoint = nextSegment.anchor();
                    }
                }
            }
            else {
                targetSegment = segments[segments.length - 1];
                if (targetSegment) {
                    endPoint = targetSegment.anchor();
                    startPoint = targetSegment.controlIn();
                    const prevSegment = segments[segments.length - 2];
                    if (!startPoint && prevSegment) {
                        startPoint = prevSegment.anchor();
                    }
                }
            }
            if (endPoint) {
                return {
                    start: this._transformToPath(startPoint, path),
                    end: this._transformToPath(endPoint, path)
                };
            }
        }
    }

    let Canvas$1 = class Canvas {
        constructor(element, options) {
            this._translate = (x, y) => {
                const viewBox = this._viewBox;
                if (defined(x) && defined(y)) {
                    viewBox.x = x;
                    viewBox.y = y;
                    this.surface.translate({ x: x, y: y });
                }
                return {
                    x: viewBox.x,
                    y: viewBox.y
                };
            };
            options = options || {};
            this.element = element;
            this.surface = kendo_drawing_cmn_chunk_js.n.create(element, options);
            if (isFunction$1(this.surface.translate)) {
                this.translate = this._translate;
            }
            this.drawingElement = new kendo_drawing_cmn_chunk_js.G();
            this._viewBox = new Rect(0, 0, options.width, options.height);
            this.size(this._viewBox);
        }
        bounds() {
            const box = this.drawingElement.clippedBBox();
            return new Rect(0, 0, box.width(), box.height());
        }
        size(size) {
            const viewBox = this._viewBox;
            if (defined(size)) {
                viewBox.width = size.width;
                viewBox.height = size.height;
                this.surface.setSize(size);
            }
            return {
                width: viewBox.width,
                height: viewBox.height
            };
        }
        draw() {
            this.surface.draw(this.drawingElement);
        }
        append(visual) {
            this.drawingElement.append(visual.drawingContainer());
            return this;
        }
        remove(visual) {
            this.drawingElement.remove(visual.drawingContainer());
        }
        insertBefore() { }
        clear() {
            this.drawingElement.clear();
        }
        destroy(clearHtml) {
            this.surface.destroy();
            if (clearHtml) {
                removeChildren$1(this.element);
                this.element.remove();
            }
        }
    };

    const AutoSizeableMixin = {
        _setScale: function () {
            const options = this.options;
            const originWidth = this._originWidth;
            const originHeight = this._originHeight;
            let scaleX = options.width / originWidth;
            let scaleY = options.height / originHeight;
            if (!isNumber(scaleX)) {
                scaleX = 1;
            }
            if (!isNumber(scaleY)) {
                scaleY = 1;
            }
            this._transform.scale = new Scale(scaleX, scaleY);
        },
        _setTranslate: function () {
            const options = this.options;
            const x = options.x || 0;
            const y = options.y || 0;
            this._transform.translate = new Translation(x, y);
        },
        _initSize: function () {
            const options = this.options;
            let transform = false;
            if (options.autoSize !== false && (isDefined(options.width) || isDefined(options.height))) {
                this._measure(true);
                this._setScale();
                transform = true;
            }
            if (isDefined(options.x) || isDefined(options.y)) {
                this._setTranslate();
                transform = true;
            }
            if (transform) {
                this._renderTransform();
            }
        },
        _updateSize: function (options) {
            let update = false;
            if (this.options.autoSize !== false && this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
                update = true;
                this._measure(true);
                this._setScale();
            }
            if (this._diffNumericOptions(options, [X, Y])) {
                update = true;
                this._setTranslate();
            }
            if (update) {
                this._renderTransform();
            }
            return update;
        }
    };

    class Circle extends VisualBase {
        constructor(options) {
            super(options);
            // Bind mixin methods to current instance
            this._setScale = AutoSizeableMixin._setScale.bind(this);
            this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
            this._initSize = AutoSizeableMixin._initSize.bind(this);
            this._updateSize = AutoSizeableMixin._updateSize.bind(this);
            this._initCircle();
            this._initSize();
        }
        redraw(options) {
            if (options) {
                const circleOptions = this.options;
                if (options.center) {
                    deepExtend(circleOptions, {
                        center: options.center
                    });
                    this._center.move(circleOptions.center.x, circleOptions.center.y);
                }
                if (this._diffNumericOptions(options, ['radius'])) {
                    this._circle.setRadius(circleOptions.radius);
                }
                this._updateSize(options);
                super.redraw.call(this, options);
            }
        }
        _initCircle() {
            const options = this.options;
            let width = options.width;
            let height = options.height;
            let radius = options.radius;
            if (!defined(radius)) {
                if (!defined(width)) {
                    width = height;
                }
                if (!defined(height)) {
                    height = width;
                }
                options.radius = radius = Math.min(width, height) / 2;
            }
            const center = options.center || { x: radius, y: radius };
            this._center = new kendo_drawing_cmn_chunk_js.P(center.x, center.y);
            this._circle = new kendo_drawing_cmn_chunk_js.g(this._center, radius);
            this.drawingElement = new kendo_drawing_cmn_chunk_js.f(this._circle, {
                stroke: options.stroke
            });
            this._fill();
        }
    }

    const defaultOptions$7 = {
        radius: 4,
        anchor: {
            x: 0,
            y: 0
        }
    };
    class CircleMarker extends MarkerBase {
        constructor(options) {
            options = deepExtend({}, defaultOptions$7, options);
            super(options);
        }
        createElement() {
            const options = this.options;
            this.drawingElement = new kendo_drawing_cmn_chunk_js.f(new kendo_drawing_cmn_chunk_js.g(this.anchor, options.radius), {
                fill: options.fill,
                stroke: options.stroke
            });
        }
        positionMarker(path) {
            const options = this.options;
            const position = options.position;
            const segments = path.segments;
            let targetSegment;
            let point;
            if (position === START$1) {
                targetSegment = segments[0];
            }
            else {
                targetSegment = segments[segments.length - 1];
            }
            if (targetSegment) {
                point = this._transformToPath(targetSegment.anchor(), path);
                this.drawingElement.transform(kendo_drawing_cmn_chunk_js.t().translate(point.x, point.y));
            }
        }
    }

    class Group extends Element {
        constructor(options) {
            options = deepExtend({ autoSize: false }, options);
            super(options);
            this.children = [];
            this._childrenChange = false;
            // Bind mixin methods to current instance
            this._setScale = AutoSizeableMixin._setScale.bind(this);
            this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
            this._initSize = AutoSizeableMixin._initSize.bind(this);
            this._updateSize = AutoSizeableMixin._updateSize.bind(this);
            this.drawingElement = new kendo_drawing_cmn_chunk_js.G();
            this._initSize();
        }
        append(visual) {
            this.drawingElement.append(visual.drawingContainer());
            this.children.push(visual);
            this._childrenChange = true;
        }
        ;
        remove(visual) {
            if (this._remove(visual)) {
                this._childrenChange = true;
            }
        }
        _remove(visual) {
            const index = this.children.indexOf(visual);
            if (index >= 0) {
                this.drawingElement.removeAt(index);
                this.children.splice(index, 1);
                return true;
            }
        }
        clear() {
            this.drawingElement.clear();
            this.children = [];
            this._childrenChange = true;
        }
        toFront(visuals) {
            let visual;
            for (let i = 0; i < visuals.length; i++) {
                visual = visuals[i];
                if (this._remove(visual)) {
                    this.append(visual);
                }
            }
        }
        // TO DO: add drawing group support for moving and inserting children
        toBack(visuals) {
            this._reorderChildren(visuals, 0);
        }
        toIndex(visuals, indices) {
            this._reorderChildren(visuals, indices);
        }
        _reorderChildren(visuals, indices) {
            const group = this.drawingElement;
            const drawingChildren = group.children.slice(0);
            const children = this.children;
            const fixedPosition = isNumber(indices);
            let i, index, toIndex, drawingElement, visual;
            for (i = 0; i < visuals.length; i++) {
                visual = visuals[i];
                drawingElement = visual.drawingContainer();
                index = children.indexOf(visual);
                if (index >= 0) {
                    drawingChildren.splice(index, 1);
                    children.splice(index, 1);
                    toIndex = fixedPosition ? indices : indices[i];
                    drawingChildren.splice(toIndex, 0, drawingElement);
                    children.splice(toIndex, 0, visual);
                }
            }
            group.clear();
            group.append(...drawingChildren);
        }
        redraw(options) {
            if (options) {
                if (this._childrenChange) {
                    this._childrenChange = false;
                    if (!this._updateSize(options)) {
                        this._initSize();
                    }
                }
                else {
                    this._updateSize(options);
                }
                super.redraw(options);
            }
        }
        _boundingBox() {
            const children = this.children;
            let boundingBox;
            let visual, childBoundingBox;
            for (let i = 0; i < children.length; i++) {
                visual = children[i];
                if (visual.visible() && visual._includeInBBox !== false) {
                    childBoundingBox = visual.drawingContainer().clippedBBox(null);
                    if (childBoundingBox) {
                        if (boundingBox) {
                            boundingBox = kendo_drawing_cmn_chunk_js.R.union(boundingBox, childBoundingBox);
                        }
                        else {
                            boundingBox = childBoundingBox;
                        }
                    }
                }
            }
            return boundingBox;
        }
    }

    class Image extends Element {
        constructor(options) {
            super(options);
            this._initImage();
        }
        redraw(options) {
            if (options) {
                if (options.source) {
                    this.drawingElement.src(options.source);
                }
                if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
                    this.drawingElement.rect(this._rect());
                }
                super.redraw(options);
            }
        }
        _initImage() {
            const options = this.options;
            const rect = this._rect();
            this.drawingElement = new kendo_drawing_cmn_chunk_js.I(options.source, rect);
        }
        _rect() {
            const sizeOptions = sizeOptionsOrDefault(this.options);
            const origin = new kendo_drawing_cmn_chunk_js.P(sizeOptions.x, sizeOptions.y);
            const size = new kendo_drawing_cmn_chunk_js.q(sizeOptions.width, sizeOptions.height);
            return new kendo_drawing_cmn_chunk_js.R(origin, size);
        }
    }

    class Layout extends Group {
        constructor(rect, options) {
            super(options);
            this.drawingElement = new kendo_drawing_cmn_chunk_js.k(toDrawingRect(rect), options);
            this._initSize();
        }
        rect(rect) {
            if (rect) {
                this.drawingElement.rect(toDrawingRect(rect));
            }
            else {
                const drawingRect = this.drawingElement.rect();
                if (drawingRect) {
                    return new Rect(drawingRect.origin.x, drawingRect.origin.y, drawingRect.size.width, drawingRect.size.height);
                }
            }
        }
        reflow() {
            this.drawingElement.reflow();
        }
        redraw(options) {
            deepExtend(this.drawingElement.options, options);
            super.redraw.call(this, options);
        }
    }

    const MarkerPathMixin = {
        _getPath: function (position) {
            let path = this.drawingElement;
            if (path instanceof kendo_drawing_cmn_chunk_js.h) {
                if (position === START$1) {
                    path = path.paths[0];
                }
                else {
                    path = path.paths[path.paths.length - 1];
                }
            }
            if (path && path.segments.length) {
                return path;
            }
        },
        _normalizeMarkerOptions: function (options) {
            const startCap = options.startCap;
            const endCap = options.endCap;
            if (isString$1(startCap)) {
                options.startCap = {
                    type: startCap
                };
            }
            if (isString$1(endCap)) {
                options.endCap = {
                    type: endCap
                };
            }
        },
        _removeMarker: function (position) {
            const marker = this._markers[position];
            if (marker) {
                this.drawingContainer().remove(marker.drawingElement);
                delete this._markers[position];
            }
        },
        _createMarkers: function () {
            const options = this.options;
            this._normalizeMarkerOptions(options);
            this._markers = {};
            this._markers[START$1] = this._createMarker(options.startCap, START$1);
            this._markers[END$1] = this._createMarker(options.endCap, END$1);
        },
        _createMarker: function (options, position) {
            const type = (options || {}).type;
            const path = this._getPath(position);
            let markerType, marker;
            if (!path) {
                this._removeMarker(position);
                return;
            }
            if (type === Markers.filledCircle) {
                markerType = CircleMarker;
            }
            else if (type === Markers.arrowStart || type === Markers.arrowEnd) {
                markerType = ArrowMarker;
            }
            else {
                this._removeMarker(position);
            }
            if (markerType) {
                marker = new markerType(deepExtend({}, options, {
                    position: position
                }));
                marker.positionMarker(path);
                this.drawingContainer().append(marker.drawingElement);
                return marker;
            }
        },
        _positionMarker: function (position) {
            const marker = this._markers[position];
            if (marker) {
                const path = this._getPath(position);
                if (path) {
                    marker.positionMarker(path);
                }
                else {
                    this._removeMarker(position);
                }
            }
        },
        _capMap: {
            start: 'startCap',
            end: 'endCap'
        },
        _redrawMarker: function (pathChange, position, options) {
            this._normalizeMarkerOptions(options);
            const pathOptions = this.options;
            const cap = this._capMap[position];
            const pathCapType = (pathOptions[cap] || {}).type;
            const optionsCap = options[cap];
            let created = false;
            if (optionsCap) {
                pathOptions[cap] = deepExtend({}, pathOptions[cap], optionsCap);
                if (optionsCap.type && pathCapType !== optionsCap.type) {
                    this._removeMarker(position);
                    this._markers[position] = this._createMarker(pathOptions[cap], position);
                    created = true;
                }
                else if (this._markers[position]) {
                    this._markers[position].redraw(optionsCap);
                }
            }
            else if (pathChange && !this._markers[position] && pathOptions[cap]) {
                this._markers[position] = this._createMarker(pathOptions[cap], position);
                created = true;
            }
            return created;
        },
        _redrawMarkers: function (pathChange, options) {
            if (!this._redrawMarker(pathChange, START$1, options) && pathChange) {
                this._positionMarker(START$1);
            }
            if (!this._redrawMarker(pathChange, END$1, options) && pathChange) {
                this._positionMarker(END$1);
            }
        }
    };

    class Line extends VisualBase {
        constructor(options) {
            super(options);
            this._capMap = MarkerPathMixin._capMap;
            this.container = new kendo_drawing_cmn_chunk_js.G();
            this._getPath = MarkerPathMixin._getPath.bind(this);
            this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
            this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
            this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
            this._createMarker = MarkerPathMixin._createMarker.bind(this);
            this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
            this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
            this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
            this._initPath();
            this._createMarkers();
        }
        drawingContainer() {
            return this.container;
        }
        redraw(options) {
            if (options) {
                options = options || {};
                const from = options.from;
                const to = options.to;
                if (from) {
                    this.options.from = from;
                }
                if (to) {
                    this.options.to = to;
                }
                if (from || to) {
                    this._drawPath();
                    this._redrawMarkers(true, options);
                }
                else {
                    this._redrawMarkers(false, options);
                }
                super.redraw(options);
            }
        }
        _initPath() {
            const options = this.options;
            const drawingElement = this.drawingElement = new kendo_drawing_cmn_chunk_js.b({
                stroke: options.stroke
            });
            this._fill();
            this._drawPath();
            this.container.append(drawingElement);
        }
        _drawPath() {
            const options = this.options;
            const drawingElement = this.drawingElement;
            const from = options.from || new Point();
            const to = options.to || new Point();
            drawingElement.segments.elements([
                createSegment(from.x, from.y),
                createSegment(to.x, to.y)
            ]);
        }
    }

    class Path extends VisualBase {
        constructor(options) {
            options = deepExtend({ autoSize: true }, options);
            super(options);
            this._capMap = MarkerPathMixin._capMap;
            this.container = new kendo_drawing_cmn_chunk_js.G();
            this._setScale = AutoSizeableMixin._setScale.bind(this);
            this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
            this._initSize = AutoSizeableMixin._initSize.bind(this);
            this._updateSize = AutoSizeableMixin._updateSize.bind(this);
            this._getPath = MarkerPathMixin._getPath.bind(this);
            this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
            this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
            this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
            this._createMarker = MarkerPathMixin._createMarker.bind(this);
            this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
            this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
            this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
            this._createElements();
            this._initSize();
        }
        drawingContainer() {
            return this.container;
        }
        data(value) {
            const options = this.options;
            if (value) {
                if (options.data !== value) {
                    options.data = value;
                    this._setData(value);
                    this._initSize();
                    this._redrawMarkers(true, {});
                }
            }
            else {
                return options.data;
            }
        }
        redraw(options) {
            if (options) {
                super.redraw(options);
                const pathOptions = this.options;
                const data = options.data;
                if (defined(data) && pathOptions.data !== data) {
                    pathOptions.data = data;
                    this._setData(data);
                    if (!this._updateSize(options)) {
                        this._initSize();
                    }
                    this._redrawMarkers(true, options);
                }
                else {
                    this._updateSize(options);
                    this._redrawMarkers(false, options);
                }
            }
        }
        _createElements() {
            const options = this.options;
            this.drawingElement = kendo_drawing_cmn_chunk_js.b.parse(options.data || '', {
                stroke: options.stroke
            });
            this._fill();
            this.container.append(this.drawingElement);
            this._createMarkers();
        }
        _setData(data) {
            const drawingElement = this.drawingElement;
            const multipath = kendo_drawing_cmn_chunk_js.b.parse(data || '');
            const paths = multipath.paths.slice(0);
            multipath.paths.elements([]);
            drawingElement.paths.elements(paths);
        }
    }

    class Polyline extends VisualBase {
        constructor(options) {
            options = deepExtend({ points: [] }, options);
            super(options);
            this._capMap = MarkerPathMixin._capMap;
            this.container = new kendo_drawing_cmn_chunk_js.G();
            this._getPath = MarkerPathMixin._getPath.bind(this);
            this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
            this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
            this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
            this._createMarker = MarkerPathMixin._createMarker.bind(this);
            this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
            this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
            this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
            this._initPath();
            this._createMarkers();
        }
        drawingContainer() {
            return this.container;
        }
        points(points) {
            const options = this.options;
            if (points) {
                options.points = points;
                this._updatePath();
            }
            else {
                return options.points;
            }
        }
        redraw(options) {
            if (options) {
                const points = options.points;
                super.redraw.call(this, options);
                if (points && this._pointsDiffer(points)) {
                    this.points(points);
                    this._redrawMarkers(true, options);
                }
                else {
                    this._redrawMarkers(false, options);
                }
            }
        }
        _initPath() {
            const options = this.options;
            this.drawingElement = new kendo_drawing_cmn_chunk_js.b({
                stroke: options.stroke
            });
            this._fill();
            this.container.append(this.drawingElement);
            if (options.points) {
                this._updatePath();
            }
        }
        _pointsDiffer(points) {
            const currentPoints = this.options.points;
            let differ = currentPoints.length !== points.length;
            if (!differ) {
                for (let i = 0; i < points.length; i++) {
                    if (currentPoints[i].x !== points[i].x || currentPoints[i].y !== points[i].y) {
                        differ = true;
                        break;
                    }
                }
            }
            return differ;
        }
        _updatePath() {
            const drawingElement = this.drawingElement;
            const options = this.options;
            const points = options.points;
            const segments = [];
            let point;
            for (let i = 0; i < points.length; i++) {
                point = points[i];
                segments.push(createSegment(point.x, point.y));
            }
            drawingElement.segments.elements(segments);
        }
    }

    class Rectangle extends VisualBase {
        constructor(options) {
            super(options);
            this._initPath();
            this._setPosition();
        }
        _setPosition() {
            const options = this.options;
            const x = options.x;
            const y = options.y;
            if (defined(x) || defined(y)) {
                this.position(x || 0, y || 0);
            }
        }
        redraw(options) {
            if (options) {
                super.redraw(options);
                if (this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
                    this._drawPath();
                }
                if (this._diffNumericOptions(options, [X, Y])) {
                    this._setPosition();
                }
            }
        }
        _initPath() {
            const options = this.options;
            this.drawingElement = new kendo_drawing_cmn_chunk_js.b({
                stroke: options.stroke,
                closed: true
            });
            this._fill();
            this._drawPath();
        }
        _drawPath() {
            const drawingElement = this.drawingElement;
            const sizeOptions = sizeOptionsOrDefault(this.options);
            const width = sizeOptions.width;
            const height = sizeOptions.height;
            drawingElement.segments.elements([
                createSegment(0, 0),
                createSegment(width, 0),
                createSegment(width, height),
                createSegment(0, height)
            ]);
        }
    }

    const textColor = (options) => {
        if (options && options.color) {
            options = deepExtend({}, options, {
                fill: {
                    color: options.color
                }
            });
        }
        return options;
    };
    const defaultOptions$6 = {
        fontSize: 15,
        fontFamily: 'sans-serif',
        stroke: {
            width: 0
        },
        fill: {
            color: 'black'
        },
        autoSize: true
    };
    class TextBlock extends VisualBase {
        constructor(options) {
            options = deepExtend({}, defaultOptions$6, options);
            options = textColor(options);
            super(options);
            this._setScale = AutoSizeableMixin._setScale.bind(this);
            this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
            this._initSize = AutoSizeableMixin._initSize.bind(this);
            this._updateSize = AutoSizeableMixin._updateSize.bind(this);
            this._font();
            this._initText();
            this._initSize();
        }
        _initText() {
            const options = this.options;
            this.drawingElement = new kendo_drawing_cmn_chunk_js.T(defined(options.text) ? options.text : '', new kendo_drawing_cmn_chunk_js.P(), {
                font: options.font
            });
            this._fill();
            this._stroke();
        }
        _font() {
            const options = this.options;
            if (options.fontFamily && defined(options.fontSize)) {
                const fontOptions = [];
                if (options.fontStyle) {
                    fontOptions.push(options.fontStyle);
                }
                if (options.fontWeight) {
                    fontOptions.push(options.fontWeight);
                }
                fontOptions.push(options.fontSize + (isNumber(options.fontSize) ? 'px' : ''));
                fontOptions.push(options.fontFamily);
                options.font = fontOptions.join(' ');
            }
            else {
                delete options.font;
            }
        }
        content(text) {
            return this.drawingElement.content(text);
        }
        redraw(options) {
            if (options) {
                let sizeChanged = false;
                const textOptions = this.options;
                options = textColor(options);
                super.redraw(options);
                if (options.fontFamily || defined(options.fontSize) || options.fontStyle || options.fontWeight) {
                    deepExtend(textOptions, {
                        fontFamily: options.fontFamily,
                        fontSize: options.fontSize,
                        fontStyle: options.fontStyle,
                        fontWeight: options.fontWeight
                    });
                    this._font();
                    this.drawingElement.options.set('font', textOptions.font);
                    sizeChanged = true;
                }
                if (options.text) {
                    this.content(options.text);
                    sizeChanged = true;
                }
                if (!this._updateSize(options) && sizeChanged) {
                    this._initSize();
                }
            }
        }
    }

    /**
     * The Sugiyama aka layered layout algorithm.
     *
     * @type {*}
     */
    class LayeredLayout extends LayoutBase {
        constructor(diagram) {
            super();
            if (isUndefined(diagram)) {
                throw new Error('Diagram is not specified.');
            }
            this.diagram = diagram;
        }
        layout(options) {
            this.transferOptions(options);
            const adapter = new DiagramToHyperTreeAdapter(this.diagram);
            const graph = adapter.convert(options);
            if (graph.isEmpty()) {
                return;
            }
            // split into connected components
            const components = graph.getConnectedComponents();
            if (isEmpty(components)) {
                return;
            }
            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                this.layoutGraph(component, options);
            }
            const finalNodeSet = this.gridLayoutComponents(components);
            return new LayoutState(this.diagram, finalNodeSet);
        }
        /**
         * Initializes the runtime data properties of the layout.
         *
         * @private
         */
        _initRuntimeProperties() {
            for (let k = 0; k < this.graph.nodes.length; k++) {
                const node = this.graph.nodes[k];
                node.layer = -1;
                node.downstreamLinkCount = 0;
                node.upstreamLinkCount = 0;
                node.isVirtual = false;
                node.uBaryCenter = 0.0;
                node.dBaryCenter = 0.0;
                node.upstreamPriority = 0;
                node.downstreamPriority = 0;
                node.gridPosition = 0;
            }
        }
        _prepare(graph) {
            const current = [];
            let i, l, link;
            // defines a mapping of a node to the layer index
            const layerMap = new Dictionary();
            let layerCount = 0;
            let targetLayer, next, target;
            forEach(graph.nodes, function (node) {
                if (node.incoming.length === 0) {
                    layerMap.set(node, 0);
                    current.push(node);
                }
            });
            while (current.length > 0) {
                next = current.shift();
                for (i = 0; i < next.outgoing.length; i++) {
                    link = next.outgoing[i];
                    target = link.target;
                    if (layerMap.containsKey(target)) {
                        targetLayer = Math.max(layerMap.get(next) + 1, layerMap.get(target));
                    }
                    else {
                        targetLayer = layerMap.get(next) + 1;
                    }
                    layerMap.set(target, targetLayer);
                    if (targetLayer > layerCount) {
                        layerCount = targetLayer;
                    }
                    if (!contains(current, target)) {
                        current.push(target);
                    }
                }
            }
            const sortedNodes = layerMap.keys();
            sortedNodes.sort(function (o1, o2) {
                const o1layer = layerMap.get(o1);
                const o2layer = layerMap.get(o2);
                return sign(o2layer - o1layer);
            });
            for (let n = 0; n < sortedNodes.length; ++n) {
                const node = sortedNodes[n];
                let minLayer = Number.MAX_VALUE;
                if (node.outgoing.length === 0) {
                    continue;
                }
                for (l = 0; l < node.outgoing.length; ++l) {
                    link = node.outgoing[l];
                    minLayer = Math.min(minLayer, layerMap.get(link.target));
                }
                if (minLayer > 1) {
                    layerMap.set(node, minLayer - 1);
                }
            }
            this.layers = [];
            let layer;
            for (i = 0; i < layerCount + 1; i++) {
                layer = [];
                layer.linksTo = {};
                this.layers.push(layer);
            }
            layerMap.forEach(function (node, layerVal) {
                node.layer = layerVal;
                this.layers[layerVal].push(node);
            }, this);
            // set initial grid positions
            for (l = 0; l < this.layers.length; l++) {
                layer = this.layers[l];
                for (i = 0; i < layer.length; i++) {
                    layer[i].gridPosition = i;
                }
            }
        }
        /**
         * Performs the layout of a single component.
         */
        layoutGraph(graph, options) {
            if (isUndefined(graph)) {
                throw new Error('No graph given or graph analysis of the diagram failed.');
            }
            if (isDefined(options)) {
                this.transferOptions(options);
            }
            this.graph = graph;
            // sets unique indices on the nodes
            graph.setItemIndices();
            // ensures no cycles present for this layout
            const reversedEdges = graph.makeAcyclic();
            // define the runtime props being used by the layout algorithm
            this._initRuntimeProperties();
            this._prepare(graph);
            this._dummify();
            this._optimizeCrossings();
            this._swapPairs();
            this.arrangeNodes();
            this._moveThingsAround();
            this._dedummify();
            // re-reverse the links which were switched earlier
            forEach(reversedEdges, function (e) {
                if (e.points) {
                    e.points.reverse();
                }
            });
        }
        setMinDist(m, _n, minDist) {
            const l = m.layer;
            const i = m.layerIndex;
            // Validate indices to prevent prototype pollution
            if (!Number.isInteger(l) || !Number.isInteger(i) || l < 0 || i < 0) {
                throw new Error('Invalid layer or index value.');
            }
            this.minDistances[l][i] = minDist;
        }
        getMinDist(m, n) {
            let dist = 0;
            const i1 = m.layerIndex, i2 = n.layerIndex, l = m.layer, min = Math.min(i1, i2), max = Math.max(i1, i2);
            // use Sum()?
            for (let k = min; k < max; ++k) {
                dist += this.minDistances[l][k];
            }
            return dist;
        }
        placeLeftToRight(leftClasses) {
            const leftPos = new Dictionary();
            let n, node;
            for (let c = 0; c < this.layers.length; ++c) {
                const classNodes = leftClasses[c];
                if (!classNodes) {
                    continue;
                }
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    if (!leftPos.containsKey(node)) {
                        this.placeLeft(node, leftPos, c);
                    }
                }
                // adjust class
                let d = Number.POSITIVE_INFINITY;
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    const rightSibling = this.rightSibling(node);
                    if (rightSibling && this.nodeLeftClass.get(rightSibling) !== c) {
                        d = Math.min(d, leftPos.get(rightSibling) - leftPos.get(node) - this.getMinDist(node, rightSibling));
                    }
                }
                if (d === Number.POSITIVE_INFINITY) {
                    const D = [];
                    for (n = 0; n < classNodes.length; n++) {
                        node = classNodes[n];
                        const neighbors = [];
                        addRange(neighbors, this.upNodes.get(node));
                        addRange(neighbors, this.downNodes.get(node));
                        for (let e = 0; e < neighbors.length; e++) {
                            const neighbor = neighbors[e];
                            if (this.nodeLeftClass.get(neighbor) < c) {
                                D.push(leftPos.get(neighbor) - leftPos.get(node));
                            }
                        }
                    }
                    D.sort();
                    if (D.length === 0) {
                        d = 0;
                    }
                    else if (D.length % 2 === 1) {
                        d = D[this.intDiv(D.length, 2)];
                    }
                    else {
                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
                    }
                }
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    leftPos.set(node, leftPos.get(node) + d);
                }
            }
            return leftPos;
        }
        placeRightToLeft(rightClasses) {
            const rightPos = new Dictionary();
            let n, node;
            for (let c = 0; c < this.layers.length; ++c) {
                const classNodes = rightClasses[c];
                if (!classNodes) {
                    continue;
                }
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    if (!rightPos.containsKey(node)) {
                        this.placeRight(node, rightPos, c);
                    }
                }
                // adjust class
                let d = Number.NEGATIVE_INFINITY;
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    const leftSibling = this.leftSibling(node);
                    if (leftSibling && this.nodeRightClass.get(leftSibling) !== c) {
                        d = Math.max(d, rightPos.get(leftSibling) - rightPos.get(node) + this.getMinDist(leftSibling, node));
                    }
                }
                if (d === Number.NEGATIVE_INFINITY) {
                    const D = [];
                    for (n = 0; n < classNodes.length; n++) {
                        node = classNodes[n];
                        const neighbors = [];
                        addRange(neighbors, this.upNodes.get(node));
                        addRange(neighbors, this.downNodes.get(node));
                        for (let e = 0; e < neighbors.length; e++) {
                            const neighbor = neighbors[e];
                            if (this.nodeRightClass.get(neighbor) < c) {
                                D.push(rightPos.get(node) - rightPos.get(neighbor));
                            }
                        }
                    }
                    D.sort();
                    if (D.length === 0) {
                        d = 0;
                    }
                    else if (D.length % 2 === 1) {
                        d = D[this.intDiv(D.length, 2)];
                    }
                    else {
                        d = (D[this.intDiv(D.length, 2) - 1] + D[this.intDiv(D.length, 2)]) / 2;
                    }
                }
                for (n = 0; n < classNodes.length; n++) {
                    node = classNodes[n];
                    rightPos.set(node, rightPos.get(node) + d);
                }
            }
            return rightPos;
        }
        _getLeftWing() {
            const leftWing = { value: null };
            const result = this.computeClasses(leftWing, 1);
            this.nodeLeftClass = leftWing.value;
            return result;
        }
        _getRightWing() {
            const rightWing = { value: null };
            const result = this.computeClasses(rightWing, -1);
            this.nodeRightClass = rightWing.value;
            return result;
        }
        computeClasses(wingPair, d) {
            let currentWing = 0;
            const wing = wingPair.value = new Dictionary();
            for (let l = 0; l < this.layers.length; ++l) {
                currentWing = l;
                const layer = this.layers[l];
                for (let n = d === 1 ? 0 : layer.length - 1; n >= 0 && n < layer.length; n += d) {
                    const node = layer[n];
                    if (!wing.containsKey(node)) {
                        wing.set(node, currentWing);
                        if (node.isVirtual) {
                            const ndsinl = this._nodesInLink(node);
                            for (let kk = 0; kk < ndsinl.length; kk++) {
                                const vnode = ndsinl[kk];
                                wing.set(vnode, currentWing);
                            }
                        }
                    }
                    else {
                        currentWing = wing.get(node);
                    }
                }
            }
            const wings = [];
            for (let i = 0; i < this.layers.length; i++) {
                wings.push(null);
            }
            wing.forEach(function (node, classIndex) {
                if (wings[classIndex] === null) {
                    wings[classIndex] = [];
                }
                wings[classIndex].push(node);
            });
            return wings;
        }
        _isVerticalLayout() {
            return this.options.subtype.toLowerCase() === 'up' || this.options.subtype.toLowerCase() === 'down' || this.options.subtype.toLowerCase() === 'vertical';
        }
        _isHorizontalLayout() {
            return this.options.subtype.toLowerCase() === 'right' || this.options.subtype.toLowerCase() === 'left' || this.options.subtype.toLowerCase() === 'horizontal';
        }
        _isIncreasingLayout() {
            // meaning that the visiting of the layers goes in the natural order of increasing layer index
            return this.options.subtype.toLowerCase() === 'right' || this.options.subtype.toLowerCase() === 'down';
        }
        _moveThingsAround() {
            let i, l, node, layer, n, w;
            // sort the layers by their grid position
            for (l = 0; l < this.layers.length; ++l) {
                layer = this.layers[l];
                layer.sort(this._gridPositionComparer.bind(this));
            }
            this.minDistances = [];
            for (l = 0; l < this.layers.length; ++l) {
                layer = this.layers[l];
                this.minDistances[l] = [];
                for (n = 0; n < layer.length; ++n) {
                    node = layer[n];
                    node.layerIndex = n;
                    this.minDistances[l][n] = this.options.nodeDistance;
                    if (n < layer.length - 1) {
                        if (this._isVerticalLayout()) {
                            this.minDistances[l][n] += (node.width + layer[n + 1].width) / 2;
                        }
                        else {
                            this.minDistances[l][n] += (node.height + layer[n + 1].height) / 2;
                        }
                    }
                }
            }
            this.downNodes = new Dictionary();
            this.upNodes = new Dictionary();
            forEach(this.graph.nodes, function (gNode) {
                this.downNodes.set(gNode, []);
                this.upNodes.set(gNode, []);
            }, this);
            forEach(this.graph.links, function (link) {
                const origin = link.source;
                const dest = link.target;
                let down = null, up = null;
                if (origin.layer > dest.layer) {
                    down = link.source;
                    up = link.target;
                }
                else {
                    up = link.source;
                    down = link.target;
                }
                this.downNodes.get(up).push(down);
                this.upNodes.get(down).push(up);
            }, this);
            this.downNodes.forEachValue(function (list) {
                list.sort(this._gridPositionComparer);
            }, this);
            this.upNodes.forEachValue(function (list) {
                list.sort(this._gridPositionComparer);
            }, this);
            for (l = 0; l < this.layers.length - 1; ++l) {
                layer = this.layers[l];
                for (w = 0; w < layer.length - 1; w++) {
                    const currentNode = layer[w];
                    if (!currentNode.isVirtual) {
                        continue;
                    }
                    const currDown = this.downNodes.get(currentNode)[0];
                    if (!currDown.isVirtual) {
                        continue;
                    }
                    for (n = w + 1; n < layer.length; ++n) {
                        node = layer[n];
                        if (!node.isVirtual) {
                            continue;
                        }
                        const downNode = this.downNodes.get(node)[0];
                        if (!downNode.isVirtual) {
                            continue;
                        }
                        if (currDown.gridPosition > downNode.gridPosition) {
                            const pos = currDown.gridPosition;
                            currDown.gridPosition = downNode.gridPosition;
                            downNode.gridPosition = pos;
                            const i1 = currDown.layerIndex;
                            const i2 = downNode.layerIndex;
                            this.layers[l + 1][i1] = downNode;
                            this.layers[l + 1][i2] = currDown;
                            currDown.layerIndex = i2;
                            downNode.layerIndex = i1;
                        }
                    }
                }
            }
            const leftClasses = this._getLeftWing();
            const rightClasses = this._getRightWing();
            const leftPos = this.placeLeftToRight(leftClasses);
            const rightPos = this.placeRightToLeft(rightClasses);
            const x = new Dictionary();
            forEach(this.graph.nodes, function (gNode) {
                x.set(gNode, (leftPos.get(gNode) + rightPos.get(gNode)) / 2);
            });
            const order = new Dictionary();
            const placed = new Dictionary();
            for (l = 0; l < this.layers.length; ++l) {
                layer = this.layers[l];
                let sequenceStart = -1; // , sequenceEnd = -1;
                for (n = 0; n < layer.length; ++n) {
                    node = layer[n];
                    order.set(node, 0);
                    placed.set(node, false);
                    if (node.isVirtual) {
                        if (sequenceStart === -1) {
                            sequenceStart = n;
                        }
                        else if (sequenceStart === n - 1) {
                            sequenceStart = n;
                        }
                        else {
                            // sequenceEnd = n;
                            order.set(layer[sequenceStart], 0);
                            if (x.get(node) - x.get(layer[sequenceStart]) === this.getMinDist(layer[sequenceStart], node)) {
                                placed.set(layer[sequenceStart], true);
                            }
                            else {
                                placed.set(layer[sequenceStart], false);
                            }
                            sequenceStart = n;
                        }
                    }
                }
            }
            const directions = [1, -1];
            forEach(directions, function (d) {
                const start = d === 1 ? 0 : this.layers.length - 1;
                for (let ll = start; ll >= 0 && ll < this.layers.length; ll += d) {
                    const layer2 = this.layers[ll];
                    let virtualStartIndex = this._firstVirtualNode(layer2);
                    let virtualStart = null;
                    let sequence = null;
                    if (virtualStartIndex !== -1) {
                        virtualStart = layer2[virtualStartIndex];
                        sequence = [];
                        for (i = 0; i < virtualStartIndex; i++) {
                            sequence.push(layer2[i]);
                        }
                    }
                    else {
                        virtualStart = null;
                        sequence = layer2;
                    }
                    if (sequence.length > 0) {
                        this._sequencer(x, null, virtualStart, d, sequence);
                        for (i = 0; i < sequence.length - 1; ++i) {
                            this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
                        }
                        if (virtualStart) {
                            this.setMinDist(sequence[sequence.length - 1], virtualStart, x.get(virtualStart) - x.get(sequence[sequence.length - 1]));
                        }
                    }
                    while (virtualStart) {
                        const virtualEnd = this.nextVirtualNode(layer2, virtualStart);
                        if (!virtualEnd) {
                            virtualStartIndex = virtualStart.layerIndex;
                            sequence = [];
                            for (i = virtualStartIndex + 1; i < layer2.length; i++) {
                                sequence.push(layer2[i]);
                            }
                            if (sequence.length > 0) {
                                this._sequencer(x, virtualStart, null, d, sequence);
                                for (i = 0; i < sequence.length - 1; ++i) {
                                    this.setMinDist(sequence[i], sequence[i + 1], x.get(sequence[i + 1]) - x.get(sequence[i]));
                                }
                                this.setMinDist(virtualStart, sequence[0], x.get(sequence[0]) - x.get(virtualStart));
                            }
                        }
                        else if (order.get(virtualStart) === d) {
                            virtualStartIndex = virtualStart.layerIndex;
                            const virtualEndIndex = virtualEnd.layerIndex;
                            sequence = [];
                            for (i = virtualStartIndex + 1; i < virtualEndIndex; i++) {
                                sequence.push(layer2[i]);
                            }
                            if (sequence.length > 0) {
                                this._sequencer(x, virtualStart, virtualEnd, d, sequence);
                            }
                            placed.set(virtualStart, true);
                        }
                        virtualStart = virtualEnd;
                    }
                    this.adjustDirections(ll, d, order, placed);
                }
            }, this);
            const fromLayerIndex = this._isIncreasingLayout() ? 0 : this.layers.length - 1;
            const reachedFinalLayerIndex = function (k, ctx) {
                if (ctx._isIncreasingLayout()) {
                    return k < ctx.layers.length;
                }
                else {
                    return k >= 0;
                }
            };
            const layerIncrement = this._isIncreasingLayout() ? +1 : -1;
            let offset = 0;
            /**
             * Calcs the max height of the given layer.
             */
            function maximumHeight(layer2, ctx) {
                let height = Number.MIN_VALUE;
                for (let nn = 0; nn < layer2.length; ++nn) {
                    const node2 = layer2[nn];
                    if (ctx._isVerticalLayout()) {
                        height = Math.max(height, node2.height);
                    }
                    else {
                        height = Math.max(height, node2.width);
                    }
                }
                return height;
            }
            for (i = fromLayerIndex; reachedFinalLayerIndex(i, this); i += layerIncrement) {
                layer = this.layers[i];
                const height = maximumHeight(layer, this);
                for (n = 0; n < layer.length; ++n) {
                    node = layer[n];
                    if (this._isVerticalLayout()) {
                        node.x = x.get(node);
                        node.y = offset + height / 2;
                    }
                    else {
                        node.x = offset + height / 2;
                        node.y = x.get(node);
                    }
                }
                offset += this.options.layerSeparation + height;
            }
        }
        adjustDirections(l, d, order, placed) {
            if (l + d < 0 || l + d >= this.layers.length) {
                return;
            }
            let prevBridge = null, prevBridgeTarget = null;
            const layer = this.layers[l + d];
            for (let n = 0; n < layer.length; ++n) {
                const nextBridge = layer[n];
                if (nextBridge.isVirtual) {
                    const nextBridgeTarget = this.getNeighborOnLayer(nextBridge, l);
                    if (nextBridgeTarget.isVirtual) {
                        if (prevBridge) {
                            let p = placed.get(prevBridgeTarget);
                            const clayer = this.layers[l];
                            const i1 = prevBridgeTarget.layerIndex;
                            const i2 = nextBridgeTarget.layerIndex;
                            for (let i = i1 + 1; i < i2; ++i) {
                                if (clayer[i].isVirtual) {
                                    p = p && placed.get(clayer[i]);
                                }
                            }
                            if (p) {
                                order.set(prevBridge, d);
                                const j1 = prevBridge.layerIndex;
                                const j2 = nextBridge.layerIndex;
                                for (let j = j1 + 1; j < j2; ++j) {
                                    if (layer[j].isVirtual) {
                                        order.set(layer[j], d);
                                    }
                                }
                            }
                        }
                        prevBridge = nextBridge;
                        prevBridgeTarget = nextBridgeTarget;
                    }
                }
            }
        }
        getNeighborOnLayer(node, l) {
            let neighbor = this.upNodes.get(node)[0];
            if (neighbor.layer === l) {
                return neighbor;
            }
            neighbor = this.downNodes.get(node)[0];
            if (neighbor.layer === l) {
                return neighbor;
            }
            return null;
        }
        _sequencer(x, virtualStart, virtualEnd, dir, sequence) {
            if (sequence.length === 1) {
                this._sequenceSingle(x, virtualStart, virtualEnd, dir, sequence[0]);
            }
            if (sequence.length > 1) {
                const r = sequence.length, t = this.intDiv(r, 2);
                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(0, t));
                this._sequencer(x, virtualStart, virtualEnd, dir, sequence.slice(t));
                this.combineSequences(x, virtualStart, virtualEnd, dir, sequence);
            }
        }
        _sequenceSingle(x, virtualStart, virtualEnd, dir, node) {
            const neighbors = dir === -1 ? this.downNodes.get(node) : this.upNodes.get(node);
            const n = neighbors.length;
            if (n !== 0) {
                if (n % 2 === 1) {
                    x.set(node, x.get(neighbors[this.intDiv(n, 2)]));
                }
                else {
                    x.set(node, (x.get(neighbors[this.intDiv(n, 2) - 1]) + x.get(neighbors[this.intDiv(n, 2)])) / 2);
                }
                if (virtualStart) {
                    x.set(node, Math.max(x.get(node), x.get(virtualStart) + this.getMinDist(virtualStart, node)));
                }
                if (virtualEnd) {
                    x.set(node, Math.min(x.get(node), x.get(virtualEnd) - this.getMinDist(node, virtualEnd)));
                }
            }
        }
        combineSequences(x, virtualStart, virtualEnd, dir, sequence) {
            const r = sequence.length, t = this.intDiv(r, 2);
            // collect left changes
            const leftHeap = [];
            let i, c, n, neighbors, neighbor, pair;
            for (i = 0; i < t; ++i) {
                c = 0;
                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
                for (n = 0; n < neighbors.length; ++n) {
                    neighbor = neighbors[n];
                    if (x.get(neighbor) >= x.get(sequence[i])) {
                        c++;
                    }
                    else {
                        c--;
                        leftHeap.push({ k: x.get(neighbor) + this.getMinDist(sequence[i], sequence[t - 1]), v: 2 });
                    }
                }
                leftHeap.push({ k: x.get(sequence[i]) + this.getMinDist(sequence[i], sequence[t - 1]), v: c });
            }
            if (virtualStart) {
                leftHeap.push({ k: x.get(virtualStart) + this.getMinDist(virtualStart, sequence[t - 1]), v: Number.MAX_VALUE });
            }
            leftHeap.sort(this._positionDescendingComparer.bind(this));
            // collect right changes
            const rightHeap = [];
            for (i = t; i < r; ++i) {
                c = 0;
                neighbors = dir === -1 ? this.downNodes.get(sequence[i]) : this.upNodes.get(sequence[i]);
                for (n = 0; n < neighbors.length; ++n) {
                    neighbor = neighbors[n];
                    if (x.get(neighbor) <= x.get(sequence[i])) {
                        c++;
                    }
                    else {
                        c--;
                        rightHeap.push({ k: x.get(neighbor) - this.getMinDist(sequence[i], sequence[t]), v: 2 });
                    }
                }
                rightHeap.push({ k: x.get(sequence[i]) - this.getMinDist(sequence[i], sequence[t]), v: c });
            }
            if (virtualEnd) {
                rightHeap.push({ k: x.get(virtualEnd) - this.getMinDist(virtualEnd, sequence[t]), v: Number.MAX_VALUE });
            }
            rightHeap.sort(this._positionAscendingComparer.bind(this));
            let leftRes = 0, rightRes = 0;
            const m = this.getMinDist(sequence[t - 1], sequence[t]);
            while (x.get(sequence[t]) - x.get(sequence[t - 1]) < m) {
                if (leftRes < rightRes) {
                    if (leftHeap.length === 0) {
                        x.set(sequence[t - 1], x.get(sequence[t]) - m);
                        break;
                    }
                    else {
                        pair = leftHeap.shift();
                        leftRes = leftRes + pair.v;
                        x.set(sequence[t - 1], pair.k);
                        x.set(sequence[t - 1], Math.max(x.get(sequence[t - 1]), x.get(sequence[t]) - m));
                    }
                }
                else {
                    if (rightHeap.length === 0) {
                        x.set(sequence[t], x.get(sequence[t - 1]) + m);
                        break;
                    }
                    else {
                        pair = rightHeap.shift();
                        rightRes = rightRes + pair.v;
                        x.set(sequence[t], pair.k);
                        x.set(sequence[t], Math.min(x.get(sequence[t]), x.get(sequence[t - 1]) + m));
                    }
                }
            }
            for (i = t - 2; i >= 0; i--) {
                x.set(sequence[i], Math.min(x.get(sequence[i]), x.get(sequence[t - 1]) - this.getMinDist(sequence[i], sequence[t - 1])));
            }
            for (i = t + 1; i < r; i++) {
                x.set(sequence[i], Math.max(x.get(sequence[i]), x.get(sequence[t]) + this.getMinDist(sequence[i], sequence[t])));
            }
        }
        placeLeft(node, leftPos, leftClass) {
            let pos = Number.NEGATIVE_INFINITY;
            forEach(this._getComposite(node), function (v) {
                const leftSibling = this.leftSibling(v);
                if (leftSibling && this.nodeLeftClass.get(leftSibling) === this.nodeLeftClass.get(v)) {
                    if (!leftPos.containsKey(leftSibling)) {
                        this.placeLeft(leftSibling, leftPos, leftClass);
                    }
                    pos = Math.max(pos, leftPos.get(leftSibling) + this.getMinDist(leftSibling, v));
                }
            }, this);
            if (pos === Number.NEGATIVE_INFINITY) {
                pos = 0;
            }
            forEach(this._getComposite(node), function (v) {
                leftPos.set(v, pos);
            });
        }
        placeRight(node, rightPos, rightClass) {
            let pos = Number.POSITIVE_INFINITY;
            forEach(this._getComposite(node), function (v) {
                const rightSibling = this.rightSibling(v);
                if (rightSibling && this.nodeRightClass.get(rightSibling) === this.nodeRightClass.get(v)) {
                    if (!rightPos.containsKey(rightSibling)) {
                        this.placeRight(rightSibling, rightPos, rightClass);
                    }
                    pos = Math.min(pos, rightPos.get(rightSibling) - this.getMinDist(v, rightSibling));
                }
            }, this);
            if (pos === Number.POSITIVE_INFINITY) {
                pos = 0;
            }
            forEach(this._getComposite(node), function (v) {
                rightPos.set(v, pos);
            });
        }
        leftSibling(node) {
            const layer = this.layers[node.layer], layerIndex = node.layerIndex;
            return layerIndex === 0 ? null : layer[layerIndex - 1];
        }
        rightSibling(node) {
            const layer = this.layers[node.layer];
            const layerIndex = node.layerIndex;
            return layerIndex === layer.length - 1 ? null : layer[layerIndex + 1];
        }
        _getComposite(node) {
            return node.isVirtual ? this._nodesInLink(node) : [node];
        }
        arrangeNodes() {
            let i, l, ni, layer, node;
            // Initialize node's base priority
            for (l = 0; l < this.layers.length; l++) {
                layer = this.layers[l];
                for (ni = 0; ni < layer.length; ni++) {
                    node = layer[ni];
                    node.upstreamPriority = node.upstreamLinkCount;
                    node.downstreamPriority = node.downstreamLinkCount;
                }
            }
            // Layout is invoked after MinimizeCrossings
            // so we may assume node's barycenters are initially correct
            const maxLayoutIterations = 2;
            for (let it = 0; it < maxLayoutIterations; it++) {
                for (i = this.layers.length - 1; i >= 1; i--) {
                    this.layoutLayer(false, i);
                }
                for (i = 0; i < this.layers.length - 1; i++) {
                    this.layoutLayer(true, i);
                }
            }
            // Offset the whole structure so that there are no gridPositions < 0
            let gridPos = Number.MAX_VALUE;
            for (l = 0; l < this.layers.length; l++) {
                layer = this.layers[l];
                for (ni = 0; ni < layer.length; ni++) {
                    node = layer[ni];
                    gridPos = Math.min(gridPos, node.gridPosition);
                }
            }
            if (gridPos < 0) {
                for (l = 0; l < this.layers.length; l++) {
                    layer = this.layers[l];
                    for (ni = 0; ni < layer.length; ni++) {
                        node = layer[ni];
                        node.gridPosition = node.gridPosition - gridPos;
                    }
                }
            }
        }
        /// <summary>
        /// Layout of a single layer.
        /// </summary>
        /// <param name="layerIndex">The layer to organize.</param>
        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
        /// <seealso cref="OptimizeCrossings()"/>
        layoutLayer(down, layer) {
            let iconsidered;
            let considered;
            if (down) {
                considered = this.layers[iconsidered = layer + 1];
            }
            else {
                considered = this.layers[iconsidered = layer - 1];
            }
            // list containing the nodes in the considered layer sorted by priority
            const sorted = [];
            for (let n = 0; n < considered.length; n++) {
                sorted.push(considered[n]);
            }
            sorted.sort(function (n1, n2) {
                const n1Priority = (n1.upstreamPriority + n1.downstreamPriority) / 2;
                const n2Priority = (n2.upstreamPriority + n2.downstreamPriority) / 2;
                if (Math.abs(n1Priority - n2Priority) < 0.0001) {
                    return 0;
                }
                if (n1Priority < n2Priority) {
                    return 1;
                }
                return -1;
            });
            // each node strives for its barycenter; high priority nodes start first
            forEach(sorted, function (node) {
                let nodeGridPos = node.gridPosition;
                const nodeBaryCenter = this.calcBaryCenter(node);
                const nodePriority = (node.upstreamPriority + node.downstreamPriority) / 2;
                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.0001) {
                    // This node is exactly at its barycenter -> perfect
                    return;
                }
                if (Math.abs(nodeGridPos - nodeBaryCenter) < 0.25 + 0.0001) {
                    // This node is close enough to the barycenter -> should work
                    return;
                }
                if (nodeGridPos < nodeBaryCenter) {
                    // Try to move the node to the right in an
                    // attempt to reach its barycenter
                    while (nodeGridPos < nodeBaryCenter) {
                        if (!this.moveRight(node, considered, nodePriority)) {
                            break;
                        }
                        nodeGridPos = node.gridPosition;
                    }
                }
                else {
                    // Try to move the node to the left in an
                    // attempt to reach its barycenter
                    while (nodeGridPos > nodeBaryCenter) {
                        if (!this.moveLeft(node, considered, nodePriority)) {
                            break;
                        }
                        nodeGridPos = node.gridPosition;
                    }
                }
            }, this);
            // after the layer has been rearranged we need to recalculate the barycenters
            // of the nodes in the surrounding layers
            if (iconsidered > 0) {
                this.calcDownData(iconsidered - 1);
            }
            if (iconsidered < this.layers.length - 1) {
                this.calcUpData(iconsidered + 1);
            }
        }
        /// <summary>
        /// Moves the node to the right and returns <c>true</c> if this was possible.
        /// </summary>
        /// <param name="node">The node.</param>
        /// <param name="layer">The layer.</param>
        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
        moveRight(node, layer, priority) {
            const index = indexOf(layer, node);
            if (index === layer.length - 1) {
                // this is the last node in the layer, so we can move to the right without troubles
                node.gridPosition = node.gridPosition + 0.5;
                return true;
            }
            const rightNode = layer[index + 1];
            const rightNodePriority = (rightNode.upstreamPriority + rightNode.downstreamPriority) / 2;
            // check if there is space between the right and the current node
            if (rightNode.gridPosition > node.gridPosition + 1) {
                node.gridPosition = node.gridPosition + 0.5;
                return true;
            }
            // we have reached a node with higher priority; no movement is allowed
            if (rightNodePriority > priority ||
                Math.abs(rightNodePriority - priority) < 0.0001) {
                return false;
            }
            // the right node has lower priority - try to move it
            if (this.moveRight(rightNode, layer, priority)) {
                node.gridPosition = node.gridPosition + 0.5;
                return true;
            }
            return false;
        }
        /// <summary>
        /// Moves the node to the left and returns <c>true</c> if this was possible.
        /// </summary>
        /// <param name="node">The node.</param>
        /// <param name="layer">The layer.</param>
        /// <returns>Returns <c>true</c> if the shift was possible, otherwise <c>false</c>.</returns>
        moveLeft(node, layer, priority) {
            const index = indexOf(layer, node);
            if (index === 0) {
                // this is the last node in the layer, so we can move to the left without troubles
                node.gridPosition = node.gridPosition - 0.5;
                return true;
            }
            const leftNode = layer[index - 1];
            const leftNodePriority = (leftNode.upstreamPriority + leftNode.downstreamPriority) / 2;
            // check if there is space between the left and the current node
            if (leftNode.gridPosition < node.gridPosition - 1) {
                node.gridPosition = node.gridPosition - 0.5;
                return true;
            }
            // we have reached a node with higher priority; no movement is allowed
            if (leftNodePriority > priority ||
                Math.abs(leftNodePriority - priority) < 0.0001) {
                return false;
            }
            // The left node has lower priority - try to move it
            if (this.moveLeft(leftNode, layer, priority)) {
                node.gridPosition = node.gridPosition - 0.5;
                return true;
            }
            return false;
        }
        mapVirtualNode(node, link) {
            this.nodeToLinkMap.set(node, link);
            if (!this.linkToNodeMap.containsKey(link)) {
                this.linkToNodeMap.set(link, []);
            }
            this.linkToNodeMap.get(link).push(node);
        }
        _nodesInLink(node) {
            return this.linkToNodeMap.get(this.nodeToLinkMap.get(node));
        }
        /// <summary>
        /// Inserts dummy nodes to break long links.
        /// </summary>
        _dummify() {
            this.linkToNodeMap = new Dictionary();
            this.nodeToLinkMap = new Dictionary();
            const links = this.graph.links.slice(0);
            const layers = this.layers;
            let layer, pos, newNode, node, r, newLink, i, l;
            const addLinkBetweenLayers = function (upLayer, downLayer, link) {
                layers[upLayer].linksTo[downLayer] = layers[upLayer].linksTo[downLayer] || [];
                layers[upLayer].linksTo[downLayer].push(link);
            };
            for (l = 0; l < links.length; l++) {
                const link = links[l];
                const o = link.source;
                const d = link.target;
                const oLayer = o.layer;
                const dLayer = d.layer;
                const oPos = o.gridPosition;
                const dPos = d.gridPosition;
                const step = (dPos - oPos) / Math.abs(dLayer - oLayer);
                let p = o;
                if (oLayer - dLayer > 1) {
                    for (i = oLayer - 1; i > dLayer; i--) {
                        newNode = new Node();
                        newNode.x = o.x;
                        newNode.y = o.y;
                        newNode.width = o.width / 100;
                        newNode.height = o.height / 100;
                        layer = layers[i];
                        pos = (i - dLayer) * step + oPos;
                        if (pos > layer.length) {
                            pos = layer.length;
                        }
                        // check if origin and dest are both last
                        if (oPos >= layers[oLayer].length - 1 &&
                            dPos >= layers[dLayer].length - 1) {
                            pos = layer.length;
                        }
                        else if (oPos === 0 && dPos === 0) { // check if origin and destination are both first
                            pos = 0;
                        }
                        newNode.layer = i;
                        newNode.uBaryCenter = 0.0;
                        newNode.dBaryCenter = 0.0;
                        newNode.upstreamLinkCount = 0;
                        newNode.downstreamLinkCount = 0;
                        newNode.gridPosition = pos;
                        newNode.isVirtual = true;
                        insert(layer, newNode, pos);
                        // translate rightwards nodes' positions
                        for (r = pos + 1; r < layer.length; r++) {
                            node = layer[r];
                            node.gridPosition = node.gridPosition + 1;
                        }
                        newLink = new Link(p, newNode);
                        newLink.depthOfDumminess = 0;
                        addLinkBetweenLayers(i - 1, i, newLink);
                        p = newNode;
                        // add the new node and the new link to the graph
                        this.graph._addNode(newNode);
                        this.graph.addLink(newLink);
                        newNode.index = this.graph.nodes.length - 1;
                        this.mapVirtualNode(newNode, link);
                    }
                    // set the origin of the real arrow to the last dummy
                    addLinkBetweenLayers(dLayer - 1, dLayer, newLink);
                    link.changeSource(p);
                    link.depthOfDumminess = oLayer - dLayer - 1;
                }
                else if (oLayer - dLayer < -1) {
                    for (i = oLayer + 1; i < dLayer; i++) {
                        newNode = new Node();
                        newNode.x = o.x;
                        newNode.y = o.y;
                        newNode.width = o.width / 100;
                        newNode.height = o.height / 100;
                        layer = layers[i];
                        pos = (i - oLayer) * step + oPos;
                        if (pos > layer.length) {
                            pos = layer.length;
                        }
                        // check if origin and dest are both last
                        if (oPos >= layers[oLayer].length - 1 &&
                            dPos >= layers[dLayer].length - 1) {
                            pos = layer.length;
                        }
                        else if (oPos === 0 && dPos === 0) { // check if origin and destination are both first
                            pos = 0;
                        }
                        newNode.layer = i;
                        newNode.uBaryCenter = 0.0;
                        newNode.dBaryCenter = 0.0;
                        newNode.upstreamLinkCount = 0;
                        newNode.downstreamLinkCount = 0;
                        newNode.gridPosition = pos;
                        newNode.isVirtual = true;
                        pos = Math.floor(pos); // truncates to int
                        insert(layer, newNode, pos);
                        // translate rightwards nodes' positions
                        for (r = pos + 1; r < layer.length; r++) {
                            node = layer[r];
                            node.gridPosition = node.gridPosition + 1;
                        }
                        newLink = new Link(p, newNode);
                        newLink.depthOfDumminess = 0;
                        addLinkBetweenLayers(i - 1, i, newLink);
                        p = newNode;
                        // add the new node and the new link to the graph
                        this.graph._addNode(newNode);
                        this.graph.addLink(newLink);
                        newNode.index = this.graph.nodes.length - 1;
                        this.mapVirtualNode(newNode, link);
                    }
                    addLinkBetweenLayers(dLayer - 1, dLayer, link);
                    // Set the origin of the real arrow to the last dummy
                    link.changeSource(p);
                    link.depthOfDumminess = dLayer - oLayer - 1;
                }
                else {
                    addLinkBetweenLayers(oLayer, dLayer, link);
                }
            }
        }
        /// <summary>
        /// Removes the dummy nodes inserted earlier to break long links.
        /// </summary>
        /// <remarks>The virtual nodes are effectively turned into intermediate connection points.</remarks>
        _dedummify() {
            let dedum = true;
            while (dedum) {
                dedum = false;
                for (let l = 0; l < this.graph.links.length; l++) {
                    const link = this.graph.links[l];
                    if (!link.depthOfDumminess) {
                        continue;
                    }
                    const points = [];
                    // add points in reverse order
                    points.unshift({ x: link.target.x, y: link.target.y });
                    points.unshift({ x: link.source.x, y: link.source.y });
                    // _dedummify the link
                    let temp = link;
                    const depthOfDumminess = link.depthOfDumminess;
                    for (let d = 0; d < depthOfDumminess; d++) {
                        const node = temp.source;
                        const prevLink = node.incoming[0];
                        points.unshift({ x: prevLink.source.x, y: prevLink.source.y });
                        temp = prevLink;
                    }
                    // restore the original link origin
                    link.changeSource(temp.source);
                    // reset dummification flag
                    link.depthOfDumminess = 0;
                    // note that we only need the intermediate points, floating links have been dropped in the analysis
                    if (points.length > 2) {
                        // first and last are the endpoints
                        points.splice(0, 1);
                        points.splice(points.length - 1);
                        link.points = points;
                    }
                    else {
                        link.points = [];
                    }
                    // we are not going to delete the dummy elements;
                    // they won't be needed anymore anyway.
                    dedum = true;
                    break;
                }
            }
        }
        /// <summary>
        /// Optimizes/reduces the crossings between the layers by turning the crossing problem into a (combinatorial) number ordering problem.
        /// </summary>
        _optimizeCrossings() {
            let moves = -1, i;
            const maxIterations = 3;
            let iter = 0;
            while (moves !== 0) {
                if (iter++ > maxIterations) {
                    break;
                }
                moves = 0;
                for (i = this.layers.length - 1; i >= 1; i--) {
                    moves += this.optimizeLayerCrossings(false, i);
                }
                for (i = 0; i < this.layers.length - 1; i++) {
                    moves += this.optimizeLayerCrossings(true, i);
                }
            }
        }
        calcUpData(layer) {
            if (layer === 0) {
                return;
            }
            const considered = this.layers[layer];
            let i, l, link;
            const upLayer = new Set();
            const temp = this.layers[layer - 1];
            for (i = 0; i < temp.length; i++) {
                upLayer.add(temp[i]);
            }
            for (i = 0; i < considered.length; i++) {
                const node = considered[i];
                // calculate barycenter
                let sum = 0;
                let total = 0;
                for (l = 0; l < node.incoming.length; l++) {
                    link = node.incoming[l];
                    if (upLayer.has(link.source)) {
                        total++;
                        sum += link.source.gridPosition;
                    }
                }
                for (l = 0; l < node.outgoing.length; l++) {
                    link = node.outgoing[l];
                    if (upLayer.has(link.target)) {
                        total++;
                        sum += link.target.gridPosition;
                    }
                }
                if (total > 0) {
                    node.uBaryCenter = sum / total;
                    node.upstreamLinkCount = total;
                }
                else {
                    node.uBaryCenter = i;
                    node.upstreamLinkCount = 0;
                }
            }
        }
        calcDownData(layer) {
            if (layer === this.layers.length - 1) {
                return;
            }
            const considered = this.layers[layer];
            let i, l, link;
            const downLayer = new Set();
            const temp = this.layers[layer + 1];
            for (i = 0; i < temp.length; i++) {
                downLayer.add(temp[i]);
            }
            for (i = 0; i < considered.length; i++) {
                const node = considered[i];
                // calculate barycenter
                let sum = 0;
                let total = 0;
                for (l = 0; l < node.incoming.length; l++) {
                    link = node.incoming[l];
                    if (downLayer.has(link.source)) {
                        total++;
                        sum += link.source.gridPosition;
                    }
                }
                for (l = 0; l < node.outgoing.length; l++) {
                    link = node.outgoing[l];
                    if (downLayer.has(link.target)) {
                        total++;
                        sum += link.target.gridPosition;
                    }
                }
                if (total > 0) {
                    node.dBaryCenter = sum / total;
                    node.downstreamLinkCount = total;
                }
                else {
                    node.dBaryCenter = i;
                    node.downstreamLinkCount = 0;
                }
            }
        }
        /// <summary>
        /// Optimizes the crossings.
        /// </summary>
        /// <remarks>The big trick here is the usage of weights or values attached to connected nodes which turn a problem of crossing links
        /// to an a problem of ordering numbers.</remarks>
        /// <param name="layerIndex">The layer index.</param>
        /// <param name="movingDownwards">If set to <c>true</c> we move down in the layer stack.</param>
        /// <returns>The number of nodes having moved, i.e. the number of crossings reduced.</returns>
        optimizeLayerCrossings(down, layer) {
            let iconsidered;
            let considered;
            if (down) {
                considered = this.layers[iconsidered = layer + 1];
            }
            else {
                considered = this.layers[iconsidered = layer - 1];
            }
            // remember what it was
            const presorted = considered.slice(0);
            // calculate barycenters for all nodes in the considered layer
            if (down) {
                this.calcUpData(iconsidered);
            }
            else {
                this.calcDownData(iconsidered);
            }
            // sort nodes within this layer according to the barycenters
            considered.sort((n1, n2) => {
                const n1BaryCenter = this.calcBaryCenter(n1), n2BaryCenter = this.calcBaryCenter(n2);
                if (Math.abs(n1BaryCenter - n2BaryCenter) < 0.0001) {
                    // in case of coinciding barycenters compare by the count of in/out links
                    if (n1.degree() === n2.degree()) {
                        return this.compareByIndex(n1, n2);
                    }
                    else if (n1.degree() < n2.degree()) {
                        return 1;
                    }
                    return -1;
                }
                const compareValue = (n2BaryCenter - n1BaryCenter) * 1000;
                if (compareValue > 0) {
                    return -1;
                }
                else if (compareValue < 0) {
                    return 1;
                }
                return this.compareByIndex(n1, n2);
            });
            // count relocations
            let i, moves = 0;
            for (i = 0; i < considered.length; i++) {
                if (considered[i] !== presorted[i]) {
                    moves++;
                }
            }
            if (moves > 0) {
                // now that the boxes have been arranged, update their grid positions
                let inode = 0;
                for (i = 0; i < considered.length; i++) {
                    const node = considered[i];
                    node.gridPosition = inode++;
                }
            }
            return moves;
        }
        /// <summary>
        /// Swaps a pair of nodes in a layer.
        /// </summary>
        /// <param name="layerIndex">Index of the layer.</param>
        /// <param name="n">The Nth node in the layer.</param>
        _swapPairs() {
            const maxIterations = this.options.layeredIterations;
            let iter = 0;
            while (true) {
                if (iter++ > maxIterations) {
                    break;
                }
                const downwards = (iter % 4 <= 1);
                const secondPass = (iter % 4 === 1);
                for (let l = (downwards ? 0 : this.layers.length - 1); downwards ? l <= this.layers.length - 1 : l >= 0; l += (downwards ? 1 : -1)) {
                    const layer = this.layers[l];
                    let hasSwapped = false;
                    // there is no need to recalculate crossings if they were calculated
                    // on the previous step and nothing has changed
                    let calcCrossings = true;
                    let memCrossings = 0;
                    for (let n = 0; n < layer.length - 1; n++) {
                        // count crossings
                        let up = 0;
                        let down = 0;
                        let crossBefore = 0;
                        if (calcCrossings) {
                            if (l !== 0) {
                                up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
                            }
                            if (l !== this.layers.length - 1) {
                                down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
                            }
                            if (downwards) {
                                up *= 2;
                            }
                            else {
                                down *= 2;
                            }
                            crossBefore = up + down;
                        }
                        else {
                            crossBefore = memCrossings;
                        }
                        if (crossBefore === 0) {
                            continue;
                        }
                        // Swap nodes
                        let node1 = layer[n];
                        let node2 = layer[n + 1];
                        let node1GridPos = node1.gridPosition;
                        let node2GridPos = node2.gridPosition;
                        layer[n] = node2;
                        layer[n + 1] = node1;
                        node1.gridPosition = node2GridPos;
                        node2.gridPosition = node1GridPos;
                        // count crossings again and if worse than before, restore swapping
                        up = 0;
                        if (l !== 0) {
                            up = this.countLinksCrossingBetweenTwoLayers(l - 1, l);
                        }
                        down = 0;
                        if (l !== this.layers.length - 1) {
                            down = this.countLinksCrossingBetweenTwoLayers(l, l + 1);
                        }
                        if (downwards) {
                            up *= 2;
                        }
                        else {
                            down *= 2;
                        }
                        const crossAfter = up + down;
                        let revert = false;
                        if (secondPass) {
                            revert = crossAfter >= crossBefore;
                        }
                        else {
                            revert = crossAfter > crossBefore;
                        }
                        if (revert) {
                            node1 = layer[n];
                            node2 = layer[n + 1];
                            node1GridPos = node1.gridPosition;
                            node2GridPos = node2.gridPosition;
                            layer[n] = node2;
                            layer[n + 1] = node1;
                            node1.gridPosition = node2GridPos;
                            node2.gridPosition = node1GridPos;
                            // nothing has changed, remember the crossings so that
                            // they are not calculated again on the next step
                            memCrossings = crossBefore;
                            calcCrossings = false;
                        }
                        else {
                            hasSwapped = true;
                            calcCrossings = true;
                        }
                    }
                    if (hasSwapped) {
                        if (l !== this.layers.length - 1) {
                            this.calcUpData(l + 1);
                        }
                        if (l !== 0) {
                            this.calcDownData(l - 1);
                        }
                    }
                }
            }
        }
        /// <summary>
        /// Counts the number of links crossing between two layers.
        /// </summary>
        /// <param name="layerIndex1">The layer index.</param>
        /// <param name="layerIndex2">Another layer index.</param>
        /// <returns></returns>
        countLinksCrossingBetweenTwoLayers(ulayer, dlayer) {
            const links = this.layers[ulayer].linksTo[dlayer];
            let link1, link2, n11, n12, n21, n22, l1, l2;
            let crossings = 0;
            const length = links.length;
            for (l1 = 0; l1 < length; l1++) {
                link1 = links[l1];
                for (l2 = l1 + 1; l2 < length; l2++) {
                    link2 = links[l2];
                    if (link1.target.layer === dlayer) {
                        n11 = link1.source;
                        n12 = link1.target;
                    }
                    else {
                        n11 = link1.target;
                        n12 = link1.source;
                    }
                    if (link2.target.layer === dlayer) {
                        n21 = link2.source;
                        n22 = link2.target;
                    }
                    else {
                        n21 = link2.target;
                        n22 = link2.source;
                    }
                    const n11gp = n11.gridPosition;
                    const n12gp = n12.gridPosition;
                    const n21gp = n21.gridPosition;
                    const n22gp = n22.gridPosition;
                    if ((n11gp - n21gp) * (n12gp - n22gp) < 0) {
                        crossings++;
                    }
                }
            }
            return crossings;
        }
        calcBaryCenter(node) {
            const upstreamLinkCount = node.upstreamLinkCount;
            const downstreamLinkCount = node.downstreamLinkCount;
            const uBaryCenter = node.uBaryCenter;
            const dBaryCenter = node.dBaryCenter;
            if (upstreamLinkCount > 0 && downstreamLinkCount > 0) {
                return (uBaryCenter + dBaryCenter) / 2;
            }
            if (upstreamLinkCount > 0) {
                return uBaryCenter;
            }
            if (downstreamLinkCount > 0) {
                return dBaryCenter;
            }
            return 0;
        }
        _gridPositionComparer(x, y) {
            if (x.gridPosition < y.gridPosition) {
                return -1;
            }
            if (x.gridPosition > y.gridPosition) {
                return 1;
            }
            return 0;
        }
        _positionAscendingComparer(x, y) {
            return x.k < y.k ? -1 : x.k > y.k ? 1 : 0;
        }
        _positionDescendingComparer(x, y) {
            return x.k < y.k ? 1 : x.k > y.k ? -1 : 0;
        }
        _firstVirtualNode(layer) {
            for (let c = 0; c < layer.length; c++) {
                if (layer[c].isVirtual) {
                    return c;
                }
            }
            return -1;
        }
        compareByIndex(o1, o2) {
            const i1 = o1.index;
            const i2 = o2.index;
            if (i1 < i2) {
                return 1;
            }
            if (i1 > i2) {
                return -1;
            }
            return 0;
        }
        intDiv(numerator, denominator) {
            return (numerator - numerator % denominator) / denominator;
        }
        nextVirtualNode(layer, node) {
            const nodeIndex = node.layerIndex;
            for (let i = nodeIndex + 1; i < layer.length; ++i) {
                if (layer[i].isVirtual) {
                    return layer[i];
                }
            }
            return null;
        }
    }

    class TreeLayoutProcessor {
        constructor(options) {
            this.center = null;
            this.options = options;
        }
        layout(treeGraph, root) {
            this.graph = treeGraph;
            if (!this.graph.nodes || this.graph.nodes.length === 0) {
                return;
            }
            if (!contains(this.graph.nodes, root)) {
                throw new Error('The given root is not in the graph.');
            }
            this.center = root;
            this.graph.cacheRelationships();
            /* var nonull = this.graph.nodes.where(function (n) {
             return n.associatedShape != null;
             });*/
            // transfer the rects
            /* nonull.forEach(function (n) {
             n.Location = n.associatedShape.Position;
             n.NodeSize = n.associatedShape.ActualBounds.ToSize();
             }

             );*/
            // caching the children
            /* nonull.forEach(function (n) {
             n.children = n.getChildren();
             });*/
            this.layoutSwitch();
            // apply the layout to the actual visuals
            // nonull.ForEach(n => n.associatedShape.Position = n.Location);
        }
        layoutLeft(left) {
            this.setChildrenDirection(this.center, 'Left', false);
            this.setChildrenLayout(this.center, 'Default', false);
            let h = 0, w = 0, y, i, node;
            for (i = 0; i < left.length; i++) {
                node = left[i];
                node.TreeDirection = 'Left';
                const s = this.measure(node, Size.Empty.bind(this));
                w = Math.max(w, s.width);
                h += s.height + this.options.verticalSeparation;
            }
            h -= this.options.verticalSeparation;
            const x = this.center.x - this.options.horizontalSeparation;
            y = this.center.y + ((this.center.height - h) / 2);
            for (i = 0; i < left.length; i++) {
                node = left[i];
                const p = new Point(x - node.Size.width, y);
                this.arrange(node, p);
                y += node.Size.height + this.options.verticalSeparation;
            }
        }
        layoutRight(right) {
            this.setChildrenDirection(this.center, 'Right', false);
            this.setChildrenLayout(this.center, 'Default', false);
            let h = 0, w = 0, y, i, node;
            for (i = 0; i < right.length; i++) {
                node = right[i];
                node.TreeDirection = 'Right';
                const s = this.measure(node, Size.Empty.bind(this));
                w = Math.max(w, s.width);
                h += s.height + this.options.verticalSeparation;
            }
            h -= this.options.verticalSeparation;
            const x = this.center.x + this.options.horizontalSeparation + this.center.width;
            y = this.center.y + ((this.center.height - h) / 2);
            for (i = 0; i < right.length; i++) {
                node = right[i];
                const p = new Point(x, y);
                this.arrange(node, p);
                y += node.Size.height + this.options.verticalSeparation;
            }
        }
        layoutUp(up) {
            this.setChildrenDirection(this.center, 'Up', false);
            this.setChildrenLayout(this.center, 'Default', false);
            let w = 0, y, node, i;
            for (i = 0; i < up.length; i++) {
                node = up[i];
                node.TreeDirection = 'Up';
                const s = this.measure(node, Size.Empty.bind(this));
                w += s.width + this.options.horizontalSeparation;
            }
            w -= this.options.horizontalSeparation;
            let x = this.center.x + (this.center.width / 2) - (w / 2);
            // y = this.center.y -verticalSeparation -this.center.height/2 - h;
            for (i = 0; i < up.length; i++) {
                node = up[i];
                y = this.center.y - this.options.verticalSeparation - node.Size.height;
                const p = new Point(x, y);
                this.arrange(node, p);
                x += node.Size.width + this.options.horizontalSeparation;
            }
        }
        layoutDown(down) {
            let node, i;
            this.setChildrenDirection(this.center, 'Down', false);
            this.setChildrenLayout(this.center, 'Default', false);
            let w = 0;
            for (i = 0; i < down.length; i++) {
                node = down[i];
                node.treeDirection = 'Down';
                const s = this.measure(node, Size.Empty.bind(this));
                w += s.width + this.options.horizontalSeparation;
            }
            w -= this.options.horizontalSeparation;
            let x = this.center.x + (this.center.width / 2) - (w / 2);
            const y = this.center.y + this.options.verticalSeparation + this.center.height;
            for (i = 0; i < down.length; i++) {
                node = down[i];
                const p = new Point(x, y);
                this.arrange(node, p);
                x += node.Size.width + this.options.horizontalSeparation;
            }
        }
        layoutRadialTree() {
            // var rmax = children.Aggregate(0D, (current, node) => Math.max(node.SectorAngle, current));
            this.setChildrenDirection(this.center, 'Radial', false);
            this.setChildrenLayout(this.center, 'Default', false);
            this.previousRoot = null;
            const startAngle = this.options.startRadialAngle * DEG_TO_RAD;
            const endAngle = this.options.endRadialAngle * DEG_TO_RAD;
            if (endAngle <= startAngle) {
                throw new Error('Final angle should not be less than the start angle.');
            }
            this.maxDepth = 0;
            this.origin = new Point(this.center.x, this.center.y);
            this.calculateAngularWidth(this.center, 0);
            // perform the layout
            if (this.maxDepth > 0) {
                this.radialLayout(this.center, this.options.radialFirstLevelSeparation, startAngle, endAngle);
            }
            // update properties of the root node
            this.center.Angle = endAngle - startAngle;
        }
        tipOverTree(down, startFromLevel) {
            if (isUndefined(startFromLevel)) {
                startFromLevel = 0;
            }
            this.setChildrenDirection(this.center, 'Down', false);
            this.setChildrenLayout(this.center, 'Default', false);
            this.setChildrenLayout(this.center, 'Underneath', false, startFromLevel);
            let w = 0, node, i;
            for (i = 0; i < down.length; i++) {
                node = down[i];
                // if (node.IsSpecial) continue;
                node.TreeDirection = 'Down';
                const s = this.measure(node, Size.Empty.bind(this));
                w += s.width + this.options.horizontalSeparation;
            }
            w -= this.options.horizontalSeparation;
            // putting the root in the center with respect to the whole diagram is not a nice result, let's put it with respect to the first level only
            w -= down[down.length - 1].width;
            w += down[down.length - 1].associatedShape.bounds().width;
            let x = this.center.x + (this.center.width / 2) - (w / 2);
            const y = this.center.y + this.options.verticalSeparation + this.center.height;
            for (i = 0; i < down.length; i++) {
                node = down[i];
                // if (node.IsSpecial) continue;
                const p = new Point(x, y);
                this.arrange(node, p);
                x += node.Size.width + this.options.horizontalSeparation;
            }
            /*/ /let's place the special node, assuming there is only one
             if (down.Count(n => n.IsSpecial) > 0)
             {
             var special = (from n in down where n.IsSpecial select n).First();
             if (special.Children.Count > 0)
             throw new DiagramException("The 'special' element should not have children.");
             special.Data.Location = new Point(Center.Data.Location.X + Center.AssociatedShape.BoundingRectangle.Width + this.options.HorizontalSeparation, Center.Data.Location.Y);
             }*/
        }
        calculateAngularWidth(n, d) {
            if (d > this.maxDepth) {
                this.maxDepth = d;
            }
            const w = 1000, h = 1000, diameter = d === 0 ? 0 : Math.sqrt((w * w) + (h * h)) / d;
            let aw = 0;
            if (n.children.length > 0) {
                // eventually with n.IsExpanded
                for (let i = 0, len = n.children.length; i < len; i++) {
                    const child = n.children[i];
                    aw += this.calculateAngularWidth(child, d + 1);
                }
                aw = Math.max(diameter, aw);
            }
            else {
                aw = diameter;
            }
            n.sectorAngle = aw;
            return aw;
        }
        sortChildren(n) {
            let basevalue = 0, i;
            // update basevalue angle for node ordering
            if (n.parents.length > 1) {
                throw new Error('Node is not part of a tree.');
            }
            const p = n.parents[0];
            if (p) {
                const pl = new Point(p.x, p.y);
                const nl = new Point(n.x, n.y);
                basevalue = this.normalizeAngle(Math.atan2(pl.y - nl.y, pl.x - nl.x));
            }
            const count = n.children.length;
            if (count === 0) {
                return null;
            }
            const angle = [];
            const idx = [];
            for (i = 0; i < count; ++i) {
                const c = n.children[i];
                const l = new Point(c.x, c.y);
                idx[i] = i;
                angle[i] = this.normalizeAngle(-basevalue + Math.atan2(l.y - l.y, l.x - l.x));
            }
            bisort(angle, idx);
            const col = []; // list of nodes
            const children = n.children;
            for (i = 0; i < count; ++i) {
                col.push(children[idx[i]]);
            }
            return col;
        }
        normalizeAngle(angle) {
            while (angle > Math.PI * 2) {
                angle -= 2 * Math.PI;
            }
            while (angle < 0) {
                angle += Math.PI * 2;
            }
            return angle;
        }
        radialLayout(node, radius, startAngle, endAngle) {
            const deltaTheta = endAngle - startAngle;
            const deltaThetaHalf = deltaTheta / 2.0;
            const parentSector = node.sectorAngle;
            let fraction = 0;
            const sorted = this.sortChildren(node);
            for (let i = 0, len = sorted.length; i < len; i++) {
                const childNode = sorted[i];
                const cp = childNode;
                const childAngleFraction = cp.sectorAngle / parentSector;
                if (childNode.children.length > 0) {
                    this.radialLayout(childNode, radius + this.options.radialSeparation, startAngle + (fraction * deltaTheta), startAngle + ((fraction + childAngleFraction) * deltaTheta));
                }
                this.setPolarLocation(childNode, radius, startAngle + (fraction * deltaTheta) + (childAngleFraction * deltaThetaHalf));
                cp.angle = childAngleFraction * deltaTheta;
                fraction += childAngleFraction;
            }
        }
        setPolarLocation(node, radius, angle) {
            node.x = this.origin.x + (radius * Math.cos(angle));
            node.y = this.origin.y + (radius * Math.sin(angle));
            node.BoundingRectangle = new Rect(node.x, node.y, node.width, node.height);
        }
        /**
         * Sets the children direction recursively.
         *
         * @param node
         * @param direction
         * @param includeStart
         */
        setChildrenDirection(node, direction, includeStart) {
            const rootDirection = node.treeDirection;
            this.graph.depthFirstTraversal(node, (n) => {
                n.treeDirection = direction;
            });
            if (!includeStart) {
                node.treeDirection = rootDirection;
            }
        }
        /**
         * Sets the children layout recursively.
         *
         * @param node
         * @param layout
         * @param includeStart
         * @param startFromLevel
         */
        setChildrenLayout(node, layout, includeStart, startFromLevel) {
            if (isUndefined(startFromLevel)) {
                startFromLevel = 0;
            }
            const rootLayout = node.childrenLayout;
            if (startFromLevel > 0) {
                // assign levels to the Node.Level property
                this.graph.assignLevels(node);
                // assign the layout on the condition that the level is at least the 'startFromLevel'
                this.graph.depthFirstTraversal(node, (s) => {
                    if (s.level >= startFromLevel + 1) {
                        s.childrenLayout = layout;
                    }
                });
            }
            else {
                this.graph.depthFirstTraversal(node, (s) => {
                    s.childrenLayout = layout;
                });
                // if the start should not be affected we put the state back
                if (!includeStart) {
                    node.childrenLayout = rootLayout;
                }
            }
        }
        /**
         * Returns the actual size of the node. The given size is the allowed space wherein the node can lay out itself.
         *
         * @param node
         * @param givenSize
         * @returns {Size}
         */
        measure(node, givenSize) {
            let w = 0, h = 0, s;
            let result = new Size(0, 0);
            if (!node) {
                throw new Error('Node is not defined.');
            }
            const b = node.associatedShape.bounds();
            const shapeWidth = b.width;
            const shapeHeight = b.height;
            if (node.parents.length !== 1) {
                throw new Error('Node not in a spanning tree.');
            }
            const parent = node.parents[0];
            if (node.treeDirection === 'Undefined') {
                node.treeDirection = parent.treeDirection;
            }
            if (isEmpty(node.children)) {
                result = new Size(Math.abs(shapeWidth) < EPSILON ? 50 : shapeWidth, Math.abs(shapeHeight) < EPSILON ? 25 : shapeHeight);
            }
            else if (node.children.length === 1) {
                switch (node.treeDirection) {
                    case 'Radial':
                        s = this.measure(node.children[0], givenSize); // child size
                        w = shapeWidth + (this.options.radialSeparation * Math.cos(node.AngleToParent)) + s.width;
                        h = shapeHeight + Math.abs(this.options.radialSeparation * Math.sin(node.AngleToParent)) + s.height;
                        break;
                    case 'Left':
                    case 'Right':
                        switch (node.childrenLayout) {
                            case 'TopAlignedWithParent':
                                break;
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                s = this.measure(node.children[0], givenSize);
                                w = shapeWidth + s.width + this.options.underneathHorizontalOffset;
                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
                                break;
                            case 'Default':
                                s = this.measure(node.children[0], givenSize);
                                w = shapeWidth + this.options.horizontalSeparation + s.width;
                                h = Math.max(shapeHeight, s.height);
                                break;
                            default:
                                throw new Error('Unhandled TreeDirection in the Radial layout measuring.');
                        }
                        break;
                    case 'Up':
                    case 'Down':
                        switch (node.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                s = this.measure(node.children[0], givenSize);
                                w = Math.max(shapeWidth, s.width + this.options.underneathHorizontalOffset);
                                h = shapeHeight + this.options.underneathVerticalTopOffset + s.height;
                                break;
                            case 'Default':
                                s = this.measure(node.children[0], givenSize);
                                h = shapeHeight + this.options.verticalSeparation + s.height;
                                w = Math.max(shapeWidth, s.width);
                                break;
                            default:
                                throw new Error('Unhandled TreeDirection in the Down layout measuring.');
                        }
                        break;
                    default:
                        throw new Error('Unhandled TreeDirection in the layout measuring.');
                }
                result = new Size(w, h);
            }
            else {
                let i, childNode;
                switch (node.treeDirection) {
                    case 'Left':
                    case 'Right':
                        switch (node.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                w = shapeWidth;
                                h = shapeHeight + this.options.underneathVerticalTopOffset;
                                for (i = 0; i < node.children.length; i++) {
                                    childNode = node.children[i];
                                    s = this.measure(childNode, givenSize);
                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
                                    h += s.height + this.options.underneathVerticalSeparation;
                                }
                                h -= this.options.underneathVerticalSeparation;
                                break;
                            case 'Default':
                                w = shapeWidth;
                                h = 0;
                                for (i = 0; i < node.children.length; i++) {
                                    childNode = node.children[i];
                                    s = this.measure(childNode, givenSize);
                                    w = Math.max(w, shapeWidth + this.options.horizontalSeparation + s.width);
                                    h += s.height + this.options.verticalSeparation;
                                }
                                h -= this.options.verticalSeparation;
                                break;
                            default:
                                throw new Error('Unhandled TreeDirection in the Right layout measuring.');
                        }
                        break;
                    case 'Up':
                    case 'Down':
                        switch (node.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                w = shapeWidth;
                                h = shapeHeight + this.options.underneathVerticalTopOffset;
                                for (i = 0; i < node.children.length; i++) {
                                    childNode = node.children[i];
                                    s = this.measure(childNode, givenSize);
                                    w = Math.max(w, s.width + this.options.underneathHorizontalOffset);
                                    h += s.height + this.options.underneathVerticalSeparation;
                                }
                                h -= this.options.underneathVerticalSeparation;
                                break;
                            case 'Default':
                                w = 0;
                                h = 0;
                                for (i = 0; i < node.children.length; i++) {
                                    childNode = node.children[i];
                                    s = this.measure(childNode, givenSize);
                                    w += s.width + this.options.horizontalSeparation;
                                    h = Math.max(h, s.height + this.options.verticalSeparation + shapeHeight);
                                }
                                w -= this.options.horizontalSeparation;
                                break;
                            default:
                                throw new Error('Unhandled TreeDirection in the Down layout measuring.');
                        }
                        break;
                    default:
                        throw new Error('Unhandled TreeDirection in the layout measuring.');
                }
                result = new Size(w, h);
            }
            node.SectorAngle = Math.sqrt((w * w / 4) + (h * h / 4));
            node.Size = result;
            return result;
        }
        arrange(n, p) {
            const b = n.associatedShape.bounds();
            let i, pp, child, node, childrenwidth;
            const shapeWidth = b.width;
            const shapeHeight = b.height;
            if (isEmpty(n.children)) {
                n.x = p.x;
                n.y = p.y;
                n.BoundingRectangle = new Rect(p.x, p.y, shapeWidth, shapeHeight);
            }
            else {
                let x, y;
                let selfLocation;
                switch (n.treeDirection) {
                    case 'Left':
                        switch (n.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                selfLocation = p;
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
                                for (i = 0; i < node.children.length; i++) {
                                    node = node.children[i];
                                    x = selfLocation.x - node.associatedShape.width - this.options.underneathHorizontalOffset;
                                    pp = new Point(x, y);
                                    this.arrange(node, pp);
                                    y += node.Size.height + this.options.underneathVerticalSeparation;
                                }
                                break;
                            case 'Default':
                                selfLocation = new Point(p.x + n.Size.width - shapeWidth, p.y + ((n.Size.height - shapeHeight) / 2));
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                x = selfLocation.x - this.options.horizontalSeparation; // alignment of children
                                y = p.y;
                                for (i = 0; i < n.children.length; i++) {
                                    node = n.children[i];
                                    pp = new Point(x - node.Size.width, y);
                                    this.arrange(node, pp);
                                    y += node.Size.height + this.options.verticalSeparation;
                                }
                                break;
                            default:
                                throw new Error('Unsupported TreeDirection');
                        }
                        break;
                    case 'Right':
                        switch (n.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                selfLocation = p;
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                x = p.x + shapeWidth + this.options.underneathHorizontalOffset;
                                // alignment of children left-underneath the parent
                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
                                for (i = 0; i < n.children.length; i++) {
                                    node = n.children[i];
                                    pp = new Point(x, y);
                                    this.arrange(node, pp);
                                    y += node.Size.height + this.options.underneathVerticalSeparation;
                                }
                                break;
                            case 'Default':
                                selfLocation = new Point(p.x, p.y + ((n.Size.height - shapeHeight) / 2));
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                x = p.x + shapeWidth + this.options.horizontalSeparation; // alignment of children
                                y = p.y;
                                for (i = 0; i < n.children.length; i++) {
                                    node = n.children[i];
                                    pp = new Point(x, y);
                                    this.arrange(node, pp);
                                    y += node.Size.height + this.options.verticalSeparation;
                                }
                                break;
                            default:
                                throw new Error('Unsupported TreeDirection');
                        }
                        break;
                    case 'Up':
                        selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y + n.Size.height - shapeHeight);
                        n.x = selfLocation.x;
                        n.y = selfLocation.y;
                        n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                        if (Math.abs(selfLocation.x - p.x) < EPSILON) {
                            childrenwidth = 0;
                            // means there is an aberration due to the oversized Element with respect to the children
                            for (i = 0; i < n.children.length; i++) {
                                child = n.children[i];
                                childrenwidth += child.Size.width + this.options.horizontalSeparation;
                            }
                            childrenwidth -= this.options.horizontalSeparation;
                            x = p.x + ((shapeWidth - childrenwidth) / 2);
                        }
                        else {
                            x = p.x;
                        }
                        for (i = 0; i < n.children.length; i++) {
                            node = n.children[i];
                            y = selfLocation.y - this.options.verticalSeparation - node.Size.height;
                            pp = new Point(x, y);
                            this.arrange(node, pp);
                            x += node.Size.width + this.options.horizontalSeparation;
                        }
                        break;
                    case 'Down':
                        switch (n.childrenLayout) {
                            case 'TopAlignedWithParent':
                            case 'BottomAlignedWithParent':
                                break;
                            case 'Underneath':
                                selfLocation = p;
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                x = p.x + this.options.underneathHorizontalOffset; // alignment of children left-underneath the parent
                                y = p.y + shapeHeight + this.options.underneathVerticalTopOffset;
                                for (i = 0; i < n.children.length; i++) {
                                    node = n.children[i];
                                    pp = new Point(x, y);
                                    this.arrange(node, pp);
                                    y += node.Size.height + this.options.underneathVerticalSeparation;
                                }
                                break;
                            case 'Default':
                                selfLocation = new Point(p.x + ((n.Size.width - shapeWidth) / 2), p.y);
                                n.x = selfLocation.x;
                                n.y = selfLocation.y;
                                n.BoundingRectangle = new Rect(n.x, n.y, n.width, n.height);
                                if (Math.abs(selfLocation.x - p.x) < EPSILON) {
                                    childrenwidth = 0;
                                    // means there is an aberration due to the oversized Element with respect to the children
                                    for (i = 0; i < n.children.length; i++) {
                                        child = n.children[i];
                                        childrenwidth += child.Size.width + this.options.horizontalSeparation;
                                    }
                                    childrenwidth -= this.options.horizontalSeparation;
                                    x = p.x + ((shapeWidth - childrenwidth) / 2);
                                }
                                else {
                                    x = p.x;
                                }
                                for (i = 0; i < n.children.length; i++) {
                                    node = n.children[i];
                                    y = selfLocation.y + this.options.verticalSeparation + shapeHeight;
                                    pp = new Point(x, y);
                                    this.arrange(node, pp);
                                    x += node.Size.width + this.options.horizontalSeparation;
                                }
                                break;
                            default:
                                throw new Error('Unsupported TreeDirection');
                        }
                        break;
                    case 'None':
                        break;
                    default:
                        throw new Error('Unsupported TreeDirection');
                }
            }
        }
        layoutSwitch() {
            if (!this.center) {
                return;
            }
            if (isEmpty(this.center.children)) {
                return;
            }
            let type = this.options.subtype;
            if (isUndefined(type)) {
                type = 'Down';
            }
            let single, male, female, leftcount;
            const children = this.center.children;
            switch (type.toLowerCase()) {
                case 'radial':
                case 'radialtree':
                    this.layoutRadialTree();
                    break;
                case 'mindmaphorizontal':
                case 'mindmap':
                    single = this.center.children;
                    if (this.center.children.length === 1) {
                        this.layoutRight(single);
                    }
                    else {
                        // odd number will give one more at the right
                        leftcount = children.length / 2;
                        male = grep$1(this.center.children, function (n) {
                            return indexOf(children, n) < leftcount;
                        });
                        female = grep$1(this.center.children, function (n) {
                            return indexOf(children, n) >= leftcount;
                        });
                        this.layoutLeft(male);
                        this.layoutRight(female);
                    }
                    break;
                case 'mindmapvertical':
                    single = this.center.children;
                    if (this.center.children.length === 1) {
                        this.layoutDown(single);
                    }
                    else {
                        // odd number will give one more at the right
                        leftcount = children.length / 2;
                        male = grep$1(this.center.children, function (n) {
                            return indexOf(children, n) < leftcount;
                        });
                        female = grep$1(this.center.children, function (n) {
                            return indexOf(children, n) >= leftcount;
                        });
                        this.layoutUp(male);
                        this.layoutDown(female);
                    }
                    break;
                case 'right':
                    this.layoutRight(this.center.children);
                    break;
                case 'left':
                    this.layoutLeft(this.center.children);
                    break;
                case 'up':
                case 'bottom':
                    this.layoutUp(this.center.children);
                    break;
                case 'down':
                case 'top':
                    this.layoutDown(this.center.children);
                    break;
                case 'tipover':
                case 'tipovertree':
                    if (this.options.tipOverTreeStartLevel < 0) {
                        throw new Error('The tip-over level should be a positive integer.');
                    }
                    this.tipOverTree(this.center.children, this.options.tipOverTreeStartLevel);
                    break;
                case 'undefined':
                case 'none':
                    break;
                default:
                    break;
            }
        }
    }

    /**
     * The various tree layout algorithms.
     *
     * @type {*}
     */
    class TreeLayout extends LayoutBase {
        constructor(diagram) {
            super();
            if (isUndefined(diagram)) {
                throw new Error('No diagram specified.');
            }
            this.diagram = diagram;
        }
        /**
         * Arranges the diagram in a tree-layout with the specified options and tree subtype.
         */
        layout(options) {
            this.transferOptions(options);
            // transform the diagram into a Graph
            const adapter = new DiagramToHyperTreeAdapter(this.diagram);
            /**
             * The Graph reduction from the given diagram.
             *
             * @type {*}
             */
            this.graph = adapter.convert();
            const finalNodeSet = this.layoutComponents();
            // note that the graph contains the original data and
            // the components are another instance of nodes referring to the same set of shapes
            return new LayoutState(this.diagram, finalNodeSet);
        }
        layoutComponents() {
            if (this.graph.isEmpty()) {
                return;
            }
            // split into connected components
            const components = this.graph.getConnectedComponents();
            if (isEmpty(components)) {
                return;
            }
            const layout = new TreeLayoutProcessor(this.options);
            const trees = [];
            // find a spanning tree for each component
            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                const treeGraph = this.getTree(component);
                if (!treeGraph) {
                    throw new Error('Failed to find a spanning tree for the component.');
                }
                const root = treeGraph.root;
                const tree = treeGraph.tree;
                layout.layout(tree, root);
                trees.push(tree);
            }
            return this.gridLayoutComponents(trees);
        }
        /**
         * Gets a spanning tree (and root) for the given graph.
         * Ensure that the given graph is connected!
         *
         * @param graph
         * @returns {*} A literal object consisting of the found root and the spanning tree.
         */
        getTree(graph) {
            let root = null;
            if (this.options.roots && this.options.roots.length > 0) {
                for (let i = 0, len = graph.nodes.length; i < len; i++) {
                    const node = graph.nodes[i];
                    for (let j = 0; j < this.options.roots.length; j++) {
                        const givenRootShape = this.options.roots[j];
                        if (givenRootShape === node.associatedShape) {
                            root = node;
                            break;
                        }
                    }
                }
            }
            if (!root) {
                // finds the most probable root on the basis of the longest path in the component
                root = graph.root();
                // should not happen really
                if (!root) {
                    throw new Error('Unable to find a root for the tree.');
                }
            }
            return this.getTreeForRoot(graph, root);
        }
        getTreeForRoot(graph, root) {
            const tree = graph.getSpanningTree(root);
            if (isUndefined(tree) || tree.isEmpty()) {
                return null;
            }
            return {
                tree: tree,
                root: tree.root()
            };
        }
    }

    class AdornerBase {
        constructor(diagram, options) {
            this.diagram = diagram;
            this.options = deepExtend({}, this.options, options);
            this.visual = new Group();
            this.diagram._adorners.push(this);
        }
        refresh() { }
    }

    class ConnectionEditUndoUnit {
        constructor(item, undoSource, undoTarget) {
            this.item = item;
            this._undoSource = undoSource;
            this._undoTarget = undoTarget;
            this._redoSource = item.source();
            this._redoTarget = item.target();
            this.title = ConnectionEditing;
        }
        undo() {
            this.item._updateConnector(this._undoSource, SOURCE);
            this.item._updateConnector(this._undoTarget, TARGET);
            this.item.updateModel();
        }
        redo() {
            this.item._updateConnector(this._redoSource, SOURCE);
            this.item._updateConnector(this._redoTarget, TARGET);
            this.item.updateModel();
        }
    }

    function mwDelta(e) {
        let delta = 0;
        if (e.wheelDelta) {
            delta = -e.wheelDelta / 40;
            delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
        }
        else if (e.detail) {
            delta = e.detail;
        }
        return delta;
    }
    function isAutoConnector(connector) {
        return connector.options.name.toLowerCase() === AUTO.toLowerCase();
    }
    function closestConnector(point, connectors) {
        let minimumDistance = MAXINT, resCtr, connector;
        for (let i = 0; i < connectors.length; i++) {
            connector = connectors[i];
            if (!isAutoConnector(connector)) {
                const dist = point.distanceTo(connector.position());
                if (dist < minimumDistance) {
                    minimumDistance = dist;
                    resCtr = connector;
                }
            }
        }
        return resCtr;
    }
    function indicesOfItems(group, visuals) {
        const indices = [];
        let i, visual;
        const children = group.drawingContainer().children;
        const length = children.length;
        for (i = 0; i < visuals.length; i++) {
            visual = visuals[i];
            for (let j = 0; j < length; j++) {
                if (children[j] === visual.drawingContainer()) {
                    indices.push(j);
                    break;
                }
            }
        }
        return indices;
    }
    function translateToOrigin(visual) {
        const bbox = visual.drawingContainer().clippedBBox(null);
        if (bbox.origin.x !== 0 || bbox.origin.y !== 0) {
            visual.position(-bbox.origin.x, -bbox.origin.y);
        }
    }
    function filterShapeDataItem(dataItem) {
        const result = {};
        dataItem = dataItem || {};
        if (defined(dataItem.text) && dataItem.text !== null) {
            result.text = dataItem.text;
        }
        if (defined(dataItem.x) && dataItem.x !== null) {
            result.x = dataItem.x;
        }
        if (defined(dataItem.y) && dataItem.y !== null) {
            result.y = dataItem.y;
        }
        if (defined(dataItem.width) && dataItem.width !== null) {
            result.width = dataItem.width;
        }
        if (defined(dataItem.height) && dataItem.height !== null) {
            result.height = dataItem.height;
        }
        if (defined(dataItem.type) && dataItem.type !== null) {
            result.type = dataItem.type;
        }
        return result;
    }
    function filterConnectionDataItem(dataItem) {
        const result = {};
        dataItem = dataItem || {};
        if (defined(dataItem.text) && dataItem.text !== null) {
            result.content = dataItem.text;
        }
        if (defined(dataItem.type) && dataItem.type !== null) {
            result.type = dataItem.type;
        }
        if (defined(dataItem.from) && dataItem.from !== null) {
            result.from = dataItem.from;
        }
        if (defined(dataItem.fromConnector) && dataItem.fromConnector !== null) {
            result.fromConnector = dataItem.fromConnector;
        }
        if (defined(dataItem.fromX) && dataItem.fromX !== null) {
            result.fromX = dataItem.fromX;
        }
        if (defined(dataItem.fromY) && dataItem.fromY !== null) {
            result.fromY = dataItem.fromY;
        }
        if (defined(dataItem.to) && dataItem.to !== null) {
            result.to = dataItem.to;
        }
        if (defined(dataItem.toConnector) && dataItem.toConnector !== null) {
            result.toConnector = dataItem.toConnector;
        }
        if (defined(dataItem.toX) && dataItem.toX !== null) {
            result.toX = dataItem.toX;
        }
        if (defined(dataItem.toY) && dataItem.toY !== null) {
            result.toY = dataItem.toY;
        }
        return result;
    }

    class RotateUnit {
        constructor(adorner, shapes, undoRotates) {
            this.shapes = shapes;
            this.undoRotates = undoRotates;
            this.title = 'Rotation';
            this.redoRotates = [];
            this.redoAngle = adorner._angle;
            this.adorner = adorner;
            this.center = adorner._innerBounds.center();
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                this.redoRotates.push(shape.rotate().angle);
            }
        }
        undo() {
            let i, shape;
            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                shape.rotate(this.undoRotates[i], this.center, false);
                if ('layout' in shape) {
                    shape.layout(shape);
                }
                shape.updateModel();
            }
            if (this.adorner) {
                this.adorner._initialize();
                this.adorner.refresh();
            }
        }
        redo() {
            let i, shape;
            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                shape.rotate(this.redoRotates[i], this.center, false);
                if ('layout' in shape) {
                    shape.layout(shape);
                }
                shape.updateModel();
            }
            if (this.adorner) {
                this.adorner._initialize();
                this.adorner.refresh();
            }
        }
    }

    const defaultOptions$5 = {
        width: 7,
        height: 7,
        fill: {
            color: DEFAULT_CONNECTION_BACKGROUND
        },
        hover: {}
    };
    class Connector {
        constructor(shape, options) {
            this.options = deepExtend({}, defaultOptions$5, options);
            this.connections = [];
            this.shape = shape;
        }
        position() {
            if (this.options.position) {
                return this.options.position(this.shape);
            }
            else {
                return this.shape.getPosition(this.options.name);
            }
        }
        toJSON() {
            return {
                shapeId: this.shape.toString(),
                connector: this.options.name
            };
        }
        static parse(diagram, str) {
            const tempStr = str.split(':'), id = tempStr[0], name = tempStr[1] || AUTO;
            for (let i = 0; i < diagram.shapes.length; i++) {
                const shape = diagram.shapes[i];
                if (shape.options.id === id) {
                    return shape.getConnector(name.trim());
                }
            }
        }
        ;
    }

    const DefaultConnectors = [{
            name: TOP
        }, {
            name: BOTTOM
        }, {
            name: LEFT
        }, {
            name: RIGHT
        }, {
            name: AUTO,
            position: function (shape) {
                return shape.getPosition('center');
            }
        }];
    const shapeDefaults = function (extra) {
        const defaults = {
            type: DEFAULT_SHAPE_TYPE,
            path: '',
            autoSize: true,
            visual: null,
            x: DEFAULT_SHAPE_POSITION,
            y: DEFAULT_SHAPE_POSITION,
            minWidth: DEFAULT_SHAPE_MINWIDTH,
            minHeight: DEFAULT_SHAPE_MINHEIGHT,
            width: DEFAULT_SHAPE_WIDTH,
            height: DEFAULT_SHAPE_HEIGHT,
            hover: {},
            editable: {
                connect: true,
                tools: []
            },
            connectors: DefaultConnectors,
            rotation: {
                angle: 0
            }
        };
        simpleExtend(defaults, extra);
        return defaults;
    };

    const defaultOptions$4 = {
        hover: {},
        cursor: Cursors.grip,
        content: {
            align: 'center middle'
        },
        selectable: true,
        serializable: true,
        enable: true
    };
    class DiagramElement extends Observable {
        constructor(options) {
            super();
            this.dataItem = (options || {}).dataItem;
            this.options = deepExtend({ id: randomId() }, defaultOptions$4, options);
            this.isSelected = false;
            this.visual = new Group({
                id: this.options.id,
                autoSize: this.options.autoSize
            });
            this.id = this.options.id;
            this._template();
        }
        _getCursor(point) {
            if (this.adorner) {
                return this.adorner._getCursor(point);
            }
            return this.options.cursor;
        }
        visible(value) {
            if (isUndefined(value)) {
                return this.visual.visible();
            }
            else {
                this.visual.visible(value);
            }
        }
        bounds(value) {
            if (isUndefined(value)) {
                return null;
            }
            return null;
        }
        refresh() {
            this.visual.redraw();
        }
        position(point) {
            this.options.x = point.x;
            this.options.y = point.y;
            this.visual.position(point);
        }
        toString() {
            return this.options.id;
        }
        serialize() {
            // the options json object describes the shape perfectly. So this object can serve as shape serialization.
            const json = deepExtend({}, { options: this.options });
            if (this.dataItem) {
                json.dataItem = this.dataItem.toString();
            }
            return json;
        }
        _content(content) {
            if (content !== undefined) {
                const options = this.options;
                if (isString$1(content)) {
                    options.content.text = content;
                }
                else {
                    deepExtend(options.content, content);
                }
                const contentOptions = options.content;
                const contentVisual = this._contentVisual;
                if (!contentVisual) {
                    this._createContentVisual(contentOptions);
                }
                else {
                    this._updateContentVisual(contentOptions);
                }
            }
            return this.options.content.text;
        }
        _createContentVisual(options) {
            if (options.text) {
                this._contentVisual = new TextBlock(options);
                this._contentVisual._includeInBBox = false;
                this.visual.append(this._contentVisual);
            }
        }
        _updateContentVisual(options) {
            this._contentVisual.redraw(options);
        }
        _hitTest(point) {
            const bounds = this.bounds();
            return this.visible() && bounds.contains(point) && this.options.enable;
        }
        _template() {
            if (this.options.content.template) {
                const data = this.dataItem || {}, elementTemplate = this.options.kendoTemplate(this.options.content.template, {
                    paramName: 'dataItem'
                });
                this.options.content.text = elementTemplate(data);
            }
        }
        _canSelect() {
            return this.options.selectable !== false;
        }
        toJSON() {
            return {
                id: this.options.id
            };
        }
    }

    class Shape extends DiagramElement {
        constructor(options, diagram) {
            super(options);
            this.options = deepExtend({}, this.options, shapeDefaults(), options);
            this.diagram = diagram;
            this.updateOptionsFromModel();
            options = this.options;
            this.connectors = [];
            this.type = options.type;
            this.createShapeVisual();
            this.updateBounds();
            this.content(this.content());
            this._createConnectors();
        }
        _setOptionsFromModel(model) {
            const modelOptions = filterShapeDataItem(model || this.dataItem);
            this.options = deepExtend({}, this.options, modelOptions);
            this.redrawVisual();
        }
        updateOptionsFromModel(model, field) {
            if (this.diagram && this.diagram._isEditable) {
                const modelOptions = filterShapeDataItem(model || this.dataItem);
                if (model && field) {
                    if (!contains(['x', 'y', 'width', 'height'], field)) {
                        if (this.options.visual) {
                            this._redrawVisual();
                        }
                        else if (modelOptions.type) {
                            this.options = deepExtend({}, this.options, modelOptions);
                            this._redrawVisual();
                        }
                        if (this.options.content) {
                            this._template();
                            this.content(this.options.content);
                        }
                    }
                    else {
                        const bounds = this.bounds();
                        bounds[field] = model[field];
                        this.bounds(bounds);
                    }
                }
                else {
                    this.options = deepExtend({}, this.options, modelOptions);
                }
            }
        }
        _redrawVisual() {
            this.visual.clear();
            this._contentVisual = null;
            this.options.dataItem = this.dataItem;
            this.createShapeVisual();
            this.updateBounds();
        }
        redrawVisual() {
            this._redrawVisual();
            if (this.options.content) {
                this._template();
                this.content(this.options.content);
            }
        }
        updateModel(syncChanges) {
            const diagram = this.diagram;
            if (diagram && diagram._isEditable) {
                diagram.updateShapeModel(this, syncChanges);
            }
        }
        updateBounds() {
            const bounds = this.visual._measure(true);
            const options = this.options;
            this.bounds(new Rect(options.x, options.y, bounds.width, bounds.height));
            this._rotate();
            this._alignContent();
        }
        content(content) {
            const result = this._content(content);
            this._alignContent();
            return result;
        }
        _alignContent() {
            const contentOptions = this.options.content || {};
            const contentVisual = this._contentVisual;
            if (contentVisual && contentOptions.align) {
                const containerRect = this.visual._measure();
                const aligner = new RectAlign(containerRect);
                const contentBounds = contentVisual.drawingElement.bbox(null);
                const contentRect = new Rect(0, 0, contentBounds.width(), contentBounds.height());
                const alignedBounds = aligner.align(contentRect, contentOptions.align);
                contentVisual.position(alignedBounds.topLeft());
            }
        }
        _createConnectors() {
            const options = this.options, length = options.connectors.length, connectorDefaults = options.connectorDefaults;
            let connector, i;
            for (i = 0; i < length; i++) {
                connector = new Connector(this, deepExtend({}, connectorDefaults, options.connectors[i]));
                this.connectors.push(connector);
            }
        }
        bounds(value) {
            let bounds;
            if (value) {
                if (isString$1(value)) {
                    switch (value) {
                        case TRANSFORMED: {
                            bounds = this._transformedBounds();
                            break;
                        }
                        case ABSOLUTE: {
                            bounds = this._transformedBounds();
                            const pan = this.diagram._pan;
                            bounds.x += pan.x;
                            bounds.y += pan.y;
                            break;
                        }
                        case ROTATED: {
                            bounds = this._rotatedBounds();
                            break;
                        }
                        default: {
                            bounds = this._bounds;
                            break;
                        }
                    }
                }
                else {
                    this._setBounds(value);
                    this._triggerBoundsChange();
                    if (!(this.diagram && this.diagram._layouting)) {
                        this.refreshConnections();
                    }
                }
            }
            else {
                bounds = this._bounds;
            }
            return bounds;
        }
        _setBounds(rect) {
            const options = this.options;
            const topLeft = rect.topLeft();
            const x = options.x = topLeft.x;
            const y = options.y = topLeft.y;
            const width = options.width = Math.max(rect.width, options.minWidth);
            const height = options.height = Math.max(rect.height, options.minHeight);
            this._bounds = new Rect(x, y, width, height);
            this.visual.redraw({
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
        position(point) {
            if (point) {
                this.bounds(new Rect(point.x, point.y, this._bounds.width, this._bounds.height));
            }
            else {
                return this._bounds.topLeft();
            }
        }
        /**
         * Returns a clone of this shape.
         *
         * @returns {Shape}
         */
        clone() {
            const json = this.serialize();
            json.options.id = randomId();
            if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
                json.options.dataItem = this.diagram.options.cloneDataItem(this.dataItem);
            }
            return new Shape(json.options, undefined);
        }
        select(value) {
            const diagram = this.diagram;
            let selected, deselected;
            if (isUndefined(value)) {
                value = true;
            }
            if (this._canSelect()) {
                if (this.isSelected !== value) {
                    selected = [];
                    deselected = [];
                    this.isSelected = value;
                    if (this.isSelected) {
                        diagram._selectedItems.push(this);
                        selected.push(this);
                    }
                    else {
                        remove(diagram._selectedItems, this);
                        deselected.push(this);
                    }
                    if (!diagram._internalSelection) {
                        diagram._selectionChanged(selected, deselected);
                    }
                    return true;
                }
            }
        }
        rotate(angle, center, undoable) {
            const rotate = this.visual.rotate();
            if (angle !== undefined) {
                if (undoable !== false && this.diagram && this.diagram.undoRedoService && angle !== rotate.angle) {
                    this.diagram.undoRedoService.add(new RotateUnit(this.diagram._resizingAdorner, [this], [rotate.angle]), false);
                }
                const b = this.bounds(), sc = new Point(b.width / 2, b.height / 2);
                let deltaAngle, newPosition;
                if (center) {
                    deltaAngle = angle - rotate.angle;
                    newPosition = b.center().rotate(deltaAngle, center).minus(sc);
                    this._rotationOffset = this._rotationOffset.plus(newPosition.minus(b.topLeft()));
                    this.position(newPosition);
                }
                this.visual.rotate(angle, sc);
                this.options.rotation.angle = angle;
                if (this.diagram && this.diagram._connectorsAdorner) {
                    this.diagram._connectorsAdorner.refresh();
                }
                this.refreshConnections();
                if (this.diagram) {
                    this.diagram.trigger(ITEMROTATE, { item: this });
                }
            }
            return rotate;
        }
        connections(type) {
            const result = [];
            let i, j, con, cons, ctr;
            for (i = 0; i < this.connectors.length; i++) {
                ctr = this.connectors[i];
                cons = ctr.connections;
                for (j = 0, cons; j < cons.length; j++) {
                    con = cons[j];
                    if (type === 'out') {
                        const source = con.source();
                        if (source.shape && source.shape === this) {
                            result.push(con);
                        }
                    }
                    else if (type === 'in') {
                        const target = con.target();
                        if (target.shape && target.shape === this) {
                            result.push(con);
                        }
                    }
                    else {
                        result.push(con);
                    }
                }
            }
            return result;
        }
        refreshConnections() {
            this.connections().forEach(function (connection) {
                connection.refresh();
            });
        }
        /**
         * Gets a connector of this shape either by the connector's supposed name or
         * via a Point in which case the closest connector will be returned.
         *
         * @param nameOrPoint The name of a Connector or a Point.
         * @returns {Connector}
         */
        getConnector(nameOrPoint) {
            let i, ctr;
            if (isString$1(nameOrPoint)) {
                nameOrPoint = nameOrPoint.toLocaleLowerCase();
                for (i = 0; i < this.connectors.length; i++) {
                    ctr = this.connectors[i];
                    if (ctr.options.name.toLocaleLowerCase() === nameOrPoint) {
                        return ctr;
                    }
                }
            }
            else if (nameOrPoint instanceof Point) {
                return closestConnector(nameOrPoint, this.connectors);
            }
            else {
                return this.connectors.length ? this.connectors[0] : null;
            }
        }
        getPosition(side) {
            const b = this.bounds(), fnName = side.charAt(0).toLowerCase() + side.slice(1);
            if (isFunction$1(b[fnName])) {
                return this._transformPoint(b[fnName]());
            }
            return b.center();
        }
        redraw(options) {
            if (options) {
                let shapeOptions = this.options;
                let boundsChange;
                this.shapeVisual.redraw(this._visualOptions(options));
                if (this._diffNumericOptions(options, [WIDTH, HEIGHT, X, Y])) {
                    this.bounds(new Rect(shapeOptions.x, shapeOptions.y, shapeOptions.width, shapeOptions.height));
                    boundsChange = true;
                }
                if (options.connectors) {
                    shapeOptions.connectors = options.connectors;
                    this._updateConnectors();
                }
                shapeOptions = deepExtend(shapeOptions, options);
                if (options.rotation || boundsChange) {
                    this._rotate();
                }
                if (shapeOptions.content) {
                    this.content(shapeOptions.content);
                }
            }
        }
        _updateConnectors() {
            const connections = this.connections();
            this.connectors = [];
            this._createConnectors();
            let connection;
            let source;
            let target;
            for (let idx = 0; idx < connections.length; idx++) {
                connection = connections[idx];
                source = connection.source();
                target = connection.target();
                if (source.shape && source.shape === this) {
                    connection.source(this.getConnector(source.options.name) || null);
                }
                else if (target.shape && target.shape === this) {
                    connection.target(this.getConnector(target.options.name) || null);
                }
                connection.updateModel();
            }
        }
        _diffNumericOptions(options, fields) {
            return diffNumericOptions.call(this, options, fields);
        }
        _visualOptions(options) {
            return {
                data: options.path,
                source: options.source,
                hover: options.hover,
                fill: options.fill,
                stroke: options.stroke
            };
        }
        _triggerBoundsChange() {
            if (this.diagram) {
                this.diagram.trigger(ITEMBOUNDSCHANGE, { item: this, bounds: this._bounds.clone() }); // the trigger modifies the arguments internally.
            }
        }
        _transformPoint(point) {
            const rotate = this.rotate(), bounds = this.bounds(), tl = bounds.topLeft();
            if (rotate.angle) {
                point.rotate(rotate.angle, rotate.center().plus(tl));
            }
            return point;
        }
        _transformedBounds() {
            const bounds = this.bounds(), tl = bounds.topLeft(), br = bounds.bottomRight();
            return Rect.fromPoints(this.diagram.modelToView(tl), this.diagram.modelToView(br));
        }
        _rotatedBounds() {
            const bounds = this.bounds().rotatedBounds(this.rotate().angle), tl = bounds.topLeft(), br = bounds.bottomRight();
            return Rect.fromPoints(tl, br);
        }
        _rotate() {
            const rotation = this.options.rotation;
            if (rotation && rotation.angle) {
                this.rotate(rotation.angle);
            }
            this._rotationOffset = new Point();
        }
        _hover(value) {
            const options = this.options, hover = options.hover;
            let stroke = options.stroke, fill = options.fill;
            if (value && isDefined(hover.stroke)) {
                stroke = deepExtend({}, stroke, hover.stroke);
            }
            if (value && isDefined(hover.fill)) {
                fill = hover.fill;
            }
            this.shapeVisual.redraw({
                stroke: stroke,
                fill: fill
            });
            if (options.editable && options.editable.connect) {
                this.diagram._showConnectors(this, value);
            }
        }
        _hitTest(value) {
            if (this.visible()) {
                const bounds = this.bounds(), angle = this.rotate().angle;
                let rotatedPoint;
                if (value.isEmpty && !value.isEmpty()) { // rect selection
                    return Intersect.rects(value, bounds, angle ? angle : 0);
                }
                else { // point
                    rotatedPoint = value.clone().rotate(angle, bounds.center()); // cloning is important because rotate modifies the point inline.
                    if (bounds.contains(rotatedPoint)) {
                        return this;
                    }
                }
            }
        }
        toJSON() {
            return {
                shapeId: this.options.id
            };
        }
        createShapeVisual() {
            const options = this.options;
            const visualOptions = this._visualOptions(options);
            const visualTemplate = options.visual;
            const type = (options.type + '').toLocaleLowerCase();
            let shapeVisual;
            visualOptions.width = options.width;
            visualOptions.height = options.height;
            if (isFunction$1(visualTemplate)) { // custom template
                shapeVisual = visualTemplate.call(this, options);
            }
            else if (visualOptions.data) {
                shapeVisual = new Path(visualOptions);
                translateToOrigin(shapeVisual);
            }
            else if (type === 'rectangle') {
                shapeVisual = new Rectangle(visualOptions);
            }
            else if (type === 'circle') {
                shapeVisual = new Circle(visualOptions);
            }
            else if (type === 'text') {
                shapeVisual = new TextBlock(visualOptions);
            }
            else if (type === 'image') {
                shapeVisual = new Image(visualOptions);
            }
            else {
                shapeVisual = new Path(visualOptions);
            }
            this.shapeVisual = shapeVisual;
            this.visual.append(this.shapeVisual);
        }
    }

    class ConnectionEditAdorner extends AdornerBase {
        constructor(connection, options) {
            options = deepExtend({ handles: {} }, options);
            super(connection.diagram, options);
            this.connection = connection;
            const diagram = this.connection.diagram;
            this._ts = diagram.toolService;
            const sp = this.connection.sourcePoint();
            const tp = this.connection.targetPoint();
            this.spVisual = new Circle(deepExtend(this.options.handles, { center: sp }));
            this.epVisual = new Circle(deepExtend(this.options.handles, { center: tp }));
            this.visual.append(this.spVisual);
            this.visual.append(this.epVisual);
        }
        _getCursor() {
            return Cursors.move;
        }
        start(p) {
            this.handle = this._hitTest(p);
            this.startPoint = p;
            this._initialSource = this.connection.source();
            this._initialTarget = this.connection.target();
            switch (this.handle) {
                case -1:
                    if (this.connection.targetConnector) {
                        this._ts._connectionManipulation(this.connection, this.connection.targetConnector.shape);
                    }
                    break;
                case 1:
                    if (this.connection.sourceConnector) {
                        this._ts._connectionManipulation(this.connection, this.connection.sourceConnector.shape);
                    }
                    break;
                default:
                    break;
            }
        }
        move(handle, p) {
            switch (handle) {
                case -1:
                    this.connection.source(p);
                    break;
                case 1:
                    this.connection.target(p);
                    break;
                default: {
                    const delta = p.minus(this.startPoint);
                    this.startPoint = p;
                    if (!this.connection.sourceConnector) {
                        this.connection.source(this.connection.sourcePoint().plus(delta));
                    }
                    if (!this.connection.targetConnector) {
                        this.connection.target(this.connection.targetPoint().plus(delta));
                    }
                    break;
                }
            }
            this.refresh();
            return true;
        }
        stop(p) {
            const ts = this.diagram.toolService, item = ts.hoveredItem;
            let target;
            if (ts._hoveredConnector) {
                target = ts._hoveredConnector._c;
            }
            else if (item && item instanceof Shape) {
                target = item.getConnector(AUTO) || item.getConnector(p);
            }
            else {
                target = p;
            }
            if (this.handle === -1) {
                this.connection.source(target);
            }
            else if (this.handle === 1) {
                this.connection.target(target);
            }
            this.handle = undefined;
            this._ts._connectionManipulation();
            return new ConnectionEditUndoUnit(this.connection, this._initialSource, this._initialTarget);
        }
        _hitTest(point) {
            const sourcePoint = this.connection.sourcePoint();
            const targetPoint = this.connection.targetPoint();
            const radiusX = this.options.handles.width / 2 + HIT_TEST_DISTANCE;
            const radiusY = this.options.handles.height / 2 + HIT_TEST_DISTANCE;
            const sourcePointDistance = sourcePoint.distanceTo(point);
            const targetPointDistance = targetPoint.distanceTo(point);
            const sourceHandle = new Rect(sourcePoint.x, sourcePoint.y).inflate(radiusX, radiusY).contains(point);
            const targetHandle = new Rect(targetPoint.x, targetPoint.y).inflate(radiusX, radiusY).contains(point);
            let handle = 0;
            if (sourceHandle && (!targetHandle || sourcePointDistance < targetPointDistance)) {
                handle = -1;
            }
            else if (targetHandle && (!sourceHandle || targetPointDistance < sourcePointDistance)) {
                handle = 1;
            }
            return handle;
        }
        refresh() {
            this.spVisual.redraw({ center: this.diagram.modelToLayer(this.connection.sourcePoint()) });
            this.epVisual.redraw({ center: this.diagram.modelToLayer(this.connection.targetPoint()) });
        }
    }

    class ConnectorVisual {
        constructor(connector) {
            this.options = deepExtend({}, connector.options);
            this._c = connector;
            this.visual = new Circle(this.options);
            this.refresh();
        }
        _hover(value) {
            const options = this.options, hover = options.hover;
            let stroke = options.stroke, fill = options.fill;
            if (value && isDefined(hover.stroke)) {
                stroke = deepExtend({}, stroke, hover.stroke);
            }
            if (value && isDefined(hover.fill)) {
                fill = hover.fill;
            }
            this.visual.redraw({
                stroke: stroke,
                fill: fill
            });
        }
        refresh() {
            const p = this._c.shape.diagram.modelToView(this._c.position()), relative = p.minus(this._c.shape.bounds('transformed').topLeft()), value = new Rect(p.x, p.y, 0, 0);
            value.inflate(this.options.width / 2, this.options.height / 2);
            this._visualBounds = value;
            this.visual.redraw({ center: new Point(relative.x, relative.y) });
        }
        _hitTest(p) {
            const tp = this._c.shape.diagram.modelToView(p);
            return this._visualBounds.contains(tp);
        }
    }

    class ConnectorsAdorner extends AdornerBase {
        constructor(diagram, options) {
            super(diagram, options);
            this._refreshHandler = (e) => {
                if (e.item === this.shape) {
                    this.refresh();
                }
            };
        }
        show(shape) {
            this._visible = true;
            this.shape = shape;
            this.diagram.bind(ITEMBOUNDSCHANGE, this._refreshHandler);
            this.connectors = [];
            this._clearVisual();
            const len = shape.connectors.length;
            for (let i = 0; i < len; i++) {
                const ctr = new ConnectorVisual(shape.connectors[i]);
                this.connectors.push(ctr);
                this.visual.append(ctr.visual);
            }
            this.visual.visible(true);
            this.refresh();
        }
        _clearVisual() {
            if (this.diagram._cachedTouchTarget) {
                this._keepCachedTouchTarget();
            }
            else {
                this.visual.clear();
            }
        }
        _keepCachedTouchTarget() {
            const visualChildren = this.visual.children;
            const childrenCount = visualChildren.length;
            const index = inArray(this.diagram._cachedTouchTarget, visualChildren);
            for (let i = childrenCount - 1; i >= 0; i--) {
                if (i === index) {
                    continue;
                }
                this.visual.remove(visualChildren[i]);
            }
        }
        destroy() {
            this.diagram.unbind(ITEMBOUNDSCHANGE, this._refreshHandler);
            this.shape = undefined;
            this._visible = undefined;
            this.visual.visible(false);
        }
        _hitTest(p) {
            let ctr, i;
            for (i = 0; i < this.connectors.length; i++) {
                ctr = this.connectors[i];
                if (ctr._hitTest(p)) {
                    ctr._hover(true);
                    this.diagram.toolService._hoveredConnector = ctr;
                    break;
                }
            }
        }
        refresh() {
            if (this.shape) {
                let bounds = this.shape.bounds();
                bounds = this.diagram.modelToLayer(bounds);
                this.visual.position(bounds.topLeft());
                this.connectors.forEach(function (ctr) {
                    ctr.refresh();
                });
            }
        }
    }

    function canDrag(element) {
        const editable = element.options.editable;
        return editable && editable.drag !== false;
    }

    /**
     * Holds the undoredo state when performing a rotation, translation or scaling. The adorner is optional.
     *
     * @type {*}
     */
    class TransformUnit {
        constructor(shapes, undoStates, adorner) {
            this.shapes = shapes;
            this.undoStates = undoStates;
            this.title = 'Transformation';
            this.redoStates = [];
            this.adorner = adorner;
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                this.redoStates.push(shape.bounds());
            }
        }
        undo() {
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                shape.bounds(this.undoStates[i]);
                if ('layout' in shape) {
                    shape.layout(shape, this.redoStates[i], this.undoStates[i]);
                }
                shape.updateModel();
            }
            if (this.adorner) {
                this.adorner.refreshBounds();
                this.adorner.refresh();
            }
        }
        redo() {
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                shape.bounds(this.redoStates[i]);
                // the 'layout' property, if implemented, lets the shape itself work out what to do with the new bounds
                if ('layout' in shape) {
                    shape.layout(shape, this.undoStates[i], this.redoStates[i]);
                }
                shape.updateModel();
            }
            if (this.adorner) {
                this.adorner.refreshBounds();
                this.adorner.refresh();
            }
        }
    }

    function hitToOppositeSide(hit, bounds) {
        let result;
        if (hit.x === -1 && hit.y === -1) {
            result = bounds.bottomRight();
        }
        else if (hit.x === 1 && hit.y === 1) {
            result = bounds.topLeft();
        }
        else if (hit.x === -1 && hit.y === 1) {
            result = bounds.topRight();
        }
        else if (hit.x === 1 && hit.y === -1) {
            result = bounds.bottomLeft();
        }
        else if (hit.x === 0 && hit.y === -1) {
            result = bounds.bottom();
        }
        else if (hit.x === 0 && hit.y === 1) {
            result = bounds.top();
        }
        else if (hit.x === 1 && hit.y === 0) {
            result = bounds.left();
        }
        else if (hit.x === -1 && hit.y === 0) {
            result = bounds.right();
        }
        return result;
    }
    const defaultOptions$3 = {
        handles: {
            fill: {
                color: '#fff'
            },
            stroke: {
                color: '#282828'
            },
            height: 7,
            width: 7,
            hover: {
                fill: {
                    color: '#282828'
                },
                stroke: {
                    color: '#282828'
                }
            }
        },
        selectable: {
            stroke: {
                color: '#778899',
                width: 1,
                dashType: 'dash'
            },
            fill: {
                color: TRANSPARENT
            }
        },
        offset: 10
    };
    class ResizingAdorner extends AdornerBase {
        constructor(diagram, options) {
            options = deepExtend({}, defaultOptions$3, options);
            super(diagram, options);
            this._manipulating = false;
            this.map = [];
            this.shapes = [];
            this._initSelection();
            this._createHandles();
            this.redraw();
            this.diagram.bind('select', () => {
                this._initialize();
            });
            this._refreshHandler = () => {
                if (!this._internalChange) {
                    this.refreshBounds();
                    this.refresh();
                }
            };
            this._rotatedHandler = () => {
                if (this.shapes.length === 1) {
                    this._angle = this.shapes[0].rotate().angle;
                }
                this._refreshHandler();
            };
            this.diagram.bind(ITEMBOUNDSCHANGE, this._refreshHandler).bind(ITEMROTATE, this._rotatedHandler);
            this.refreshBounds();
            this.refresh();
        }
        _initSelection() {
            const diagram = this.diagram;
            const selectable = diagram.options.selectable;
            const options = deepExtend({}, this.options.selectable, selectable);
            this.rect = new Rectangle(options);
            this.visual.append(this.rect);
        }
        _resizable() {
            return this.options.editable && this.options.editable.resize !== false;
        }
        _handleOptions() {
            return (this.options.editable.resize || {}).handles || this.options.handles;
        }
        _createHandles() {
            let handles, item, y, x;
            if (this._resizable()) {
                handles = this._handleOptions();
                for (x = -1; x <= 1; x++) {
                    for (y = -1; y <= 1; y++) {
                        if ((x !== 0) || (y !== 0)) { // (0, 0) element, (-1, -1) top-left, (+1, +1) bottom-right
                            item = new Rectangle(handles);
                            item.drawingElement._hover = this._hover.bind(this);
                            this.map.push({ x: x, y: y, visual: item });
                            this.visual.append(item);
                        }
                    }
                }
            }
        }
        bounds(value) {
            if (value) {
                this._innerBounds = value.clone();
                this._bounds = this.diagram.modelToLayer(value).inflate(this.options.offset, this.options.offset);
            }
            else {
                return this._bounds;
            }
        }
        _hitTest(p) {
            const handlesCount = this.map.length;
            let tp = this.diagram.modelToLayer(p), i, hit, handleBounds, handle;
            if (this._angle) {
                tp = tp.clone().rotate(this._angle, this._bounds.center());
            }
            if (this._resizable()) {
                for (i = 0; i < handlesCount; i++) {
                    handle = this.map[i];
                    hit = new Point(handle.x, handle.y);
                    handleBounds = this._getHandleBounds(hit); // local coordinates
                    handleBounds.offset(this._bounds.x, this._bounds.y);
                    if (handleBounds.contains(tp)) {
                        return hit;
                    }
                }
            }
            if (this._bounds.contains(tp)) {
                return new Point(0, 0);
            }
        }
        _getHandleBounds(p) {
            if (this._resizable()) {
                const handles = this._handleOptions(), w = handles.width, h = handles.height, r = new Rect(0, 0, w, h);
                if (p.x < 0) {
                    r.x = -w / 2;
                }
                else if (p.x === 0) {
                    r.x = Math.floor(this._bounds.width / 2) - w / 2;
                }
                else if (p.x > 0) {
                    r.x = this._bounds.width + 1.0 - w / 2;
                }
                if (p.y < 0) {
                    r.y = -h / 2;
                }
                else if (p.y === 0) {
                    r.y = Math.floor(this._bounds.height / 2) - h / 2;
                }
                else if (p.y > 0) {
                    r.y = this._bounds.height + 1.0 - h / 2;
                }
                return r;
            }
        }
        _getCursor(point) {
            let hit = this._hitTest(point);
            if (hit && (hit.x >= -1) && (hit.x <= 1) && (hit.y >= -1) && (hit.y <= 1) && this._resizable()) {
                const angle = this._angle;
                if (angle) {
                    hit.rotate(angle, new Point(0, 0));
                    hit = new Point(Math.round(hit.x), Math.round(hit.y));
                }
                if (hit.x === -1 && hit.y === -1) {
                    return 'nw-resize';
                }
                if (hit.x === 1 && hit.y === 1) {
                    return 'se-resize';
                }
                if (hit.x === -1 && hit.y === 1) {
                    return 'sw-resize';
                }
                if (hit.x === 1 && hit.y === -1) {
                    return 'ne-resize';
                }
                if (hit.x === 0 && hit.y === -1) {
                    return 'n-resize';
                }
                if (hit.x === 0 && hit.y === 1) {
                    return 's-resize';
                }
                if (hit.x === 1 && hit.y === 0) {
                    return 'e-resize';
                }
                if (hit.x === -1 && hit.y === 0) {
                    return 'w-resize';
                }
            }
            return this._manipulating ? Cursors.move : Cursors.select;
        }
        _initialize() {
            let i, item;
            const items = this.diagram.select();
            this.shapes = [];
            for (i = 0; i < items.length; i++) {
                item = items[i];
                if (item instanceof Shape) {
                    this.shapes.push(item);
                    item._rotationOffset = new Point();
                }
            }
            this._angle = this.shapes.length === 1 ? this.shapes[0].rotate().angle : 0;
            this._startAngle = this._angle;
            this._rotates();
            this._positions();
            this.refreshBounds();
            this.refresh();
            this.redraw();
        }
        _rotates() {
            let i, shape;
            this.initialRotates = [];
            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                this.initialRotates.push(shape.rotate().angle);
            }
        }
        _positions() {
            let i, shape;
            this.initialStates = [];
            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                this.initialStates.push(shape.bounds());
            }
        }
        _hover(value, element) {
            if (this._resizable()) {
                const handleOptions = this._handleOptions(), hover = handleOptions.hover;
                let stroke = handleOptions.stroke, fill = handleOptions.fill;
                if (value && isDefined(hover.stroke)) {
                    stroke = deepExtend({}, stroke, hover.stroke);
                }
                if (value && isDefined(hover.fill)) {
                    fill = hover.fill;
                }
                element.stroke(stroke.color, stroke.width, stroke.opacity);
                element.fill(fill.color, fill.opacity);
            }
        }
        start(p) {
            this._sp = p;
            this._cp = p;
            this._lp = p;
            this._manipulating = true;
            this._internalChange = true;
            this.shapeStates = [];
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                this.shapeStates.push(shape.bounds());
            }
        }
        redraw() {
            let i, handle;
            const visibleHandles = this._resizable();
            for (i = 0; i < this.map.length; i++) {
                handle = this.map[i];
                handle.visual.visible(visibleHandles);
            }
        }
        angle(value) {
            if (defined(value)) {
                this._angle = value;
            }
            return this._angle;
        }
        rotate() {
            const center = this._innerBounds.center();
            let currentAngle = this.angle();
            this._internalChange = true;
            for (let i = 0; i < this.shapes.length; i++) {
                const shape = this.shapes[i];
                currentAngle = (currentAngle + this.initialRotates[i] - this._startAngle) % 360;
                shape.rotate(currentAngle, center);
            }
            this.refresh();
        }
        move(handle, p) {
            let delta, dragging, dtl = new Point(), dbr = new Point(), bounds, center, shape, i, angle, newBounds, changed = 0, staticPoint, scaleX, scaleY;
            if (handle.y === -2 && handle.x === -1) {
                center = this._innerBounds.center();
                this._angle = this._truncateAngle(findAngle(center, p));
                for (i = 0; i < this.shapes.length; i++) {
                    shape = this.shapes[i];
                    angle = (this._angle + this.initialRotates[i] - this._startAngle) % 360;
                    shape.rotate(angle, center);
                    if (Object.prototype.hasOwnProperty.call(shape, 'layout')) {
                        shape.layout(shape);
                    }
                    this._rotating = true;
                }
                this.refresh();
            }
            else {
                if (this.shouldSnap()) {
                    const thr = this._truncateDistance(p.minus(this._lp));
                    // threshold
                    if (thr.x === 0 && thr.y === 0) {
                        this._cp = p;
                        return;
                    }
                    delta = thr;
                    this._lp = new Point(this._lp.x + thr.x, this._lp.y + thr.y);
                }
                else {
                    delta = p.minus(this._cp);
                }
                if (this.isDragHandle(handle)) {
                    dbr = dtl = delta; // dragging
                    dragging = true;
                }
                else {
                    if (this._angle) { // adjust the delta so this resizers resize in the correct direction after rotation.
                        delta.rotate(this._angle, new Point(0, 0));
                    }
                    if (handle.x === -1) {
                        dtl.x = delta.x;
                    }
                    else if (handle.x === 1) {
                        dbr.x = delta.x;
                    }
                    if (handle.y === -1) {
                        dtl.y = delta.y;
                    }
                    else if (handle.y === 1) {
                        dbr.y = delta.y;
                    }
                }
                if (!dragging) {
                    staticPoint = hitToOppositeSide(handle, this._innerBounds);
                    scaleX = (this._innerBounds.width + delta.x * handle.x) / this._innerBounds.width;
                    scaleY = (this._innerBounds.height + delta.y * handle.y) / this._innerBounds.height;
                }
                for (i = 0; i < this.shapes.length; i++) {
                    shape = this.shapes[i];
                    bounds = shape.bounds();
                    if (dragging) {
                        if (!canDrag(shape)) {
                            continue;
                        }
                        newBounds = this._displaceBounds(bounds, dtl, dbr, dragging);
                    }
                    else {
                        newBounds = bounds.clone();
                        newBounds.scale(scaleX, scaleY, staticPoint, this._innerBounds.center(), shape.rotate().angle);
                        const newCenter = newBounds.center(); // fixes the new rotation center.
                        newCenter.rotate(-this._angle, bounds.center());
                        newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
                    }
                    if (newBounds.width >= shape.options.minWidth && newBounds.height >= shape.options.minHeight) { // if we up-size very small shape
                        const oldBounds = bounds;
                        shape.bounds(newBounds);
                        if (Object.prototype.hasOwnProperty.call(shape, 'layout')) {
                            shape.layout(shape, oldBounds, newBounds);
                        }
                        if (oldBounds.width !== newBounds.width || oldBounds.height !== newBounds.height) {
                            shape.rotate(shape.rotate().angle); // forces the rotation to update it's rotation center
                        }
                        changed += 1;
                    }
                }
                if (changed) {
                    if (changed === i) {
                        newBounds = this._displaceBounds(this._innerBounds, dtl, dbr, dragging);
                        this.bounds(newBounds);
                    }
                    else {
                        this.refreshBounds();
                    }
                    this.refresh();
                }
                this._positions();
            }
            this._cp = p;
        }
        isDragHandle(handle) {
            return handle.x === 0 && handle.y === 0;
        }
        cancel() {
            const shapes = this.shapes;
            const states = this.shapeStates;
            for (let idx = 0; idx < shapes.length; idx++) {
                shapes[idx].bounds(states[idx]);
            }
            this.refreshBounds();
            this.refresh();
            this._manipulating = undefined;
            this._internalChange = undefined;
            this._rotating = undefined;
        }
        _truncatePositionToGuides(bounds) {
            if (this.diagram.ruler) {
                return this.diagram.ruler.truncatePositionToGuides(bounds);
            }
            return bounds;
        }
        _truncateSizeToGuides(bounds) {
            if (this.diagram.ruler) {
                return this.diagram.ruler.truncateSizeToGuides(bounds);
            }
            return bounds;
        }
        _truncateAngle(a) {
            const snap = this.snapOptions();
            const snapAngle = Math.max(snap.angle || DEFAULT_SNAP_ANGLE, MIN_SNAP_ANGLE);
            return snap ? Math.floor((a % 360) / snapAngle) * snapAngle : (a % 360);
        }
        _truncateDistance(d) {
            if (d instanceof Point) {
                return new Point(this._truncateDistance(d.x), this._truncateDistance(d.y));
            }
            else {
                const snap = this.snapOptions() || {};
                const snapSize = Math.max(snap.size || DEFAULT_SNAP_SIZE, MIN_SNAP_SIZE);
                return snap ? Math.floor(d / snapSize) * snapSize : d;
            }
        }
        snapOptions() {
            const editable = this.diagram.options.editable;
            const snap = ((editable || {}).drag || {}).snap || {};
            return snap;
        }
        shouldSnap() {
            const editable = this.diagram.options.editable;
            const drag = (editable || {}).drag;
            const snap = (drag || {}).snap;
            return editable !== false && drag !== false && snap !== false;
        }
        _displaceBounds(bounds, dtl, dbr, dragging) {
            const tl = bounds.topLeft().plus(dtl), br = bounds.bottomRight().plus(dbr);
            let newBounds = Rect.fromPoints(tl, br), newCenter;
            if (!dragging) {
                newCenter = newBounds.center();
                newCenter.rotate(-this._angle, bounds.center());
                newBounds = new Rect(newCenter.x - newBounds.width / 2, newCenter.y - newBounds.height / 2, newBounds.width, newBounds.height);
            }
            return newBounds;
        }
        stop() {
            let unit, i, shape;
            if (this._cp !== this._sp) {
                if (this._rotating) {
                    unit = new RotateUnit(this, this.shapes, this.initialRotates);
                    this._rotating = false;
                }
                else if (this._diffStates()) {
                    if (this.diagram.ruler) {
                        for (i = 0; i < this.shapes.length; i++) {
                            shape = this.shapes[i];
                            let bounds = shape.bounds();
                            bounds = this._truncateSizeToGuides(this._truncatePositionToGuides(bounds));
                            shape.bounds(bounds);
                            this.refreshBounds();
                            this.refresh();
                        }
                    }
                    for (i = 0; i < this.shapes.length; i++) {
                        shape = this.shapes[i];
                        shape.updateModel();
                    }
                    unit = new TransformUnit(this.shapes, this.shapeStates, this);
                    this.diagram._syncShapeChanges();
                }
            }
            this._manipulating = undefined;
            this._internalChange = undefined;
            this._rotating = undefined;
            return unit;
        }
        _diffStates() {
            const shapes = this.shapes;
            const states = this.shapeStates;
            for (let idx = 0; idx < shapes.length; idx++) {
                if (!shapes[idx].bounds().equals(states[idx])) {
                    return true;
                }
            }
            return false;
        }
        refreshBounds() {
            const bounds = this.shapes.length === 1 ?
                this.shapes[0].bounds().clone() :
                this.diagram.boundingBox(this.shapes, true);
            this.bounds(bounds);
        }
        refresh() {
            let b, bounds;
            if (this.shapes.length > 0) {
                bounds = this.bounds();
                this.visual.visible(true);
                this.visual.position(bounds.topLeft());
                this.map.forEach((m) => {
                    b = this._getHandleBounds(new Point(m.x, m.y));
                    m.visual.position(b.topLeft());
                });
                this.visual.position(bounds.topLeft());
                const center = new Point(bounds.width / 2, bounds.height / 2);
                this.visual.rotate(this._angle, center);
                this.rect.redraw({ width: bounds.width, height: bounds.height });
                if (this.rotationThumb) {
                    const thumb = this.options.editable.rotate.thumb;
                    this._rotationThumbBounds = new Rect(bounds.center().x, bounds.y + thumb.y, 0, 0).inflate(thumb.width);
                    this.rotationThumb.redraw({ x: bounds.width / 2 - thumb.width / 2 });
                }
            }
            else {
                this.visual.visible(false);
            }
        }
    }

    const defaultOptions$2 = {
        stroke: {
            color: '#778899',
            width: 1,
            dashType: 'dash'
        },
        fill: {
            color: TRANSPARENT
        }
    };
    class Selector {
        constructor(diagram) {
            const selectable = diagram.options.selectable;
            this.options = deepExtend({}, defaultOptions$2, selectable);
            this.visual = new Rectangle(this.options);
            this.diagram = diagram;
        }
        start(p) {
            this._sp = this._ep = p;
            this.refresh();
            this.diagram._adorn(this, true);
        }
        end() {
            this._sp = this._ep = undefined;
            this.diagram._adorn(this, false);
        }
        bounds(value) {
            if (value) {
                this._bounds = value;
            }
            return this._bounds;
        }
        move(p) {
            this._ep = p;
            this.refresh();
        }
        refresh() {
            if (this._sp) {
                const visualBounds = Rect.fromPoints(this.diagram.modelToLayer(this._sp), this.diagram.modelToLayer(this._ep));
                this.bounds(Rect.fromPoints(this._sp, this._ep));
                this.visual.position(visualBounds.topLeft());
                this.visual.redraw({ height: visualBounds.height + 1, width: visualBounds.width + 1 });
            }
        }
    }

    /**
     * Base class for connection routers.
     */
    class ConnectionRouterBase {
        constructor() { }
    }

    /**
     * Base class for polyline and cascading routing.
     */
    class LinearConnectionRouter extends ConnectionRouterBase {
        constructor(connection) {
            super();
            this.connection = connection;
        }
        /**
         * Hit testing for polyline paths.
         */
        hitTest(p) {
            const rec = this.getBounds().inflate(HIT_TEST_DISTANCE);
            if (!rec.contains(p)) {
                return false;
            }
            return Geometry.distanceToPolyline(p, this.connection.allPoints()) < HIT_TEST_DISTANCE;
        }
        /**
         * Bounds of a polyline.
         *
         * @returns {kendo.dataviz.diagram.Rect}
         */
        getBounds() {
            const points = this.connection.allPoints(), s = points[0], e = points[points.length - 1];
            let right = Math.max(s.x, e.x), left = Math.min(s.x, e.x), top = Math.min(s.y, e.y), bottom = Math.max(s.y, e.y);
            for (let i = 1; i < points.length - 1; ++i) {
                right = Math.max(right, points[i].x);
                left = Math.min(left, points[i].x);
                top = Math.min(top, points[i].y);
                bottom = Math.max(bottom, points[i].y);
            }
            return new Rect(left, top, right - left, bottom - top);
        }
    }

    const topLeft = 'topLeft';
    const bottomRight = 'bottomRight';
    class CascadingRouter extends LinearConnectionRouter {
        constructor(connection) {
            super(connection);
            this.SAME_SIDE_DISTANCE_RATIO = 5;
            this._connectorSides = [{
                    name: TOP,
                    axis: Y,
                    boundsPoint: topLeft,
                    secondarySign: 1
                }, {
                    name: LEFT,
                    axis: X,
                    boundsPoint: topLeft,
                    secondarySign: 1
                }, {
                    name: BOTTOM,
                    axis: Y,
                    boundsPoint: bottomRight,
                    secondarySign: -1
                }, {
                    name: RIGHT,
                    axis: X,
                    boundsPoint: bottomRight,
                    secondarySign: -1
                }];
            this.connection = connection;
        }
        routePoints(start, end, sourceConnector, targetConnector) {
            let result;
            if (sourceConnector && targetConnector) {
                result = this._connectorPoints(start, end, sourceConnector, targetConnector);
            }
            else {
                result = this._floatingPoints(start, end, sourceConnector);
            }
            return result;
        }
        route() {
            const sourceConnector = this.connection._resolvedSourceConnector;
            const targetConnector = this.connection._resolvedTargetConnector;
            const start = this.connection.sourcePoint();
            const end = this.connection.targetPoint();
            const points = this.routePoints(start, end, sourceConnector, targetConnector);
            this.connection.points(points);
        }
        _connectorSide(connector, targetPoint) {
            const position = connector.position();
            const shapeBounds = connector.shape.bounds(ROTATED);
            const bounds = {
                topLeft: shapeBounds.topLeft(),
                bottomRight: shapeBounds.bottomRight()
            };
            const sides = this._connectorSides;
            let min = Number.MAX_VALUE;
            let sideDistance;
            let minSide;
            let axis;
            let side;
            for (let idx = 0; idx < sides.length; idx++) {
                side = sides[idx];
                axis = side.axis;
                sideDistance = Math.round(Math.abs(position[axis] - bounds[side.boundsPoint][axis]));
                if (sideDistance < min) {
                    min = sideDistance;
                    minSide = side;
                }
                else if (sideDistance === min &&
                    (position[axis] - targetPoint[axis]) * side.secondarySign > (position[minSide.axis] - targetPoint[minSide.axis]) * minSide.secondarySign) {
                    minSide = side;
                }
            }
            return minSide.name;
        }
        _sameSideDistance(connector) {
            const bounds = connector.shape.bounds(ROTATED);
            return Math.min(bounds.width, bounds.height) / this.SAME_SIDE_DISTANCE_RATIO;
        }
        _connectorPoints(start, end, sourceConnector, targetConnector) {
            const sourceConnectorSide = this._connectorSide(sourceConnector, end);
            const targetConnectorSide = this._connectorSide(targetConnector, start);
            const deltaX = end.x - start.x;
            const deltaY = end.y - start.y;
            const sameSideDistance = this._sameSideDistance(sourceConnector);
            let result = [];
            let pointX, pointY;
            if (sourceConnectorSide === TOP || sourceConnectorSide === BOTTOM) {
                if (targetConnectorSide === TOP || targetConnectorSide === BOTTOM) {
                    if (sourceConnectorSide === targetConnectorSide) {
                        if (sourceConnectorSide === TOP) {
                            pointY = Math.min(start.y, end.y) - sameSideDistance;
                        }
                        else {
                            pointY = Math.max(start.y, end.y) + sameSideDistance;
                        }
                        result = [new Point(start.x, pointY), new Point(end.x, pointY)];
                    }
                    else {
                        result = [new Point(start.x, start.y + deltaY / 2), new Point(end.x, start.y + deltaY / 2)];
                    }
                }
                else {
                    result = [new Point(start.x, end.y)];
                }
            }
            else {
                if (targetConnectorSide === LEFT || targetConnectorSide === RIGHT) {
                    if (sourceConnectorSide === targetConnectorSide) {
                        if (sourceConnectorSide === LEFT) {
                            pointX = Math.min(start.x, end.x) - sameSideDistance;
                        }
                        else {
                            pointX = Math.max(start.x, end.x) + sameSideDistance;
                        }
                        result = [new Point(pointX, start.y), new Point(pointX, end.y)];
                    }
                    else {
                        result = [new Point(start.x + deltaX / 2, start.y), new Point(start.x + deltaX / 2, start.y + deltaY)];
                    }
                }
                else {
                    result = [new Point(end.x, start.y)];
                }
            }
            return result;
        }
        _floatingPoints(start, end, sourceConnector) {
            const sourceConnectorSide = sourceConnector ? this._connectorSide(sourceConnector, end) : null;
            const cascadeStartHorizontal = this._startHorizontal(start, end, sourceConnectorSide);
            const points = [start, start, end, end];
            const deltaX = end.x - start.x;
            const deltaY = end.y - start.y;
            const length = points.length;
            let idx = 1;
            let shiftX;
            let shiftY;
            // note that this is more generic than needed for only two intermediate points.
            for (; idx < length - 1; ++idx) {
                if (cascadeStartHorizontal) {
                    if (idx % 2 !== 0) {
                        shiftX = deltaX / (length / 2);
                        shiftY = 0;
                    }
                    else {
                        shiftX = 0;
                        shiftY = deltaY / ((length - 1) / 2);
                    }
                }
                else {
                    if (idx % 2 !== 0) {
                        shiftX = 0;
                        shiftY = deltaY / (length / 2);
                    }
                    else {
                        shiftX = deltaX / ((length - 1) / 2);
                        shiftY = 0;
                    }
                }
                points[idx] = new Point(points[idx - 1].x + shiftX, points[idx - 1].y + shiftY);
            }
            // need to fix the wrong 1.5 factor of the last intermediate point
            idx--;
            if ((cascadeStartHorizontal && (idx % 2 !== 0)) || (!cascadeStartHorizontal && (idx % 2 === 0))) {
                points[length - 2] = new Point(points[length - 1].x, points[length - 2].y);
            }
            else {
                points[length - 2] = new Point(points[length - 2].x, points[length - 1].y);
            }
            return [points[1], points[2]];
        }
        _startHorizontal(start, end, sourceSide) {
            let horizontal;
            if (sourceSide !== null && (sourceSide === RIGHT || sourceSide === LEFT)) {
                horizontal = true;
            }
            else {
                horizontal = Math.abs(start.x - end.x) > Math.abs(start.y - end.y);
            }
            return horizontal;
        }
    }

    /**
     * A simple poly-linear routing which does not alter the intermediate points.
     * Does hold the underlying hit, bounds....logic.
     *
     * @type {*|Object|void|extend|Zepto.extend|b.extend}
     */
    class PolylineRouter extends LinearConnectionRouter {
        constructor(connection) {
            super(connection);
            this.connection = connection;
        }
        route() {
            // just keep the points as is
        }
    }

    class ConnectionEditTool {
        constructor(toolService) {
            this.toolService = toolService;
            this.type = 'ConnectionTool';
        }
        tryActivate(_p, meta) {
            const toolService = this.toolService, diagram = toolService.diagram, selectable = diagram.options.selectable, item = toolService.hoveredItem, isActive = selectable !== false &&
                item && item.path && !(item.isSelected && meta.ctrlKey);
            if (isActive) {
                this._c = item;
            }
            return isActive;
        }
        start(p, meta) {
            const toolService = this.toolService;
            const connection = this._c;
            toolService.selectSingle(connection, meta);
            const adorner = connection.adorner;
            let handle, name;
            if (adorner) {
                handle = adorner._hitTest(p);
                name = HANDLE_NAMES[handle];
            }
            if (canDrag(connection) && adorner && !toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: name })) {
                this.handle = handle;
                this.handleName = name;
                adorner.start(p);
            }
            else {
                toolService.startPoint = p;
                toolService.end(p);
            }
        }
        move(p) {
            const adorner = this._c.adorner;
            if (canDrag(this._c) && adorner) {
                adorner.move(this.handle, p);
                this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], connectionHandle: this.handleName });
                return true;
            }
        }
        end(p) {
            const connection = this._c;
            const adorner = connection.adorner;
            const toolService = this.toolService;
            const diagram = toolService.diagram;
            if (adorner) {
                if (canDrag(connection)) {
                    const unit = adorner.stop(p);
                    if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: this.handleName })) {
                        diagram.undoRedoService.add(unit, false);
                        connection.updateModel();
                        diagram._syncConnectionChanges();
                    }
                    else {
                        unit.undo();
                    }
                }
            }
        }
        getCursor() {
            return Cursors.move;
        }
    }

    class ConnectionTool {
        constructor(toolService) {
            this.toolService = toolService;
            this.type = 'ConnectionTool';
        }
        tryActivate() {
            return this.toolService._hoveredConnector;
        }
        start(p, meta) {
            const toolService = this.toolService, diagram = toolService.diagram, connector = toolService._hoveredConnector, connection = diagram._createConnection({}, connector._c, p);
            if (canDrag(connection) && !diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: TARGET }) && diagram._addConnection(connection)) {
                toolService._connectionManipulation(connection, connector._c.shape, true);
                toolService._removeHover();
                toolService.selectSingle(toolService.activeConnection, meta);
                if (meta.type === 'touchmove') {
                    diagram._cachedTouchTarget = connector.visual;
                }
            }
            else {
                connection.source(null);
                toolService.end(p);
            }
        }
        move(p) {
            const toolService = this.toolService;
            const connection = toolService.activeConnection;
            connection.target(p);
            toolService.diagram.trigger(DRAG, { shapes: [], connections: [connection], connectionHandle: TARGET });
            return true;
        }
        end(p) {
            const toolService = this.toolService, diagram = toolService.diagram, connection = toolService.activeConnection, hoveredItem = toolService.hoveredItem, connector = toolService._hoveredConnector, cachedTouchTarget = diagram._cachedTouchTarget;
            let target;
            if (!connection) {
                return;
            }
            if (connector && connector._c !== connection.sourceConnector) {
                target = connector._c;
            }
            else if (hoveredItem && hoveredItem instanceof Shape) {
                target = hoveredItem.getConnector(AUTO) || hoveredItem.getConnector(p);
            }
            else {
                target = p;
            }
            connection.target(target);
            if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: TARGET })) {
                connection.updateModel();
                diagram._syncConnectionChanges();
            }
            else {
                diagram.remove(connection, false);
                diagram.undoRedoService.pop();
            }
            toolService._connectionManipulation();
            if (cachedTouchTarget) {
                diagram._connectorsAdorner.visual.remove(cachedTouchTarget);
                diagram._cachedTouchTarget = null;
            }
        }
        getCursor() {
            return Cursors.arrow;
        }
    }

    class EmptyTool {
        constructor(toolService) {
            this.toolService = toolService;
        }
        start() {
        }
        move() {
        }
        end() {
        }
        tryActivate() {
            return false;
        }
        getCursor() {
            return Cursors.arrow;
        }
    }

    function noMeta(meta) {
        return meta.ctrlKey === false && meta.altKey === false && meta.shiftKey === false;
    }

    /**
     * The tool handling the transformations via the adorner.
     *
     * @type {*}
     */
    class PointerTool {
        constructor(toolService) {
            this.toolService = toolService;
        }
        tryActivate() {
            return true; // the pointer tool is last and handles all others requests.
        }
        start(p, meta) {
            const toolService = this.toolService, diagram = toolService.diagram, hoveredItem = toolService.hoveredItem;
            if (hoveredItem) {
                toolService.selectSingle(hoveredItem, meta);
                if (hoveredItem.adorner) { // connection
                    this.adorner = hoveredItem.adorner;
                    this.handle = this.adorner._hitTest(p);
                }
            }
            if (!this.handle) {
                this.handle = diagram._resizingAdorner._hitTest(p);
                if (this.handle) {
                    this.adorner = diagram._resizingAdorner;
                }
            }
            if (this.adorner) {
                if (!this.adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_START, { shapes: this.adorner.shapes, connections: [] })) {
                    this.adorner.start(p);
                }
                else {
                    toolService.startPoint = p;
                    toolService.end(p);
                }
            }
        }
        move(p) {
            if (this.adorner) {
                this.adorner.move(this.handle, p);
                if (this.adorner.isDragHandle(this.handle)) {
                    this.toolService.diagram.trigger(DRAG, { shapes: this.adorner.shapes, connections: [] });
                }
            }
        }
        end() {
            const diagram = this.toolService.diagram, adorner = this.adorner;
            let unit;
            if (adorner) {
                if (!adorner.isDragHandle(this.handle) || !diagram.trigger(DRAG_END, { shapes: adorner.shapes, connections: [] })) {
                    unit = adorner.stop();
                    if (unit) {
                        diagram.undoRedoService.add(unit, false);
                    }
                }
                else {
                    adorner.cancel();
                }
            }
            this.adorner = undefined;
            this.handle = undefined;
        }
        getCursor(p) {
            return this.toolService.hoveredItem ? this.toolService.hoveredItem._getCursor(p) : Cursors.arrow;
        }
    }

    const eventMap = {
        down: 'pointerdown',
        move: 'pointermove',
        up: 'pointerup',
        cancel: 'pointercancel pointerleave'
    };
    function queryEventMap(e) {
        return eventMap[e] || e;
    }
    const applyEventMap = (events) => {
        const eventRegEx = /([^ ]+)/g;
        const appliedEvents = events.replace(eventRegEx, queryEventMap);
        return appliedEvents;
    };

    function getSupportedFeatures() {
        const os = detectOS(navigator.userAgent);
        const support = {};
        support.mobileOS = os;
        return support;
    }
    function detectOS(ua) {
        let os = false;
        const agentRxs = {
            wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
            fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
            android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
            iphone: /(iPhone|iPod).*OS\s+(\d+)[._]([\d._]+)/,
            ipad: /(iPad).*OS\s+(\d+)[._]([\d_]+)/,
            playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
            windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
            tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
            sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i
        }, osRxs = {
            ios: /^i(phone|pad|pod)$/i,
            android: /^android|fire$/i,
            windows: /windows/,
            wp: /wp/,
            flat: /sailfish|ffos|tizen/i
        };
        for (const agent in agentRxs) {
            if (!Object.prototype.hasOwnProperty.call(agentRxs, agent)) {
                continue;
            }
            const match = ua.match(agentRxs[agent]);
            if (match) {
                if (agent === 'windows' && 'plugins' in navigator) {
                    return false;
                } // Break if not Metro/Mobile Windows
                os = {};
                os.device = agent;
                os.name = testRegex(agent, osRxs);
                os[os.name] = true;
                break;
            }
        }
        return os;
    }
    function testRegex(agent, regexes, dflt) {
        for (const regex in regexes) {
            if (regexes[regex].test(agent)) {
                return regex;
            }
        }
        return dflt !== undefined ? dflt : agent;
    }

    const extend$1 = Object.assign;
    const now = () => {
        return new Date().getTime();
    };
    const addClass = (element, className) => {
        element.classList.add(className);
    };
    const convertToHtml = (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.firstChild;
    };
    const appendHtml = (html, element) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        // use childNodes instead of children
        // to cover text nodes as well
        while (div.childNodes.length > 0) {
            element.appendChild(div.childNodes[0]);
        }
    };
    const removeChildren = (element) => {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    };
    const prepend = (element, originElement) => {
        originElement.insertBefore(element, originElement.firstChild);
    };
    const wrapInner = (parent, wrapper) => {
        parent.appendChild(wrapper);
        while (parent.firstChild !== wrapper) {
            wrapper.appendChild(parent.firstChild);
        }
    };
    const toHyphens = (str) => {
        const result = str.replace(/([a-z][A-Z])/g, function (g) {
            return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
        });
        return result;
    };
    const toPixels = (value) => {
        let result;
        if (value && String(value).endsWith('px')) {
            result = value;
        }
        else {
            result = String(value) + 'px';
        }
        return result;
    };
    const hasNativeScrolling = () => {
        const { mobileOS } = getSupportedFeatures();
        return mobileOS.ios || mobileOS.android;
    };
    const wheelDeltaY = (e) => {
        const deltaY = e.wheelDeltaY;
        let delta;
        if (e.wheelDelta) { // Webkit and IE
            if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
                delta = e.wheelDelta;
            }
        }
        else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
            delta = (-e.detail) * 10;
        }
        return delta;
    };
    const renderPos = (pos) => {
        const result = [];
        if (pos) {
            const parts = toHyphens(pos).split('-');
            for (let i = 0; i < parts.length; i++) {
                result.push('k-pos-' + parts[i]);
            }
        }
        return result.join(' ');
    };

    const elementOffset$1 = kendo_drawing_cmn_chunk_js.w;
    const translate = function (x, y, scale) {
        return 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')';
    };
    class TapCapture extends Observable {
        constructor(element, options) {
            super();
            const domElement = element[0] || element;
            this.element = domElement;
            this.capture = false;
            this._pressHandler = this._press.bind(this);
            this._releaseHandler = this._release.bind(this);
            eventMap.down.split(' ').forEach((event) => {
                domElement.addEventListener(event, this._pressHandler, true);
            });
            eventMap.up.split(' ').forEach((event) => {
                domElement.addEventListener(event, this._releaseHandler, true);
            });
            this.bind([
                'press',
                'release'
            ], options || {});
        }
        captureNext() {
            this.capture = true;
        }
        cancelCapture() {
            this.capture = false;
        }
        _press(e) {
            this.trigger('press');
            if (this.capture) {
                e.preventDefault();
            }
        }
        _release(e) {
            this.trigger('release');
            if (this.capture) {
                e.preventDefault();
                this.cancelCapture();
            }
        }
        destroy() {
            const domElement = this.element;
            eventMap.down.split(' ').forEach((event) => {
                domElement.removeEventListener(event, this._pressHandler, true);
            });
            eventMap.up.split(' ').forEach((event) => {
                domElement.removeEventListener(event, this._releaseHandler, true);
            });
        }
    }
    class PaneDimension extends Observable {
        constructor(options) {
            super();
            this.forcedEnabled = false;
            extend$1(this, options);
            this.scale = 1;
            if (this.horizontal) {
                this.measure = 'offsetWidth';
                this.scrollSize = 'scrollWidth';
                this.axis = 'x';
            }
            else {
                this.measure = 'offsetHeight';
                this.scrollSize = 'scrollHeight';
                this.axis = 'y';
            }
        }
        makeVirtual() {
            extend$1(this, {
                virtual: true,
                forcedEnabled: true,
                _virtualMin: 0,
                _virtualMax: 0
            });
        }
        virtualSize(min, max) {
            if (this._virtualMin !== min || this._virtualMax !== max) {
                this._virtualMin = min;
                this._virtualMax = max;
                this.update();
            }
        }
        outOfBounds(offset) {
            return offset > this.max || offset < this.min;
        }
        forceEnabled() {
            this.forcedEnabled = true;
        }
        getSize() {
            return this.container[this.measure];
        }
        getTotal() {
            return this.element[this.scrollSize];
        }
        rescale(scale) {
            this.scale = scale;
        }
        update(silent) {
            const total = this.virtual ? this._virtualMax : this.getTotal(), scaledTotal = total * this.scale, size = this.getSize();
            if (total === 0 && !this.forcedEnabled) {
                return;
            }
            this.max = this.virtual ? -this._virtualMin : 0;
            this.size = size;
            this.total = scaledTotal;
            this.min = Math.min(this.max, size - scaledTotal);
            this.minScale = size / total;
            this.centerOffset = (scaledTotal - size) / 2;
            this.enabled = this.forcedEnabled || scaledTotal > size;
            if (!silent) {
                this.trigger(CHANGE$1, this);
            }
        }
    }
    class PaneDimensions extends Observable {
        constructor(options) {
            super();
            this.x = new PaneDimension(extend$1({
                horizontal: true
            }, options));
            this.y = new PaneDimension(extend$1({
                horizontal: false
            }, options));
            this.container = options.container;
            this.forcedMinScale = options.minScale;
            this.maxScale = options.maxScale || 100;
            this.bind(CHANGE$1, options);
        }
        rescale(newScale) {
            this.x.rescale(newScale);
            this.y.rescale(newScale);
            this.refresh();
        }
        centerCoordinates() {
            return {
                x: Math.min(0, -this.x.centerOffset),
                y: Math.min(0, -this.y.centerOffset)
            };
        }
        refresh() {
            this.x.update();
            this.y.update();
            this.enabled = this.x.enabled || this.y.enabled;
            this.minScale = this.forcedMinScale || Math.min(this.x.minScale, this.y.minScale);
            this.fitScale = Math.max(this.x.minScale, this.y.minScale);
            this.trigger(CHANGE$1);
        }
    }
    class PaneAxis extends Observable {
        constructor(options) {
            super();
            extend$1(this, options);
        }
        outOfBounds() {
            return this.dimension.outOfBounds(this.movable[this.axis]);
        }
        dragMove(delta) {
            const dimension = this.dimension, axis = this.axis, movable = this.movable, position = movable[axis] + delta;
            if (!dimension.enabled) {
                return;
            }
            let dragDelta = delta;
            if (position < dimension.min && delta < 0 || position > dimension.max && delta > 0) {
                dragDelta *= this.resistance;
            }
            movable.translateAxis(axis, dragDelta);
            this.trigger(CHANGE$1, this);
        }
    }
    class Pane {
        constructor(options) {
            let x, y;
            extend$1(this, {
                elastic: true
            }, options);
            const resistance = this.elastic ? 0.5 : 0;
            const movable = this.movable;
            this.x = x = new PaneAxis({
                axis: 'x',
                dimension: this.dimensions.x,
                resistance: resistance,
                movable: movable
            });
            this.y = y = new PaneAxis({
                axis: 'y',
                dimension: this.dimensions.y,
                resistance: resistance,
                movable: movable
            });
            this.userEvents.bind([
                'press',
                'move',
                'end',
                'gesturestart',
                'gesturechange'
            ], {
                gesturestart(e) {
                    this.gesture = e;
                    this.offset = elementOffset$1(this.dimensions.container);
                },
                press(e) {
                    const closestAnchor = e.event.target.closest('a');
                    if (closestAnchor && closestAnchor.matches('[data-navigate-on-press=true]')) {
                        e.sender.cancel();
                    }
                },
                gesturechange(e) {
                    const previousGesture = this.gesture, previousCenter = previousGesture.center, center = e.center, minScale = this.dimensions.minScale, maxScale = this.dimensions.maxScale;
                    let scaleDelta = e.distance / previousGesture.distance;
                    if (movable.scale <= minScale && scaleDelta < 1) {
                        scaleDelta += (1 - scaleDelta) * 0.8;
                    }
                    if (movable.scale * scaleDelta >= maxScale) {
                        scaleDelta = maxScale / movable.scale;
                    }
                    const offsetX = movable.x + this.offset.left, offsetY = movable.y + this.offset.top;
                    const coordinates = {
                        x: (offsetX - previousCenter.x) * scaleDelta + center.x - offsetX,
                        y: (offsetY - previousCenter.y) * scaleDelta + center.y - offsetY
                    };
                    movable.scaleWith(scaleDelta);
                    x.dragMove(coordinates.x);
                    y.dragMove(coordinates.y);
                    this.dimensions.rescale(movable.scale);
                    this.gesture = e;
                    e.preventDefault();
                },
                move(e) {
                    if (e.event.target.tagName.match(/textarea|input/i)) {
                        return;
                    }
                    if (x.dimension.enabled || y.dimension.enabled) {
                        x.dragMove(e.x.delta);
                        y.dragMove(e.y.delta);
                        e.preventDefault();
                    }
                    else {
                        e.touch.skip();
                    }
                },
                end(e) {
                    e.preventDefault();
                }
            });
        }
    }
    class Movable extends Observable {
        constructor(element) {
            super();
            this.element = element;
            this.element.style.transformOrigin = 'left top';
            this.x = 0;
            this.y = 0;
            this.scale = 1;
            const coordinates = translate(this.x, this.y, this.scale);
            this.element.style.transform = coordinates;
            this._saveCoordinates(coordinates);
        }
        translateAxis(axis, by) {
            this[axis] += by;
            this.refresh();
        }
        scaleTo(scale) {
            this.scale = scale;
            this.refresh();
        }
        scaleWith(scaleDelta) {
            this.scale *= scaleDelta;
            this.refresh();
        }
        translate(coordinates) {
            this.x += coordinates.x;
            this.y += coordinates.y;
            this.refresh();
        }
        moveAxis(axis, value) {
            this[axis] = value;
            this.refresh();
        }
        moveTo(coordinates) {
            extend$1(this, coordinates);
            this.refresh();
        }
        refresh() {
            let x = this.x, y = this.y;
            if (this.round) {
                x = Math.round(x);
                y = Math.round(y);
            }
            const newCoordinates = translate(x, y, this.scale);
            if (newCoordinates !== this.coordinates) {
                this.element.style.transform = newCoordinates;
                this._saveCoordinates(newCoordinates);
                this.trigger(CHANGE$1);
            }
        }
        _saveCoordinates(coordinates) {
            this.coordinates = coordinates;
        }
    }

    function animationFrame(callback) {
        window.requestAnimationFrame(callback);
    }
    class Animation {
        constructor() {
            this._tickProxy = () => this._tick();
            this._started = false;
        }
        tick() { }
        done() { return false; }
        onEnd() { }
        onCancel() { }
        start() {
            if (!this.enabled()) {
                return;
            }
            if (!this.done()) {
                this._started = true;
                animationFrame(this._tickProxy);
            }
            else {
                this.onEnd();
            }
        }
        enabled() {
            return true;
        }
        cancel() {
            this._started = false;
            this.onCancel();
        }
        _tick() {
            if (!this._started) {
                return;
            }
            this.tick();
            if (!this.done()) {
                animationFrame(this._tickProxy);
            }
            else {
                this._started = false;
                this.onEnd();
            }
        }
    }
    class Transition extends Animation {
        constructor(options) {
            super();
            extend$1(this, options);
        }
        done() {
            return this.timePassed() >= this.duration;
        }
        timePassed() {
            return Math.min(this.duration, now() - this.startDate);
        }
        moveTo(options) {
            const movable = this.movable;
            this.initial = movable[this.axis];
            this.delta = options.location - this.initial;
            this.duration = typeof options.duration === 'number' ? options.duration : 300;
            this.tick = this._easeProxy(options.ease);
            this.startDate = now();
            this.start();
        }
        _easeProxy(ease) {
            return function () {
                this.movable.moveAxis(this.axis, ease(this.timePassed(), this.initial, this.delta, this.duration));
            };
        }
        static easeOutExpo(t, b, c, d) {
            return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
        }
    }

    function guid() {
        let id = '';
        let i;
        let random;
        for (i = 0; i < 32; i++) {
            random = Math.floor(Math.random() * 16);
            if (i === 8 || i === 12 || i === 16 || i === 20) {
                id += '-';
            }
            id += (i === 12 ? 4 : (i === 16 ? ((random % 4) + 8) : random)).toString(16);
        }
        return id;
    }

    const elementEventHandlers = new WeakMap();
    const ID = Symbol('id');
    function on(element, events, filter, handler, useCapture) {
        addEventListeners(element, events, filter, handler, useCapture);
    }
    function off(element, events, handler, useCapture) {
        removeEventListeners(element, events, handler, useCapture);
    }
    function isString(value) {
        return typeof (value) === 'string';
    }
    function addEventListeners(element, events, filter, handler, useCapture) {
        const eventNames = Array.isArray(events) ? events : (events || '').split(' ');
        eventNames.forEach(function (eventName) {
            addEventListener(element, eventName, filter, handler, useCapture);
        });
    }
    function addEventListener(element, event, filter, handler, useCapture) {
        let eventHandler = handler;
        let eventFilter;
        if (filter && isFunction$1(filter) && !handler) {
            eventHandler = filter;
        }
        else if (filter && isString(filter) && isFunction$1(eventHandler)) {
            eventFilter = filter;
        }
        const attachedHandler = function (e) {
            const closestMatchingTarget = e.target ? e.target.closest(eventFilter) : null;
            if (!eventFilter ||
                (eventFilter && e.target && closestMatchingTarget)) {
                const currentTarget = eventFilter ? closestMatchingTarget : e.currentTarget;
                // reassign the property as it is a getters only
                Object.defineProperty(e, 'currentTarget', { value: currentTarget });
                // keep a reference to the top-level target
                Object.defineProperty(e, 'delegateTarget', { value: element });
                eventHandler(e);
            }
        };
        if (!eventHandler[ID]) {
            eventHandler[ID] = guid();
        }
        let eventHandlers = elementEventHandlers.get(element);
        if (!eventHandlers) {
            eventHandlers = new Map();
            elementEventHandlers.set(element, eventHandlers);
        }
        eventHandlers.set(event + eventHandler[ID], attachedHandler);
        element.addEventListener(event, attachedHandler, Boolean(useCapture));
    }
    function removeEventListeners(element, events, handler, useCapture) {
        const eventNames = Array.isArray(events) ? events : (events || '').split(' ');
        eventNames.forEach(function (eventName) {
            removeEventListener(element, eventName, handler, useCapture);
        });
    }
    function removeEventListener(element, event, handler, useCapture) {
        const eventHandlers = elementEventHandlers.get(element);
        if (eventHandlers && handler && handler[ID]) {
            const handlerId = event + handler[ID];
            const attachedHandler = eventHandlers.get(handlerId);
            eventHandlers.delete(handlerId);
            if (attachedHandler) {
                element.removeEventListener(event, attachedHandler, Boolean(useCapture));
            }
        }
    }

    function grep(array, callback) {
        const length = array.length;
        const result = [];
        for (let idx = 0; idx < length; idx++) {
            if (callback(array[idx])) {
                result.push(array[idx]);
            }
        }
        return result;
    }

    const preventDefault$1 = (e) => {
        e.preventDefault();
    };
    const noop = () => { };
    const CLICK_DELAY = 300, PRESS = 'press', HOLD = 'hold', SELECT = 'select', START = 'start', MOVE = 'move', END = 'end', CANCEL = 'cancel', TAP = 'tap', DOUBLETAP = 'doubleTap', RELEASE = 'release', GESTURESTART = 'gesturestart', GESTURECHANGE = 'gesturechange', GESTUREEND = 'gestureend', GESTURETAP = 'gesturetap';
    const THRESHOLD = {
        'api': 0,
        'touch': 0,
        'mouse': 9,
        'pointer': 9
    };
    let DEFAULT_MIN_HOLD = 800, DEFAULT_THRESHOLD = 0;
    function touchDelta(touch1, touch2) {
        const x1 = touch1.x.location, y1 = touch1.y.location, x2 = touch2.x.location, y2 = touch2.y.location, dx = x1 - x2, dy = y1 - y2;
        return {
            center: {
                x: (x1 + x2) / 2,
                y: (y1 + y2) / 2
            },
            distance: Math.sqrt(dx * dx + dy * dy)
        };
    }
    function getTouches(e) {
        const touches = [], originalEvent = e.originalEvent || e, currentTarget = e.currentTarget;
        if (e.api) {
            touches.push({
                id: 2, // hardcoded ID for API call
                event: e,
                target: e.target,
                currentTarget: e.target,
                location: e,
                type: 'api'
            });
        }
        else {
            touches.push({
                location: originalEvent,
                event: e,
                target: e.target,
                currentTarget: currentTarget,
                id: originalEvent.pointerId,
                type: 'pointer'
            });
        }
        return touches;
    }
    class TouchAxis {
        constructor(axis, location) {
            this.support = getSupportedFeatures();
            this.invalidZeroEvents = this.support.mobileOS && this.support.mobileOS.android;
            this.axis = axis;
            this._updateLocationData(location);
            this.startLocation = this.location;
            this.velocity = this.delta = 0;
            this.timeStamp = now();
        }
        move(location) {
            const offset = location['page' + this.axis], timeStamp = now(), timeDelta = timeStamp - this.timeStamp || 1;
            if (!offset && this.invalidZeroEvents) {
                return;
            }
            this.delta = offset - this.location;
            this._updateLocationData(location);
            this.initialDelta = offset - this.startLocation;
            this.velocity = this.delta / timeDelta;
            this.timeStamp = timeStamp;
        }
        _updateLocationData(location) {
            const axis = this.axis;
            this.location = location['page' + axis];
            this.client = location['client' + axis];
            this.screen = location['screen' + axis];
        }
    }
    class Touch {
        constructor(userEvents, target, touchInfo) {
            extend$1(this, {
                x: new TouchAxis('X', touchInfo.location),
                y: new TouchAxis('Y', touchInfo.location),
                type: touchInfo.type,
                threshold: userEvents.threshold || THRESHOLD[touchInfo.type],
                userEvents: userEvents,
                target: target,
                currentTarget: touchInfo.currentTarget,
                initialTouch: touchInfo.target,
                id: touchInfo.id,
                pressEvent: touchInfo,
                _clicks: userEvents._clicks,
                supportDoubleTap: userEvents.supportDoubleTap,
                _moved: false,
                _finished: false
            });
        }
        press() {
            this._holdTimeout = setTimeout(() => this._hold(), this.userEvents.minHold);
            this._trigger(PRESS, this.pressEvent);
        }
        _tap(touchInfo) {
            this.userEvents._clicks++;
            if (this.userEvents._clicks === 1) {
                this._clickTimeout = setTimeout(() => {
                    if (this.userEvents._clicks === 1) {
                        this._trigger(TAP, touchInfo);
                    }
                    else {
                        this._trigger(DOUBLETAP, touchInfo);
                    }
                    this.userEvents._clicks = 0;
                }, CLICK_DELAY);
            }
        }
        _hold() {
            this._trigger(HOLD, this.pressEvent);
        }
        move(touchInfo) {
            const preventMove = touchInfo.type !== 'api' && this.userEvents._shouldNotMove;
            if (this._finished || preventMove) {
                return;
            }
            this.x.move(touchInfo.location);
            this.y.move(touchInfo.location);
            if (!this._moved) {
                if (this._withinIgnoreThreshold()) {
                    return;
                }
                if (!UserEvents.current || UserEvents.current === this.userEvents) {
                    this._start(touchInfo);
                }
                else {
                    return this.dispose();
                }
            }
            if (!this._finished) {
                this._trigger(MOVE, touchInfo);
            }
        }
        end(touchInfo) {
            this.endTime = now();
            if (this._finished) {
                return;
            }
            this._finished = true;
            this._trigger(RELEASE, touchInfo);
            if (this._moved) {
                this._trigger(END, touchInfo);
            }
            else {
                if (this.supportDoubleTap) {
                    this._tap(touchInfo);
                }
                else {
                    this._trigger(TAP, touchInfo);
                }
            }
            clearTimeout(this._holdTimeout);
            this.dispose();
        }
        dispose() {
            const userEvents = this.userEvents, activeTouches = userEvents.touches || [];
            this._finished = true;
            this.pressEvent = null;
            clearTimeout(this._holdTimeout);
            // activeTouches.splice($.inArray(this, activeTouches), 1);
            const activeTouchIndex = activeTouches.indexOf(this);
            activeTouches.splice(activeTouchIndex, 1);
        }
        skip() {
            this.dispose();
        }
        cancel() {
            this.dispose();
        }
        isMoved() {
            return this._moved;
        }
        _start(touchInfo) {
            clearTimeout(this._holdTimeout);
            this.startTime = now();
            this._moved = true;
            this._trigger(START, touchInfo);
        }
        _trigger(name, touchInfo) {
            const e = touchInfo.event;
            const data = {
                touch: this,
                x: this.x,
                y: this.y,
                target: this.target,
                event: e
            };
            if (this.userEvents.notify(name, data)) {
                e.preventDefault();
            }
        }
        _withinIgnoreThreshold() {
            const xDelta = this.x.initialDelta, yDelta = this.y.initialDelta;
            return Math.sqrt(xDelta * xDelta + yDelta * yDelta) <= this.threshold;
        }
    }
    function withEachUpEvent(callback) {
        const downEvents = eventMap.up.split(' '), length = downEvents.length;
        for (let idx = 0; idx < length; idx++) {
            callback(downEvents[idx]);
        }
    }
    class UserEvents extends Observable {
        constructor(element, options) {
            super();
            const support = getSupportedFeatures();
            this.support = support;
            options = options || {};
            this.options = options;
            const filter = this.filter = options.filter;
            this.threshold = options.threshold || DEFAULT_THRESHOLD;
            this.minHold = options.minHold || DEFAULT_MIN_HOLD;
            this.touches = [];
            this._maxTouches = options.multiTouch ? 2 : 1;
            this.allowSelection = options.allowSelection;
            this.captureUpIfMoved = options.captureUpIfMoved;
            this._clicks = 0;
            this.supportDoubleTap = options.supportDoubleTap;
            extend$1(this, {
                element: element,
                surface: options.surface || element,
                stopPropagation: options.stopPropagation,
                pressed: false
            });
            this._surfaceMoveHandler = this._move.bind(this);
            on(this.surface, applyEventMap('move'), this._surfaceMoveHandler);
            this._surfaceEndHandler = this._end.bind(this);
            on(this.surface, applyEventMap('up cancel'), this._surfaceEndHandler);
            this._elementStartHandler = this._start.bind(this);
            on(element, applyEventMap('down'), filter, this._elementStartHandler);
            element.style['touch-action'] = options.touchAction || 'none';
            if (options.preventDragEvent) {
                this._elementDragStartHandler = preventDefault$1;
                on(element, applyEventMap('dragstart'), this._elementDragStartHandler);
            }
            // element.on(kendo.applyEventMap('mousedown'), filter, {
            //     root: element
            // } '_select');
            // todo: use root
            this._elementSelectHandler = this._select.bind(this);
            on(element, applyEventMap('mousedown'), filter, this._elementSelectHandler);
            if (this.captureUpIfMoved) {
                const surfaceElement = this.surface;
                this.preventIfMovingProxy = this.preventIfMoving.bind(this);
                withEachUpEvent((eventName) => {
                    surfaceElement.addEventListener(eventName, this.preventIfMovingProxy, true);
                });
            }
            this.bind([
                PRESS,
                HOLD,
                TAP,
                DOUBLETAP,
                START,
                MOVE,
                END,
                RELEASE,
                CANCEL,
                GESTURESTART,
                GESTURECHANGE,
                GESTUREEND,
                GESTURETAP,
                SELECT
            ], options);
        }
        preventIfMoving(e) {
            if (this._isMoved()) {
                e.preventDefault();
            }
        }
        destroy() {
            const options = this.options;
            const element = this.element;
            if (this._destroyed) {
                return;
            }
            this._destroyed = true;
            if (this.captureUpIfMoved) {
                const surfaceElement = this.surface;
                withEachUpEvent((eventName) => {
                    surfaceElement.removeEventListener(eventName, this.preventIfMovingProxy, true);
                });
            }
            off(this.surface, applyEventMap('move'), this._surfaceMoveHandler);
            off(this.surface, applyEventMap('up cancel'), this._surfaceEndHandler);
            off(element, applyEventMap('down'), this._elementStartHandler);
            if (options.preventDragEvent) {
                off(element, applyEventMap('dragstart'), this._elementDragStartHandler);
            }
            off(element, applyEventMap('mousedown'), this._elementSelectHandler);
            this._disposeAll();
            this.unbind();
            delete this.surface;
            delete this.element;
            delete this.currentTarget;
        }
        capture() {
            UserEvents.current = this;
        }
        cancel() {
            this._disposeAll();
            this.trigger(CANCEL);
        }
        notify(event, data) {
            const touches = this.touches;
            let eventName = event;
            if (this._isMultiTouch()) {
                switch (eventName) {
                    case MOVE:
                        eventName = GESTURECHANGE;
                        break;
                    case END:
                        eventName = GESTUREEND;
                        break;
                    case TAP:
                        eventName = GESTURETAP;
                        break;
                    default:
                        break;
                }
                extend$1(data, {
                    touches: touches
                }, touchDelta(touches[0], touches[1]));
            }
            return this.trigger(eventName, extend$1(data, {
                type: eventName
            }));
        }
        press(x, y, target) {
            this._apiCall('_start', x, y, target);
        }
        move(x, y) {
            this._apiCall('_move', x, y);
        }
        end(x, y) {
            this._apiCall('_end', x, y);
        }
        _isMultiTouch() {
            return this.touches.length > 1;
        }
        _maxTouchesReached() {
            return this.touches.length >= this._maxTouches;
        }
        _disposeAll() {
            const touches = this.touches;
            while (touches.length > 0) {
                touches.pop().dispose();
            }
        }
        _isMoved() {
            return grep(this.touches, function (touch) {
                return touch.isMoved();
            }).length;
        }
        _select(e) {
            if (!this.allowSelection || this.trigger(SELECT, { event: e })) {
                e.preventDefault();
            }
        }
        _start(e) {
            if (e.which && e.which > 1 || this._maxTouchesReached()) {
                return;
            }
            UserEvents.current = null;
            this.currentTarget = e.currentTarget;
            if (this.stopPropagation) {
                e.stopPropagation();
            }
            let target;
            const eventTouches = getTouches(e);
            for (let idx = 0; idx < eventTouches.length; idx++) {
                if (this._maxTouchesReached()) {
                    break;
                }
                const eventTouch = eventTouches[idx];
                if (this.filter) {
                    target = eventTouch.currentTarget;
                }
                else {
                    target = this.element;
                }
                if (target && target.length === 0) {
                    continue;
                }
                const touch = new Touch(this, target, eventTouch);
                this.touches.push(touch);
                touch.press();
                if (this._isMultiTouch()) {
                    this.notify('gesturestart', {});
                }
            }
        }
        _move(e) {
            this._eachTouch('move', e);
        }
        _end(e) {
            this._eachTouch('end', e);
        }
        _eachTouch(methodName, e) {
            const dict = {}, touches = getTouches(e), activeTouches = this.touches;
            let idx, touch, touchInfo, matchingTouch;
            for (idx = 0; idx < activeTouches.length; idx++) {
                touch = activeTouches[idx];
                dict[touch.id] = touch;
            }
            for (idx = 0; idx < touches.length; idx++) {
                touchInfo = touches[idx];
                matchingTouch = dict[touchInfo.id];
                if (matchingTouch) {
                    const shouldCapture = methodName === 'move' && touchInfo.type === 'pointer' && !this.surface.hasPointerCapture(touchInfo.id);
                    if (shouldCapture) {
                        this.surface.setPointerCapture(touchInfo.id);
                    }
                    matchingTouch[methodName](touchInfo);
                }
            }
        }
        _apiCall(type, x, y, target) {
            this[type]({
                api: true,
                pageX: x,
                pageY: y,
                clientX: x,
                clientY: y,
                target: target || this.element,
                stopPropagation: noop,
                preventDefault: noop
            });
        }
        static defaultThreshold(value) {
            DEFAULT_THRESHOLD = value;
        }
        static minHold(value) {
            DEFAULT_MIN_HOLD = value;
        }
    }

    const extend = Object.assign, abs = Math.abs, SNAPBACK_DURATION = 500, SCROLLBAR_OPACITY = 0.7, FRICTION = 0.96, VELOCITY_MULTIPLIER = 10, MAX_VELOCITY = 55, OUT_OF_BOUNDS_FRICTION = 0.5, ANIMATED_SCROLLER_PRECISION = 5, 
    // SCROLLER_RELEASE_CLASS = 'km-scroller-release',
    // SCROLLER_REFRESH_CLASS = 'km-scroller-refresh',
    PULL = 'pull', CHANGE = 'change', RESIZE = 'resize', SCROLL = 'scroll', MOUSE_WHEEL_ID = 2;
    class ZoomSnapBack extends Animation {
        constructor(options) {
            super();
            extend(this, options);
            this.userEvents.bind('gestureend', this.start.bind(this));
            this.tapCapture.bind('press', this.cancel.bind(this));
        }
        enabled() {
            return this.movable.scale < this.dimensions.minScale;
        }
        done() {
            return this.dimensions.minScale - this.movable.scale < 0.01;
        }
        tick() {
            const movable = this.movable;
            movable.scaleWith(1.1);
            this.dimensions.rescale(movable.scale);
        }
        onEnd() {
            const movable = this.movable;
            movable.scaleTo(this.dimensions.minScale);
            this.dimensions.rescale(movable.scale);
        }
    }
    class DragInertia extends Animation {
        constructor(options) {
            super();
            extend(this, options, {
                transition: new Transition({
                    axis: options.axis,
                    movable: options.movable,
                    onEnd: () => {
                        this._end();
                    }
                })
            });
            this.tapCapture.bind('press', () => {
                this.cancel();
            });
            this.userEvents.bind('end', () => this.start());
            this.userEvents.bind('gestureend', () => this.start());
            this.userEvents.bind('tap', () => this.onEnd());
        }
        onCancel() {
            this.transition.cancel();
        }
        freeze(location) {
            this.cancel();
            this._moveTo(location);
        }
        onEnd() {
            if (this.paneAxis.outOfBounds()) {
                this._snapBack();
            }
            else {
                this._end();
            }
        }
        done() {
            return abs(this.velocity) < 1;
        }
        start(e) {
            let velocity;
            if (!this.dimension.enabled) {
                return;
            }
            if (this.paneAxis.outOfBounds()) {
                if (this.transition._started) {
                    this.transition.cancel();
                    this.velocity = Math.min(e.touch[this.axis].velocity * this.velocityMultiplier, MAX_VELOCITY);
                    super.start();
                }
                else {
                    this._snapBack();
                }
            }
            else {
                velocity = e ? (e.touch.id === MOUSE_WHEEL_ID ? 0 : e.touch[this.axis].velocity) : 0;
                this.velocity = Math.max(Math.min(velocity * this.velocityMultiplier, MAX_VELOCITY), -MAX_VELOCITY);
                this.tapCapture.captureNext();
                super.start();
            }
        }
        tick() {
            const dimension = this.dimension, friction = this.paneAxis.outOfBounds() ? OUT_OF_BOUNDS_FRICTION : this.friction, delta = this.velocity *= friction;
            let location = this.movable[this.axis] + delta;
            if (!this.elastic && dimension.outOfBounds(location)) {
                location = Math.max(Math.min(location, dimension.max), dimension.min);
                this.velocity = 0;
            }
            this.movable.moveAxis(this.axis, location);
        }
        _end() {
            this.tapCapture.cancelCapture();
            this.end();
        }
        end() { }
        _snapBack() {
            const dimension = this.dimension, snapBack = this.movable[this.axis] > dimension.max ? dimension.max : dimension.min;
            this._moveTo(snapBack);
        }
        _moveTo(location) {
            this.transition.moveTo({
                location: location,
                duration: SNAPBACK_DURATION,
                ease: (...args) => {
                    Transition.easeOutExpo.apply(null, args);
                }
            });
        }
    }
    class AnimatedScroller extends Animation {
        constructor(options) {
            super();
            extend(this, options, {
                origin: {},
                destination: {},
                offset: {}
            });
        }
        moveTo(_to) { }
        tick() {
            this._updateCoordinates();
            this.moveTo(this.origin);
        }
        done() {
            return abs(this.offset.y) < ANIMATED_SCROLLER_PRECISION && abs(this.offset.x) < ANIMATED_SCROLLER_PRECISION;
        }
        onEnd() {
            this.moveTo(this.destination);
            if (this.callback) {
                this.callback.call();
            }
        }
        setCoordinates(from, to) {
            this.offset = {};
            this.origin = from;
            this.destination = to;
        }
        setCallback(callback) {
            if (callback && isFunction$1(callback)) {
                this.callback = callback;
            }
            else {
                callback = undefined;
            }
        }
        _updateCoordinates() {
            this.offset = {
                x: (this.destination.x - this.origin.x) / 4,
                y: (this.destination.y - this.origin.y) / 4
            };
            this.origin = {
                y: this.origin.y + this.offset.y,
                x: this.origin.x + this.offset.x
            };
        }
    }
    class ScrollBar {
        constructor(options) {
            const horizontal = options.axis === 'x';
            const orientation = (horizontal ? 'horizontal' : 'vertical');
            const element = convertToHtml('<div class="km-touch-scrollbar km-' + orientation + '-scrollbar" />');
            extend(this, options, {
                element: element,
                elementSize: 0,
                movable: new Movable(element),
                scrollMovable: options.movable,
                alwaysVisible: options.alwaysVisible,
                size: horizontal ? 'width' : 'height'
            });
            this.scrollMovable.bind(CHANGE, this.refresh.bind(this));
            this.container.appendChild(element);
            if (options.alwaysVisible) {
                this.show();
            }
        }
        refresh() {
            const axis = this.axis, dimension = this.dimension, paneSize = dimension.size, scrollMovable = this.scrollMovable, sizeRatio = paneSize / dimension.total;
            let size = Math.round(paneSize * sizeRatio), position = Math.round(-scrollMovable[axis] * sizeRatio);
            if (sizeRatio >= 1) {
                this.element.style.display = 'none';
            }
            else {
                this.element.style.display = '';
            }
            if (position + size > paneSize) {
                size = paneSize - position;
            }
            else if (position < 0) {
                size += position;
                position = 0;
            }
            if (this.elementSize !== size) {
                this.element.style[this.size] = size + 'px';
                this.elementSize = size;
            }
            this.movable.moveAxis(axis, position);
        }
        show() {
            this.element.style.opacity = SCROLLBAR_OPACITY;
            this.element.style.visibility = 'visible';
        }
        hide() {
            if (!this.alwaysVisible) {
                this.element.style.opacity = 0;
            }
        }
    }
    const defaultScrollerOptions = {
        name: 'Scroller',
        zoom: false,
        pullOffset: 140,
        visibleScrollHints: false,
        elastic: true,
        useNative: false,
        mousewheelScrolling: true,
        avoidScrolling: () => false,
        pullToRefresh: false,
        messages: {
            pullTemplate: 'Pull to refresh',
            releaseTemplate: 'Release to refresh',
            refreshTemplate: 'Refreshing'
        }
    };
    // export class Scroller extends Class {
    class Scroller extends Observable {
        constructor(element, options) {
            super();
            this.element = element = element[0] || element;
            this._initOptions(options);
            this.events.push(PULL, SCROLL, RESIZE);
            const hasScrolling = hasNativeScrolling();
            this._native = this.options.useNative && hasScrolling;
            const scrollHeader = convertToHtml('<div class="km-scroll-header"/>');
            if (this._native) {
                addClass(element, 'km-native-scroller');
                prepend(scrollHeader, element);
                extend(this, {
                    scrollElement: element,
                    fixedContainer: element.children[0]
                });
                return;
            }
            element.style.overflow = 'hidden';
            addClass(element, 'km-scroll-wrapper');
            const scrollContainer = convertToHtml('<div class="km-scroll-container"/>');
            wrapInner(element, scrollContainer);
            prepend(scrollHeader, element);
            const inner = element.children[1], tapCapture = new TapCapture(element), movable = new Movable(inner), dimensions = new PaneDimensions({
                element: inner,
                container: element,
                forcedEnabled: this.options.zoom
            }), avoidScrolling = this.options.avoidScrolling, userEvents = new UserEvents(element, {
                touchAction: 'none',
                allowSelection: true,
                preventDragEvent: true,
                captureUpIfMoved: true,
                multiTouch: this.options.zoom,
                supportDoubleTap: this.options.supportDoubleTap,
                start: (e) => {
                    dimensions.refresh();
                    const velocityX = abs(e.x.velocity), velocityY = abs(e.y.velocity), horizontalSwipe = velocityX * 2 >= velocityY, originatedFromFixedContainer = this.fixedContainer.contains(e.event.target), verticalSwipe = velocityY * 2 >= velocityX;
                    if (!originatedFromFixedContainer && !avoidScrolling(e) && this.enabled && (dimensions.x.enabled && horizontalSwipe || dimensions.y.enabled && verticalSwipe)) {
                        userEvents.capture();
                    }
                    else {
                        userEvents.cancel();
                    }
                }
            }), pane = new Pane({
                movable: movable,
                dimensions: dimensions,
                userEvents: userEvents,
                elastic: this.options.elastic
            }), zoomSnapBack = new ZoomSnapBack({
                movable: movable,
                dimensions: dimensions,
                userEvents: userEvents,
                tapCapture: tapCapture
            }), animatedScroller = new AnimatedScroller({
                moveTo: (coordinates) => {
                    this.scrollTo(coordinates.x, coordinates.y);
                }
            });
            movable.bind(CHANGE, () => {
                this.scrollTop = -movable.y;
                this.scrollLeft = -movable.x;
                this.trigger(SCROLL, {
                    scrollTop: this.scrollTop,
                    scrollLeft: this.scrollLeft
                });
            });
            if (this.options.mousewheelScrolling) {
                this._wheelScrollHandler = this._wheelScroll.bind(this);
                on(element, 'wheel', this._wheelScrollHandler);
            }
            extend(this, {
                movable: movable,
                dimensions: dimensions,
                zoomSnapBack: zoomSnapBack,
                animatedScroller: animatedScroller,
                userEvents: userEvents,
                pane: pane,
                tapCapture: tapCapture,
                pulled: false,
                enabled: true,
                scrollElement: inner,
                scrollTop: 0,
                scrollLeft: 0,
                fixedContainer: element.children[0]
            });
            this._initAxis('x');
            this._initAxis('y');
            this._wheelEnd = () => {
                this._wheel = false;
                this.userEvents.end(0, this._wheelY);
            };
            dimensions.refresh();
            if (this.options.pullToRefresh) {
                this._initPullToRefresh();
            }
            this.bind(this.events, this.options);
        }
        _initOptions(options) {
            this.options = deepExtend({}, this.options, defaultScrollerOptions, options);
        }
        _wheelScroll(e) {
            if (e.ctrlKey) {
                return;
            }
            if (!this._wheel) {
                this._wheel = true;
                this._wheelY = 0;
                this.userEvents.press(0, this._wheelY);
            }
            clearTimeout(this._wheelTimeout);
            this._wheelTimeout = setTimeout(() => this._wheelEnd(), 50);
            const delta = wheelDeltaY(e);
            if (delta) {
                this._wheelY += delta;
                this.userEvents.move(0, this._wheelY);
            }
            e.preventDefault();
        }
        makeVirtual() {
            this.dimensions.y.makeVirtual();
        }
        virtualSize(min, max) {
            this.dimensions.y.virtualSize(min, max);
        }
        height() {
            return this.dimensions.y.size;
        }
        scrollHeight() {
            return this.scrollElement.scrollHeight;
        }
        scrollWidth() {
            return this.scrollElement.scrollWidth;
        }
        _resize() {
            if (!this._native) {
                this.contentResized();
            }
        }
        setOptions(options) {
            this._initOptions(options);
            if (options.pullToRefresh) {
                this._initPullToRefresh();
            }
        }
        reset() {
            if (this._native) {
                this.scrollElement.scrollTop(0);
            }
            else {
                this.movable.moveTo({
                    x: 0,
                    y: 0
                });
                this._scale(1);
            }
        }
        contentResized() {
            this.dimensions.refresh();
            if (this.pane.x.outOfBounds()) {
                this.movable.moveAxis('x', this.dimensions.x.min);
            }
            if (this.pane.y.outOfBounds()) {
                this.movable.moveAxis('y', this.dimensions.y.min);
            }
        }
        zoomOut() {
            const dimensions = this.dimensions;
            dimensions.refresh();
            this._scale(dimensions.fitScale);
            this.movable.moveTo(dimensions.centerCoordinates());
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        scrollTo(x, y) {
            if (this._native) {
                this.scrollElement.scrollLeft(abs(x));
                this.scrollElement.scrollTop(abs(y));
            }
            else {
                this.dimensions.refresh();
                this.movable.moveTo({
                    x: x,
                    y: y
                });
            }
        }
        animatedScrollTo(x, y, callback) {
            let from, to;
            if (this._native) {
                this.scrollTo(x, y);
            }
            else {
                from = {
                    x: this.movable.x,
                    y: this.movable.y
                };
                to = {
                    x: x,
                    y: y
                };
                this.animatedScroller.setCoordinates(from, to);
                this.animatedScroller.setCallback(callback);
                this.animatedScroller.start();
            }
        }
        // kept for API compatibility, not used
        pullHandled() {
            // let this = this;
            // removeClass(this.refreshHint, SCROLLER_REFRESH_CLASS);
            // this.hintContainer.innerHTML = this.pullTemplate({}));
            // this.yinertia.onEnd();
            // this.xinertia.onEnd();
            // this.userEvents.cancel();
        }
        destroy() {
            const element = this.element;
            off(element, 'wheel', this._wheelScrollHandler);
            if (this.userEvents) {
                this.userEvents.destroy();
            }
            if (this.tapCapture) {
                this.tapCapture.destroy();
            }
        }
        _scale(scale) {
            this.dimensions.rescale(scale);
            this.movable.scaleTo(scale);
        }
        _initPullToRefresh() {
        }
        // kept for API compatibility, not used
        _dragEnd() {
            // let this = this;
            // if (!this.pulled) {
            //     return;
            // }
            // this.pulled = false;
            // removeClass(this.refreshHint, SCROLLER_RELEASE_CLASS);
            // addClass(this.refreshHint, SCROLLER_REFRESH_CLASS);
            // this.hintContainer.innerHTML = this.refreshTemplate({});
            // this.yinertia.freeze(this.options.pullOffset / 2);
            // this.trigger('pull');
        }
        // kept for API compatibility, not used
        _paneChange() {
            // let this = this;
            // if (this.movable.y / OUT_OF_BOUNDS_FRICTION > this.options.pullOffset) {
            //     if (!this.pulled) {
            //         this.pulled = true;
            //         this.refreshHint.removeClass(SCROLLER_REFRESH_CLASS).addClass(SCROLLER_RELEASE_CLASS);
            //         this.hintContainer.html(this.releaseTemplate({}));
            //         this.hintContainer.html(this.releaseTemplate({}));
            //     }
            // } else if (this.pulled) {
            //     this.pulled = false;
            //     this.refreshHint.removeClass(SCROLLER_RELEASE_CLASS);
            //     this.hintContainer.html(this.pullTemplate({}));
            // }
        }
        _initAxis(axis) {
            const movable = this.movable, dimension = this.dimensions[axis], tapCapture = this.tapCapture, paneAxis = this.pane[axis], scrollBar = new ScrollBar({
                axis: axis,
                movable: movable,
                dimension: dimension,
                container: this.element,
                alwaysVisible: this.options.visibleScrollHints
            });
            dimension.bind(CHANGE, () => {
                scrollBar.refresh();
            });
            paneAxis.bind(CHANGE, () => {
                scrollBar.show();
            });
            this[axis + 'inertia'] = new DragInertia({
                axis: axis,
                paneAxis: paneAxis,
                movable: movable,
                tapCapture: tapCapture,
                userEvents: this.userEvents,
                dimension: dimension,
                elastic: this.options.elastic,
                friction: this.options.friction || FRICTION,
                velocityMultiplier: this.options.velocityMultiplier || VELOCITY_MULTIPLIER,
                end: () => {
                    scrollBar.hide();
                    this.trigger('scrollEnd', {
                        axis: axis,
                        scrollTop: this.scrollTop,
                        scrollLeft: this.scrollLeft
                    });
                }
            });
        }
    }

    class ScrollerTool extends EmptyTool {
        constructor(toolService) {
            super(toolService);
            const diagram = this.toolService.diagram, canvas = diagram.canvas;
            const friction = diagram._mobileOS() ? FRICTION_MOBILE : FRICTION$1;
            const scroller = diagram.scroller = this.scroller = new Scroller(diagram.scrollable, {
                friction: friction,
                velocityMultiplier: VELOCITY_MULTIPLIER$1,
                mousewheelScrolling: false,
                zoom: false,
                scroll: this._move.bind(this)
            });
            if (canvas.translate) {
                this.movableCanvas = new Movable(canvas.element);
            }
            const virtualScroll = function (dimension, min, max) {
                dimension.makeVirtual();
                dimension.virtualSize(min || SCROLL_MIN, max || SCROLL_MAX);
            };
            virtualScroll(scroller.dimensions.x);
            virtualScroll(scroller.dimensions.y);
            scroller.disable();
        }
        tryActivate(_p, meta) {
            const toolService = this.toolService;
            const options = toolService.diagram.options.pannable;
            let enabled = meta.ctrlKey;
            if (defined(options.key)) {
                if (!options.key || options.key === 'none') {
                    enabled = noMeta(meta) && !defined(toolService.hoveredItem);
                }
                else {
                    enabled = meta[options.key + 'Key'];
                }
            }
            return options !== false && enabled && !defined(toolService.hoveredAdorner) && !defined(toolService._hoveredConnector);
        }
        start() {
            this.scroller.enable();
        }
        move() {
        } // the tool itself should not handle the scrolling. Let kendo scroller take care of this part. Check _move
        _move(args) {
            const diagram = this.toolService.diagram, canvas = diagram.canvas;
            let scrollPos = new Point(args.scrollLeft, args.scrollTop);
            if (canvas.translate) {
                diagram._storePan(scrollPos.times(-1));
                this.movableCanvas.moveTo(scrollPos);
                canvas.translate(scrollPos.x, scrollPos.y);
            }
            else {
                scrollPos = scrollPos.plus(diagram._pan.times(-1));
            }
            diagram.trigger(PAN, { pan: scrollPos });
        }
        end() {
            this.scroller.disable();
        }
        getCursor() {
            return Cursors.move;
        }
    }

    class SelectionTool {
        constructor(toolService) {
            this.toolService = toolService;
        }
        tryActivate(_p, meta) {
            const toolService = this.toolService;
            const selectable = toolService.diagram.options.selectable;
            let enabled = selectable && selectable.multiple !== false;
            if (enabled) {
                if (selectable.key && selectable.key !== 'none') {
                    enabled = meta[selectable.key + 'Key'];
                }
                else {
                    enabled = noMeta(meta);
                }
            }
            return enabled && !defined(toolService.hoveredItem) && !defined(toolService.hoveredAdorner);
        }
        start(p) {
            const diagram = this.toolService.diagram;
            diagram.deselect();
            diagram.selector.start(p);
        }
        move(p) {
            const diagram = this.toolService.diagram;
            diagram.selector.move(p);
        }
        end(_p, meta) {
            const diagram = this.toolService.diagram, hoveredItem = this.toolService.hoveredItem;
            const rect = diagram.selector.bounds();
            if ((!hoveredItem || !hoveredItem.isSelected) && !meta.ctrlKey) {
                diagram.deselect();
            }
            if (!rect.isEmpty()) {
                diagram.selectArea(rect);
            }
            diagram.selector.end();
        }
        getCursor() {
            return Cursors.arrow;
        }
    }

    function testKey(key, str) {
        return str.charCodeAt(0) === key || str.toUpperCase().charCodeAt(0) === key;
    }

    class ConnectionEditUnit {
        constructor(item, redoSource, redoTarget) {
            this.item = item;
            this._redoSource = redoSource;
            this._redoTarget = redoTarget;
            if (defined(redoSource)) {
                this._undoSource = item.source();
            }
            if (defined(redoTarget)) {
                this._undoTarget = item.target();
            }
            this.title = ConnectionEditing;
        }
        undo() {
            if (this._undoSource !== undefined) {
                this.item._updateConnector(this._undoSource, SOURCE);
            }
            if (this._undoTarget !== undefined) {
                this.item._updateConnector(this._undoTarget, TARGET);
            }
            this.item.updateModel();
        }
        redo() {
            if (this._redoSource !== undefined) {
                this.item._updateConnector(this._redoSource, SOURCE);
            }
            if (this._redoTarget !== undefined) {
                this.item._updateConnector(this._redoTarget, TARGET);
            }
            this.item.updateModel();
        }
    }

    const defaultOptions$1 = {
        hover: {
            stroke: {}
        },
        startCap: NONE,
        endCap: NONE,
        points: [],
        selectable: true,
        fromConnector: AUTO,
        toConnector: AUTO
    };
    /**
     * The visual link between two Shapes through the intermediate of Connectors.
     */
    class Connection extends DiagramElement {
        constructor(from, to, options) {
            options = deepExtend({}, defaultOptions$1, options);
            super(options);
            this.updateOptionsFromModel();
            this._initRouter();
            this.path = new Polyline(this.options);
            this.path.fill(TRANSPARENT);
            this.visual.append(this.path);
            this._sourcePoint = this._targetPoint = new Point();
            this._setSource(from);
            this._setTarget(to);
            this.content(this.options.content);
            this.definers = [];
            if (defined(options) && options.points) {
                this.points(options.points);
            }
        }
        _setOptionsFromModel(model) {
            this.updateOptionsFromModel(model || this.dataItem);
        }
        updateOptionsFromModel(model) {
            if (this.diagram && this.diagram._isEditable) {
                const dataMap = this.diagram._dataMap;
                const options = filterConnectionDataItem(model || this.dataItem);
                if (model) {
                    if (defined(options.from)) {
                        let from = dataMap[options.from];
                        if (from && defined(options.fromConnector)) {
                            from = from.getConnector(options.fromConnector);
                        }
                        this.source(from);
                    }
                    else if (defined(options.fromX) && defined(options.fromY)) {
                        this.source(new Point(options.fromX, options.fromY));
                    }
                    if (defined(options.to)) {
                        let to = dataMap[options.to];
                        if (to && defined(options.toConnector)) {
                            to = to.getConnector(options.toConnector);
                        }
                        this.target(to);
                    }
                    else if (defined(options.toX) && defined(options.toY)) {
                        this.target(new Point(options.toX, options.toY));
                    }
                    if (defined(options.type) && this.type() !== options.type) {
                        this.points([]);
                        this.type(options.type);
                    }
                    this.dataItem = model;
                    this._template();
                    this.redraw(this.options);
                }
                else {
                    this.options = deepExtend({}, options, this.options);
                }
            }
        }
        updateModel(syncChanges) {
            if (this.diagram && this.diagram._isEditable) {
                this.diagram.updateConnectionModel(this, syncChanges);
            }
        }
        /**
         * Gets the Point where the source of the connection resides.
         * If the endpoint in Auto-connector the location of the resolved connector will be returned.
         * If the endpoint is floating the location of the endpoint is returned.
         */
        sourcePoint() {
            return this._resolvedSourceConnector ? this._resolvedSourceConnector.position() : this._sourcePoint;
        }
        _setSource(source) {
            const shapeSource = source instanceof Shape;
            const defaultConnector = this.options.fromConnector || AUTO;
            let dataItem;
            if (shapeSource && !source.getConnector(defaultConnector)) {
                return;
            }
            if (source !== undefined) {
                this.from = source;
            }
            this._removeFromSourceConnector();
            if (source === null) { // detach
                if (this.sourceConnector) {
                    this._sourcePoint = (this._resolvedSourceConnector || this.sourceConnector).position();
                    this._clearSourceConnector();
                    this._setFromOptions(null, this._sourcePoint);
                }
            }
            else if (source instanceof Connector) {
                dataItem = source.shape.dataItem;
                if (dataItem) {
                    this._setFromOptions(dataItem.id);
                }
                this.sourceConnector = source;
                this.sourceConnector.connections.push(this);
            }
            else if (source instanceof Point) {
                this._setFromOptions(null, source);
                this._sourcePoint = source;
                if (this.sourceConnector) {
                    this._clearSourceConnector();
                }
            }
            else if (shapeSource) {
                dataItem = source.dataItem;
                if (dataItem) {
                    this._setFromOptions(dataItem.id);
                }
                this.sourceConnector = source.getConnector(defaultConnector);
                this.sourceConnector.connections.push(this);
            }
        }
        source(source, undoable) {
            if (isDefined(source)) {
                if (undoable && this.diagram) {
                    this.diagram.undoRedoService.addCompositeItem(new ConnectionEditUnit(this, source));
                }
                this._setSource(source);
                this.refresh();
            }
            return this.sourceConnector ? this.sourceConnector : this._sourcePoint;
        }
        _setFromOptions(from, fromPoint) {
            this.options.from = from;
            if (fromPoint) {
                this.options.fromX = fromPoint.x;
                this.options.fromY = fromPoint.y;
            }
            else {
                this.options.fromX = null;
                this.options.fromY = null;
            }
        }
        /**
         * Gets or sets the PathDefiner of the sourcePoint.
         * The left part of this definer is always null since it defines the source tangent.
         *
         * @param value
         * @returns {*}
         */
        sourceDefiner(value) {
            if (value) {
                if (value instanceof PathDefiner) {
                    value.left = null;
                    this._sourceDefiner = value;
                    this.source(value.point); // refresh implicit here
                }
                else {
                    throw new Error('The sourceDefiner needs to be a PathDefiner.');
                }
            }
            else {
                if (!this._sourceDefiner) {
                    this._sourceDefiner = new PathDefiner(this.sourcePoint(), null, null);
                }
                return this._sourceDefiner;
            }
        }
        /**
         * Gets  the Point where the target of the connection resides.
         */
        targetPoint() {
            return this._resolvedTargetConnector ? this._resolvedTargetConnector.position() : this._targetPoint;
        }
        _setTarget(target) {
            const shapeTarget = target instanceof Shape;
            const defaultConnector = this.options.toConnector || AUTO;
            let dataItem;
            if (shapeTarget && !target.getConnector(defaultConnector)) {
                return;
            }
            if (target !== undefined) {
                this.to = target;
            }
            this._removeFromTargetConnector();
            if (target === null) { // detach
                if (this.targetConnector) {
                    this._targetPoint = (this._resolvedTargetConnector || this.targetConnector).position();
                    this._clearTargetConnector();
                    this._setToOptions(null, this._targetPoint);
                }
            }
            else if (target instanceof Connector) {
                dataItem = target.shape.dataItem;
                if (dataItem) {
                    this._setToOptions(dataItem.id);
                }
                this.targetConnector = target;
                this.targetConnector.connections.push(this);
            }
            else if (target instanceof Point) {
                this._setToOptions(null, target);
                this._targetPoint = target;
                if (this.targetConnector) {
                    this._clearTargetConnector();
                }
            }
            else if (shapeTarget) {
                dataItem = target.dataItem;
                if (dataItem) {
                    this._setToOptions(dataItem.id);
                }
                this.targetConnector = target.getConnector(defaultConnector);
                this.targetConnector.connections.push(this);
            }
        }
        target(target, undoable) {
            if (isDefined(target)) {
                if (undoable && this.diagram) {
                    this.diagram.undoRedoService.addCompositeItem(new ConnectionEditUnit(this, undefined, target));
                }
                this._setTarget(target);
                this.refresh();
            }
            return this.targetConnector ? this.targetConnector : this._targetPoint;
        }
        _setToOptions(to, toPoint) {
            this.options.to = to;
            if (toPoint) {
                this.options.toX = toPoint.x;
                this.options.toY = toPoint.y;
            }
            else {
                this.options.toX = null;
                this.options.toY = null;
            }
        }
        /**
         * Gets or sets the PathDefiner of the targetPoint.
         * The right part of this definer is always null since it defines the target tangent.
         *
         * @param value
         * @returns {*}
         */
        targetDefiner(value) {
            if (value) {
                if (value instanceof PathDefiner) {
                    value.right = null;
                    this._targetDefiner = value;
                    this.target(value.point); // refresh implicit here
                }
                else {
                    throw new Error('The sourceDefiner needs to be a PathDefiner.');
                }
            }
            else {
                if (!this._targetDefiner) {
                    this._targetDefiner = new PathDefiner(this.targetPoint(), null, null);
                }
                return this._targetDefiner;
            }
        }
        _updateConnectors() {
            this._updateConnector(this.source(), 'source');
            this._updateConnector(this.target(), 'target');
        }
        _updateConnector(instance, name) {
            const diagram = this.diagram;
            if (instance instanceof Connector && !diagram.getShapeById(instance.shape.id)) {
                const dataItem = instance.shape.dataItem;
                const connectorName = instance.options.name;
                const setNewTarget = () => {
                    const shape = diagram._dataMap[dataItem.id];
                    instance = shape.getConnector(connectorName);
                    this[name](instance, false);
                    this.updateModel();
                };
                if (diagram._dataMap[dataItem.id]) {
                    setNewTarget();
                }
                else {
                    const inactiveItem = diagram._inactiveShapeItems.getByUid(dataItem.uid);
                    if (inactiveItem) {
                        diagram._deferredConnectionUpdates.push(inactiveItem.onActivate(setNewTarget));
                    }
                }
            }
            else {
                this[name](instance, false);
            }
        }
        content(content) {
            const result = this._content(content);
            if (defined(content)) {
                this._alignContent();
            }
            return result;
        }
        _createContentVisual(options) {
            let visual;
            if (isFunction$1(options.visual)) {
                visual = options.visual.call(this, options);
            }
            else if (options.text) {
                visual = new TextBlock(options);
            }
            if (visual) {
                this._contentVisual = visual;
                visual._includeInBBox = false;
                this.visual.append(visual);
            }
            return visual;
        }
        _updateContentVisual(options) {
            if (isFunction$1(options.visual)) {
                this.visual.remove(this._contentVisual);
                this._createContentVisual(options);
            }
            else {
                this._contentVisual.redraw(options);
            }
        }
        _alignContent() {
            if (this._contentVisual) {
                let offset = CONNECTION_CONTENT_OFFSET;
                const points = this.allPoints();
                let endIdx = Math.floor(points.length / 2);
                let startIdx = endIdx - 1;
                while (startIdx > 0 && points[startIdx].equals(points[endIdx])) {
                    startIdx--;
                    endIdx++;
                }
                let endPoint = points[endIdx];
                let startPoint = points[startIdx];
                const boundingBox = this._contentVisual._measure();
                const width = boundingBox.width;
                const height = boundingBox.height;
                let alignToPath = points.length % 2 === 0;
                const distance = startPoint.distanceTo(endPoint);
                if (alignToPath && points.length > 2 && distance > 0 &&
                    ((startPoint.y === endPoint.y && distance < width) || (startPoint.x === endPoint.x && distance < height))) {
                    alignToPath = false;
                    offset = 0;
                }
                let point;
                if (alignToPath) {
                    const angle = kendo_drawing_cmn_chunk_js.v(Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x));
                    point = new Point((endPoint.x - startPoint.x) / 2 + startPoint.x, (endPoint.y - startPoint.y) / 2 + startPoint.y);
                    if (Math.abs(angle) === 90) {
                        point.x += offset;
                        point.y -= height / 2;
                    }
                    else if (angle % 180 === 0) {
                        point.x -= width / 2;
                        point.y -= height + offset;
                    }
                    else if (angle < -90 || (0 < angle && angle < 90)) {
                        point.y -= height;
                    }
                    else if (angle < 0 || angle > 90) {
                        point.x -= width;
                        point.y -= height;
                    }
                }
                else {
                    const midIdx = Math.floor(points.length / 2);
                    point = points[midIdx].clone();
                    startPoint = points[midIdx - 1];
                    endPoint = points[midIdx + 1];
                    const offsetX = startPoint.x <= point.x && endPoint.x <= point.x ? offset : -boundingBox.width - offset;
                    const offsetY = startPoint.y <= point.y && endPoint.y <= point.y ? offset : -boundingBox.height - offset;
                    point.x += offsetX;
                    point.y += offsetY;
                }
                this._contentVisual.position(point);
            }
        }
        /**
         * Selects or unselects this connections.
         *
         * @param value True to select, false to unselect.
         */
        select(value) {
            const diagram = this.diagram;
            let selected, deselected;
            if (this._canSelect()) {
                if (this.isSelected !== value) {
                    this.isSelected = value;
                    selected = [];
                    deselected = [];
                    if (this.isSelected) {
                        this.adorner = new ConnectionEditAdorner(this, this.options.selection);
                        diagram._adorn(this.adorner, true);
                        diagram._selectedItems.push(this);
                        selected.push(this);
                    }
                    else {
                        if (this.adorner) {
                            diagram._adorn(this.adorner, false);
                            remove(diagram._selectedItems, this);
                            this.adorner = undefined;
                            deselected.push(this);
                        }
                    }
                    if (this.adorner) {
                        this.adorner.refresh();
                    }
                    if (!diagram._internalSelection) {
                        diagram._selectionChanged(selected, deselected);
                    }
                    return true;
                }
            }
        }
        /**
         * Gets or sets the bounds of this connection.
         *
         * @param value A Rect object.
         * @remark This is automatically set in the refresh().
         * @returns {Rect}
         */
        bounds(value) {
            if (value && !isString$1(value)) {
                this._bounds = value;
            }
            else {
                return this._bounds;
            }
        }
        /**
         * Gets or sets the connection type (see ConnectionType enumeration).
         *
         * @param value A ConnectionType value.
         * @returns {ConnectionType}
         */
        type(value) {
            const options = this.options;
            if (value) {
                if (value !== options.type) {
                    options.type = value;
                    this._initRouter();
                    this.refresh();
                }
            }
            else {
                return options.type;
            }
        }
        _initRouter() {
            const type = (this.options.type || '').toLowerCase();
            if (type === CASCADING) {
                this._router = new CascadingRouter(this);
            }
            else {
                this._router = new PolylineRouter(this);
            }
        }
        /**
         * Gets or sets the collection of *intermediate* points.
         * The 'allPoints()' property will return all the points.
         * The 'definers' property returns the definers of the intermediate points.
         * The 'sourceDefiner' and 'targetDefiner' return the definers of the endpoints.
         *
         * @param value
         */
        points(value) {
            if (value) {
                this.definers = [];
                for (let i = 0; i < value.length; i++) {
                    const definition = value[i];
                    if (definition instanceof Point) {
                        this.definers.push(new PathDefiner(definition));
                    }
                    else if (Object.prototype.hasOwnProperty.call(definition, 'x') && Object.prototype.hasOwnProperty.call(definition, 'y')) { // e.g. Clipboard does not preserve the Point definition and turned into an Object
                        this.definers.push(new PathDefiner(new Point(definition.x, definition.y)));
                    }
                    else {
                        throw new Error('A Connection point needs to be a Point or an object with x and y properties.');
                    }
                }
            }
            else {
                const pts = [];
                if (isDefined(this.definers)) {
                    for (let k = 0; k < this.definers.length; k++) {
                        pts.push(this.definers[k].point);
                    }
                }
                return pts;
            }
        }
        /**
         * Gets all the points of this connection. This is the combination of the sourcePoint, the points and the targetPoint.
         *
         * @returns {Array}
         */
        allPoints() {
            const pts = [this.sourcePoint()];
            if (this.definers) {
                for (let k = 0; k < this.definers.length; k++) {
                    pts.push(this.definers[k].point);
                }
            }
            pts.push(this.targetPoint());
            return pts;
        }
        refresh() {
            this._resolveConnectors();
            this._refreshPath();
            this._alignContent();
            if (this.adorner) {
                this.adorner.refresh();
            }
        }
        _resolveConnectors() {
            let sourcePoint, targetPoint, sourceConnectors, targetConnectors;
            const source = this.source(), target = this.target();
            if (source instanceof Point) {
                sourcePoint = source;
            }
            else if (source instanceof Connector) {
                if (isAutoConnector(source)) {
                    sourceConnectors = source.shape.connectors;
                }
                else {
                    sourceConnectors = [source];
                }
            }
            if (target instanceof Point) {
                targetPoint = target;
            }
            else if (target instanceof Connector) {
                if (isAutoConnector(target)) {
                    targetConnectors = target.shape.connectors;
                }
                else {
                    targetConnectors = [target];
                }
            }
            if (sourcePoint) {
                if (targetConnectors) {
                    this._resolvedTargetConnector = closestConnector(sourcePoint, targetConnectors);
                }
            }
            else if (sourceConnectors) {
                if (targetPoint) {
                    this._resolvedSourceConnector = closestConnector(targetPoint, sourceConnectors);
                }
                else if (targetConnectors) {
                    this._resolveAutoConnectors(sourceConnectors, targetConnectors);
                }
            }
        }
        _resolveAutoConnectors(sourceConnectors, targetConnectors) {
            let minNonConflict = MAXINT;
            let minDist = MAXINT;
            let minNonConflictSource, minNonConflictTarget;
            let sourcePoint, targetPoint;
            let minSource, minTarget;
            let sourceConnector, targetConnector;
            let sourceIdx, targetIdx;
            let dist;
            for (sourceIdx = 0; sourceIdx < sourceConnectors.length; sourceIdx++) {
                sourceConnector = sourceConnectors[sourceIdx];
                if (!isAutoConnector(sourceConnector)) {
                    sourcePoint = sourceConnector.position();
                    for (targetIdx = 0; targetIdx < targetConnectors.length; targetIdx++) {
                        targetConnector = targetConnectors[targetIdx];
                        if (!isAutoConnector(targetConnector)) {
                            targetPoint = targetConnector.position();
                            dist = Math.round(sourcePoint.distanceTo(targetPoint));
                            if (dist < minNonConflict && this.diagram && this._testRoutePoints(sourcePoint, targetPoint, sourceConnector, targetConnector)) {
                                minNonConflict = dist;
                                minNonConflictSource = sourceConnector;
                                minNonConflictTarget = targetConnector;
                            }
                            if (dist < minDist) {
                                minSource = sourceConnector;
                                minTarget = targetConnector;
                                minDist = dist;
                            }
                        }
                    }
                }
            }
            if (minNonConflictSource) {
                minSource = minNonConflictSource;
                minTarget = minNonConflictTarget;
            }
            this._resolvedSourceConnector = minSource;
            this._resolvedTargetConnector = minTarget;
        }
        _testRoutePoints(sourcePoint, targetPoint, sourceConnector, targetConnector) {
            const router = this._router;
            let passRoute = true;
            if (router instanceof CascadingRouter) {
                const points = router.routePoints(sourcePoint, targetPoint, sourceConnector, targetConnector), exclude = this._getRouteExclude(sourcePoint, targetPoint, sourceConnector.shape, targetConnector.shape);
                let start, end, rect;
                points.unshift(sourcePoint);
                points.push(targetPoint);
                for (let idx = 1; idx < points.length; idx++) {
                    start = points[idx - 1];
                    end = points[idx];
                    rect = new Rect(Math.min(start.x, end.x), Math.min(start.y, end.y), Math.abs(start.x - end.x), Math.abs(start.y - end.y));
                    if (rect.width > 0) {
                        rect.x++;
                        rect.width -= 2;
                    }
                    if (rect.height > 0) {
                        rect.y++;
                        rect.height -= 2;
                    }
                    if (!rect.isEmpty() && this.diagram._shapesQuadTree.hitTestRect(rect, exclude)) {
                        passRoute = false;
                        break;
                    }
                }
            }
            return passRoute;
        }
        _getRouteExclude(sourcePoint, targetPoint, sourceShape, targetShape) {
            const exclude = [];
            if (this._isPointInsideShape(sourcePoint, sourceShape)) {
                exclude.push(sourceShape);
            }
            if (this._isPointInsideShape(targetPoint, targetShape)) {
                exclude.push(targetShape);
            }
            return exclude;
        }
        _isPointInsideShape(point, shape) {
            const bounds = shape.bounds(), angle = shape.rotate().angle, boundsX = bounds.x, boundsY = bounds.y;
            const rotatedPoint = point.clone().rotate(angle, bounds.center());
            const pointX = rotatedPoint.x;
            const pointY = rotatedPoint.y;
            return pointX > boundsX && pointX < (boundsX + bounds.width) && pointY > boundsY && pointY < (boundsY + bounds.height);
        }
        redraw(options) {
            if (options) {
                this.options = deepExtend({}, this.options, options);
                const points = this.options.points;
                if (defined(points) && points.length > 0) {
                    this.points(points);
                    this._refreshPath();
                }
                if ((options && options.content) || options.text) {
                    this.content(options.content);
                }
                this.path.redraw({
                    fill: options.fill,
                    stroke: options.stroke,
                    startCap: options.startCap,
                    endCap: options.endCap
                });
            }
        }
        /**
         * Returns a clone of this connection.
         *
         * @returns {Connection}
         */
        clone() {
            const json = this.serialize();
            if (this.diagram && this.diagram._isEditable && defined(this.dataItem)) {
                json.options.dataItem = this.diagram.options.cloneDataItem(this.dataItem);
            }
            return new Connection(this.from, this.to, json.options);
        }
        /**
         * Returns a serialized connection in json format. Consist of the options and the dataItem.
         *
         * @returns {Connection}
         */
        serialize() {
            const from = this.from.toJSON ? this.from.toJSON : this.from.toString(), to = this.to.toJSON ? this.to.toJSON : this.to.toString();
            const json = deepExtend({}, {
                options: this.options,
                from: from,
                to: to
            });
            if (defined(this.dataItem)) {
                json.dataItem = this.dataItem.toString();
            }
            json.options.points = this.points();
            return json;
        }
        /**
         * Returns whether the given Point or Rect hits this connection.
         *
         * @param value
         * @returns {Connection}
         * @private
         */
        _hitTest(value) {
            if (this.visible()) {
                const p = new Point(value.x, value.y), from = this.sourcePoint(), to = this.targetPoint();
                if (value.isEmpty && !value.isEmpty() && value.contains(from) && value.contains(to)) {
                    return this;
                }
                if (this._router.hitTest(p)) {
                    return this;
                }
            }
        }
        _hover(value) {
            let color = (this.options.stroke || {}).color;
            if (value && isDefined(this.options.hover.stroke.color)) {
                color = this.options.hover.stroke.color;
            }
            this.path.redraw({
                stroke: {
                    color: color
                }
            });
        }
        _refreshPath() {
            if (!defined(this.path)) {
                return;
            }
            this._drawPath();
            this.bounds(this._router.getBounds());
        }
        _drawPath() {
            if (this._router) {
                this._router.route(); // sets the intermediate points
            }
            const source = this.sourcePoint();
            const target = this.targetPoint();
            const points = this.points();
            this.path.redraw({
                points: [source].concat(points, [target])
            });
        }
        _clearSourceConnector() {
            this.sourceConnector = undefined;
            this._resolvedSourceConnector = undefined;
        }
        _clearTargetConnector() {
            this.targetConnector = undefined;
            this._resolvedTargetConnector = undefined;
        }
        _removeFromSourceConnector() {
            if (this.sourceConnector) {
                remove(this.sourceConnector.connections, this);
            }
        }
        _removeFromTargetConnector() {
            if (this.targetConnector) {
                remove(this.targetConnector.connections, this);
            }
        }
        toJSON() {
            let from, to, point;
            if (this.from && this.from.toJSON) {
                from = this.from.toJSON();
            }
            else {
                point = this._sourcePoint;
                from = {
                    x: point.x,
                    y: point.y
                };
            }
            if (this.to && this.to.toJSON) {
                to = this.to.toJSON();
            }
            else {
                point = this._targetPoint;
                to = {
                    x: point.x,
                    y: point.y
                };
            }
            return {
                from: from,
                to: to
            };
        }
    }

    const round = kendo_drawing_cmn_chunk_js.r;
    function hitTestShapeConnectors(shape, point) {
        let connector, position, rect;
        for (let idx = 0; idx < shape.connectors.length; idx++) {
            connector = shape.connectors[idx];
            position = connector.position();
            rect = new Rect(position.x, position.y);
            rect.inflate(HIT_TEST_DISTANCE, HIT_TEST_DISTANCE);
            if (rect.contains(point)) {
                return connector;
            }
        }
    }
    /**
     * The service managing the tools.
     *
     * @type {*}
     */
    class ToolService {
        constructor(diagram) {
            this.diagram = diagram;
            this.tools = [
                new ScrollerTool(this),
                new ConnectionEditTool(this),
                new ConnectionTool(this),
                new SelectionTool(this),
                new PointerTool(this)
            ]; // the order matters.
            this.activeTool = undefined;
        }
        start(p, meta) {
            meta = deepExtend({}, meta);
            if (this.activeTool) {
                this.activeTool.end(p, meta);
            }
            this._updateHoveredItem(p);
            this._activateTool(p, meta);
            this.activeTool.start(p, meta);
            this._updateCursor(p);
            this.diagram.focus();
            this.diagram.canvas.surface.suspendTracking();
            this.startPoint = p;
            return true;
        }
        move(p, meta) {
            meta = deepExtend({}, meta);
            let updateHovered = true;
            if (this.activeTool) {
                updateHovered = this.activeTool.move(p, meta);
            }
            if (updateHovered) {
                this._updateHoveredItem(p);
            }
            this._updateCursor(p);
            return true;
        }
        end(p, meta) {
            meta = deepExtend({}, meta);
            if (this.activeTool) {
                this.activeTool.end(p, meta);
            }
            this.diagram.canvas.surface.resumeTracking();
            this.activeTool = undefined;
            this._updateCursor(p);
            return true;
        }
        keyDown(key, meta) {
            const diagram = this.diagram;
            meta = deepExtend({ ctrlKey: false, metaKey: false, altKey: false }, meta);
            if ((meta.ctrlKey || meta.metaKey) && !meta.altKey) { // ctrl or option
                if (testKey(key, 'a')) { // A: select all
                    diagram.selectAll();
                    diagram._destroyToolBar();
                    return true;
                }
                else if (testKey(key, 'z')) { // Z: undo
                    diagram.undo();
                    diagram._destroyToolBar();
                    return true;
                }
                else if (testKey(key, 'y')) { // y: redo
                    diagram.redo();
                    diagram._destroyToolBar();
                    return true;
                }
                else if (testKey(key, 'c')) {
                    diagram.copy();
                    diagram._destroyToolBar();
                }
                else if (testKey(key, 'x')) {
                    diagram.cut();
                    diagram._destroyToolBar();
                }
                else if (testKey(key, 'v')) {
                    diagram.paste();
                    diagram._destroyToolBar();
                }
                else if (testKey(key, 'l')) {
                    diagram.layout();
                    diagram._destroyToolBar();
                }
                else if (testKey(key, 'd')) {
                    diagram._destroyToolBar();
                    diagram.copy();
                    diagram.paste();
                }
            }
            else if (key === 46 || key === 8) { // del: deletion
                const toRemove = this.diagram._triggerRemove(diagram.select());
                if (toRemove.length) {
                    this.diagram.remove(toRemove, true);
                    this.diagram._syncChanges();
                    this.diagram._destroyToolBar();
                }
                return true;
            }
            else if (key === 27) { // ESC: stop any action
                this._discardNewConnection();
                diagram.deselect();
                diagram._destroyToolBar();
                return true;
            }
        }
        wheel(p, meta) {
            const diagram = this.diagram;
            let z = diagram.zoom();
            const delta = meta.delta, options = diagram.options, zoomRate = options.zoomRate, zoomOptions = { point: p, meta: meta, zoom: z };
            if (diagram.trigger(ZOOM_START, zoomOptions)) {
                return;
            }
            if (delta < 0) {
                z += zoomRate;
            }
            else {
                z -= zoomRate;
            }
            z = round(Math.max(options.zoomMin, Math.min(options.zoomMax, z)), 2);
            zoomOptions.zoom = z;
            diagram.zoom(z, zoomOptions);
            diagram.trigger(ZOOM_END, zoomOptions);
            return true;
        }
        setTool(tool, index) {
            tool.toolService = this;
            this.tools[index] = tool;
        }
        selectSingle(item, meta) {
            const diagram = this.diagram;
            const selectable = diagram.options.selectable;
            if (selectable && !item.isSelected && item.options.selectable !== false) {
                const addToSelection = meta.ctrlKey && selectable.multiple !== false;
                diagram.select(item, { addToSelection: addToSelection });
            }
        }
        _discardNewConnection() {
            if (this.newConnection) {
                this.diagram.remove(this.newConnection);
                this.newConnection = undefined;
            }
        }
        _activateTool(p, meta) {
            for (let i = 0; i < this.tools.length; i++) {
                const tool = this.tools[i];
                if (tool.tryActivate(p, meta)) {
                    this.activeTool = tool;
                    break; // activating the first available tool in the loop.
                }
            }
        }
        _updateCursor(p) {
            const element = this.diagram.element;
            const cursor = this.activeTool ? this.activeTool.getCursor(p) : (this.hoveredAdorner ? this.hoveredAdorner._getCursor(p) : (this.hoveredItem ? this.hoveredItem._getCursor(p) : Cursors.arrow));
            element.style.cursor = cursor;
        }
        _connectionManipulation(connection, disabledShape, isNew) {
            this.activeConnection = connection;
            this.disabledShape = disabledShape;
            if (isNew) {
                this.newConnection = this.activeConnection;
            }
            else {
                this.newConnection = undefined;
            }
        }
        _updateHoveredItem(p) {
            const hit = this._hitTest(p);
            const diagram = this.diagram;
            if (hit !== this.hoveredItem && (!this.disabledShape || hit !== this.disabledShape)) {
                if (this.hoveredItem) {
                    diagram.trigger(MOUSE_LEAVE, { item: this.hoveredItem });
                    this.hoveredItem._hover(false);
                }
                if (hit && hit.options.enable) {
                    diagram.trigger(MOUSE_ENTER, { item: hit });
                    this.hoveredItem = hit; // Shape, connection or connector
                    this.hoveredItem._hover(true);
                }
                else {
                    this.hoveredItem = undefined;
                }
            }
        }
        _removeHover() {
            if (this.hoveredItem) {
                this.hoveredItem._hover(false);
                this.hoveredItem = undefined;
            }
        }
        _hitTest(point) {
            const d = this.diagram;
            let hit, item, i;
            // connectors
            if (this._hoveredConnector) {
                this._hoveredConnector._hover(false);
                this._hoveredConnector = undefined;
            }
            if (d._connectorsAdorner._visible) {
                hit = d._connectorsAdorner._hitTest(point);
                if (hit) {
                    return hit;
                }
            }
            hit = this.diagram._resizingAdorner._hitTest(point);
            if (hit) {
                this.hoveredAdorner = d._resizingAdorner;
                if (hit.x !== 0 || hit.y !== 0) { // hit testing for resizers or rotator, otherwise if (0,0) than pass through.
                    return;
                }
                hit = undefined;
            }
            else {
                this.hoveredAdorner = undefined;
            }
            if (!this.activeTool || this.activeTool.type !== 'ConnectionTool') {
                const selectedConnections = []; // only the connections should have higher presence because the connection edit point is on top of connector.
                // TODO: This should be reworked. The connection adorner should be one for all selected connections and should be hit tested prior the connections and shapes itself.
                for (i = 0; i < d._selectedItems.length; i++) {
                    item = d._selectedItems[i];
                    if (item instanceof Connection) {
                        selectedConnections.push(item);
                    }
                }
                hit = this._hitTestItems(selectedConnections, point);
            }
            return hit || this._hitTestElements(point);
        }
        _hitTestElements(point) {
            const diagram = this.diagram;
            const shapeHit = this._hitTestItems(diagram.shapes, point);
            const connectionHit = this._hitTestItems(diagram.connections, point);
            let hit;
            if ((!this.activeTool || this.activeTool.type !== 'ConnectionTool') && shapeHit && connectionHit && !hitTestShapeConnectors(shapeHit, point)) {
                const mainLayer = diagram.mainLayer;
                const shapeIdx = inArray(shapeHit.visual, mainLayer.children);
                const connectionIdx = inArray(connectionHit.visual, mainLayer.children);
                hit = shapeIdx > connectionIdx ? shapeHit : connectionHit;
            }
            return hit || shapeHit || connectionHit;
        }
        _hitTestItems(array, point) {
            let i, item, hit;
            for (i = array.length - 1; i >= 0; i--) {
                item = array[i];
                hit = item._hitTest(point);
                if (hit) {
                    return hit;
                }
            }
        }
    }

    class AddConnectionUnit {
        constructor(connection, diagram) {
            this.connection = connection;
            this.diagram = diagram;
            this.title = 'New connection';
        }
        undo() {
            this.diagram.remove(this.connection, false);
        }
        redo() {
            this.diagram._addConnection(this.connection, false);
        }
    }

    class AddShapeUnit {
        constructor(shape, diagram) {
            this.shape = shape;
            this.diagram = diagram;
            this.title = 'New shape';
        }
        undo() {
            this.diagram.deselect();
            this.diagram.remove(this.shape, false);
        }
        redo() {
            this.diagram._addShape(this.shape, false);
        }
    }

    class CompositeUnit {
        constructor(unit) {
            this.units = [];
            this.title = 'Composite unit';
            if (unit !== undefined) {
                this.units.push(unit);
            }
        }
        add(undoUnit) {
            this.units.push(undoUnit);
        }
        undo() {
            for (let i = 0; i < this.units.length; i++) {
                this.units[i].undo();
            }
        }
        redo() {
            for (let i = 0; i < this.units.length; i++) {
                this.units[i].redo();
            }
        }
    }

    class DeleteConnectionUnit {
        constructor(connection) {
            this.connection = connection;
            this.diagram = connection.diagram;
            this.targetConnector = connection.targetConnector;
            this.title = 'Delete connection';
        }
        undo() {
            this.diagram._addConnection(this.connection, false);
        }
        redo() {
            this.diagram.remove(this.connection, false);
        }
    }

    class DeleteShapeUnit {
        constructor(shape) {
            this.shape = shape;
            this.diagram = shape.diagram;
            this.title = 'Deletion';
        }
        undo() {
            this.diagram._addShape(this.shape, false);
            this.shape.select(false);
        }
        redo() {
            this.shape.select(false);
            this.diagram.remove(this.shape, false);
        }
    }

    class PositionAdapter {
        constructor(layoutState) {
            this.layoutState = layoutState;
            this.diagram = layoutState.diagram;
        }
        initState() {
            this.froms = [];
            this.tos = [];
            this.subjects = [];
            const pusher = (id, bounds) => {
                const shape = this.diagram.getShapeById(id);
                if (shape) {
                    this.subjects.push(shape);
                    this.froms.push(shape.bounds().topLeft());
                    this.tos.push(bounds.topLeft());
                }
            };
            this.layoutState.nodeMap.forEach(pusher, this);
        }
        update(tick) {
            if (this.subjects.length <= 0) {
                return;
            }
            for (let i = 0; i < this.subjects.length; i++) {
                // todo: define a Lerp function instead
                this.subjects[i].position(new Point(this.froms[i].x + (this.tos[i].x - this.froms[i].x) * tick, this.froms[i].y + (this.tos[i].y - this.froms[i].y) * tick));
            }
        }
    }

    class LayoutUndoUnit {
        constructor(initialState, finalState, animate) {
            if (isUndefined(animate)) {
                this.animate = false;
            }
            else {
                this.animate = Boolean(animate);
            }
            this._initialState = initialState;
            this._finalState = finalState;
            this.title = 'Diagram layout';
        }
        undo() {
            this.setState(this._initialState);
        }
        redo() {
            this.setState(this._finalState);
        }
        setState(state) {
            const diagram = state.diagram;
            if (this.animate) {
                state.linkMap.forEach(function (id, points) {
                    const conn = diagram.getShapeById(id);
                    conn.visible(false);
                    if (conn) {
                        conn.points(points);
                    }
                });
                const ticker = new Ticker();
                ticker.addAdapter(new PositionAdapter(state));
                ticker.onComplete(function () {
                    state.linkMap.forEach(function (id) {
                        const conn = diagram.getShapeById(id);
                        conn.visible(true);
                    });
                });
                ticker.play();
            }
            else {
                state.nodeMap.forEach(function (id, bounds) {
                    const shape = diagram.getShapeById(id);
                    if (shape) {
                        shape.position(bounds.topLeft());
                    }
                });
                state.linkMap.forEach(function (id, points) {
                    const conn = diagram.getShapeById(id);
                    if (conn) {
                        conn.points(points);
                    }
                });
            }
        }
    }

    class PanUndoUnit {
        constructor(initialPosition, finalPosition, diagram) {
            this.initial = initialPosition;
            this.finalPos = finalPosition;
            this.diagram = diagram;
            this.title = 'Pan Unit';
        }
        undo() {
            this.diagram.pan(this.initial);
        }
        redo() {
            this.diagram.pan(this.finalPos);
        }
    }

    class ToBackUnit {
        constructor(diagram, items, initialIndices) {
            this.diagram = diagram;
            this.indices = initialIndices;
            this.items = items;
            this.title = 'Rotate Unit';
        }
        undo() {
            this.diagram._toIndex(this.items, this.indices);
        }
        redo() {
            this.diagram.toBack(this.items, false);
        }
    }

    class ToFrontUnit {
        constructor(diagram, items, initialIndices) {
            this.diagram = diagram;
            this.indices = initialIndices;
            this.items = items;
            this.title = 'Rotate Unit';
        }
        undo() {
            this.diagram._toIndex(this.items, this.indices);
        }
        redo() {
            this.diagram.toFront(this.items, false);
        }
    }

    /**
     * Undo-redo service.
     */
    class UndoRedoService extends Observable {
        constructor(options = {}) {
            super();
            this.events = ['undone', 'redone'];
            this.bind(this.events, options);
            this.stack = [];
            this.index = 0;
            this.capacity = 100;
        }
        /**
         * Starts the collection of units. Add those with
         * the addCompositeItem method and call commit. Or cancel to forget about it.
         */
        begin() {
            this.composite = new CompositeUnit();
        }
        /**
         * Cancels the collection process of unit started with 'begin'.
         */
        cancel() {
            this.composite = undefined;
        }
        /**
         * Commits a batch of units.
         */
        commit(execute) {
            if (this.composite.units.length > 0) {
                this._restart(this.composite, execute);
            }
            this.composite = undefined;
        }
        /**
         * Adds a unit as part of the begin-commit batch.
         *
         * @param undoUnit
         */
        addCompositeItem(undoUnit) {
            if (this.composite) {
                this.composite.add(undoUnit);
            }
            else {
                this.add(undoUnit);
            }
        }
        /**
         * Standard addition of a unit. See also the batch version; begin-addCompositeUnit-commit methods.
         *
         * @param undoUnit The unit to be added.
         * @param execute If false, the unit will be added but not executed.
         */
        add(undoUnit, execute) {
            this._restart(undoUnit, execute);
        }
        /**
         * Returns the number of undoable unit in the stack.
         *
         * @returns {Number}
         */
        pop() {
            if (this.index > 0) {
                this.stack.pop();
                this.index--;
            }
        }
        count() {
            return this.stack.length;
        }
        /**
         * Rollback of the unit on top of the stack.
         */
        undo() {
            if (this.index > 0) {
                this.index--;
                this.stack[this.index].undo();
                this.trigger('undone');
            }
        }
        /**
         * Redo of the last undone action.
         */
        redo() {
            if (this.stack.length > 0 && this.index < this.stack.length) {
                this.stack[this.index].redo();
                this.index++;
                this.trigger('redone');
            }
        }
        _restart(composite, execute) {
            // throw away anything beyond this point if this is a new branch
            this.stack.splice(this.index, this.stack.length - this.index);
            this.stack.push(composite);
            if (execute !== false) {
                this.redo();
            }
            else {
                this.index++;
            }
            // check the capacity
            if (this.stack.length > this.capacity) {
                this.stack.splice(0, this.stack.length - this.capacity);
                this.index = this.capacity; // points to the end of the stack
            }
        }
        /**
         * Clears the stack.
         */
        clear() {
            this.stack = [];
            this.index = 0;
        }
    }

    class InactiveItem {
        constructor(dataItem) {
            this.dataItem = dataItem;
            this.callbacks = [];
        }
        onActivate(callback) {
            return new Promise((resolve) => {
                this.callbacks.push({
                    callback,
                    resolve
                });
            });
        }
        activate() {
            const callbacks = this.callbacks;
            let item;
            for (let idx = 0; idx < callbacks.length; idx++) {
                item = this.callbacks[idx];
                item.callback(this.dataItem);
                item.resolve();
            }
            this.callbacks = [];
        }
    }
    class InactiveItemsCollection {
        constructor() {
            this.items = {};
        }
        add(items) {
            for (let idx = 0; idx < items.length; idx++) {
                this.items[items[idx].uid] = new InactiveItem(items[idx]);
            }
        }
        forEach(callback) {
            for (const uid in this.items) {
                if (Object.prototype.hasOwnProperty.call(this.items, uid)) {
                    callback(this.items[uid]);
                }
            }
        }
        getByUid(uid) {
            return this.items[uid];
        }
        remove(item) {
            delete this.items[item.uid];
        }
        destroy() {
            this.items = {};
        }
    }

    class QuadRoot {
        constructor() {
            this.shapes = [];
        }
        _add(shape, bounds) {
            this.shapes.push({
                bounds: bounds,
                shape: shape
            });
            shape._quadNode = this;
        }
        insert(shape, bounds) {
            this._add(shape, bounds);
        }
        remove(shape) {
            const shapes = this.shapes;
            const length = shapes.length;
            for (let idx = 0; idx < length; idx++) {
                if (shapes[idx].shape === shape) {
                    shapes.splice(idx, 1);
                    break;
                }
            }
        }
        hitTestRect(rect, exclude) {
            const shapes = this.shapes;
            const length = shapes.length;
            for (let i = 0; i < length; i++) {
                if (this._testRect(shapes[i].shape, rect) && !contains(exclude, shapes[i].shape)) {
                    return true;
                }
            }
        }
        _testRect(shape, rect) {
            const angle = shape.rotate().angle;
            const bounds = shape.bounds();
            let hit;
            if (!angle) {
                hit = bounds.overlaps(rect);
            }
            else {
                hit = Intersect.rects(rect, bounds, -angle);
            }
            return hit;
        }
    }

    class QuadNode extends QuadRoot {
        constructor(rect) {
            super();
            this.children = [];
            this.rect = rect;
        }
        inBounds(rect) {
            const nodeRect = this.rect;
            const nodeBottomRight = nodeRect.bottomRight();
            const bottomRight = rect.bottomRight();
            const inBounds = nodeRect.x <= rect.x && nodeRect.y <= rect.y && bottomRight.x <= nodeBottomRight.x &&
                bottomRight.y <= nodeBottomRight.y;
            return inBounds;
        }
        overlapsBounds(rect) {
            return this.rect.overlaps(rect);
        }
        insert(shape, bounds) {
            let inserted = false;
            const children = this.children;
            const length = children.length;
            if (this.inBounds(bounds)) {
                if (!length && this.shapes.length < 4) {
                    this._add(shape, bounds);
                }
                else {
                    if (!length) {
                        this._initChildren();
                    }
                    for (let idx = 0; idx < children.length; idx++) {
                        if (children[idx].insert(shape, bounds)) {
                            inserted = true;
                            break;
                        }
                    }
                    if (!inserted) {
                        this._add(shape, bounds);
                    }
                }
                inserted = true;
            }
            return inserted;
        }
        _initChildren() {
            const rect = this.rect, children = this.children, shapes = this.shapes, center = rect.center(), halfWidth = rect.width / 2, halfHeight = rect.height / 2;
            let childIdx, shapeIdx;
            children.push(new QuadNode(new Rect(rect.x, rect.y, halfWidth, halfHeight)), new QuadNode(new Rect(center.x, rect.y, halfWidth, halfHeight)), new QuadNode(new Rect(rect.x, center.y, halfWidth, halfHeight)), new QuadNode(new Rect(center.x, center.y, halfWidth, halfHeight)));
            for (shapeIdx = shapes.length - 1; shapeIdx >= 0; shapeIdx--) {
                for (childIdx = 0; childIdx < children.length; childIdx++) {
                    if (children[childIdx].insert(shapes[shapeIdx].shape, shapes[shapeIdx].bounds)) {
                        shapes.splice(shapeIdx, 1);
                        break;
                    }
                }
            }
        }
        hitTestRect(rect, exclude) {
            let idx;
            const children = this.children;
            const length = children.length;
            let hit = false;
            if (this.overlapsBounds(rect)) {
                if (super.hitTestRect(rect, exclude)) {
                    hit = true;
                }
                else {
                    for (idx = 0; idx < length; idx++) {
                        if (children[idx].hitTestRect(rect, exclude)) {
                            hit = true;
                            break;
                        }
                    }
                }
            }
            return hit;
        }
    }

    class ShapesQuadTree {
        constructor(diagram) {
            this.ROOT_SIZE = 1000;
            const boundsChangeHandler = this._boundsChange.bind(this);
            diagram.bind(ITEMBOUNDSCHANGE, boundsChangeHandler);
            diagram.bind(ITEMROTATE, boundsChangeHandler);
            this.initRoots();
        }
        initRoots() {
            this.rootMap = {};
            this.root = new QuadRoot();
        }
        clear() {
            this.initRoots();
        }
        _boundsChange(e) {
            if (e.item._quadNode) {
                e.item._quadNode.remove(e.item);
            }
            this.insert(e.item);
        }
        insert(shape) {
            const bounds = shape.bounds(ROTATED);
            const rootSize = this.ROOT_SIZE;
            const sectors = this.getSectors(bounds);
            const x = sectors[0][0];
            const y = sectors[1][0];
            if (this.inRoot(sectors)) {
                this.root.insert(shape, bounds);
            }
            else {
                if (!this.rootMap[x]) {
                    this.rootMap[x] = {};
                }
                if (!this.rootMap[x][y]) {
                    this.rootMap[x][y] = new QuadNode(new Rect(x * rootSize, y * rootSize, rootSize, rootSize));
                }
                this.rootMap[x][y].insert(shape, bounds);
            }
        }
        remove(shape) {
            if (shape._quadNode) {
                shape._quadNode.remove(shape);
            }
        }
        inRoot(sectors) {
            return sectors[0].length > 1 || sectors[1].length > 1;
        }
        getSectors(rect) {
            const rootSize = this.ROOT_SIZE;
            const bottomRight = rect.bottomRight();
            const bottomX = Math.floor(bottomRight.x / rootSize);
            const bottomY = Math.floor(bottomRight.y / rootSize);
            const sectors = [[], []];
            for (let x = Math.floor(rect.x / rootSize); x <= bottomX; x++) {
                sectors[0].push(x);
            }
            for (let y = Math.floor(rect.y / rootSize); y <= bottomY; y++) {
                sectors[1].push(y);
            }
            return sectors;
        }
        hitTestRect(rect, exclude) {
            const sectors = this.getSectors(rect);
            let xIdx, yIdx, x, y;
            let root;
            if (this.root.hitTestRect(rect, exclude)) {
                return true;
            }
            for (xIdx = 0; xIdx < sectors[0].length; xIdx++) {
                x = sectors[0][xIdx];
                for (yIdx = 0; yIdx < sectors[1].length; yIdx++) {
                    y = sectors[1][yIdx];
                    root = (this.rootMap[x] || {})[y];
                    if (root && root.hitTestRect(rect, exclude)) {
                        return true;
                    }
                }
            }
            return false;
        }
    }

    function copyDefaultOptions(mainOptions, elementOptions, fields) {
        let field;
        for (let idx = 0; idx < fields.length; idx++) {
            field = fields[idx];
            if (elementOptions && !defined(elementOptions[field])) {
                elementOptions[field] = mainOptions[field];
            }
        }
    }
    const defaultOptions = {
        name: 'Diagram',
        theme: 'sass',
        layout: '',
        zoomRate: 0.1,
        zoom: 1,
        zoomMin: 0,
        zoomMax: 2,
        dataSource: {},
        draggable: true,
        template: '',
        autoBind: true,
        editable: {
            rotate: {},
            resize: {},
            text: true,
            tools: [],
            drag: {
                snap: {
                    size: 10,
                    angle: 10
                }
            },
            remove: true
        },
        pannable: {},
        selectable: {
            key: 'none'
        },
        tooltip: { enabled: true, format: '{0}' },
        copy: {
            enabled: true,
            offsetX: 20,
            offsetY: 20
        },
        shapeDefaults: shapeDefaults({ undoable: true }),
        connectionDefaults: {
            editable: {
                tools: []
            },
            type: CASCADING
        },
        shapes: [],
        connections: []
    };
    const events = [
        ZOOM_END,
        ZOOM_START,
        PAN, SELECT$1,
        ITEMROTATE,
        ITEMBOUNDSCHANGE,
        CHANGE$1,
        CLICK,
        MOUSE_ENTER,
        MOUSE_LEAVE,
        'toolBarClick',
        'save',
        'cancel',
        'edit',
        'remove',
        'add',
        'dataBound',
        DRAG_START,
        DRAG,
        DRAG_END
    ];
    function splitDiagramElements(elements) {
        const connections = [];
        const shapes = [];
        let element, idx;
        for (idx = 0; idx < elements.length; idx++) {
            element = elements[idx];
            if (element instanceof Shape) {
                shapes.push(element);
            }
            else {
                connections.push(element);
            }
        }
        return {
            shapes: shapes,
            connections: connections
        };
    }
    function preventDefault(e) {
        e.preventDefault();
    }
    function elementOffset(element) {
        const rect = element.getBoundingClientRect();
        const doc = element.ownerDocument;
        const scrollLeft = doc.defaultView.scrollX || doc.documentElement.scrollLeft || 0;
        const scrollTop = doc.defaultView.scrollY || doc.documentElement.scrollTop || 0;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft
        };
    }
    function outerWidth(element, includeMargins = false) {
        let widthValue = element.offsetWidth; // Width of the element with padding and border
        if (includeMargins) {
            const style = getComputedStyle(element);
            const marginLeft = parseFloat(style.marginLeft);
            const marginRight = parseFloat(style.marginRight);
            widthValue += marginLeft + marginRight;
        }
        return widthValue;
    }
    function outerHeight(element, includeMargins = false) {
        let heightValue = element.offsetHeight;
        if (includeMargins) {
            const style = getComputedStyle(element);
            const marginTop = parseFloat(style.marginTop);
            const marginBottom = parseFloat(style.marginBottom);
            heightValue += marginTop + marginBottom;
        }
        return heightValue;
    }
    function elementWidth(element) {
        const style = getComputedStyle(element);
        const widthValue = element.clientWidth; // Includes content + padding
        const paddingLeft = parseFloat(style.paddingLeft);
        const paddingRight = parseFloat(style.paddingRight);
        return widthValue - paddingLeft - paddingRight; // Only content
    }
    function elementHeight(element) {
        const style = getComputedStyle(element);
        const heightValue = element.clientHeight;
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);
        return heightValue - paddingTop - paddingBottom;
    }

    class Diagram extends Observable {
        constructor(element, userOptions, themeOptions) {
            super();
            this._clipboard = [];
            this._connectionsDataMap = {};
            this._dataMap = {};
            this._inactiveShapeItems = new InactiveItemsCollection();
            this._selectedItems = [];
            this.shapes = [];
            this.connections = [];
            this._deferredConnectionUpdates = [];
            this.element = element;
            this.options = deepExtend({ createToolBar: noop$1, destroyToolBar: noop$1 }, defaultOptions, userOptions);
            this.events = events;
            this._initTheme(themeOptions);
            this._initElements();
            this._extendLayoutOptions(this.options);
            this._initDefaults(userOptions);
            this._interactionDefaults();
            this._initCanvas();
            this.mainLayer = new Group({
                id: 'main-layer'
            });
            this.canvas.append(this.mainLayer);
            this._shapesQuadTree = new ShapesQuadTree(this);
            this._pan = new Point();
            this._adorners = [];
            this.adornerLayer = new Group({
                id: 'adorner-layer'
            });
            this.canvas.append(this.adornerLayer);
            this._createHandlers();
            this._initialize();
            this._resizingAdorner = new ResizingAdorner(this, { editable: this.options.editable });
            this._connectorsAdorner = new ConnectorsAdorner(this);
            this._adorn(this._resizingAdorner, true);
            this._adorn(this._connectorsAdorner, true);
            this.selector = new Selector(this);
            // TODO: We may consider using real Clipboard API once is supported by the standard.
            this._clipboard.length = 0;
            this.pauseMouseHandlers = false;
        }
        _createShape(dataItem, options) {
            options = deepExtend({}, this.options.shapeDefaults, options);
            options.dataItem = dataItem;
            const shape = new Shape(options, this);
            return shape;
        }
        _createConnection(dataItem, source, target) {
            const options = deepExtend({}, this.options.connectionDefaults);
            options.dataItem = dataItem;
            const connection = new Connection(source || new Point(), target || new Point(), options);
            return connection;
        }
        _initElements() {
            this.element.innerHTML = '';
            this.element.style.position = 'relative';
            this.element.setAttribute('tabindex', '0');
            this.element.classList.add('k-widget', 'k-diagram');
            this.scrollable = document.createElement('div');
            this.element.appendChild(this.scrollable);
            this.wrapper = this.element;
        }
        _initDefaults(userOptions) {
            const options = this.options;
            const editable = options.editable;
            const shapeDefaults = options.shapeDefaults;
            const connectionDefaults = options.connectionDefaults;
            const userShapeDefaults = (userOptions || {}).shapeDefaults;
            if (editable === false) {
                shapeDefaults.editable = false;
                connectionDefaults.editable = false;
            }
            else {
                copyDefaultOptions(editable, shapeDefaults.editable, ['drag', 'remove', 'connect']);
                copyDefaultOptions(editable, connectionDefaults.editable, ['drag', 'remove']);
            }
            if (userShapeDefaults && userShapeDefaults.connectors) {
                options.shapeDefaults.connectors = userShapeDefaults.connectors;
            }
        }
        _interactionDefaults() {
            const options = this.options;
            const selectable = options.selectable;
            const pannable = options.pannable;
            const mobile = this._mobileOS();
            if (selectable && !defined(selectable.multiple)) {
                options.selectable = deepExtend({
                    multiple: mobile ? false : true
                }, options.selectable);
            }
            if (pannable && !defined(pannable.key)) {
                options.pannable = deepExtend({
                    key: mobile ? 'none' : 'ctrl'
                }, options.pannable);
            }
        }
        _initCanvas() {
            const canvasContainer = document.createElement('div');
            canvasContainer.classList.add('k-layer');
            this.scrollable.appendChild(canvasContainer);
            const viewPort = this.viewport();
            this.canvas = new (this.options.Canvas || Canvas$1)(canvasContainer, {
                width: viewPort.width || DEFAULT_CANVAS_WIDTH,
                height: viewPort.height || DEFAULT_CANVAS_HEIGHT
            });
        }
        _createHandlers() {
            const element = this.element;
            this._wheelHandler = this._wheelHandler || this._wheel.bind(this);
            this._keydownHandler = this._keydownHandler || this._keydown.bind(this);
            if (this._mobileOS() && this._mobileOS().browser.mobilesafari) {
                element.addEventListener('mousewheel', this._wheelHandler);
            }
            else {
                element.addEventListener('wheel', this._wheelHandler);
            }
            element.addEventListener('keydown', this._keydownHandler);
            this._userEvents = new UserEvents(this.scrollable, {
                multiTouch: true,
                fastTap: true,
                tap: this._tap.bind(this),
                start: this._dragStart.bind(this),
                move: this._drag.bind(this),
                end: this._dragEnd.bind(this),
                gesturestart: this._gestureStart.bind(this),
                gesturechange: this._gestureChange.bind(this),
                gestureend: this._gestureEnd.bind(this),
                doubleTap: this._doubleTap.bind(this),
                supportDoubleTap: true
            });
            this.toolService = new ToolService(this);
            this._mouseoverHandler = this._mouseoverHandler || this._mouseover.bind(this);
            this._mouseoutHandler = this._mouseoutHandler || this._mouseout.bind(this);
            this._mouseMoveHandler = this._mouseMoveHandler || this._mouseMove.bind(this);
            this._mouseDownHandler = this._mouseDownHandler || this._mouseDown.bind(this);
            this._mouseUpHandler = this._mouseUpHandler || this._mouseUp.bind(this);
            this.scrollable.addEventListener('mouseover', this._mouseoverHandler);
            this.scrollable.addEventListener('mouseout', this._mouseoutHandler);
            this.scrollable.addEventListener('mousemove', this._mouseMoveHandler);
            this.scrollable.addEventListener('mousedown', this._mouseDownHandler);
            this.scrollable.addEventListener('mouseup', this._mouseUpHandler);
            this._initResizeObserver();
            this.bind(ZOOM_START, this._destroyToolBar.bind(this));
            this.bind(PAN, this._destroyToolBar.bind(this));
        }
        _initResizeObserver() {
            const observer = new ResizeObserver((entries) => {
                entries.forEach(entry => {
                    const { width, height } = entry.contentRect;
                    if (entry.target !== this.element ||
                        (this.size && this.size.width === width && this.size.height === height)) {
                        return;
                    }
                    this.size = { width, height };
                    this._resize();
                    this.trigger('resize', this.size);
                });
            });
            this._resizeObserver = observer;
            observer.observe(this.element);
        }
        _destroyResizeObserver() {
            if (this._resizeObserver) {
                this._resizeObserver.disconnect();
                this._resizeObserver = null;
            }
        }
        _dragStart(e) {
            this._pauseMouseHandlers = true;
            const point = this._eventPositions(e, true);
            if (this.toolService.start(point, this._meta(e))) {
                this._destroyToolBar();
                e.preventDefault();
            }
        }
        _drag(e) {
            const p = this._eventPositions(e);
            if (this.toolService.move(p, this._meta(e))) {
                e.preventDefault();
            }
        }
        _dragEnd(e) {
            this._pauseMouseHandlers = false;
            const p = this._eventPositions(e);
            if (this.toolService.end(p, this._meta(e))) {
                this.options.createToolBar();
                e.preventDefault();
            }
        }
        _mouseMove(e) {
            if (!this._pauseMouseHandlers) {
                const p = this._eventPositions(e);
                this.toolService._updateHoveredItem(p);
                this.toolService._updateCursor(p);
            }
        }
        _mouseDown() {
            this._pauseMouseHandlers = true;
        }
        _mouseUp() {
            this._pauseMouseHandlers = false;
        }
        _tap(e) {
            const toolService = this.toolService;
            const selectable = this.options.selectable;
            const point = this._eventPositions(e);
            const focused = this.focus();
            toolService._updateHoveredItem(point);
            if (toolService.hoveredItem) {
                const item = toolService.hoveredItem;
                this.trigger('click', {
                    item: item,
                    point: point,
                    meta: this._meta(e)
                });
                if (selectable && item.options.selectable !== false) {
                    const multiple = selectable.multiple !== false;
                    const ctrlPressed = kendo_common_cmn_chunk_js.m || this._meta(e).ctrlKey;
                    if (item.isSelected) {
                        if (ctrlPressed) {
                            this._destroyToolBar();
                            item.select(false);
                        }
                        else {
                            this.options.createToolBar(focused);
                        }
                    }
                    else {
                        this._destroyToolBar();
                        this.select(item, {
                            addToSelection: multiple && ctrlPressed
                        });
                        this.options.createToolBar(focused);
                    }
                }
            }
            else if (selectable) {
                this._destroyToolBar();
                this.deselect();
            }
        }
        _keydown(e) {
            if (this.toolService.keyDown(e.keyCode, this._meta(e))) {
                e.preventDefault();
            }
        }
        _wheel(e) {
            const delta = mwDelta(e), p = this._eventPositions(e), meta = deepExtend(this._meta(e), { delta: delta });
            if (this.toolService.wheel(p, meta)) {
                e.preventDefault();
            }
        }
        _meta(e) {
            e = e.event || e;
            return { ctrlKey: e.ctrlKey, metaKey: e.metaKey, altKey: e.altKey, shiftKey: e.shiftKey, type: e.type };
        }
        _eventPositions(e, start) {
            let point;
            if (e.touch) {
                const field = start ? 'startLocation' : 'location';
                point = new Point(e.x[field], e.y[field]);
            }
            else {
                point = new Point(e.pageX, e.pageY);
            }
            return this.documentToModel(point);
        }
        _gestureStart(e) {
            this._destroyToolBar();
            this.scroller.disable();
            const initialCenter = this.documentToModel(new Point(e.center.x, e.center.y));
            const eventArgs = {
                point: initialCenter,
                zoom: this.zoom()
            };
            if (this.trigger(ZOOM_START, eventArgs)) {
                return;
            }
            this._gesture = e;
            this._initialCenter = initialCenter;
        }
        _gestureChange(e) {
            const previousGesture = this._gesture;
            const initialCenter = this._initialCenter;
            const center = this.documentToView(new Point(e.center.x, e.center.y));
            const scaleDelta = e.distance / previousGesture.distance;
            let zoom = this._zoom;
            let updateZoom = false;
            if (Math.abs(scaleDelta - 1) >= MOBILE_ZOOM_RATE) {
                this._zoom = zoom = this._getValidZoom(zoom * scaleDelta);
                this.options.zoom = zoom;
                this._gesture = e;
                updateZoom = true;
            }
            const zoomedPoint = initialCenter.times(zoom);
            const pan = center.minus(zoomedPoint);
            if (updateZoom || this._pan.distanceTo(pan) >= MOBILE_PAN_DISTANCE) {
                this._panTransform(pan);
                this._updateAdorners();
            }
            e.preventDefault();
        }
        _doubleTap(e) {
            const pointPosition = this._eventPositions(e);
            const options = this.options;
            const zoomRate = options.zoomRate;
            let zoom = this.zoom() + zoomRate;
            const meta = this._meta(e);
            const zoomOptions = { point: pointPosition, meta: meta, zoom: zoom };
            if (this.trigger(ZOOM_START, zoomOptions)) {
                return;
            }
            zoom = kendo_drawing_cmn_chunk_js.r(Math.max(options.zoomMin, Math.min(options.zoomMax, zoom)), 2);
            zoomOptions.zoom = zoom;
            this.zoom(zoom, zoomOptions);
            this.trigger(ZOOM_END, zoomOptions);
        }
        _gestureEnd() {
            if (this.options.pannable !== false) {
                this.scroller.enable();
            }
            this.trigger(ZOOM_END, {
                point: this._initialCenter,
                zoom: this.zoom()
            });
        }
        _resize() {
            const viewport = this.viewport();
            if (this.canvas) {
                this.canvas.size(viewport);
            }
            if (this.scrollable && this.toolBar) {
                this.scrollable.style.height = viewport.height + 'px';
            }
        }
        _mouseover(e) {
            const node = e.target._kendoNode;
            if (node && node.srcElement._hover) {
                node.srcElement._hover(true, node.srcElement);
            }
        }
        _mouseout(e) {
            const node = e.target._kendoNode;
            if (node && node.srcElement._hover) {
                node.srcElement._hover(false, node.srcElement);
            }
        }
        _initTheme(themeOptions) {
            this.options = deepExtend({}, themeOptions, this.options);
            if (this.options.editable === true) {
                this.options.editable = (themeOptions || {}).editable;
            }
        }
        _createOptionElements() {
            const options = this.options;
            const shapesLength = options.shapes.length;
            if (shapesLength) {
                this._createShapes();
            }
            if (options.connections.length) {
                this._createConnections();
            }
            if (shapesLength && options.layout) {
                this.layout(options.layout);
            }
        }
        _createShapes() {
            const options = this.options, shapes = options.shapes;
            let shape, i;
            for (i = 0; i < shapes.length; i++) {
                shape = shapes[i];
                this.addShape(shape);
            }
        }
        _createConnections() {
            const options = this.options, defaults = options.connectionDefaults, connections = options.connections;
            let conn, source, target, i;
            for (i = 0; i < connections.length; i++) {
                conn = connections[i];
                source = this._findConnectionTarget(conn.from);
                target = this._findConnectionTarget(conn.to);
                if (this.options.connect) {
                    this.options.connect(source, target, deepExtend({}, defaults, conn));
                }
                else {
                    this.connect(source, target, deepExtend({}, defaults, conn));
                }
            }
        }
        _findConnectionTarget(options) {
            options = options || {};
            const shapeId = isString$1(options) ? options : options.shapeId || options.id;
            let target;
            if (shapeId) {
                target = this.getShapeById(shapeId);
                if (options.connector) {
                    target = target.getConnector(options.connector);
                }
            }
            else {
                target = new Point(options.x || 0, options.y || 0);
            }
            return target;
        }
        destroy() {
            super.destroy();
            this._destroyResizeObserver();
            if (this._userEvents) {
                this._userEvents.destroy();
            }
            this.clear();
            this.element.removeEventListener('mousewheel', this._wheelHandler);
            this.element.removeEventListener('wheel', this._wheelHandler);
            this.element.removeEventListener('keydown', this._keydownHandler);
            this.scrollable.removeEventListener('mouseover', this._mouseoverHandler);
            this.scrollable.removeEventListener('mouseout', this._mouseoutHandler);
            this.scrollable.removeEventListener('mousemove', this._mouseMoveHandler);
            this.scrollable.removeEventListener('mousedown', this._mouseDownHandler);
            this.scrollable.removeEventListener('mouseup', this._mouseUpHandler);
            this.canvas.destroy(true);
            this.canvas = undefined;
            this.destroyScroller();
            this._destroyGlobalToolBar();
            this._destroyToolBar();
            this._inactiveShapeItems.destroy();
        }
        destroyScroller() {
            const scroller = this.scroller;
            if (!scroller) {
                return;
            }
            scroller.destroy();
            scroller.element.remove();
            this.scroller = null;
        }
        save() {
            const json = {
                shapes: [],
                connections: []
            };
            let i, connection, shape;
            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                if (shape.options.serializable) {
                    json.shapes.push(shape.options);
                }
            }
            for (i = 0; i < this.connections.length; i++) {
                connection = this.connections[i];
                json.connections.push(deepExtend({}, connection.options, connection.toJSON()));
            }
            return json;
        }
        focus() {
            if (this.element !== this.element.ownerDocument.activeElement) {
                const element = this.element, containers = [], offsets = [], documentElement = element.ownerDocument.documentElement;
                let scrollContainer = element, i;
                do {
                    scrollContainer = scrollContainer.parentNode;
                    if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
                        containers.push(scrollContainer);
                        offsets.push(scrollContainer.scrollTop);
                    }
                } while (scrollContainer !== documentElement);
                element.focus({ preventScroll: true });
                for (i = 0; i < containers.length; i++) {
                    containers[i].scrollTop = offsets[i];
                }
                return true;
            }
        }
        load(options) {
            this.clear();
            this.setOptions(options);
            this._createShapes();
            this._createConnections();
        }
        setOptions(options) {
            deepExtend(this.options, options);
        }
        clear() {
            this.select(false);
            this.mainLayer.clear();
            this._shapesQuadTree.clear();
            this._initialize();
        }
        /**
         * Determines whether the the two items are connected.
         *
         * @param source Shape, Connector, Point.
         * @param target Shape, Connector, Point.
         * @returns true if the two items are connected.
         */
        connected(source, target) {
            for (let i = 0; i < this.connections.length; i++) {
                const c = this.connections[i];
                if (c.from === source && c.to === target) {
                    return true;
                }
            }
            return false;
        }
        /**
         * Adds connection to the diagram.
         *
         * @param connection Connection.
         * @param undoable Boolean.
         * @returns The newly created connection.
         */
        addConnection(connection, undoable) {
            if (undoable !== false) {
                this.undoRedoService.add(new AddConnectionUnit(connection, this), false);
            }
            connection.diagram = this;
            connection._setOptionsFromModel();
            connection.refresh();
            this.mainLayer.append(connection.visual);
            this.connections.push(connection);
            this.trigger(CHANGE$1, {
                added: [connection],
                removed: []
            });
            return connection;
        }
        /**
         * Adds shape to the diagram.
         *
         * @param item Shape, Point. If point is passed it will be created new Shape and positioned at that point.
         * @param options. The options to be passed to the newly created Shape.
         * @returns The newly created shape.
         */
        addShape(item, undoable) {
            let shape, shapeDefaults = this.options.shapeDefaults;
            if (item instanceof Shape) {
                shape = item;
                this._parseBounds(shape.bounds());
            }
            else if (!(item.prototype)) {
                shapeDefaults = deepExtend({}, shapeDefaults, item || {});
                shape = new Shape(shapeDefaults, this);
                this._parseBounds(shape.bounds());
            }
            else {
                return;
            }
            if (undoable !== false) {
                this.undoRedoService.add(new AddShapeUnit(shape, this), false);
            }
            this.shapes.push(shape);
            if (shape.diagram !== this) {
                this._shapesQuadTree.insert(shape);
                shape.diagram = this;
            }
            this.mainLayer.append(shape.visual);
            this.trigger(CHANGE$1, {
                added: [shape],
                removed: []
            });
            return shape;
        }
        /**
         * Removes items (or single item) from the diagram.
         *
         * @param items DiagramElement, Array of Items.
         * @param undoable.
         */
        remove(items, undoable) {
            items = Array.isArray(items) ? items.slice(0) : [items];
            const elements = splitDiagramElements(items);
            const shapes = elements.shapes;
            const connections = elements.connections;
            let i;
            if (!defined(undoable)) {
                undoable = true;
            }
            if (undoable) {
                this.undoRedoService.begin();
            }
            this._suspendModelRefresh();
            for (i = shapes.length - 1; i >= 0; i--) {
                this._removeItem(shapes[i], undoable, connections);
            }
            for (i = connections.length - 1; i >= 0; i--) {
                this._removeItem(connections[i], undoable);
            }
            this._resumeModelRefresh();
            if (undoable) {
                this.undoRedoService.commit(false);
            }
            this.trigger(CHANGE$1, {
                added: [],
                removed: items
            });
        }
        _addConnection(connection, undoable) {
            if (this.options._addConnection) {
                return this.options._addConnection(connection, undoable);
            }
            else if (!this.trigger('add', { connection: connection })) {
                this.addConnection(connection, undoable);
                connection._updateConnectors();
                return connection;
            }
        }
        _addShape(shape, undoable) {
            if (this.options._addShape) {
                return this.options._addShape(shape, undoable);
            }
            else if (!this.trigger('add', { shape: shape })) {
                return this.addShape(shape, undoable);
            }
        }
        _parseBounds(bounds) {
            bounds.x = typeof (bounds.x) == 'string' ? parseFloat(bounds.x) : bounds.x;
            bounds.y = typeof (bounds.y) == 'string' ? parseFloat(bounds.y) : bounds.y;
        }
        _shouldRefresh() {
            return !this._suspended;
        }
        _suspendModelRefresh() {
            this._suspended = (this._suspended || 0) + 1;
        }
        _resumeModelRefresh() {
            this._suspended = Math.max((this._suspended || 0) - 1, 0);
        }
        _triggerRemove(items) {
            const toRemove = [];
            let item, args, editable;
            for (let idx = 0; idx < items.length; idx++) {
                item = items[idx];
                editable = item.options.editable;
                if (item instanceof Shape) {
                    args = { shape: item };
                }
                else {
                    args = { connection: item };
                }
                if (editable && editable.remove !== false && !this.trigger('remove', args)) {
                    toRemove.push(item);
                }
            }
            return toRemove;
        }
        _addConnections(connections, undoable) {
            const length = connections.length;
            for (let i = 0; i < length; i++) {
                const dataItem = connections[i];
                this._addConnectionDataItem(dataItem, undoable);
            }
        }
        _addConnectionDataItem(dataItem, undoable) {
            if (!this._connectionsDataMap[dataItem.uid]) {
                let from = this._validateConnector(dataItem.from);
                if (!defined(from) || from === null) {
                    from = new Point(dataItem.fromX, dataItem.fromY);
                }
                let to = this._validateConnector(dataItem.to);
                if (!defined(to) || to === null) {
                    to = new Point(dataItem.toX, dataItem.toY);
                }
                if (defined(from) && defined(to)) {
                    const options = deepExtend({}, this.options.connectionDefaults);
                    options.dataItem = dataItem;
                    const connection = new Connection(from, to, options);
                    this._connectionsDataMap[dataItem.uid] = connection;
                    this.addConnection(connection, undoable);
                }
            }
        }
        _validateConnector(value) {
            let connector;
            if (defined(value) && value !== null) {
                connector = this._dataMap[value];
            }
            return connector;
        }
        _addDataItems(items, parent) {
            let item, idx, shape, parentShape;
            for (idx = 0; idx < items.length; idx++) {
                item = items[idx];
                shape = this._addDataItemByUid(item);
                parentShape = this._addDataItemByUid(parent);
                if (parentShape && !this.connected(parentShape, shape)) { // check if connected to not duplicate connections.
                    this.connect(parentShape, shape);
                }
            }
        }
        connect(source, target, options) {
            const resolvedOptions = deepExtend({}, this.options.connectionDefaults, options);
            const connection = new Connection(source, target, resolvedOptions);
            return this.addConnection(connection);
        }
        /**
         * Executes the next undoable action on top of the undo stack if any.
         */
        undo() {
            this.undoRedoService.undo();
        }
        /**
         * Executes the previous undoable action on top of the redo stack if any.
         */
        redo() {
            this.undoRedoService.redo();
        }
        /**
         * Selects items on the basis of the given input or returns the current selection if none.
         *
         * @param itemsOrRect DiagramElement, Array of elements, "All", false or Rect. A value 'false' will deselect everything.
         * @param options
         * @returns {Array}
         */
        select(item, options) {
            if (isDefined(item)) {
                options = deepExtend({ addToSelection: false }, options);
                const addToSelection = options.addToSelection, selected = [];
                let items = [], i, element;
                if (!addToSelection) {
                    this.deselect();
                }
                this._internalSelection = true;
                if (item instanceof Array) {
                    items = item;
                }
                else if (item instanceof DiagramElement) {
                    items = [item];
                }
                for (i = 0; i < items.length; i++) {
                    element = items[i];
                    if (element.select(true)) {
                        selected.push(element);
                    }
                }
                this._selectionChanged(selected, []);
                this._internalSelection = false;
            }
            else {
                return this._selectedItems;
            }
        }
        selectAll() {
            this.select(this.shapes.concat(this.connections));
        }
        selectArea(rect) {
            let i, items, item;
            this._internalSelection = true;
            const selected = [];
            if (rect instanceof Rect) {
                items = this.shapes.concat(this.connections);
                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    if ((!rect || item._hitTest(rect)) && item.options.enable) {
                        if (item.select(true)) {
                            selected.push(item);
                        }
                    }
                }
            }
            this._selectionChanged(selected, []);
            this._internalSelection = false;
        }
        deselect(item) {
            this._internalSelection = true;
            const deselected = [];
            let items = [], element, i;
            if (item instanceof Array) {
                items = item;
            }
            else if (item instanceof DiagramElement) {
                items.push(item);
            }
            else if (!isDefined(item)) {
                items = this._selectedItems.slice(0);
            }
            for (i = 0; i < items.length; i++) {
                element = items[i];
                if (element.select(false)) {
                    deselected.push(element);
                }
            }
            this._selectionChanged([], deselected);
            this._internalSelection = false;
        }
        /**
         * Brings to front the passed items.
         *
         * @param items DiagramElement, Array of Items.
         * @param undoable. By default the action is undoable.
         */
        toFront(items, undoable) {
            if (!items) {
                items = this._selectedItems.slice();
            }
            const result = this._getDiagramItems(items);
            let indices;
            if (!defined(undoable) || undoable) {
                indices = indicesOfItems(this.mainLayer, result.visuals);
                const unit = new ToFrontUnit(this, items, indices);
                this.undoRedoService.add(unit);
            }
            else {
                this.mainLayer.toFront(result.visuals);
                this._fixOrdering(result, true);
            }
        }
        /**
         * Sends to back the passed items.
         *
         * @param items DiagramElement, Array of Items.
         * @param undoable. By default the action is undoable.
         */
        toBack(items, undoable) {
            if (!items) {
                items = this._selectedItems.slice();
            }
            const result = this._getDiagramItems(items);
            let indices;
            if (!defined(undoable) || undoable) {
                indices = indicesOfItems(this.mainLayer, result.visuals);
                const unit = new ToBackUnit(this, items, indices);
                this.undoRedoService.add(unit);
            }
            else {
                this.mainLayer.toBack(result.visuals);
                this._fixOrdering(result, false);
            }
        }
        /**
         * Bring into view the passed item(s) or rectangle.
         *
         * @param items DiagramElement, Array of Items, Rect.
         * @param options. align - controls the position of the calculated rectangle relative to the viewport.
         * "Center middle" will position the items in the center. animate - controls if the pan should be animated.
         */
        bringIntoView(item, options) {
            const viewport = this.viewport();
            const aligner = new RectAlign(viewport);
            let rect;
            if (viewport.width === 0 || viewport.height === 0) {
                return;
            }
            options = deepExtend({ animate: false, align: 'center middle' }, options);
            if (options.align === 'none') {
                options.align = 'center middle';
            }
            if (item instanceof DiagramElement) {
                rect = item.bounds(TRANSFORMED);
            }
            else if (Array.isArray(item)) {
                rect = this.boundingBox(item);
            }
            else if (item instanceof Rect) {
                rect = item.clone();
            }
            const original = rect.clone();
            rect.zoom(this._zoom);
            if (rect.width > viewport.width || rect.height > viewport.height) {
                this._zoom = this._getValidZoom(Math.min(viewport.width / original.width, viewport.height / original.height));
                rect = original.clone().zoom(this._zoom);
            }
            this._zoomMainLayer();
            const current = rect.clone();
            aligner.align(rect, options.align);
            const newPan = rect.topLeft().minus(current.topLeft());
            this.pan(newPan.times(-1), options.animate);
        }
        alignShapes(direction) {
            if (isUndefined(direction)) {
                direction = 'Left';
            }
            let val, item, i;
            const items = this.select();
            if (items.length === 0) {
                return;
            }
            switch (direction.toLowerCase()) {
                case 'left':
                case 'top':
                    val = MAX_VALUE;
                    break;
                case 'right':
                case 'bottom':
                    val = MIN_VALUE;
                    break;
                default:
                    break;
            }
            for (i = 0; i < items.length; i++) {
                item = items[i];
                if (item instanceof Shape) {
                    switch (direction.toLowerCase()) {
                        case 'left':
                            val = Math.min(val, item.options.x);
                            break;
                        case 'top':
                            val = Math.min(val, item.options.y);
                            break;
                        case 'right':
                            val = Math.max(val, item.options.x);
                            break;
                        case 'bottom':
                            val = Math.max(val, item.options.y);
                            break;
                        default:
                            break;
                    }
                }
            }
            const undoStates = [];
            const shapes = [];
            for (i = 0; i < items.length; i++) {
                item = items[i];
                if (item instanceof Shape) {
                    shapes.push(item);
                    undoStates.push(item.bounds());
                    switch (direction.toLowerCase()) {
                        case 'left':
                        case 'right':
                            item.position(new Point(val, item.options.y));
                            break;
                        case 'top':
                        case 'bottom':
                            item.position(new Point(item.options.x, val));
                            break;
                        default:
                            break;
                    }
                }
            }
            const unit = new TransformUnit(shapes, undoStates);
            this.undoRedoService.add(unit, false);
        }
        zoom(zoom, options) {
            if (zoom) {
                let staticPoint = options ? options.point : new Point(0, 0);
                // var meta = options ? options.meta : 0;
                zoom = this._zoom = this._getValidZoom(zoom);
                if (!isUndefined(staticPoint)) { // Viewpoint vector is constant
                    staticPoint = new Point(Math.round(staticPoint.x), Math.round(staticPoint.y));
                    const zoomedPoint = staticPoint.times(zoom);
                    const viewportVector = this.modelToView(staticPoint);
                    const raw = viewportVector.minus(zoomedPoint); // pan + zoomed point = viewpoint vector
                    this._storePan(new Point(Math.round(raw.x), Math.round(raw.y)));
                }
                if (options) {
                    options.zoom = zoom;
                }
                this._panTransform();
                if (this.canvas.surface.hideTooltip) {
                    this.canvas.surface.hideTooltip();
                }
                this._updateAdorners();
            }
            return this._zoom;
        }
        _getPan(pan) {
            const canvas = this.canvas;
            if (!canvas.translate) {
                pan = pan.plus(this._pan);
            }
            return pan;
        }
        pan(pan, animate) {
            if (pan instanceof Point) {
                const scroller = this.scroller;
                pan = this._getPan(pan);
                pan = pan.times(-1);
                if (animate) {
                    scroller.animatedScrollTo(pan.x, pan.y, () => {
                        this._updateAdorners();
                    });
                }
                else {
                    scroller.scrollTo(pan.x, pan.y);
                    this._updateAdorners();
                }
            }
            else {
                return this._pan.times(-1);
            }
        }
        viewport() {
            const element = this.element;
            const width = elementWidth(element);
            let height = elementHeight(element);
            if (this.toolBar) {
                height -= outerHeight(this.toolBar.element);
            }
            return new Rect(0, 0, width, height);
        }
        copy() {
            if (this.options.copy.enabled) {
                this._clipboard.length = 0;
                this._copyOffset = 1;
                for (let i = 0; i < this._selectedItems.length; i++) {
                    const item = this._selectedItems[i];
                    this._clipboard.push(item);
                }
            }
        }
        cut() {
            if (this.options.copy.enabled) {
                this._clipboard.length = 0;
                this._copyOffset = 0;
                for (let i = 0; i < this._selectedItems.length; i++) {
                    const item = this._selectedItems[i];
                    this._clipboard.push(item);
                }
                this.remove(this._clipboard, true);
            }
        }
        paste() {
            if (this._clipboard.length > 0) {
                let item, copied, i;
                const mapping = {};
                const elements = splitDiagramElements(this._clipboard);
                const connections = elements.connections;
                const shapes = elements.shapes;
                const offset = {
                    x: this._copyOffset * this.options.copy.offsetX,
                    y: this._copyOffset * this.options.copy.offsetY
                };
                this.deselect();
                // first the shapes
                for (i = 0; i < shapes.length; i++) {
                    item = shapes[i];
                    copied = item.clone();
                    mapping[item.id] = copied;
                    copied.position(new Point(item.options.x + offset.x, item.options.y + offset.y));
                    copied.diagram = this;
                    copied = this._addShape(copied);
                    if (copied) {
                        copied.select();
                    }
                }
                // then the connections
                for (i = 0; i < connections.length; i++) {
                    item = connections[i];
                    copied = this._addConnection(item.clone());
                    if (copied) {
                        this._updateCopiedConnection(copied, item, 'source', mapping, offset);
                        this._updateCopiedConnection(copied, item, 'target', mapping, offset);
                        copied.select(true);
                        copied.updateModel();
                    }
                }
                this._syncChanges();
                this._copyOffset += 1;
            }
        }
        _syncChanges() {
            if (this.options._syncChanges) {
                this.options._syncChanges();
            }
        }
        _syncConnectionChanges() {
            if (this.options._syncConnectionChanges) {
                this.options._syncConnectionChanges();
            }
        }
        _syncShapeChanges() {
            if (this.options._syncShapeChanges) {
                this.options._syncShapeChanges();
            }
        }
        _updateCopiedConnection(connection, sourceConnection, connectorName, mapping, offset) {
            let onActivate, inactiveItem, targetShape;
            const target = sourceConnection[connectorName]();
            if (target instanceof Connector && mapping[target.shape.id]) {
                targetShape = mapping[target.shape.id];
                if (this.getShapeById(targetShape.id)) {
                    connection[connectorName](targetShape.getConnector(target.options.name));
                }
                else {
                    inactiveItem = this._inactiveShapeItems.getByUid(targetShape.dataItem.uid);
                    if (inactiveItem) {
                        onActivate = (item) => {
                            targetShape = this._dataMap[item.id];
                            connection[connectorName](targetShape.getConnector(target.options.name));
                            connection.updateModel();
                        };
                        this._deferredConnectionUpdates.push(inactiveItem.onActivate(onActivate));
                    }
                }
            }
            else {
                connection[connectorName](new Point(sourceConnection[connectorName + 'Point']().x + offset.x, sourceConnection[connectorName + 'Point']().y + offset.y));
            }
        }
        /**
         * Gets the bounding rectangle of the given items.
         *
         * @param items DiagramElement, Array of elements.
         * @param origin Boolean. Pass 'true' if you need to get the bounding box of the shapes without their rotation offset.
         * @returns {Rect}
         */
        boundingBox(items, origin) {
            let rect = Rect.empty(), temp;
            const di = isDefined(items) ? this._getDiagramItems(items) : { shapes: this.shapes };
            if (di.shapes.length > 0) {
                let item = di.shapes[0];
                rect = item.bounds(ROTATED);
                for (let i = 1; i < di.shapes.length; i++) {
                    item = di.shapes[i];
                    temp = item.bounds(ROTATED);
                    if (origin === true) {
                        temp.x -= item._rotationOffset.x;
                        temp.y -= item._rotationOffset.y;
                    }
                    rect = rect.union(temp);
                }
            }
            return rect;
        }
        _containerOffset() {
            const containerOffset = elementOffset(this.element);
            if (this.toolBar) {
                containerOffset.top += outerHeight(this.toolBar.element);
            }
            return containerOffset;
        }
        documentToView(point) {
            const containerOffset = this._containerOffset();
            return new Point(point.x - containerOffset.left, point.y - containerOffset.top);
        }
        viewToDocument(point) {
            const containerOffset = this._containerOffset();
            return new Point(point.x + containerOffset.left, point.y + containerOffset.top);
        }
        viewToModel(point) {
            return this._transformWithMatrix(point, this._matrixInvert);
        }
        modelToView(point) {
            return this._transformWithMatrix(point, this._matrix);
        }
        modelToLayer(point) {
            return this._transformWithMatrix(point, this._layerMatrix);
        }
        layerToModel(point) {
            return this._transformWithMatrix(point, this._layerMatrixInvert);
        }
        documentToModel(point) {
            const viewPoint = this.documentToView(point);
            if (!this.canvas.translate) {
                viewPoint.x = viewPoint.x + this.scroller.scrollLeft;
                viewPoint.y = viewPoint.y + this.scroller.scrollTop;
            }
            return this.viewToModel(viewPoint);
        }
        modelToDocument(point) {
            return this.viewToDocument(this.modelToView(point));
        }
        _transformWithMatrix(point, matrix) {
            let result = point;
            if (point instanceof Point) {
                if (matrix) {
                    result = matrix.apply(point);
                }
            }
            else {
                const tl = this._transformWithMatrix(point.topLeft(), matrix), br = this._transformWithMatrix(point.bottomRight(), matrix);
                result = Rect.fromPoints(tl, br);
            }
            return result;
        }
        /**
         * Performs a diagram layout of the given type.
         *
         * @param layoutType The layout algorithm to be applied (TreeLayout, LayeredLayout, SpringLayout).
         * @param options Layout-specific options.
         */
        layout(options) {
            this._layouting = true;
            // TODO: raise layout event?
            let type;
            if (isUndefined(options)) {
                options = this.options.layout;
            }
            if (isUndefined(options) || isUndefined(options.type)) {
                type = 'Tree';
            }
            else {
                type = options.type;
            }
            let l;
            switch (type.toLowerCase()) {
                case 'tree':
                    l = new TreeLayout(this);
                    break;
                case 'layered':
                    l = new LayeredLayout(this);
                    break;
                case 'forcedirected':
                case 'force':
                case 'spring':
                case 'springembedder':
                    l = new SpringLayout(this);
                    break;
                default:
                    throw new Error('Layout algorithm \'' + type + '\' is not supported.');
            }
            const initialState = new LayoutState(this);
            const finalState = l.layout(options);
            if (finalState) {
                const unit = new LayoutUndoUnit(initialState, finalState, options ? options.animate : null);
                this.undoRedoService.add(unit);
            }
            this._layouting = false;
            this._redrawConnections();
        }
        /**
         * Gets a shape on the basis of its identifier.
         *
         * @param id (string) the identifier of a shape.
         * @returns {Shape}
         */
        getShapeById(id) {
            let found;
            found = first(this.shapes, function (s) {
                return s.visual.id === id;
            });
            if (found) {
                return found;
            }
            found = first(this.connections, function (c) {
                return c.visual.id === id;
            });
            return found;
        }
        getShapeByModelId(id) {
            let shapeResult;
            if (this._isEditable) {
                shapeResult = this._dataMap[id];
            }
            else {
                shapeResult = first(this.shapes, function (shape) {
                    return (shape.dataItem || {}).id === id;
                });
            }
            return shapeResult;
        }
        getShapeByModelUid(uid) {
            let shapeResult;
            if (this._isEditable) {
                shapeResult = first(this.shapes, function (shape) {
                    return (shape.dataItem || {}).uid === uid;
                });
            }
            else {
                shapeResult = this._dataMap[uid];
            }
            return shapeResult;
        }
        _extendLayoutOptions(options) {
            if (options.layout) {
                options.layout = deepExtend({}, LayoutDefaultOptions, options.layout);
            }
        }
        _selectionChanged(selected, deselected) {
            if (selected.length || deselected.length) {
                this.trigger(SELECT$1, { selected: selected, deselected: deselected });
            }
        }
        _getValidZoom(zoom) {
            return Math.min(Math.max(zoom, this.options.zoomMin), this.options.zoomMax);
        }
        _panTransform(pos) {
            const pan = pos || this._pan;
            if (this.canvas.translate) {
                this.scroller.scrollTo(pan.x, pan.y);
                this._zoomMainLayer();
            }
            else {
                this._storePan(pan);
                this._transformMainLayer();
            }
        }
        _finishPan() {
            this.trigger(PAN, { total: this._pan, delta: Number.NaN });
        }
        _storePan(pan) {
            this._pan = pan;
            this._storeViewMatrix();
        }
        _zoomMainLayer() {
            const zoom = this._zoom;
            const transform = new CompositeTransform(0, 0, zoom, zoom);
            transform.render(this.mainLayer);
            this._storeLayerMatrix(transform);
            this._storeViewMatrix();
        }
        _transformMainLayer() {
            const pan = this._pan, zoom = this._zoom;
            const transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
            transform.render(this.mainLayer);
            this._storeLayerMatrix(transform);
            this._storeViewMatrix();
        }
        _storeLayerMatrix(canvasTransform) {
            this._layerMatrix = canvasTransform.toMatrix();
            this._layerMatrixInvert = canvasTransform.invert().toMatrix();
        }
        _storeViewMatrix() {
            const pan = this._pan, zoom = this._zoom;
            const transform = new CompositeTransform(pan.x, pan.y, zoom, zoom);
            this._matrix = transform.toMatrix();
            this._matrixInvert = transform.invert().toMatrix();
        }
        _toIndex(items, indices) {
            const result = this._getDiagramItems(items);
            this.mainLayer.toIndex(result.visuals, indices);
            this._fixOrdering(result, false);
        }
        _fixOrdering(result, toFront) {
            const shapePos = toFront ? this.shapes.length - 1 : 0, conPos = toFront ? this.connections.length - 1 : 0;
            let i, item;
            for (i = 0; i < result.shapes.length; i++) {
                item = result.shapes[i];
                remove(this.shapes, item);
                insert(this.shapes, item, shapePos);
            }
            for (i = 0; i < result.cons.length; i++) {
                item = result.cons[i];
                remove(this.connections, item);
                insert(this.connections, item, conPos);
            }
        }
        _getDiagramItems(items) {
            let i, args = items;
            const result = {};
            result.visuals = [];
            result.shapes = [];
            result.cons = [];
            if (!items) {
                args = this._selectedItems.slice();
            }
            else if (!Array.isArray(items)) {
                args = [items];
            }
            for (i = 0; i < args.length; i++) {
                const item = args[i];
                if (item instanceof Shape) {
                    result.shapes.push(item);
                    result.visuals.push(item.visual);
                }
                else if (item instanceof Connection) {
                    result.cons.push(item);
                    result.visuals.push(item.visual);
                }
            }
            return result;
        }
        _addDataItemByUid(dataItem) {
            if (!defined(dataItem)) {
                return;
            }
            let shape = this._dataMap[dataItem.uid];
            if (shape) {
                return shape;
            }
            const options = deepExtend({}, this.options.shapeDefaults);
            options.dataItem = dataItem;
            shape = new Shape(options, this);
            this.addShape(shape);
            this._dataMap[dataItem.uid] = shape;
            return shape;
        }
        _addItem(item) {
            if (item instanceof Shape) {
                this.addShape(item);
            }
            else if (item instanceof Connection) {
                this.addConnection(item);
            }
        }
        _toolBarClick(e) {
            this.trigger('toolBarClick', e);
            this._destroyToolBar();
        }
        _normalizePointZoom(point) {
            return point.times(1 / this.zoom());
        }
        _initialize() {
            this.shapes.length = 0;
            this.connections.length = 0;
            this._selectedItems.length = 0;
            Object.keys(this._dataMap).forEach((key) => {
                delete this._dataMap[key];
            });
            Object.keys(this._connectionsDataMap).forEach((key) => {
                delete this._connectionsDataMap[key];
            });
            this._deferredConnectionUpdates.length = 0;
            this.undoRedoService = new UndoRedoService({
                undone: this._syncChanges.bind(this),
                redone: this._syncChanges.bind(this)
            });
            this.id = randomId();
        }
        _redrawConnections() {
            const connections = this.connections;
            for (let idx = 0; idx < connections.length; idx++) {
                connections[idx].refresh();
            }
        }
        _adorn(adorner, isActive) {
            if (isActive !== undefined && adorner) {
                if (isActive) {
                    this._adorners.push(adorner);
                    this.adornerLayer.append(adorner.visual);
                }
                else {
                    remove(this._adorners, adorner);
                    this.adornerLayer.remove(adorner.visual);
                }
            }
        }
        _showConnectors(shape, value) {
            if (value) {
                this._connectorsAdorner.show(shape);
            }
            else {
                this._connectorsAdorner.destroy();
            }
        }
        _updateAdorners() {
            const adorners = this._adorners;
            for (let i = 0; i < adorners.length; i++) {
                const adorner = adorners[i];
                if (adorner.refreshBounds) {
                    adorner.refreshBounds();
                }
                adorner.refresh();
            }
        }
        _refresh() {
            for (let i = 0; i < this.connections.length; i++) {
                this.connections[i].refresh();
            }
        }
        _removeItem(item, undoable, removedConnections) {
            item.select(false);
            if (item instanceof Shape) {
                this._removeShapeDataItem(item);
                this._removeShape(item, undoable, removedConnections);
            }
            else if (item instanceof Connection) {
                this._removeConnectionDataItem(item);
                this._removeConnection(item, undoable);
            }
            this.mainLayer.remove(item.visual);
        }
        _removeConnectionDataItem(item) {
            if (this._isEditable) {
                this.options._removeConnectionDataItem(item.dataItem);
                delete this._connectionsDataMap[item.dataItem.uid];
            }
        }
        _removeShapeDataItem(item) {
            if (this._isEditable) {
                this.options._removeShapeDataItem(item.dataItem);
                delete this._dataMap[item.dataItem.id];
            }
        }
        _removeShape(shape, undoable, removedConnections) {
            let i, connection, connector;
            const sources = [], targets = [];
            this.toolService._removeHover();
            if (undoable) {
                this.undoRedoService.addCompositeItem(new DeleteShapeUnit(shape));
            }
            remove(this.shapes, shape);
            this._shapesQuadTree.remove(shape);
            for (i = 0; i < shape.connectors.length; i++) {
                connector = shape.connectors[i];
                for (let j = 0; j < connector.connections.length; j++) {
                    connection = connector.connections[j];
                    if (!removedConnections || !contains(removedConnections, connection)) {
                        if (connection.sourceConnector === connector) {
                            sources.push(connection);
                        }
                        else if (connection.targetConnector === connector) {
                            targets.push(connection);
                        }
                    }
                }
            }
            for (i = 0; i < sources.length; i++) {
                sources[i].source(null, undoable);
                sources[i].updateModel();
            }
            for (i = 0; i < targets.length; i++) {
                targets[i].target(null, undoable);
                targets[i].updateModel();
            }
        }
        _removeConnection(connection, undoable) {
            if (connection.sourceConnector) {
                remove(connection.sourceConnector.connections, connection);
            }
            if (connection.targetConnector) {
                remove(connection.targetConnector.connections, connection);
            }
            if (undoable) {
                this.undoRedoService.addCompositeItem(new DeleteConnectionUnit(connection));
            }
            remove(this.connections, connection);
        }
        _removeShapeConnections(shape) {
            const connections = shape.connections();
            let idx;
            if (connections) {
                for (idx = 0; idx < connections.length; idx++) {
                    this._removeItem(connections[idx], false);
                }
            }
        }
        _destroyToolBar() {
            this.options.destroyToolBar();
        }
        _destroyGlobalToolBar() {
            if (this.toolBar) {
                this.toolBar = null;
            }
        }
        _mobileOS() {
            return kendo_common_cmn_chunk_js.m;
        }
        exportDOMVisual() {
            const viewBox = this.canvas._viewBox;
            const scrollOffset = kendo_drawing_cmn_chunk_js.t()
                .translate(-viewBox.x, -viewBox.y);
            const viewRect = new kendo_drawing_cmn_chunk_js.R([0, 0], [viewBox.width, viewBox.height]);
            const clipPath = kendo_drawing_cmn_chunk_js.b.fromRect(viewRect);
            const wrap = new kendo_drawing_cmn_chunk_js.G({ transform: scrollOffset });
            const clipWrap = new kendo_drawing_cmn_chunk_js.G({ clip: clipPath });
            const root = this.canvas.drawingElement.children[0];
            clipWrap.append(wrap);
            // Don't reparent the root
            wrap.children.push(root);
            return clipWrap;
        }
        exportVisual() {
            const scaleX = 1 / this._zoom;
            const scale = kendo_drawing_cmn_chunk_js.t().scale(scaleX, scaleX);
            const wrap = new kendo_drawing_cmn_chunk_js.G({
                transform: scale
            });
            const root = this.mainLayer.drawingElement;
            wrap.children.push(root);
            return wrap;
        }
        updateConnectionModel(connection, syncChanges) {
            if (this.options.updateConnectionModel) {
                return this.options.updateConnectionModel(connection, syncChanges);
            }
        }
        updateShapeModel(shape, syncChanges) {
            if (this.options.updateShapeModel) {
                return this.options.updateShapeModel(shape, syncChanges);
            }
        }
    }

    const elementStyles = (element) => element.ownerDocument.defaultView.getComputedStyle(element);
    const cache = {};
    const toColor = (colorMix, element) => {
        if (cache[colorMix]) {
            return cache[colorMix];
        }
        const curColor = element.style.color;
        element.style.color = colorMix;
        const color = elementStyles(element).color;
        element.style.color = curColor;
        cache[colorMix] = color;
        return color;
    };
    const getProp = (element, prop) => {
        let value = elementStyles(element).getPropertyValue(prop);
        if (/^color-mix/i.test(value)) {
            value = toColor(value, element);
        }
        return value;
    };
    const loadTheme = (element) => {
        const primaryBg = getProp(element, '--kendo-chart-primary-bg');
        const primaryContrast = getProp(element, '--kendo-chart-primary-contrast');
        const normalTextColor = getProp(element, '--kendo-chart-text');
        const normalBackground = getProp(element, '--kendo-color-surface');
        return {
            shapeDefaults: {
                fill: {
                    color: primaryBg
                },
                content: {
                    color: primaryContrast
                },
                connectorDefaults: {
                    fill: {
                        color: normalTextColor
                    },
                    stroke: {
                        color: primaryContrast
                    },
                    hover: {
                        fill: {
                            color: primaryContrast
                        },
                        stroke: {
                            color: normalTextColor
                        }
                    }
                }
            },
            editable: {
                resize: {
                    handles: {
                        stroke: {
                            color: normalTextColor
                        },
                        fill: {
                            color: normalBackground
                        },
                        hover: {
                            stroke: {
                                color: normalTextColor
                            },
                            fill: {
                                color: normalTextColor
                            }
                        }
                    }
                }
            },
            selectable: {
                stroke: {
                    color: normalTextColor
                }
            },
            connectionDefaults: {
                stroke: {
                    color: normalTextColor
                },
                content: {
                    color: normalTextColor
                },
                selection: {
                    handles: {
                        fill: {
                            color: primaryContrast
                        },
                        stroke: {
                            color: normalTextColor
                        },
                        width: 8,
                        height: 8
                    },
                    stroke: {
                        color: normalTextColor
                    }
                }
            }
        };
    };

    exports.$ = ConnectionEditUnit;
    exports.A = ArrowMarker;
    exports.B = RotateUnit;
    exports.C = Canvas$1;
    exports.D = Dictionary;
    exports.E = Element;
    exports.F = ConnectionEditTool;
    exports.G = Graph;
    exports.H = HashTable;
    exports.I = Intersect;
    exports.J = PointerTool;
    exports.K = ScrollerTool;
    exports.L = Link;
    exports.M = MatrixVector;
    exports.N = Node$1;
    exports.O = SelectionTool;
    exports.P = PathDefiner;
    exports.Q = Queue;
    exports.R = Range;
    exports.S = Set$1;
    exports.T = Ticker;
    exports.U = Utils$1;
    exports.V = VisualBase;
    exports.W = CascadingRouter;
    exports.X = PolylineRouter;
    exports.Y = ConnectionRouterBase;
    exports.Z = ToBackUnit;
    exports._ = ToFrontUnit;
    exports.__meta__ = __meta__;
    exports.a = Matrix;
    exports.a0 = LayoutUndoUnit;
    exports.a1 = ConnectorsAdorner;
    exports.a2 = ToolService;
    exports.a3 = Selector;
    exports.a4 = ResizingAdorner;
    exports.a5 = UndoRedoService;
    exports.a6 = ConnectorVisual;
    exports.a7 = ConnectionTool;
    exports.a8 = ConnectionEditAdorner;
    exports.a9 = DeleteConnectionUnit;
    exports.aa = DeleteShapeUnit;
    exports.ab = AddConnectionUnit;
    exports.ac = AddShapeUnit;
    exports.ad = PanUndoUnit;
    exports.ae = TransformUnit;
    exports.af = CompositeUnit;
    exports.ag = LayoutState;
    exports.ah = LayoutBase;
    exports.ai = LayeredLayout;
    exports.aj = DiagramToHyperTreeAdapter;
    exports.ak = TreeLayout;
    exports.al = SpringLayout;
    exports.am = DefaultConnectors;
    exports.an = shapeDefaults;
    exports.ao = defined;
    exports.ap = Shape;
    exports.aq = events;
    exports.ar = Connection;
    exports.as = first;
    exports.at = defaultOptions;
    exports.au = Diagram;
    exports.av = ShapesQuadTree;
    exports.aw = QuadRoot;
    exports.ax = QuadNode;
    exports.ay = Connector;
    exports.b = RectAlign;
    exports.c = Size;
    exports.d = Rect;
    exports.e = Geometry;
    exports.f = Point;
    exports.g = Image;
    exports.h = TextBlock;
    exports.i = CompositeTransform;
    exports.j = Polyline;
    exports.k = CircleMarker;
    exports.l = MarkerBase;
    exports.m = Line;
    exports.n = normalVariable;
    exports.o = Layout;
    exports.p = Path;
    exports.q = Rectangle;
    exports.r = randomId;
    exports.s = Group;
    exports.t = Circle;
    exports.u = Rotation;
    exports.v = Translation;
    exports.w = Scale;
    exports.x = Markers;
    exports.y = diffNumericOptions;
    exports.z = Cursors;

}));
